
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3976"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3976"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k3E3u", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e9a328961bc88595$export$ffb0004e005737fa; }, function (v) { return $e9a328961bc88595$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e9a328961bc88595$export$34b9dba7ce09269b; }, function (v) { return $e9a328961bc88595$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e9a328961bc88595$export$25062201e9e25d76; }, function (v) { return $e9a328961bc88595$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e9a328961bc88595$export$ffb0004e005737fa;
var $e9a328961bc88595$export$34b9dba7ce09269b;
var $e9a328961bc88595$export$25062201e9e25d76;
"use strict";
var $e9a328961bc88595$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e9a328961bc88595$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $e9a328961bc88595$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $e9a328961bc88595$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$e9a328961bc88595$export$ffb0004e005737fa = $e9a328961bc88595$var$REACT_FRAGMENT_TYPE;
$e9a328961bc88595$export$34b9dba7ce09269b = $e9a328961bc88595$var$jsxProd;
$e9a328961bc88595$export$25062201e9e25d76 = $e9a328961bc88595$var$jsxProd;

});

parcelRegister("13pnY", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $0c49c351e4bf4c9d$export$882461b6382ed46c; }, function (v) { return $0c49c351e4bf4c9d$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0c49c351e4bf4c9d$export$757ceba2d55c277e; }, function (v) { return $0c49c351e4bf4c9d$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $0c49c351e4bf4c9d$export$83d89fbfd8236492; }, function (v) { return $0c49c351e4bf4c9d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0c49c351e4bf4c9d$export$882461b6382ed46c;
var $0c49c351e4bf4c9d$export$757ceba2d55c277e;
var $0c49c351e4bf4c9d$export$83d89fbfd8236492;
"use strict";

var $aDD22 = parcelRequire("aDD22");

var $c56K2 = parcelRequire("c56K2");

var $dg2Np = parcelRequire("dg2Np");
function $0c49c351e4bf4c9d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $0c49c351e4bf4c9d$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $0c49c351e4bf4c9d$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $0c49c351e4bf4c9d$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $0c49c351e4bf4c9d$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $0c49c351e4bf4c9d$var$assertIsMounted(fiber) {
    if ($0c49c351e4bf4c9d$var$getNearestMountedFiber(fiber) !== fiber) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(188));
}
function $0c49c351e4bf4c9d$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $0c49c351e4bf4c9d$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $0c49c351e4bf4c9d$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $0c49c351e4bf4c9d$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $0c49c351e4bf4c9d$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $0c49c351e4bf4c9d$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $0c49c351e4bf4c9d$var$assign = Object.assign, $0c49c351e4bf4c9d$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $0c49c351e4bf4c9d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0c49c351e4bf4c9d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0c49c351e4bf4c9d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0c49c351e4bf4c9d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0c49c351e4bf4c9d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0c49c351e4bf4c9d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0c49c351e4bf4c9d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0c49c351e4bf4c9d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0c49c351e4bf4c9d$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $0c49c351e4bf4c9d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $0c49c351e4bf4c9d$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $0c49c351e4bf4c9d$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $0c49c351e4bf4c9d$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $0c49c351e4bf4c9d$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $0c49c351e4bf4c9d$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$0c49c351e4bf4c9d$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $0c49c351e4bf4c9d$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $0c49c351e4bf4c9d$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $0c49c351e4bf4c9d$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $0c49c351e4bf4c9d$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $0c49c351e4bf4c9d$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $0c49c351e4bf4c9d$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $0c49c351e4bf4c9d$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $0c49c351e4bf4c9d$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $0c49c351e4bf4c9d$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $0c49c351e4bf4c9d$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $0c49c351e4bf4c9d$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $0c49c351e4bf4c9d$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $0c49c351e4bf4c9d$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $0c49c351e4bf4c9d$var$getComponentNameFromType(type.type) || "Memo";
        case $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $0c49c351e4bf4c9d$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $0c49c351e4bf4c9d$var$isArrayImpl = Array.isArray, $0c49c351e4bf4c9d$var$ReactSharedInternals = $c56K2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $0c49c351e4bf4c9d$var$ReactDOMSharedInternals = $dg2Np.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $0c49c351e4bf4c9d$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $0c49c351e4bf4c9d$var$valueStack = [], $0c49c351e4bf4c9d$var$index = -1;
function $0c49c351e4bf4c9d$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $0c49c351e4bf4c9d$var$pop(cursor) {
    0 > $0c49c351e4bf4c9d$var$index || (cursor.current = $0c49c351e4bf4c9d$var$valueStack[$0c49c351e4bf4c9d$var$index], $0c49c351e4bf4c9d$var$valueStack[$0c49c351e4bf4c9d$var$index] = null, $0c49c351e4bf4c9d$var$index--);
}
function $0c49c351e4bf4c9d$var$push(cursor, value) {
    $0c49c351e4bf4c9d$var$index++;
    $0c49c351e4bf4c9d$var$valueStack[$0c49c351e4bf4c9d$var$index] = cursor.current;
    cursor.current = value;
}
var $0c49c351e4bf4c9d$var$contextStackCursor = $0c49c351e4bf4c9d$var$createCursor(null), $0c49c351e4bf4c9d$var$contextFiberStackCursor = $0c49c351e4bf4c9d$var$createCursor(null), $0c49c351e4bf4c9d$var$rootInstanceStackCursor = $0c49c351e4bf4c9d$var$createCursor(null), $0c49c351e4bf4c9d$var$hostTransitionProviderCursor = $0c49c351e4bf4c9d$var$createCursor(null);
function $0c49c351e4bf4c9d$var$pushHostContainer(fiber, nextRootInstance) {
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$rootInstanceStackCursor, nextRootInstance);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$contextFiberStackCursor, fiber);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $0c49c351e4bf4c9d$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $0c49c351e4bf4c9d$var$getOwnHostContext(nextRootInstance), fiber = $0c49c351e4bf4c9d$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$contextStackCursor);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$contextStackCursor, fiber);
}
function $0c49c351e4bf4c9d$var$popHostContainer() {
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$contextStackCursor);
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$contextFiberStackCursor);
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$rootInstanceStackCursor);
}
function $0c49c351e4bf4c9d$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$hostTransitionProviderCursor, fiber);
    var context = $0c49c351e4bf4c9d$var$contextStackCursor.current;
    var JSCompiler_inline_result = $0c49c351e4bf4c9d$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$contextFiberStackCursor, fiber), $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$contextStackCursor, JSCompiler_inline_result));
}
function $0c49c351e4bf4c9d$var$popHostContext(fiber) {
    $0c49c351e4bf4c9d$var$contextFiberStackCursor.current === fiber && ($0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$contextStackCursor), $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$contextFiberStackCursor));
    $0c49c351e4bf4c9d$var$hostTransitionProviderCursor.current === fiber && ($0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$hostTransitionProviderCursor), $0c49c351e4bf4c9d$var$HostTransitionContext._currentValue = $0c49c351e4bf4c9d$var$sharedNotPendingObject);
}
var $0c49c351e4bf4c9d$var$prefix, $0c49c351e4bf4c9d$var$suffix;
function $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $0c49c351e4bf4c9d$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $0c49c351e4bf4c9d$var$prefix = match && match[1] || "";
        $0c49c351e4bf4c9d$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $0c49c351e4bf4c9d$var$prefix + name + $0c49c351e4bf4c9d$var$suffix;
}
var $0c49c351e4bf4c9d$var$reentry = !1;
function $0c49c351e4bf4c9d$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $0c49c351e4bf4c9d$var$reentry) return "";
    $0c49c351e4bf4c9d$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $0c49c351e4bf4c9d$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $0c49c351e4bf4c9d$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame("Suspense Fallback") : $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $0c49c351e4bf4c9d$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $0c49c351e4bf4c9d$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $0c49c351e4bf4c9d$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $0c49c351e4bf4c9d$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $0c49c351e4bf4c9d$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $0c49c351e4bf4c9d$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $0c49c351e4bf4c9d$var$hasOwnProperty = Object.prototype.hasOwnProperty, $0c49c351e4bf4c9d$var$scheduleCallback$3 = $aDD22.unstable_scheduleCallback, $0c49c351e4bf4c9d$var$cancelCallback$1 = $aDD22.unstable_cancelCallback, $0c49c351e4bf4c9d$var$shouldYield = $aDD22.unstable_shouldYield, $0c49c351e4bf4c9d$var$requestPaint = $aDD22.unstable_requestPaint, $0c49c351e4bf4c9d$var$now = $aDD22.unstable_now, $0c49c351e4bf4c9d$var$getCurrentPriorityLevel = $aDD22.unstable_getCurrentPriorityLevel, $0c49c351e4bf4c9d$var$ImmediatePriority = $aDD22.unstable_ImmediatePriority, $0c49c351e4bf4c9d$var$UserBlockingPriority = $aDD22.unstable_UserBlockingPriority, $0c49c351e4bf4c9d$var$NormalPriority$1 = $aDD22.unstable_NormalPriority, $0c49c351e4bf4c9d$var$LowPriority = $aDD22.unstable_LowPriority, $0c49c351e4bf4c9d$var$IdlePriority = $aDD22.unstable_IdlePriority, $0c49c351e4bf4c9d$var$log$1 = $aDD22.log, $0c49c351e4bf4c9d$var$unstable_setDisableYieldValue = $aDD22.unstable_setDisableYieldValue, $0c49c351e4bf4c9d$var$rendererID = null, $0c49c351e4bf4c9d$var$injectedHook = null;
function $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $0c49c351e4bf4c9d$var$log$1 && $0c49c351e4bf4c9d$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($0c49c351e4bf4c9d$var$injectedHook && "function" === typeof $0c49c351e4bf4c9d$var$injectedHook.setStrictMode) try {
        $0c49c351e4bf4c9d$var$injectedHook.setStrictMode($0c49c351e4bf4c9d$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $0c49c351e4bf4c9d$var$clz32 = Math.clz32 ? Math.clz32 : $0c49c351e4bf4c9d$var$clz32Fallback, $0c49c351e4bf4c9d$var$log = Math.log, $0c49c351e4bf4c9d$var$LN2 = Math.LN2;
function $0c49c351e4bf4c9d$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($0c49c351e4bf4c9d$var$log(x) / $0c49c351e4bf4c9d$var$LN2 | 0) | 0;
}
var $0c49c351e4bf4c9d$var$nextTransitionUpdateLane = 256, $0c49c351e4bf4c9d$var$nextTransitionDeferredLane = 262144, $0c49c351e4bf4c9d$var$nextRetryLane = 4194304;
function $0c49c351e4bf4c9d$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $0c49c351e4bf4c9d$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $0c49c351e4bf4c9d$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $0c49c351e4bf4c9d$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $0c49c351e4bf4c9d$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $0c49c351e4bf4c9d$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $0c49c351e4bf4c9d$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $0c49c351e4bf4c9d$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $0c49c351e4bf4c9d$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $0c49c351e4bf4c9d$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0c49c351e4bf4c9d$var$claimNextRetryLane() {
    var lane = $0c49c351e4bf4c9d$var$nextRetryLane;
    $0c49c351e4bf4c9d$var$nextRetryLane <<= 1;
    0 === ($0c49c351e4bf4c9d$var$nextRetryLane & 62914560) && ($0c49c351e4bf4c9d$var$nextRetryLane = 4194304);
    return lane;
}
function $0c49c351e4bf4c9d$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $0c49c351e4bf4c9d$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $0c49c351e4bf4c9d$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $0c49c351e4bf4c9d$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $0c49c351e4bf4c9d$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $0c49c351e4bf4c9d$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $0c49c351e4bf4c9d$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $0c49c351e4bf4c9d$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $0c49c351e4bf4c9d$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $0c49c351e4bf4c9d$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $0c49c351e4bf4c9d$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $0c49c351e4bf4c9d$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $0c49c351e4bf4c9d$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $0c49c351e4bf4c9d$var$resolveUpdatePriority() {
    var updatePriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $0c49c351e4bf4c9d$var$getEventPriority(updatePriority.type);
}
function $0c49c351e4bf4c9d$var$runWithPriority(priority, fn) {
    var previousPriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
    try {
        return $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $0c49c351e4bf4c9d$var$randomKey = Math.random().toString(36).slice(2), $0c49c351e4bf4c9d$var$internalInstanceKey = "__reactFiber$" + $0c49c351e4bf4c9d$var$randomKey, $0c49c351e4bf4c9d$var$internalPropsKey = "__reactProps$" + $0c49c351e4bf4c9d$var$randomKey, $0c49c351e4bf4c9d$var$internalContainerInstanceKey = "__reactContainer$" + $0c49c351e4bf4c9d$var$randomKey, $0c49c351e4bf4c9d$var$internalEventHandlersKey = "__reactEvents$" + $0c49c351e4bf4c9d$var$randomKey, $0c49c351e4bf4c9d$var$internalEventHandlerListenersKey = "__reactListeners$" + $0c49c351e4bf4c9d$var$randomKey, $0c49c351e4bf4c9d$var$internalEventHandlesSetKey = "__reactHandles$" + $0c49c351e4bf4c9d$var$randomKey, $0c49c351e4bf4c9d$var$internalRootNodeResourcesKey = "__reactResources$" + $0c49c351e4bf4c9d$var$randomKey, $0c49c351e4bf4c9d$var$internalHoistableMarker = "__reactMarker$" + $0c49c351e4bf4c9d$var$randomKey;
function $0c49c351e4bf4c9d$var$detachDeletedInstance(node) {
    delete node[$0c49c351e4bf4c9d$var$internalInstanceKey];
    delete node[$0c49c351e4bf4c9d$var$internalPropsKey];
    delete node[$0c49c351e4bf4c9d$var$internalEventHandlersKey];
    delete node[$0c49c351e4bf4c9d$var$internalEventHandlerListenersKey];
    delete node[$0c49c351e4bf4c9d$var$internalEventHandlesSetKey];
}
function $0c49c351e4bf4c9d$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$0c49c351e4bf4c9d$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$0c49c351e4bf4c9d$var$internalContainerInstanceKey] || parentNode[$0c49c351e4bf4c9d$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $0c49c351e4bf4c9d$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$0c49c351e4bf4c9d$var$internalInstanceKey]) return parentNode;
                targetNode = $0c49c351e4bf4c9d$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $0c49c351e4bf4c9d$var$getInstanceFromNode(node) {
    if (node = node[$0c49c351e4bf4c9d$var$internalInstanceKey] || node[$0c49c351e4bf4c9d$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $0c49c351e4bf4c9d$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(33));
}
function $0c49c351e4bf4c9d$var$getResourcesFromRoot(root) {
    var resources = root[$0c49c351e4bf4c9d$var$internalRootNodeResourcesKey];
    resources || (resources = root[$0c49c351e4bf4c9d$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $0c49c351e4bf4c9d$var$markNodeAsHoistable(node) {
    node[$0c49c351e4bf4c9d$var$internalHoistableMarker] = !0;
}
var $0c49c351e4bf4c9d$var$allNativeEvents = new Set(), $0c49c351e4bf4c9d$var$registrationNameDependencies = {};
function $0c49c351e4bf4c9d$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $0c49c351e4bf4c9d$var$registerDirectEvent(registrationName, dependencies);
    $0c49c351e4bf4c9d$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $0c49c351e4bf4c9d$var$registerDirectEvent(registrationName, dependencies) {
    $0c49c351e4bf4c9d$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$0c49c351e4bf4c9d$var$allNativeEvents.add(dependencies[registrationName]);
}
var $0c49c351e4bf4c9d$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $0c49c351e4bf4c9d$var$illegalAttributeNameCache = {}, $0c49c351e4bf4c9d$var$validatedAttributeNameCache = {};
function $0c49c351e4bf4c9d$var$isAttributeNameSafe(attributeName) {
    if ($0c49c351e4bf4c9d$var$hasOwnProperty.call($0c49c351e4bf4c9d$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($0c49c351e4bf4c9d$var$hasOwnProperty.call($0c49c351e4bf4c9d$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($0c49c351e4bf4c9d$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $0c49c351e4bf4c9d$var$validatedAttributeNameCache[attributeName] = !0;
    $0c49c351e4bf4c9d$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $0c49c351e4bf4c9d$var$setValueForAttribute(node, name, value) {
    if ($0c49c351e4bf4c9d$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $0c49c351e4bf4c9d$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $0c49c351e4bf4c9d$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $0c49c351e4bf4c9d$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $0c49c351e4bf4c9d$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $0c49c351e4bf4c9d$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $0c49c351e4bf4c9d$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $0c49c351e4bf4c9d$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $0c49c351e4bf4c9d$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $0c49c351e4bf4c9d$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $0c49c351e4bf4c9d$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $0c49c351e4bf4c9d$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $0c49c351e4bf4c9d$var$getToStringValue(value);
        } else element.value !== "" + $0c49c351e4bf4c9d$var$getToStringValue(value) && (element.value = "" + $0c49c351e4bf4c9d$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $0c49c351e4bf4c9d$var$setDefaultValue(element, type, $0c49c351e4bf4c9d$var$getToStringValue(value)) : null != defaultValue ? $0c49c351e4bf4c9d$var$setDefaultValue(element, type, $0c49c351e4bf4c9d$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $0c49c351e4bf4c9d$var$getToStringValue(name) : element.removeAttribute("name");
}
function $0c49c351e4bf4c9d$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $0c49c351e4bf4c9d$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $0c49c351e4bf4c9d$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $0c49c351e4bf4c9d$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $0c49c351e4bf4c9d$var$track(element);
}
function $0c49c351e4bf4c9d$var$setDefaultValue(node, type, value) {
    "number" === type && $0c49c351e4bf4c9d$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $0c49c351e4bf4c9d$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $0c49c351e4bf4c9d$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $0c49c351e4bf4c9d$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $0c49c351e4bf4c9d$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $0c49c351e4bf4c9d$var$getToStringValue(defaultValue) : "";
}
function $0c49c351e4bf4c9d$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(92));
            if ($0c49c351e4bf4c9d$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $0c49c351e4bf4c9d$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $0c49c351e4bf4c9d$var$track(element);
}
function $0c49c351e4bf4c9d$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $0c49c351e4bf4c9d$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $0c49c351e4bf4c9d$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $0c49c351e4bf4c9d$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $0c49c351e4bf4c9d$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $0c49c351e4bf4c9d$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $0c49c351e4bf4c9d$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $0c49c351e4bf4c9d$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0c49c351e4bf4c9d$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $0c49c351e4bf4c9d$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $0c49c351e4bf4c9d$var$sanitizeURL(url) {
    return $0c49c351e4bf4c9d$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $0c49c351e4bf4c9d$var$noop$1() {}
var $0c49c351e4bf4c9d$var$currentReplayingEvent = null;
function $0c49c351e4bf4c9d$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $0c49c351e4bf4c9d$var$restoreTarget = null, $0c49c351e4bf4c9d$var$restoreQueue = null;
function $0c49c351e4bf4c9d$var$restoreStateOfTarget(target) {
    var internalInstance = $0c49c351e4bf4c9d$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$0c49c351e4bf4c9d$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $0c49c351e4bf4c9d$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$0c49c351e4bf4c9d$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(90));
                            $0c49c351e4bf4c9d$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $0c49c351e4bf4c9d$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $0c49c351e4bf4c9d$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $0c49c351e4bf4c9d$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $0c49c351e4bf4c9d$var$isInsideEventHandler = !1;
function $0c49c351e4bf4c9d$var$batchedUpdates$1(fn, a, b) {
    if ($0c49c351e4bf4c9d$var$isInsideEventHandler) return fn(a, b);
    $0c49c351e4bf4c9d$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($0c49c351e4bf4c9d$var$isInsideEventHandler = !1, null !== $0c49c351e4bf4c9d$var$restoreTarget || null !== $0c49c351e4bf4c9d$var$restoreQueue) {
            if ($0c49c351e4bf4c9d$var$flushSyncWork$1(), $0c49c351e4bf4c9d$var$restoreTarget && (a = $0c49c351e4bf4c9d$var$restoreTarget, fn = $0c49c351e4bf4c9d$var$restoreQueue, $0c49c351e4bf4c9d$var$restoreQueue = $0c49c351e4bf4c9d$var$restoreTarget = null, $0c49c351e4bf4c9d$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$0c49c351e4bf4c9d$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $0c49c351e4bf4c9d$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$0c49c351e4bf4c9d$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $0c49c351e4bf4c9d$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0c49c351e4bf4c9d$var$passiveBrowserEventsSupported = !1;
if ($0c49c351e4bf4c9d$var$canUseDOM) try {
    var $0c49c351e4bf4c9d$var$options = {};
    Object.defineProperty($0c49c351e4bf4c9d$var$options, "passive", {
        get: function() {
            $0c49c351e4bf4c9d$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $0c49c351e4bf4c9d$var$options, $0c49c351e4bf4c9d$var$options);
    window.removeEventListener("test", $0c49c351e4bf4c9d$var$options, $0c49c351e4bf4c9d$var$options);
} catch (e) {
    $0c49c351e4bf4c9d$var$passiveBrowserEventsSupported = !1;
}
var $0c49c351e4bf4c9d$var$root = null, $0c49c351e4bf4c9d$var$startText = null, $0c49c351e4bf4c9d$var$fallbackText = null;
function $0c49c351e4bf4c9d$var$getData() {
    if ($0c49c351e4bf4c9d$var$fallbackText) return $0c49c351e4bf4c9d$var$fallbackText;
    var start, startValue = $0c49c351e4bf4c9d$var$startText, startLength = startValue.length, end, endValue = "value" in $0c49c351e4bf4c9d$var$root ? $0c49c351e4bf4c9d$var$root.value : $0c49c351e4bf4c9d$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $0c49c351e4bf4c9d$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $0c49c351e4bf4c9d$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $0c49c351e4bf4c9d$var$functionThatReturnsTrue() {
    return !0;
}
function $0c49c351e4bf4c9d$var$functionThatReturnsFalse() {
    return !1;
}
function $0c49c351e4bf4c9d$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $0c49c351e4bf4c9d$var$functionThatReturnsTrue : $0c49c351e4bf4c9d$var$functionThatReturnsFalse;
        this.isPropagationStopped = $0c49c351e4bf4c9d$var$functionThatReturnsFalse;
        return this;
    }
    $0c49c351e4bf4c9d$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $0c49c351e4bf4c9d$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $0c49c351e4bf4c9d$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $0c49c351e4bf4c9d$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $0c49c351e4bf4c9d$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0c49c351e4bf4c9d$var$SyntheticEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$EventInterface), $0c49c351e4bf4c9d$var$UIEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$EventInterface, {
    view: 0,
    detail: 0
}), $0c49c351e4bf4c9d$var$SyntheticUIEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$UIEventInterface), $0c49c351e4bf4c9d$var$lastMovementX, $0c49c351e4bf4c9d$var$lastMovementY, $0c49c351e4bf4c9d$var$lastMouseEvent, $0c49c351e4bf4c9d$var$MouseEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0c49c351e4bf4c9d$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $0c49c351e4bf4c9d$var$lastMouseEvent && ($0c49c351e4bf4c9d$var$lastMouseEvent && "mousemove" === event.type ? ($0c49c351e4bf4c9d$var$lastMovementX = event.screenX - $0c49c351e4bf4c9d$var$lastMouseEvent.screenX, $0c49c351e4bf4c9d$var$lastMovementY = event.screenY - $0c49c351e4bf4c9d$var$lastMouseEvent.screenY) : $0c49c351e4bf4c9d$var$lastMovementY = $0c49c351e4bf4c9d$var$lastMovementX = 0, $0c49c351e4bf4c9d$var$lastMouseEvent = event);
        return $0c49c351e4bf4c9d$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $0c49c351e4bf4c9d$var$lastMovementY;
    }
}), $0c49c351e4bf4c9d$var$SyntheticMouseEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$MouseEventInterface), $0c49c351e4bf4c9d$var$DragEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$MouseEventInterface, {
    dataTransfer: 0
}), $0c49c351e4bf4c9d$var$SyntheticDragEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$DragEventInterface), $0c49c351e4bf4c9d$var$FocusEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$UIEventInterface, {
    relatedTarget: 0
}), $0c49c351e4bf4c9d$var$SyntheticFocusEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$FocusEventInterface), $0c49c351e4bf4c9d$var$AnimationEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0c49c351e4bf4c9d$var$SyntheticAnimationEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$AnimationEventInterface), $0c49c351e4bf4c9d$var$ClipboardEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $0c49c351e4bf4c9d$var$SyntheticClipboardEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$ClipboardEventInterface), $0c49c351e4bf4c9d$var$CompositionEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$EventInterface, {
    data: 0
}), $0c49c351e4bf4c9d$var$SyntheticCompositionEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$CompositionEventInterface), $0c49c351e4bf4c9d$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0c49c351e4bf4c9d$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0c49c351e4bf4c9d$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0c49c351e4bf4c9d$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $0c49c351e4bf4c9d$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $0c49c351e4bf4c9d$var$getEventModifierState() {
    return $0c49c351e4bf4c9d$var$modifierStateGetter;
}
var $0c49c351e4bf4c9d$var$KeyboardEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $0c49c351e4bf4c9d$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $0c49c351e4bf4c9d$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $0c49c351e4bf4c9d$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0c49c351e4bf4c9d$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $0c49c351e4bf4c9d$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $0c49c351e4bf4c9d$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $0c49c351e4bf4c9d$var$SyntheticKeyboardEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$KeyboardEventInterface), $0c49c351e4bf4c9d$var$PointerEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0c49c351e4bf4c9d$var$SyntheticPointerEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$PointerEventInterface), $0c49c351e4bf4c9d$var$TouchEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0c49c351e4bf4c9d$var$getEventModifierState
}), $0c49c351e4bf4c9d$var$SyntheticTouchEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$TouchEventInterface), $0c49c351e4bf4c9d$var$TransitionEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0c49c351e4bf4c9d$var$SyntheticTransitionEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$TransitionEventInterface), $0c49c351e4bf4c9d$var$WheelEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0c49c351e4bf4c9d$var$SyntheticWheelEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$WheelEventInterface), $0c49c351e4bf4c9d$var$ToggleEventInterface = $0c49c351e4bf4c9d$var$assign({}, $0c49c351e4bf4c9d$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $0c49c351e4bf4c9d$var$SyntheticToggleEvent = $0c49c351e4bf4c9d$var$createSyntheticEvent($0c49c351e4bf4c9d$var$ToggleEventInterface), $0c49c351e4bf4c9d$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $0c49c351e4bf4c9d$var$canUseCompositionEvent = $0c49c351e4bf4c9d$var$canUseDOM && "CompositionEvent" in window, $0c49c351e4bf4c9d$var$documentMode = null;
$0c49c351e4bf4c9d$var$canUseDOM && "documentMode" in document && ($0c49c351e4bf4c9d$var$documentMode = document.documentMode);
var $0c49c351e4bf4c9d$var$canUseTextInputEvent = $0c49c351e4bf4c9d$var$canUseDOM && "TextEvent" in window && !$0c49c351e4bf4c9d$var$documentMode, $0c49c351e4bf4c9d$var$useFallbackCompositionData = $0c49c351e4bf4c9d$var$canUseDOM && (!$0c49c351e4bf4c9d$var$canUseCompositionEvent || $0c49c351e4bf4c9d$var$documentMode && 8 < $0c49c351e4bf4c9d$var$documentMode && 11 >= $0c49c351e4bf4c9d$var$documentMode), $0c49c351e4bf4c9d$var$SPACEBAR_CHAR = String.fromCharCode(32), $0c49c351e4bf4c9d$var$hasSpaceKeypress = !1;
function $0c49c351e4bf4c9d$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $0c49c351e4bf4c9d$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0c49c351e4bf4c9d$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $0c49c351e4bf4c9d$var$isComposing = !1;
function $0c49c351e4bf4c9d$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $0c49c351e4bf4c9d$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $0c49c351e4bf4c9d$var$hasSpaceKeypress = !0;
            return $0c49c351e4bf4c9d$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $0c49c351e4bf4c9d$var$SPACEBAR_CHAR && $0c49c351e4bf4c9d$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $0c49c351e4bf4c9d$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($0c49c351e4bf4c9d$var$isComposing) return "compositionend" === domEventName || !$0c49c351e4bf4c9d$var$canUseCompositionEvent && $0c49c351e4bf4c9d$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $0c49c351e4bf4c9d$var$getData(), $0c49c351e4bf4c9d$var$fallbackText = $0c49c351e4bf4c9d$var$startText = $0c49c351e4bf4c9d$var$root = null, $0c49c351e4bf4c9d$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $0c49c351e4bf4c9d$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $0c49c351e4bf4c9d$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0c49c351e4bf4c9d$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$0c49c351e4bf4c9d$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $0c49c351e4bf4c9d$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $0c49c351e4bf4c9d$var$restoreTarget ? $0c49c351e4bf4c9d$var$restoreQueue ? $0c49c351e4bf4c9d$var$restoreQueue.push(target) : $0c49c351e4bf4c9d$var$restoreQueue = [
        target
    ] : $0c49c351e4bf4c9d$var$restoreTarget = target;
    inst = $0c49c351e4bf4c9d$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $0c49c351e4bf4c9d$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $0c49c351e4bf4c9d$var$activeElement$1 = null, $0c49c351e4bf4c9d$var$activeElementInst$1 = null;
function $0c49c351e4bf4c9d$var$runEventInBatch(dispatchQueue) {
    $0c49c351e4bf4c9d$var$processDispatchQueue(dispatchQueue, 0);
}
function $0c49c351e4bf4c9d$var$getInstIfValueChanged(targetInst) {
    var targetNode = $0c49c351e4bf4c9d$var$getNodeFromInstance(targetInst);
    if ($0c49c351e4bf4c9d$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $0c49c351e4bf4c9d$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $0c49c351e4bf4c9d$var$isInputEventSupported = !1;
if ($0c49c351e4bf4c9d$var$canUseDOM) {
    var $0c49c351e4bf4c9d$var$JSCompiler_inline_result$jscomp$286;
    if ($0c49c351e4bf4c9d$var$canUseDOM) {
        var $0c49c351e4bf4c9d$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$0c49c351e4bf4c9d$var$isSupported$jscomp$inline_427) {
            var $0c49c351e4bf4c9d$var$element$jscomp$inline_428 = document.createElement("div");
            $0c49c351e4bf4c9d$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $0c49c351e4bf4c9d$var$isSupported$jscomp$inline_427 = "function" === typeof $0c49c351e4bf4c9d$var$element$jscomp$inline_428.oninput;
        }
        $0c49c351e4bf4c9d$var$JSCompiler_inline_result$jscomp$286 = $0c49c351e4bf4c9d$var$isSupported$jscomp$inline_427;
    } else $0c49c351e4bf4c9d$var$JSCompiler_inline_result$jscomp$286 = !1;
    $0c49c351e4bf4c9d$var$isInputEventSupported = $0c49c351e4bf4c9d$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $0c49c351e4bf4c9d$var$stopWatchingForValueChange() {
    $0c49c351e4bf4c9d$var$activeElement$1 && ($0c49c351e4bf4c9d$var$activeElement$1.detachEvent("onpropertychange", $0c49c351e4bf4c9d$var$handlePropertyChange), $0c49c351e4bf4c9d$var$activeElementInst$1 = $0c49c351e4bf4c9d$var$activeElement$1 = null);
}
function $0c49c351e4bf4c9d$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $0c49c351e4bf4c9d$var$getInstIfValueChanged($0c49c351e4bf4c9d$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $0c49c351e4bf4c9d$var$createAndAccumulateChangeEvent(dispatchQueue, $0c49c351e4bf4c9d$var$activeElementInst$1, nativeEvent, $0c49c351e4bf4c9d$var$getEventTarget(nativeEvent));
        $0c49c351e4bf4c9d$var$batchedUpdates$1($0c49c351e4bf4c9d$var$runEventInBatch, dispatchQueue);
    }
}
function $0c49c351e4bf4c9d$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($0c49c351e4bf4c9d$var$stopWatchingForValueChange(), $0c49c351e4bf4c9d$var$activeElement$1 = target, $0c49c351e4bf4c9d$var$activeElementInst$1 = targetInst, $0c49c351e4bf4c9d$var$activeElement$1.attachEvent("onpropertychange", $0c49c351e4bf4c9d$var$handlePropertyChange)) : "focusout" === domEventName && $0c49c351e4bf4c9d$var$stopWatchingForValueChange();
}
function $0c49c351e4bf4c9d$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $0c49c351e4bf4c9d$var$getInstIfValueChanged($0c49c351e4bf4c9d$var$activeElementInst$1);
}
function $0c49c351e4bf4c9d$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $0c49c351e4bf4c9d$var$getInstIfValueChanged(targetInst);
}
function $0c49c351e4bf4c9d$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $0c49c351e4bf4c9d$var$getInstIfValueChanged(targetInst);
}
function $0c49c351e4bf4c9d$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $0c49c351e4bf4c9d$var$objectIs = "function" === typeof Object.is ? Object.is : $0c49c351e4bf4c9d$var$is;
function $0c49c351e4bf4c9d$var$shallowEqual(objA, objB) {
    if ($0c49c351e4bf4c9d$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$0c49c351e4bf4c9d$var$hasOwnProperty.call(objB, currentKey) || !$0c49c351e4bf4c9d$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $0c49c351e4bf4c9d$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $0c49c351e4bf4c9d$var$getNodeForCharacterOffset(root, offset) {
    var node = $0c49c351e4bf4c9d$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $0c49c351e4bf4c9d$var$getLeafNode(node);
    }
}
function $0c49c351e4bf4c9d$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $0c49c351e4bf4c9d$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $0c49c351e4bf4c9d$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $0c49c351e4bf4c9d$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $0c49c351e4bf4c9d$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $0c49c351e4bf4c9d$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $0c49c351e4bf4c9d$var$skipSelectionChangeEvent = $0c49c351e4bf4c9d$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $0c49c351e4bf4c9d$var$activeElement = null, $0c49c351e4bf4c9d$var$activeElementInst = null, $0c49c351e4bf4c9d$var$lastSelection = null, $0c49c351e4bf4c9d$var$mouseDown = !1;
function $0c49c351e4bf4c9d$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $0c49c351e4bf4c9d$var$mouseDown || null == $0c49c351e4bf4c9d$var$activeElement || $0c49c351e4bf4c9d$var$activeElement !== $0c49c351e4bf4c9d$var$getActiveElement(doc) || (doc = $0c49c351e4bf4c9d$var$activeElement, "selectionStart" in doc && $0c49c351e4bf4c9d$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $0c49c351e4bf4c9d$var$lastSelection && $0c49c351e4bf4c9d$var$shallowEqual($0c49c351e4bf4c9d$var$lastSelection, doc) || ($0c49c351e4bf4c9d$var$lastSelection = doc, doc = $0c49c351e4bf4c9d$var$accumulateTwoPhaseListeners($0c49c351e4bf4c9d$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $0c49c351e4bf4c9d$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $0c49c351e4bf4c9d$var$activeElement)));
}
function $0c49c351e4bf4c9d$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $0c49c351e4bf4c9d$var$vendorPrefixes = {
    animationend: $0c49c351e4bf4c9d$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $0c49c351e4bf4c9d$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $0c49c351e4bf4c9d$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $0c49c351e4bf4c9d$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $0c49c351e4bf4c9d$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $0c49c351e4bf4c9d$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $0c49c351e4bf4c9d$var$makePrefixMap("Transition", "TransitionEnd")
}, $0c49c351e4bf4c9d$var$prefixedEventNames = {}, $0c49c351e4bf4c9d$var$style = {};
$0c49c351e4bf4c9d$var$canUseDOM && ($0c49c351e4bf4c9d$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $0c49c351e4bf4c9d$var$vendorPrefixes.animationend.animation, delete $0c49c351e4bf4c9d$var$vendorPrefixes.animationiteration.animation, delete $0c49c351e4bf4c9d$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $0c49c351e4bf4c9d$var$vendorPrefixes.transitionend.transition);
function $0c49c351e4bf4c9d$var$getVendorPrefixedEventName(eventName) {
    if ($0c49c351e4bf4c9d$var$prefixedEventNames[eventName]) return $0c49c351e4bf4c9d$var$prefixedEventNames[eventName];
    if (!$0c49c351e4bf4c9d$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $0c49c351e4bf4c9d$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $0c49c351e4bf4c9d$var$style) return $0c49c351e4bf4c9d$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $0c49c351e4bf4c9d$var$ANIMATION_END = $0c49c351e4bf4c9d$var$getVendorPrefixedEventName("animationend"), $0c49c351e4bf4c9d$var$ANIMATION_ITERATION = $0c49c351e4bf4c9d$var$getVendorPrefixedEventName("animationiteration"), $0c49c351e4bf4c9d$var$ANIMATION_START = $0c49c351e4bf4c9d$var$getVendorPrefixedEventName("animationstart"), $0c49c351e4bf4c9d$var$TRANSITION_RUN = $0c49c351e4bf4c9d$var$getVendorPrefixedEventName("transitionrun"), $0c49c351e4bf4c9d$var$TRANSITION_START = $0c49c351e4bf4c9d$var$getVendorPrefixedEventName("transitionstart"), $0c49c351e4bf4c9d$var$TRANSITION_CANCEL = $0c49c351e4bf4c9d$var$getVendorPrefixedEventName("transitioncancel"), $0c49c351e4bf4c9d$var$TRANSITION_END = $0c49c351e4bf4c9d$var$getVendorPrefixedEventName("transitionend"), $0c49c351e4bf4c9d$var$topLevelEventsToReactNames = new Map(), $0c49c351e4bf4c9d$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$0c49c351e4bf4c9d$var$simpleEventPluginEvents.push("scrollEnd");
function $0c49c351e4bf4c9d$var$registerSimpleEvent(domEventName, reactName) {
    $0c49c351e4bf4c9d$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $0c49c351e4bf4c9d$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $0c49c351e4bf4c9d$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $0c49c351e4bf4c9d$var$concurrentQueues = [], $0c49c351e4bf4c9d$var$concurrentQueuesIndex = 0, $0c49c351e4bf4c9d$var$concurrentlyUpdatedLanes = 0;
function $0c49c351e4bf4c9d$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $0c49c351e4bf4c9d$var$concurrentQueuesIndex, i = $0c49c351e4bf4c9d$var$concurrentlyUpdatedLanes = $0c49c351e4bf4c9d$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $0c49c351e4bf4c9d$var$concurrentQueues[i];
        $0c49c351e4bf4c9d$var$concurrentQueues[i++] = null;
        var queue = $0c49c351e4bf4c9d$var$concurrentQueues[i];
        $0c49c351e4bf4c9d$var$concurrentQueues[i++] = null;
        var update = $0c49c351e4bf4c9d$var$concurrentQueues[i];
        $0c49c351e4bf4c9d$var$concurrentQueues[i++] = null;
        var lane = $0c49c351e4bf4c9d$var$concurrentQueues[i];
        $0c49c351e4bf4c9d$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $0c49c351e4bf4c9d$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $0c49c351e4bf4c9d$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $0c49c351e4bf4c9d$var$concurrentQueues[$0c49c351e4bf4c9d$var$concurrentQueuesIndex++] = fiber;
    $0c49c351e4bf4c9d$var$concurrentQueues[$0c49c351e4bf4c9d$var$concurrentQueuesIndex++] = queue;
    $0c49c351e4bf4c9d$var$concurrentQueues[$0c49c351e4bf4c9d$var$concurrentQueuesIndex++] = update;
    $0c49c351e4bf4c9d$var$concurrentQueues[$0c49c351e4bf4c9d$var$concurrentQueuesIndex++] = lane;
    $0c49c351e4bf4c9d$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $0c49c351e4bf4c9d$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $0c49c351e4bf4c9d$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $0c49c351e4bf4c9d$var$getRootForUpdatedFiber(fiber);
}
function $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $0c49c351e4bf4c9d$var$enqueueUpdate$1(fiber, null, null, lane);
    return $0c49c351e4bf4c9d$var$getRootForUpdatedFiber(fiber);
}
function $0c49c351e4bf4c9d$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $0c49c351e4bf4c9d$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $0c49c351e4bf4c9d$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $0c49c351e4bf4c9d$var$nestedUpdateCount) throw $0c49c351e4bf4c9d$var$nestedUpdateCount = 0, $0c49c351e4bf4c9d$var$rootWithNestedUpdates = null, Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $0c49c351e4bf4c9d$var$emptyContextObject = {};
function $0c49c351e4bf4c9d$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0c49c351e4bf4c9d$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $0c49c351e4bf4c9d$var$FiberNode(tag, pendingProps, key, mode);
}
function $0c49c351e4bf4c9d$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $0c49c351e4bf4c9d$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $0c49c351e4bf4c9d$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $0c49c351e4bf4c9d$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $0c49c351e4bf4c9d$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $0c49c351e4bf4c9d$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $0c49c351e4bf4c9d$var$isHostHoistableType(type, pendingProps, $0c49c351e4bf4c9d$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $0c49c351e4bf4c9d$var$REACT_ACTIVITY_TYPE:
            return type = $0c49c351e4bf4c9d$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $0c49c351e4bf4c9d$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $0c49c351e4bf4c9d$var$REACT_FRAGMENT_TYPE:
            return $0c49c351e4bf4c9d$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $0c49c351e4bf4c9d$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $0c49c351e4bf4c9d$var$REACT_PROFILER_TYPE:
            return type = $0c49c351e4bf4c9d$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $0c49c351e4bf4c9d$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $0c49c351e4bf4c9d$var$REACT_SUSPENSE_TYPE:
            return type = $0c49c351e4bf4c9d$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $0c49c351e4bf4c9d$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $0c49c351e4bf4c9d$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $0c49c351e4bf4c9d$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $0c49c351e4bf4c9d$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $0c49c351e4bf4c9d$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $0c49c351e4bf4c9d$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $0c49c351e4bf4c9d$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $0c49c351e4bf4c9d$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $0c49c351e4bf4c9d$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $0c49c351e4bf4c9d$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $0c49c351e4bf4c9d$var$createFiberFromText(content, mode, lanes) {
    content = $0c49c351e4bf4c9d$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $0c49c351e4bf4c9d$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $0c49c351e4bf4c9d$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $0c49c351e4bf4c9d$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $0c49c351e4bf4c9d$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $0c49c351e4bf4c9d$var$CapturedStacks = new WeakMap();
function $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $0c49c351e4bf4c9d$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $0c49c351e4bf4c9d$var$getStackByFiberInDevAndProd(source)
        };
        $0c49c351e4bf4c9d$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $0c49c351e4bf4c9d$var$getStackByFiberInDevAndProd(source)
    };
}
var $0c49c351e4bf4c9d$var$forkStack = [], $0c49c351e4bf4c9d$var$forkStackIndex = 0, $0c49c351e4bf4c9d$var$treeForkProvider = null, $0c49c351e4bf4c9d$var$treeForkCount = 0, $0c49c351e4bf4c9d$var$idStack = [], $0c49c351e4bf4c9d$var$idStackIndex = 0, $0c49c351e4bf4c9d$var$treeContextProvider = null, $0c49c351e4bf4c9d$var$treeContextId = 1, $0c49c351e4bf4c9d$var$treeContextOverflow = "";
function $0c49c351e4bf4c9d$var$pushTreeFork(workInProgress, totalChildren) {
    $0c49c351e4bf4c9d$var$forkStack[$0c49c351e4bf4c9d$var$forkStackIndex++] = $0c49c351e4bf4c9d$var$treeForkCount;
    $0c49c351e4bf4c9d$var$forkStack[$0c49c351e4bf4c9d$var$forkStackIndex++] = $0c49c351e4bf4c9d$var$treeForkProvider;
    $0c49c351e4bf4c9d$var$treeForkProvider = workInProgress;
    $0c49c351e4bf4c9d$var$treeForkCount = totalChildren;
}
function $0c49c351e4bf4c9d$var$pushTreeId(workInProgress, totalChildren, index) {
    $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex++] = $0c49c351e4bf4c9d$var$treeContextId;
    $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex++] = $0c49c351e4bf4c9d$var$treeContextOverflow;
    $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex++] = $0c49c351e4bf4c9d$var$treeContextProvider;
    $0c49c351e4bf4c9d$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $0c49c351e4bf4c9d$var$treeContextId;
    workInProgress = $0c49c351e4bf4c9d$var$treeContextOverflow;
    var baseLength = 32 - $0c49c351e4bf4c9d$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $0c49c351e4bf4c9d$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $0c49c351e4bf4c9d$var$treeContextId = 1 << 32 - $0c49c351e4bf4c9d$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $0c49c351e4bf4c9d$var$treeContextOverflow = length + workInProgress;
    } else $0c49c351e4bf4c9d$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $0c49c351e4bf4c9d$var$treeContextOverflow = workInProgress;
}
function $0c49c351e4bf4c9d$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($0c49c351e4bf4c9d$var$pushTreeFork(workInProgress, 1), $0c49c351e4bf4c9d$var$pushTreeId(workInProgress, 1, 0));
}
function $0c49c351e4bf4c9d$var$popTreeContext(workInProgress) {
    for(; workInProgress === $0c49c351e4bf4c9d$var$treeForkProvider;)$0c49c351e4bf4c9d$var$treeForkProvider = $0c49c351e4bf4c9d$var$forkStack[--$0c49c351e4bf4c9d$var$forkStackIndex], $0c49c351e4bf4c9d$var$forkStack[$0c49c351e4bf4c9d$var$forkStackIndex] = null, $0c49c351e4bf4c9d$var$treeForkCount = $0c49c351e4bf4c9d$var$forkStack[--$0c49c351e4bf4c9d$var$forkStackIndex], $0c49c351e4bf4c9d$var$forkStack[$0c49c351e4bf4c9d$var$forkStackIndex] = null;
    for(; workInProgress === $0c49c351e4bf4c9d$var$treeContextProvider;)$0c49c351e4bf4c9d$var$treeContextProvider = $0c49c351e4bf4c9d$var$idStack[--$0c49c351e4bf4c9d$var$idStackIndex], $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex] = null, $0c49c351e4bf4c9d$var$treeContextOverflow = $0c49c351e4bf4c9d$var$idStack[--$0c49c351e4bf4c9d$var$idStackIndex], $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex] = null, $0c49c351e4bf4c9d$var$treeContextId = $0c49c351e4bf4c9d$var$idStack[--$0c49c351e4bf4c9d$var$idStackIndex], $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex] = null;
}
function $0c49c351e4bf4c9d$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex++] = $0c49c351e4bf4c9d$var$treeContextId;
    $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex++] = $0c49c351e4bf4c9d$var$treeContextOverflow;
    $0c49c351e4bf4c9d$var$idStack[$0c49c351e4bf4c9d$var$idStackIndex++] = $0c49c351e4bf4c9d$var$treeContextProvider;
    $0c49c351e4bf4c9d$var$treeContextId = suspendedContext.id;
    $0c49c351e4bf4c9d$var$treeContextOverflow = suspendedContext.overflow;
    $0c49c351e4bf4c9d$var$treeContextProvider = workInProgress;
}
var $0c49c351e4bf4c9d$var$hydrationParentFiber = null, $0c49c351e4bf4c9d$var$nextHydratableInstance = null, $0c49c351e4bf4c9d$var$isHydrating = !1, $0c49c351e4bf4c9d$var$hydrationErrors = null, $0c49c351e4bf4c9d$var$rootOrSingletonContext = !1, $0c49c351e4bf4c9d$var$HydrationMismatchException = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(519));
function $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(fiber) {
    var error = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $0c49c351e4bf4c9d$var$queueHydrationError($0c49c351e4bf4c9d$var$createCapturedValueAtFiber(error, fiber));
    throw $0c49c351e4bf4c9d$var$HydrationMismatchException;
}
function $0c49c351e4bf4c9d$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$0c49c351e4bf4c9d$var$internalInstanceKey] = fiber;
    instance[$0c49c351e4bf4c9d$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("cancel", instance);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $0c49c351e4bf4c9d$var$mediaEventTypes.length; type++)$0c49c351e4bf4c9d$var$listenToNonDelegatedEvent($0c49c351e4bf4c9d$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("error", instance);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("invalid", instance);
            $0c49c351e4bf4c9d$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("invalid", instance), $0c49c351e4bf4c9d$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $0c49c351e4bf4c9d$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("beforetoggle", instance), $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $0c49c351e4bf4c9d$var$noop$1), instance = !0) : instance = !1;
    instance || $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(fiber, !0);
}
function $0c49c351e4bf4c9d$var$popToNextHostParent(fiber) {
    for($0c49c351e4bf4c9d$var$hydrationParentFiber = fiber.return; $0c49c351e4bf4c9d$var$hydrationParentFiber;)switch($0c49c351e4bf4c9d$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $0c49c351e4bf4c9d$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $0c49c351e4bf4c9d$var$rootOrSingletonContext = !0;
            return;
        default:
            $0c49c351e4bf4c9d$var$hydrationParentFiber = $0c49c351e4bf4c9d$var$hydrationParentFiber.return;
    }
}
function $0c49c351e4bf4c9d$var$popHydrationState(fiber) {
    if (fiber !== $0c49c351e4bf4c9d$var$hydrationParentFiber) return !1;
    if (!$0c49c351e4bf4c9d$var$isHydrating) return $0c49c351e4bf4c9d$var$popToNextHostParent(fiber), $0c49c351e4bf4c9d$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $0c49c351e4bf4c9d$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $0c49c351e4bf4c9d$var$nextHydratableInstance && $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(fiber);
    $0c49c351e4bf4c9d$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(317));
        $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(317));
        $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $0c49c351e4bf4c9d$var$nextHydratableInstance, $0c49c351e4bf4c9d$var$isSingletonScope(fiber.type) ? (fiber = $0c49c351e4bf4c9d$var$previousHydratableOnEnteringScopedSingleton, $0c49c351e4bf4c9d$var$previousHydratableOnEnteringScopedSingleton = null, $0c49c351e4bf4c9d$var$nextHydratableInstance = fiber) : $0c49c351e4bf4c9d$var$nextHydratableInstance = tag) : $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$hydrationParentFiber ? $0c49c351e4bf4c9d$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $0c49c351e4bf4c9d$var$resetHydrationState() {
    $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$hydrationParentFiber = null;
    $0c49c351e4bf4c9d$var$isHydrating = !1;
}
function $0c49c351e4bf4c9d$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $0c49c351e4bf4c9d$var$hydrationErrors;
    null !== queuedErrors && (null === $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors ? $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors = queuedErrors : $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors.push.apply($0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors, queuedErrors), $0c49c351e4bf4c9d$var$hydrationErrors = null);
    return queuedErrors;
}
function $0c49c351e4bf4c9d$var$queueHydrationError(error) {
    null === $0c49c351e4bf4c9d$var$hydrationErrors ? $0c49c351e4bf4c9d$var$hydrationErrors = [
        error
    ] : $0c49c351e4bf4c9d$var$hydrationErrors.push(error);
}
var $0c49c351e4bf4c9d$var$valueCursor = $0c49c351e4bf4c9d$var$createCursor(null), $0c49c351e4bf4c9d$var$currentlyRenderingFiber$1 = null, $0c49c351e4bf4c9d$var$lastContextDependency = null;
function $0c49c351e4bf4c9d$var$pushProvider(providerFiber, context, nextValue) {
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $0c49c351e4bf4c9d$var$popProvider(context) {
    context._currentValue = $0c49c351e4bf4c9d$var$valueCursor.current;
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$valueCursor);
}
function $0c49c351e4bf4c9d$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $0c49c351e4bf4c9d$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $0c49c351e4bf4c9d$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $0c49c351e4bf4c9d$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $0c49c351e4bf4c9d$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $0c49c351e4bf4c9d$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $0c49c351e4bf4c9d$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($0c49c351e4bf4c9d$var$HostTransitionContext) : current = [
                $0c49c351e4bf4c9d$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $0c49c351e4bf4c9d$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $0c49c351e4bf4c9d$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$0c49c351e4bf4c9d$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $0c49c351e4bf4c9d$var$prepareToReadContext(workInProgress) {
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber$1 = workInProgress;
    $0c49c351e4bf4c9d$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $0c49c351e4bf4c9d$var$readContext(context) {
    return $0c49c351e4bf4c9d$var$readContextForConsumer($0c49c351e4bf4c9d$var$currentlyRenderingFiber$1, context);
}
function $0c49c351e4bf4c9d$var$readContextDuringReconciliation(consumer, context) {
    null === $0c49c351e4bf4c9d$var$currentlyRenderingFiber$1 && $0c49c351e4bf4c9d$var$prepareToReadContext(consumer);
    return $0c49c351e4bf4c9d$var$readContextForConsumer(consumer, context);
}
function $0c49c351e4bf4c9d$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $0c49c351e4bf4c9d$var$lastContextDependency) {
        if (null === consumer) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(308));
        $0c49c351e4bf4c9d$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $0c49c351e4bf4c9d$var$lastContextDependency = $0c49c351e4bf4c9d$var$lastContextDependency.next = context;
    return value;
}
var $0c49c351e4bf4c9d$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $0c49c351e4bf4c9d$var$scheduleCallback$2 = $aDD22.unstable_scheduleCallback, $0c49c351e4bf4c9d$var$NormalPriority = $aDD22.unstable_NormalPriority, $0c49c351e4bf4c9d$var$CacheContext = {
    $$typeof: $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $0c49c351e4bf4c9d$var$createCache() {
    return {
        controller: new $0c49c351e4bf4c9d$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $0c49c351e4bf4c9d$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $0c49c351e4bf4c9d$var$scheduleCallback$2($0c49c351e4bf4c9d$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $0c49c351e4bf4c9d$var$currentEntangledListeners = null, $0c49c351e4bf4c9d$var$currentEntangledPendingCount = 0, $0c49c351e4bf4c9d$var$currentEntangledLane = 0, $0c49c351e4bf4c9d$var$currentEntangledActionThenable = null;
function $0c49c351e4bf4c9d$var$entangleAsyncAction(transition, thenable) {
    if (null === $0c49c351e4bf4c9d$var$currentEntangledListeners) {
        var entangledListeners = $0c49c351e4bf4c9d$var$currentEntangledListeners = [];
        $0c49c351e4bf4c9d$var$currentEntangledPendingCount = 0;
        $0c49c351e4bf4c9d$var$currentEntangledLane = $0c49c351e4bf4c9d$var$requestTransitionLane();
        $0c49c351e4bf4c9d$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $0c49c351e4bf4c9d$var$currentEntangledPendingCount++;
    thenable.then($0c49c351e4bf4c9d$var$pingEngtangledActionScope, $0c49c351e4bf4c9d$var$pingEngtangledActionScope);
    return thenable;
}
function $0c49c351e4bf4c9d$var$pingEngtangledActionScope() {
    if (0 === --$0c49c351e4bf4c9d$var$currentEntangledPendingCount && null !== $0c49c351e4bf4c9d$var$currentEntangledListeners) {
        null !== $0c49c351e4bf4c9d$var$currentEntangledActionThenable && ($0c49c351e4bf4c9d$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $0c49c351e4bf4c9d$var$currentEntangledListeners;
        $0c49c351e4bf4c9d$var$currentEntangledListeners = null;
        $0c49c351e4bf4c9d$var$currentEntangledLane = 0;
        $0c49c351e4bf4c9d$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $0c49c351e4bf4c9d$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $0c49c351e4bf4c9d$var$prevOnStartTransitionFinish = $0c49c351e4bf4c9d$var$ReactSharedInternals.S;
$0c49c351e4bf4c9d$var$ReactSharedInternals.S = function(transition, returnValue) {
    $0c49c351e4bf4c9d$var$globalMostRecentTransitionTime = $0c49c351e4bf4c9d$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $0c49c351e4bf4c9d$var$entangleAsyncAction(transition, returnValue);
    null !== $0c49c351e4bf4c9d$var$prevOnStartTransitionFinish && $0c49c351e4bf4c9d$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $0c49c351e4bf4c9d$var$resumedCache = $0c49c351e4bf4c9d$var$createCursor(null);
function $0c49c351e4bf4c9d$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $0c49c351e4bf4c9d$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $0c49c351e4bf4c9d$var$workInProgressRoot.pooledCache;
}
function $0c49c351e4bf4c9d$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$resumedCache, $0c49c351e4bf4c9d$var$resumedCache.current) : $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$resumedCache, prevCachePool.pool);
}
function $0c49c351e4bf4c9d$var$getSuspendedCache() {
    var cacheFromPool = $0c49c351e4bf4c9d$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $0c49c351e4bf4c9d$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $0c49c351e4bf4c9d$var$SuspenseException = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(460)), $0c49c351e4bf4c9d$var$SuspenseyCommitException = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(474)), $0c49c351e4bf4c9d$var$SuspenseActionException = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(542)), $0c49c351e4bf4c9d$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $0c49c351e4bf4c9d$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $0c49c351e4bf4c9d$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($0c49c351e4bf4c9d$var$noop$1, $0c49c351e4bf4c9d$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $0c49c351e4bf4c9d$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($0c49c351e4bf4c9d$var$noop$1, $0c49c351e4bf4c9d$var$noop$1);
            else {
                thenableState = $0c49c351e4bf4c9d$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $0c49c351e4bf4c9d$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $0c49c351e4bf4c9d$var$suspendedThenable = thenable;
            throw $0c49c351e4bf4c9d$var$SuspenseException;
    }
}
function $0c49c351e4bf4c9d$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $0c49c351e4bf4c9d$var$suspendedThenable = x, $0c49c351e4bf4c9d$var$SuspenseException;
        throw x;
    }
}
var $0c49c351e4bf4c9d$var$suspendedThenable = null;
function $0c49c351e4bf4c9d$var$getSuspendedThenable() {
    if (null === $0c49c351e4bf4c9d$var$suspendedThenable) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(459));
    var thenable = $0c49c351e4bf4c9d$var$suspendedThenable;
    $0c49c351e4bf4c9d$var$suspendedThenable = null;
    return thenable;
}
function $0c49c351e4bf4c9d$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $0c49c351e4bf4c9d$var$SuspenseException || rejectedReason === $0c49c351e4bf4c9d$var$SuspenseActionException) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(483));
}
var $0c49c351e4bf4c9d$var$thenableState$1 = null, $0c49c351e4bf4c9d$var$thenableIndexCounter$1 = 0;
function $0c49c351e4bf4c9d$var$unwrapThenable(thenable) {
    var index = $0c49c351e4bf4c9d$var$thenableIndexCounter$1;
    $0c49c351e4bf4c9d$var$thenableIndexCounter$1 += 1;
    null === $0c49c351e4bf4c9d$var$thenableState$1 && ($0c49c351e4bf4c9d$var$thenableState$1 = []);
    return $0c49c351e4bf4c9d$var$trackUsedThenable($0c49c351e4bf4c9d$var$thenableState$1, thenable, index);
}
function $0c49c351e4bf4c9d$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $0c49c351e4bf4c9d$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $0c49c351e4bf4c9d$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $0c49c351e4bf4c9d$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $0c49c351e4bf4c9d$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $0c49c351e4bf4c9d$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $0c49c351e4bf4c9d$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE && $0c49c351e4bf4c9d$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $0c49c351e4bf4c9d$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $0c49c351e4bf4c9d$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $0c49c351e4bf4c9d$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $0c49c351e4bf4c9d$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $0c49c351e4bf4c9d$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $0c49c351e4bf4c9d$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c49c351e4bf4c9d$var$REACT_ELEMENT_TYPE:
                    return lanes = $0c49c351e4bf4c9d$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $0c49c351e4bf4c9d$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $0c49c351e4bf4c9d$var$REACT_PORTAL_TYPE:
                    return newChild = $0c49c351e4bf4c9d$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE:
                    return newChild = $0c49c351e4bf4c9d$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($0c49c351e4bf4c9d$var$isArrayImpl(newChild) || $0c49c351e4bf4c9d$var$getIteratorFn(newChild)) return newChild = $0c49c351e4bf4c9d$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $0c49c351e4bf4c9d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $0c49c351e4bf4c9d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c49c351e4bf4c9d$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c49c351e4bf4c9d$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $0c49c351e4bf4c9d$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE:
                    return newChild = $0c49c351e4bf4c9d$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($0c49c351e4bf4c9d$var$isArrayImpl(newChild) || $0c49c351e4bf4c9d$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $0c49c351e4bf4c9d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $0c49c351e4bf4c9d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c49c351e4bf4c9d$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c49c351e4bf4c9d$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $0c49c351e4bf4c9d$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE:
                    return newChild = $0c49c351e4bf4c9d$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($0c49c351e4bf4c9d$var$isArrayImpl(newChild) || $0c49c351e4bf4c9d$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $0c49c351e4bf4c9d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $0c49c351e4bf4c9d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c49c351e4bf4c9d$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $0c49c351e4bf4c9d$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c49c351e4bf4c9d$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $0c49c351e4bf4c9d$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE && $0c49c351e4bf4c9d$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $0c49c351e4bf4c9d$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $0c49c351e4bf4c9d$var$REACT_FRAGMENT_TYPE ? (lanes = $0c49c351e4bf4c9d$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $0c49c351e4bf4c9d$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $0c49c351e4bf4c9d$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $0c49c351e4bf4c9d$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $0c49c351e4bf4c9d$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $0c49c351e4bf4c9d$var$REACT_LAZY_TYPE:
                    return newChild = $0c49c351e4bf4c9d$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($0c49c351e4bf4c9d$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($0c49c351e4bf4c9d$var$getIteratorFn(newChild)) {
                key = $0c49c351e4bf4c9d$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $0c49c351e4bf4c9d$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $0c49c351e4bf4c9d$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c49c351e4bf4c9d$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $0c49c351e4bf4c9d$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $0c49c351e4bf4c9d$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $0c49c351e4bf4c9d$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $0c49c351e4bf4c9d$var$SuspenseException || x === $0c49c351e4bf4c9d$var$SuspenseActionException) throw x;
            var fiber = $0c49c351e4bf4c9d$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $0c49c351e4bf4c9d$var$reconcileChildFibers = $0c49c351e4bf4c9d$var$createChildReconciler(!0), $0c49c351e4bf4c9d$var$mountChildFibers = $0c49c351e4bf4c9d$var$createChildReconciler(!1), $0c49c351e4bf4c9d$var$hasForceUpdate = !1;
function $0c49c351e4bf4c9d$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $0c49c351e4bf4c9d$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $0c49c351e4bf4c9d$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0c49c351e4bf4c9d$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($0c49c351e4bf4c9d$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $0c49c351e4bf4c9d$var$getRootForUpdatedFiber(fiber);
        $0c49c351e4bf4c9d$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $0c49c351e4bf4c9d$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $0c49c351e4bf4c9d$var$getRootForUpdatedFiber(fiber);
}
function $0c49c351e4bf4c9d$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $0c49c351e4bf4c9d$var$markRootEntangled(root, lane);
    }
}
function $0c49c351e4bf4c9d$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $0c49c351e4bf4c9d$var$didReadFromEntangledAsyncAction = !1;
function $0c49c351e4bf4c9d$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($0c49c351e4bf4c9d$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $0c49c351e4bf4c9d$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $0c49c351e4bf4c9d$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $0c49c351e4bf4c9d$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $0c49c351e4bf4c9d$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $0c49c351e4bf4c9d$var$currentEntangledLane && ($0c49c351e4bf4c9d$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $0c49c351e4bf4c9d$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $0c49c351e4bf4c9d$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $0c49c351e4bf4c9d$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $0c49c351e4bf4c9d$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$0c49c351e4bf4c9d$var$callCallback(callbacks[updateQueue], context);
}
var $0c49c351e4bf4c9d$var$currentTreeHiddenStackCursor = $0c49c351e4bf4c9d$var$createCursor(null), $0c49c351e4bf4c9d$var$prevEntangledRenderLanesCursor = $0c49c351e4bf4c9d$var$createCursor(0);
function $0c49c351e4bf4c9d$var$pushHiddenContext(fiber, context) {
    fiber = $0c49c351e4bf4c9d$var$entangledRenderLanes;
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$prevEntangledRenderLanesCursor, fiber);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$currentTreeHiddenStackCursor, context);
    $0c49c351e4bf4c9d$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $0c49c351e4bf4c9d$var$reuseHiddenContextOnStack() {
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$prevEntangledRenderLanesCursor, $0c49c351e4bf4c9d$var$entangledRenderLanes);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$currentTreeHiddenStackCursor, $0c49c351e4bf4c9d$var$currentTreeHiddenStackCursor.current);
}
function $0c49c351e4bf4c9d$var$popHiddenContext() {
    $0c49c351e4bf4c9d$var$entangledRenderLanes = $0c49c351e4bf4c9d$var$prevEntangledRenderLanesCursor.current;
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$currentTreeHiddenStackCursor);
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$prevEntangledRenderLanesCursor);
}
var $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor = $0c49c351e4bf4c9d$var$createCursor(null), $0c49c351e4bf4c9d$var$shellBoundary = null;
function $0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, $0c49c351e4bf4c9d$var$suspenseStackCursor.current & 1);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseHandlerStackCursor, handler);
    null === $0c49c351e4bf4c9d$var$shellBoundary && (null === current || null !== $0c49c351e4bf4c9d$var$currentTreeHiddenStackCursor.current ? $0c49c351e4bf4c9d$var$shellBoundary = handler : null !== current.memoizedState && ($0c49c351e4bf4c9d$var$shellBoundary = handler));
}
function $0c49c351e4bf4c9d$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, $0c49c351e4bf4c9d$var$suspenseStackCursor.current);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseHandlerStackCursor, fiber);
    null === $0c49c351e4bf4c9d$var$shellBoundary && ($0c49c351e4bf4c9d$var$shellBoundary = fiber);
}
function $0c49c351e4bf4c9d$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, $0c49c351e4bf4c9d$var$suspenseStackCursor.current), $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseHandlerStackCursor, fiber), null === $0c49c351e4bf4c9d$var$shellBoundary && ($0c49c351e4bf4c9d$var$shellBoundary = fiber)) : $0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(fiber);
}
function $0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack() {
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, $0c49c351e4bf4c9d$var$suspenseStackCursor.current);
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseHandlerStackCursor, $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current);
}
function $0c49c351e4bf4c9d$var$popSuspenseHandler(fiber) {
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$suspenseHandlerStackCursor);
    $0c49c351e4bf4c9d$var$shellBoundary === fiber && ($0c49c351e4bf4c9d$var$shellBoundary = null);
    $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$suspenseStackCursor);
}
var $0c49c351e4bf4c9d$var$suspenseStackCursor = $0c49c351e4bf4c9d$var$createCursor(0);
function $0c49c351e4bf4c9d$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $0c49c351e4bf4c9d$var$isSuspenseInstancePending(state) || $0c49c351e4bf4c9d$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $0c49c351e4bf4c9d$var$renderLanes = 0, $0c49c351e4bf4c9d$var$currentlyRenderingFiber = null, $0c49c351e4bf4c9d$var$currentHook = null, $0c49c351e4bf4c9d$var$workInProgressHook = null, $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdate = !1, $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $0c49c351e4bf4c9d$var$localIdCounter = 0, $0c49c351e4bf4c9d$var$thenableIndexCounter = 0, $0c49c351e4bf4c9d$var$thenableState = null, $0c49c351e4bf4c9d$var$globalClientIdCounter = 0;
function $0c49c351e4bf4c9d$var$throwInvalidHookError() {
    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(321));
}
function $0c49c351e4bf4c9d$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$0c49c351e4bf4c9d$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $0c49c351e4bf4c9d$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $0c49c351e4bf4c9d$var$renderLanes = nextRenderLanes;
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $0c49c351e4bf4c9d$var$HooksDispatcherOnMount : $0c49c351e4bf4c9d$var$HooksDispatcherOnUpdate;
    $0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $0c49c351e4bf4c9d$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $0c49c351e4bf4c9d$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $0c49c351e4bf4c9d$var$finishRenderingHooks(current) {
    $0c49c351e4bf4c9d$var$ReactSharedInternals.H = $0c49c351e4bf4c9d$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $0c49c351e4bf4c9d$var$currentHook && null !== $0c49c351e4bf4c9d$var$currentHook.next;
    $0c49c351e4bf4c9d$var$renderLanes = 0;
    $0c49c351e4bf4c9d$var$workInProgressHook = $0c49c351e4bf4c9d$var$currentHook = $0c49c351e4bf4c9d$var$currentlyRenderingFiber = null;
    $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdate = !1;
    $0c49c351e4bf4c9d$var$thenableIndexCounter = 0;
    $0c49c351e4bf4c9d$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(300));
    null === current || $0c49c351e4bf4c9d$var$didReceiveUpdate || (current = current.dependencies, null !== current && $0c49c351e4bf4c9d$var$checkIfContextChanged(current) && ($0c49c351e4bf4c9d$var$didReceiveUpdate = !0));
}
function $0c49c351e4bf4c9d$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdateDuringThisPass && ($0c49c351e4bf4c9d$var$thenableState = null);
        $0c49c351e4bf4c9d$var$thenableIndexCounter = 0;
        $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $0c49c351e4bf4c9d$var$workInProgressHook = $0c49c351e4bf4c9d$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $0c49c351e4bf4c9d$var$ReactSharedInternals.H = $0c49c351e4bf4c9d$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $0c49c351e4bf4c9d$var$TransitionAwareHostComponent() {
    var dispatcher = $0c49c351e4bf4c9d$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $0c49c351e4bf4c9d$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $0c49c351e4bf4c9d$var$currentHook ? $0c49c351e4bf4c9d$var$currentHook.memoizedState : null) !== dispatcher && ($0c49c351e4bf4c9d$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $0c49c351e4bf4c9d$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $0c49c351e4bf4c9d$var$localIdCounter;
    $0c49c351e4bf4c9d$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $0c49c351e4bf4c9d$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $0c49c351e4bf4c9d$var$resetHooksOnUnwind(workInProgress) {
    if ($0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdate = !1;
    }
    $0c49c351e4bf4c9d$var$renderLanes = 0;
    $0c49c351e4bf4c9d$var$workInProgressHook = $0c49c351e4bf4c9d$var$currentHook = $0c49c351e4bf4c9d$var$currentlyRenderingFiber = null;
    $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $0c49c351e4bf4c9d$var$thenableIndexCounter = $0c49c351e4bf4c9d$var$localIdCounter = 0;
    $0c49c351e4bf4c9d$var$thenableState = null;
}
function $0c49c351e4bf4c9d$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0c49c351e4bf4c9d$var$workInProgressHook ? $0c49c351e4bf4c9d$var$currentlyRenderingFiber.memoizedState = $0c49c351e4bf4c9d$var$workInProgressHook = hook : $0c49c351e4bf4c9d$var$workInProgressHook = $0c49c351e4bf4c9d$var$workInProgressHook.next = hook;
    return $0c49c351e4bf4c9d$var$workInProgressHook;
}
function $0c49c351e4bf4c9d$var$updateWorkInProgressHook() {
    if (null === $0c49c351e4bf4c9d$var$currentHook) {
        var nextCurrentHook = $0c49c351e4bf4c9d$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $0c49c351e4bf4c9d$var$currentHook.next;
    var nextWorkInProgressHook = null === $0c49c351e4bf4c9d$var$workInProgressHook ? $0c49c351e4bf4c9d$var$currentlyRenderingFiber.memoizedState : $0c49c351e4bf4c9d$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $0c49c351e4bf4c9d$var$workInProgressHook = nextWorkInProgressHook, $0c49c351e4bf4c9d$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $0c49c351e4bf4c9d$var$currentlyRenderingFiber.alternate) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(467));
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(310));
        }
        $0c49c351e4bf4c9d$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $0c49c351e4bf4c9d$var$currentHook.memoizedState,
            baseState: $0c49c351e4bf4c9d$var$currentHook.baseState,
            baseQueue: $0c49c351e4bf4c9d$var$currentHook.baseQueue,
            queue: $0c49c351e4bf4c9d$var$currentHook.queue,
            next: null
        };
        null === $0c49c351e4bf4c9d$var$workInProgressHook ? $0c49c351e4bf4c9d$var$currentlyRenderingFiber.memoizedState = $0c49c351e4bf4c9d$var$workInProgressHook = nextCurrentHook : $0c49c351e4bf4c9d$var$workInProgressHook = $0c49c351e4bf4c9d$var$workInProgressHook.next = nextCurrentHook;
    }
    return $0c49c351e4bf4c9d$var$workInProgressHook;
}
function $0c49c351e4bf4c9d$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $0c49c351e4bf4c9d$var$useThenable(thenable) {
    var index = $0c49c351e4bf4c9d$var$thenableIndexCounter;
    $0c49c351e4bf4c9d$var$thenableIndexCounter += 1;
    null === $0c49c351e4bf4c9d$var$thenableState && ($0c49c351e4bf4c9d$var$thenableState = []);
    thenable = $0c49c351e4bf4c9d$var$trackUsedThenable($0c49c351e4bf4c9d$var$thenableState, thenable, index);
    index = $0c49c351e4bf4c9d$var$currentlyRenderingFiber;
    null === (null === $0c49c351e4bf4c9d$var$workInProgressHook ? index.memoizedState : $0c49c351e4bf4c9d$var$workInProgressHook.next) && (index = index.alternate, $0c49c351e4bf4c9d$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $0c49c351e4bf4c9d$var$HooksDispatcherOnMount : $0c49c351e4bf4c9d$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $0c49c351e4bf4c9d$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $0c49c351e4bf4c9d$var$useThenable(usable);
        if (usable.$$typeof === $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE) return $0c49c351e4bf4c9d$var$readContext(usable);
    }
    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(438, String(usable)));
}
function $0c49c351e4bf4c9d$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $0c49c351e4bf4c9d$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $0c49c351e4bf4c9d$var$createFunctionComponentUpdateQueue(), $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $0c49c351e4bf4c9d$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $0c49c351e4bf4c9d$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $0c49c351e4bf4c9d$var$updateReducer(reducer) {
    var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    return $0c49c351e4bf4c9d$var$updateReducerImpl(hook, $0c49c351e4bf4c9d$var$currentHook, reducer);
}
function $0c49c351e4bf4c9d$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($0c49c351e4bf4c9d$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $0c49c351e4bf4c9d$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($0c49c351e4bf4c9d$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $0c49c351e4bf4c9d$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $0c49c351e4bf4c9d$var$currentlyRenderingFiber.lanes |= revertLane, $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $0c49c351e4bf4c9d$var$currentlyRenderingFiber.lanes |= updateLane, $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$0c49c351e4bf4c9d$var$objectIs(pendingQueue, hook.memoizedState) && ($0c49c351e4bf4c9d$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $0c49c351e4bf4c9d$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $0c49c351e4bf4c9d$var$rerenderReducer(reducer) {
    var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $0c49c351e4bf4c9d$var$objectIs(newState, hook.memoizedState) || ($0c49c351e4bf4c9d$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $0c49c351e4bf4c9d$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $0c49c351e4bf4c9d$var$currentlyRenderingFiber, hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $0c49c351e4bf4c9d$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$0c49c351e4bf4c9d$var$objectIs(($0c49c351e4bf4c9d$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $0c49c351e4bf4c9d$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $0c49c351e4bf4c9d$var$updateEffect($0c49c351e4bf4c9d$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $0c49c351e4bf4c9d$var$workInProgressHook && $0c49c351e4bf4c9d$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $0c49c351e4bf4c9d$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $0c49c351e4bf4c9d$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $0c49c351e4bf4c9d$var$workInProgressRoot) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($0c49c351e4bf4c9d$var$renderLanes & 127) || $0c49c351e4bf4c9d$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $0c49c351e4bf4c9d$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $0c49c351e4bf4c9d$var$createFunctionComponentUpdateQueue(), $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $0c49c351e4bf4c9d$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $0c49c351e4bf4c9d$var$checkIfSnapshotChanged(inst) && $0c49c351e4bf4c9d$var$forceStoreRerender(fiber);
}
function $0c49c351e4bf4c9d$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $0c49c351e4bf4c9d$var$checkIfSnapshotChanged(inst) && $0c49c351e4bf4c9d$var$forceStoreRerender(fiber);
    });
}
function $0c49c351e4bf4c9d$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$0c49c351e4bf4c9d$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $0c49c351e4bf4c9d$var$forceStoreRerender(fiber) {
    var root = $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $0c49c351e4bf4c9d$var$mountStateImpl(initialState) {
    var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0c49c351e4bf4c9d$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $0c49c351e4bf4c9d$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $0c49c351e4bf4c9d$var$updateReducerImpl(hook, $0c49c351e4bf4c9d$var$currentHook, "function" === typeof reducer ? reducer : $0c49c351e4bf4c9d$var$basicStateReducer);
}
function $0c49c351e4bf4c9d$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($0c49c351e4bf4c9d$var$isRenderPhaseUpdate(fiber)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $0c49c351e4bf4c9d$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $0c49c351e4bf4c9d$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $0c49c351e4bf4c9d$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $0c49c351e4bf4c9d$var$ReactSharedInternals.T, currentTransition = {};
        $0c49c351e4bf4c9d$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $0c49c351e4bf4c9d$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $0c49c351e4bf4c9d$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $0c49c351e4bf4c9d$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $0c49c351e4bf4c9d$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $0c49c351e4bf4c9d$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $0c49c351e4bf4c9d$var$onActionError(actionQueue, node, error$66);
    }
}
function $0c49c351e4bf4c9d$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $0c49c351e4bf4c9d$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $0c49c351e4bf4c9d$var$onActionError(actionQueue, node, error);
    }) : $0c49c351e4bf4c9d$var$onActionSuccess(actionQueue, node, returnValue);
}
function $0c49c351e4bf4c9d$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $0c49c351e4bf4c9d$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $0c49c351e4bf4c9d$var$runActionStateAction(actionQueue, nextState)));
}
function $0c49c351e4bf4c9d$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $0c49c351e4bf4c9d$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $0c49c351e4bf4c9d$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $0c49c351e4bf4c9d$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $0c49c351e4bf4c9d$var$mountActionState(action, initialStateProp) {
    if ($0c49c351e4bf4c9d$var$isHydrating) {
        var ssrFormState = $0c49c351e4bf4c9d$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $0c49c351e4bf4c9d$var$currentlyRenderingFiber;
                if ($0c49c351e4bf4c9d$var$isHydrating) {
                    if ($0c49c351e4bf4c9d$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $0c49c351e4bf4c9d$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $0c49c351e4bf4c9d$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $0c49c351e4bf4c9d$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0c49c351e4bf4c9d$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $0c49c351e4bf4c9d$var$dispatchSetState.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $0c49c351e4bf4c9d$var$mountStateImpl(!1);
    inRootOrSingleton = $0c49c351e4bf4c9d$var$dispatchOptimisticSetState.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $0c49c351e4bf4c9d$var$dispatchActionState.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $0c49c351e4bf4c9d$var$updateActionState(action) {
    var stateHook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    return $0c49c351e4bf4c9d$var$updateActionStateImpl(stateHook, $0c49c351e4bf4c9d$var$currentHook, action);
}
function $0c49c351e4bf4c9d$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $0c49c351e4bf4c9d$var$updateReducerImpl(stateHook, currentStateHook, $0c49c351e4bf4c9d$var$actionStateReducer)[0];
    stateHook = $0c49c351e4bf4c9d$var$updateReducer($0c49c351e4bf4c9d$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $0c49c351e4bf4c9d$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $0c49c351e4bf4c9d$var$SuspenseException) throw $0c49c351e4bf4c9d$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($0c49c351e4bf4c9d$var$currentlyRenderingFiber.flags |= 2048, $0c49c351e4bf4c9d$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $0c49c351e4bf4c9d$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $0c49c351e4bf4c9d$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $0c49c351e4bf4c9d$var$rerenderActionState(action) {
    var stateHook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook(), currentStateHook = $0c49c351e4bf4c9d$var$currentHook;
    if (null !== currentStateHook) return $0c49c351e4bf4c9d$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $0c49c351e4bf4c9d$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $0c49c351e4bf4c9d$var$createFunctionComponentUpdateQueue(), $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $0c49c351e4bf4c9d$var$updateRef() {
    return $0c49c351e4bf4c9d$var$updateWorkInProgressHook().memoizedState;
}
function $0c49c351e4bf4c9d$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $0c49c351e4bf4c9d$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $0c49c351e4bf4c9d$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $0c49c351e4bf4c9d$var$currentHook && null !== deps && $0c49c351e4bf4c9d$var$areHookInputsEqual(deps, $0c49c351e4bf4c9d$var$currentHook.memoizedState.deps) ? hook.memoizedState = $0c49c351e4bf4c9d$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($0c49c351e4bf4c9d$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $0c49c351e4bf4c9d$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $0c49c351e4bf4c9d$var$mountEffect(create, deps) {
    $0c49c351e4bf4c9d$var$mountEffectImpl(8390656, 8, create, deps);
}
function $0c49c351e4bf4c9d$var$updateEffect(create, deps) {
    $0c49c351e4bf4c9d$var$updateEffectImpl(2048, 8, create, deps);
}
function $0c49c351e4bf4c9d$var$useEffectEventImpl(payload) {
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $0c49c351e4bf4c9d$var$createFunctionComponentUpdateQueue(), $0c49c351e4bf4c9d$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $0c49c351e4bf4c9d$var$updateEvent(callback) {
    var ref = $0c49c351e4bf4c9d$var$updateWorkInProgressHook().memoizedState;
    $0c49c351e4bf4c9d$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($0c49c351e4bf4c9d$var$executionContext & 2)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $0c49c351e4bf4c9d$var$updateInsertionEffect(create, deps) {
    return $0c49c351e4bf4c9d$var$updateEffectImpl(4, 2, create, deps);
}
function $0c49c351e4bf4c9d$var$updateLayoutEffect(create, deps) {
    return $0c49c351e4bf4c9d$var$updateEffectImpl(4, 4, create, deps);
}
function $0c49c351e4bf4c9d$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $0c49c351e4bf4c9d$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $0c49c351e4bf4c9d$var$updateEffectImpl(4, 4, $0c49c351e4bf4c9d$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $0c49c351e4bf4c9d$var$mountDebugValue() {}
function $0c49c351e4bf4c9d$var$updateCallback(callback, deps) {
    var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $0c49c351e4bf4c9d$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $0c49c351e4bf4c9d$var$updateMemo(nextCreate, deps) {
    var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $0c49c351e4bf4c9d$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $0c49c351e4bf4c9d$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($0c49c351e4bf4c9d$var$renderLanes & 1073741824) && 0 === ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $0c49c351e4bf4c9d$var$requestDeferredLane();
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber.lanes |= hook;
    $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $0c49c351e4bf4c9d$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($0c49c351e4bf4c9d$var$objectIs(value, prevValue)) return value;
    if (null !== $0c49c351e4bf4c9d$var$currentTreeHiddenStackCursor.current) return hook = $0c49c351e4bf4c9d$var$mountDeferredValueImpl(hook, value, initialValue), $0c49c351e4bf4c9d$var$objectIs(hook, prevValue) || ($0c49c351e4bf4c9d$var$didReceiveUpdate = !0), hook;
    if (0 === ($0c49c351e4bf4c9d$var$renderLanes & 42) || 0 !== ($0c49c351e4bf4c9d$var$renderLanes & 1073741824) && 0 === ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 261930)) return $0c49c351e4bf4c9d$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $0c49c351e4bf4c9d$var$requestDeferredLane();
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber.lanes |= hook;
    $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $0c49c351e4bf4c9d$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
    $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $0c49c351e4bf4c9d$var$ReactSharedInternals.T, currentTransition = {};
    $0c49c351e4bf4c9d$var$ReactSharedInternals.T = currentTransition;
    $0c49c351e4bf4c9d$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $0c49c351e4bf4c9d$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $0c49c351e4bf4c9d$var$chainThenableValue(returnValue, finishedState);
            $0c49c351e4bf4c9d$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $0c49c351e4bf4c9d$var$requestUpdateLane(fiber));
        } else $0c49c351e4bf4c9d$var$dispatchSetStateInternal(fiber, queue, finishedState, $0c49c351e4bf4c9d$var$requestUpdateLane(fiber));
    } catch (error) {
        $0c49c351e4bf4c9d$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $0c49c351e4bf4c9d$var$requestUpdateLane());
    } finally{
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $0c49c351e4bf4c9d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $0c49c351e4bf4c9d$var$noop() {}
function $0c49c351e4bf4c9d$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(476));
    var queue = $0c49c351e4bf4c9d$var$ensureFormComponentIsStateful(formFiber).queue;
    $0c49c351e4bf4c9d$var$startTransition(formFiber, queue, pendingState, $0c49c351e4bf4c9d$var$sharedNotPendingObject, null === action ? $0c49c351e4bf4c9d$var$noop : function() {
        $0c49c351e4bf4c9d$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $0c49c351e4bf4c9d$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $0c49c351e4bf4c9d$var$sharedNotPendingObject,
        baseState: $0c49c351e4bf4c9d$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $0c49c351e4bf4c9d$var$basicStateReducer,
            lastRenderedState: $0c49c351e4bf4c9d$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $0c49c351e4bf4c9d$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $0c49c351e4bf4c9d$var$requestFormReset$1(formFiber) {
    var stateHook = $0c49c351e4bf4c9d$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $0c49c351e4bf4c9d$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $0c49c351e4bf4c9d$var$requestUpdateLane());
}
function $0c49c351e4bf4c9d$var$useHostTransitionStatus() {
    return $0c49c351e4bf4c9d$var$readContext($0c49c351e4bf4c9d$var$HostTransitionContext);
}
function $0c49c351e4bf4c9d$var$updateId() {
    return $0c49c351e4bf4c9d$var$updateWorkInProgressHook().memoizedState;
}
function $0c49c351e4bf4c9d$var$updateRefresh() {
    return $0c49c351e4bf4c9d$var$updateWorkInProgressHook().memoizedState;
}
function $0c49c351e4bf4c9d$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $0c49c351e4bf4c9d$var$requestUpdateLane();
                fiber = $0c49c351e4bf4c9d$var$createUpdate(lane);
                var root$69 = $0c49c351e4bf4c9d$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(root$69, provider, lane), $0c49c351e4bf4c9d$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $0c49c351e4bf4c9d$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $0c49c351e4bf4c9d$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $0c49c351e4bf4c9d$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $0c49c351e4bf4c9d$var$isRenderPhaseUpdate(fiber) ? $0c49c351e4bf4c9d$var$enqueueRenderPhaseUpdate(queue, action) : (action = $0c49c351e4bf4c9d$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(action, fiber, lane), $0c49c351e4bf4c9d$var$entangleTransitionUpdate(action, queue, lane)));
}
function $0c49c351e4bf4c9d$var$dispatchSetState(fiber, queue, action) {
    var lane = $0c49c351e4bf4c9d$var$requestUpdateLane();
    $0c49c351e4bf4c9d$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $0c49c351e4bf4c9d$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0c49c351e4bf4c9d$var$isRenderPhaseUpdate(fiber)) $0c49c351e4bf4c9d$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($0c49c351e4bf4c9d$var$objectIs(eagerState, currentState)) return $0c49c351e4bf4c9d$var$enqueueUpdate$1(fiber, queue, update, 0), null === $0c49c351e4bf4c9d$var$workInProgressRoot && $0c49c351e4bf4c9d$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $0c49c351e4bf4c9d$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(action, fiber, lane), $0c49c351e4bf4c9d$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $0c49c351e4bf4c9d$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $0c49c351e4bf4c9d$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0c49c351e4bf4c9d$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $0c49c351e4bf4c9d$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $0c49c351e4bf4c9d$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $0c49c351e4bf4c9d$var$currentlyRenderingFiber || null !== alternate && alternate === $0c49c351e4bf4c9d$var$currentlyRenderingFiber;
}
function $0c49c351e4bf4c9d$var$enqueueRenderPhaseUpdate(queue, update) {
    $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdateDuringThisPass = $0c49c351e4bf4c9d$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $0c49c351e4bf4c9d$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $0c49c351e4bf4c9d$var$markRootEntangled(root, lane);
    }
}
var $0c49c351e4bf4c9d$var$ContextOnlyDispatcher = {
    readContext: $0c49c351e4bf4c9d$var$readContext,
    use: $0c49c351e4bf4c9d$var$use,
    useCallback: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useContext: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useEffect: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useImperativeHandle: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useLayoutEffect: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useInsertionEffect: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useMemo: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useReducer: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useRef: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useState: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useDebugValue: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useDeferredValue: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useTransition: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useSyncExternalStore: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useId: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useHostTransitionStatus: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useFormState: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useActionState: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useOptimistic: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useMemoCache: $0c49c351e4bf4c9d$var$throwInvalidHookError,
    useCacheRefresh: $0c49c351e4bf4c9d$var$throwInvalidHookError
};
$0c49c351e4bf4c9d$var$ContextOnlyDispatcher.useEffectEvent = $0c49c351e4bf4c9d$var$throwInvalidHookError;
var $0c49c351e4bf4c9d$var$HooksDispatcherOnMount = {
    readContext: $0c49c351e4bf4c9d$var$readContext,
    use: $0c49c351e4bf4c9d$var$use,
    useCallback: function(callback, deps) {
        $0c49c351e4bf4c9d$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $0c49c351e4bf4c9d$var$readContext,
    useEffect: $0c49c351e4bf4c9d$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $0c49c351e4bf4c9d$var$mountEffectImpl(4194308, 4, $0c49c351e4bf4c9d$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $0c49c351e4bf4c9d$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $0c49c351e4bf4c9d$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($0c49c351e4bf4c9d$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $0c49c351e4bf4c9d$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $0c49c351e4bf4c9d$var$dispatchReducerAction.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $0c49c351e4bf4c9d$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $0c49c351e4bf4c9d$var$dispatchSetState.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $0c49c351e4bf4c9d$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
        return $0c49c351e4bf4c9d$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $0c49c351e4bf4c9d$var$mountStateImpl(!1);
        stateHook = $0c49c351e4bf4c9d$var$startTransition.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $0c49c351e4bf4c9d$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $0c49c351e4bf4c9d$var$currentlyRenderingFiber, hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
        if ($0c49c351e4bf4c9d$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $0c49c351e4bf4c9d$var$workInProgressRoot) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(349));
            0 !== ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 127) || $0c49c351e4bf4c9d$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $0c49c351e4bf4c9d$var$mountEffect($0c49c351e4bf4c9d$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $0c49c351e4bf4c9d$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $0c49c351e4bf4c9d$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook(), identifierPrefix = $0c49c351e4bf4c9d$var$workInProgressRoot.identifierPrefix;
        if ($0c49c351e4bf4c9d$var$isHydrating) {
            var JSCompiler_inline_result = $0c49c351e4bf4c9d$var$treeContextOverflow;
            var idWithLeadingBit = $0c49c351e4bf4c9d$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $0c49c351e4bf4c9d$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $0c49c351e4bf4c9d$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $0c49c351e4bf4c9d$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $0c49c351e4bf4c9d$var$useHostTransitionStatus,
    useFormState: $0c49c351e4bf4c9d$var$mountActionState,
    useActionState: $0c49c351e4bf4c9d$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $0c49c351e4bf4c9d$var$dispatchOptimisticSetState.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $0c49c351e4bf4c9d$var$useMemoCache,
    useCacheRefresh: function() {
        return $0c49c351e4bf4c9d$var$mountWorkInProgressHook().memoizedState = $0c49c351e4bf4c9d$var$refreshCache.bind(null, $0c49c351e4bf4c9d$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $0c49c351e4bf4c9d$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($0c49c351e4bf4c9d$var$executionContext & 2)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $0c49c351e4bf4c9d$var$HooksDispatcherOnUpdate = {
    readContext: $0c49c351e4bf4c9d$var$readContext,
    use: $0c49c351e4bf4c9d$var$use,
    useCallback: $0c49c351e4bf4c9d$var$updateCallback,
    useContext: $0c49c351e4bf4c9d$var$readContext,
    useEffect: $0c49c351e4bf4c9d$var$updateEffect,
    useImperativeHandle: $0c49c351e4bf4c9d$var$updateImperativeHandle,
    useInsertionEffect: $0c49c351e4bf4c9d$var$updateInsertionEffect,
    useLayoutEffect: $0c49c351e4bf4c9d$var$updateLayoutEffect,
    useMemo: $0c49c351e4bf4c9d$var$updateMemo,
    useReducer: $0c49c351e4bf4c9d$var$updateReducer,
    useRef: $0c49c351e4bf4c9d$var$updateRef,
    useState: function() {
        return $0c49c351e4bf4c9d$var$updateReducer($0c49c351e4bf4c9d$var$basicStateReducer);
    },
    useDebugValue: $0c49c351e4bf4c9d$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
        return $0c49c351e4bf4c9d$var$updateDeferredValueImpl(hook, $0c49c351e4bf4c9d$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $0c49c351e4bf4c9d$var$updateReducer($0c49c351e4bf4c9d$var$basicStateReducer)[0], start = $0c49c351e4bf4c9d$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $0c49c351e4bf4c9d$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $0c49c351e4bf4c9d$var$updateSyncExternalStore,
    useId: $0c49c351e4bf4c9d$var$updateId,
    useHostTransitionStatus: $0c49c351e4bf4c9d$var$useHostTransitionStatus,
    useFormState: $0c49c351e4bf4c9d$var$updateActionState,
    useActionState: $0c49c351e4bf4c9d$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
        return $0c49c351e4bf4c9d$var$updateOptimisticImpl(hook, $0c49c351e4bf4c9d$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $0c49c351e4bf4c9d$var$useMemoCache,
    useCacheRefresh: $0c49c351e4bf4c9d$var$updateRefresh
};
$0c49c351e4bf4c9d$var$HooksDispatcherOnUpdate.useEffectEvent = $0c49c351e4bf4c9d$var$updateEvent;
var $0c49c351e4bf4c9d$var$HooksDispatcherOnRerender = {
    readContext: $0c49c351e4bf4c9d$var$readContext,
    use: $0c49c351e4bf4c9d$var$use,
    useCallback: $0c49c351e4bf4c9d$var$updateCallback,
    useContext: $0c49c351e4bf4c9d$var$readContext,
    useEffect: $0c49c351e4bf4c9d$var$updateEffect,
    useImperativeHandle: $0c49c351e4bf4c9d$var$updateImperativeHandle,
    useInsertionEffect: $0c49c351e4bf4c9d$var$updateInsertionEffect,
    useLayoutEffect: $0c49c351e4bf4c9d$var$updateLayoutEffect,
    useMemo: $0c49c351e4bf4c9d$var$updateMemo,
    useReducer: $0c49c351e4bf4c9d$var$rerenderReducer,
    useRef: $0c49c351e4bf4c9d$var$updateRef,
    useState: function() {
        return $0c49c351e4bf4c9d$var$rerenderReducer($0c49c351e4bf4c9d$var$basicStateReducer);
    },
    useDebugValue: $0c49c351e4bf4c9d$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
        return null === $0c49c351e4bf4c9d$var$currentHook ? $0c49c351e4bf4c9d$var$mountDeferredValueImpl(hook, value, initialValue) : $0c49c351e4bf4c9d$var$updateDeferredValueImpl(hook, $0c49c351e4bf4c9d$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $0c49c351e4bf4c9d$var$rerenderReducer($0c49c351e4bf4c9d$var$basicStateReducer)[0], start = $0c49c351e4bf4c9d$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $0c49c351e4bf4c9d$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $0c49c351e4bf4c9d$var$updateSyncExternalStore,
    useId: $0c49c351e4bf4c9d$var$updateId,
    useHostTransitionStatus: $0c49c351e4bf4c9d$var$useHostTransitionStatus,
    useFormState: $0c49c351e4bf4c9d$var$rerenderActionState,
    useActionState: $0c49c351e4bf4c9d$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $0c49c351e4bf4c9d$var$updateWorkInProgressHook();
        if (null !== $0c49c351e4bf4c9d$var$currentHook) return $0c49c351e4bf4c9d$var$updateOptimisticImpl(hook, $0c49c351e4bf4c9d$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $0c49c351e4bf4c9d$var$useMemoCache,
    useCacheRefresh: $0c49c351e4bf4c9d$var$updateRefresh
};
$0c49c351e4bf4c9d$var$HooksDispatcherOnRerender.useEffectEvent = $0c49c351e4bf4c9d$var$updateEvent;
function $0c49c351e4bf4c9d$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $0c49c351e4bf4c9d$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $0c49c351e4bf4c9d$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $0c49c351e4bf4c9d$var$requestUpdateLane(), update = $0c49c351e4bf4c9d$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $0c49c351e4bf4c9d$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(payload, inst, lane), $0c49c351e4bf4c9d$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $0c49c351e4bf4c9d$var$requestUpdateLane(), update = $0c49c351e4bf4c9d$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $0c49c351e4bf4c9d$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(payload, inst, lane), $0c49c351e4bf4c9d$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $0c49c351e4bf4c9d$var$requestUpdateLane(), update = $0c49c351e4bf4c9d$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $0c49c351e4bf4c9d$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(callback, inst, lane), $0c49c351e4bf4c9d$var$entangleTransitions(callback, inst, lane));
    }
};
function $0c49c351e4bf4c9d$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$0c49c351e4bf4c9d$var$shallowEqual(oldProps, newProps) || !$0c49c351e4bf4c9d$var$shallowEqual(oldState, newState) : !0;
}
function $0c49c351e4bf4c9d$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $0c49c351e4bf4c9d$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $0c49c351e4bf4c9d$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $0c49c351e4bf4c9d$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $0c49c351e4bf4c9d$var$defaultOnUncaughtError(error) {
    $0c49c351e4bf4c9d$var$reportGlobalError(error);
}
function $0c49c351e4bf4c9d$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $0c49c351e4bf4c9d$var$defaultOnRecoverableError(error) {
    $0c49c351e4bf4c9d$var$reportGlobalError(error);
}
function $0c49c351e4bf4c9d$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $0c49c351e4bf4c9d$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $0c49c351e4bf4c9d$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $0c49c351e4bf4c9d$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $0c49c351e4bf4c9d$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $0c49c351e4bf4c9d$var$createClassErrorUpdate(lane) {
    lane = $0c49c351e4bf4c9d$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $0c49c351e4bf4c9d$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $0c49c351e4bf4c9d$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $0c49c351e4bf4c9d$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed ? $0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $0c49c351e4bf4c9d$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $0c49c351e4bf4c9d$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $0c49c351e4bf4c9d$var$shellBoundary ? $0c49c351e4bf4c9d$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $0c49c351e4bf4c9d$var$workInProgressRootExitStatus && ($0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $0c49c351e4bf4c9d$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $0c49c351e4bf4c9d$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $0c49c351e4bf4c9d$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $0c49c351e4bf4c9d$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $0c49c351e4bf4c9d$var$attachPingListener(root, value, rootRenderLanes);
        $0c49c351e4bf4c9d$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($0c49c351e4bf4c9d$var$isHydrating) return returnFiber = $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $0c49c351e4bf4c9d$var$HydrationMismatchException && (root = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(422), {
        cause: value
    }), $0c49c351e4bf4c9d$var$queueHydrationError($0c49c351e4bf4c9d$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $0c49c351e4bf4c9d$var$HydrationMismatchException && (returnFiber = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(423), {
        cause: value
    }), $0c49c351e4bf4c9d$var$queueHydrationError($0c49c351e4bf4c9d$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $0c49c351e4bf4c9d$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $0c49c351e4bf4c9d$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $0c49c351e4bf4c9d$var$workInProgressRootExitStatus && ($0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $0c49c351e4bf4c9d$var$workInProgressRootConcurrentErrors ? $0c49c351e4bf4c9d$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $0c49c351e4bf4c9d$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $0c49c351e4bf4c9d$var$workInProgressRootExitStatus && ($0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $0c49c351e4bf4c9d$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $0c49c351e4bf4c9d$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed || !$0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $0c49c351e4bf4c9d$var$createClassErrorUpdate(rootRenderLanes), $0c49c351e4bf4c9d$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $0c49c351e4bf4c9d$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $0c49c351e4bf4c9d$var$SelectiveHydrationException = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(461)), $0c49c351e4bf4c9d$var$didReceiveUpdate = !1;
function $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $0c49c351e4bf4c9d$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $0c49c351e4bf4c9d$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $0c49c351e4bf4c9d$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $0c49c351e4bf4c9d$var$prepareToReadContext(workInProgress);
    nextProps = $0c49c351e4bf4c9d$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $0c49c351e4bf4c9d$var$checkDidRenderIdHook();
    if (null !== current && !$0c49c351e4bf4c9d$var$didReceiveUpdate) return $0c49c351e4bf4c9d$var$bailoutHooks(current, workInProgress, renderLanes), $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $0c49c351e4bf4c9d$var$isHydrating && key && $0c49c351e4bf4c9d$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $0c49c351e4bf4c9d$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$0c49c351e4bf4c9d$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $0c49c351e4bf4c9d$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $0c49c351e4bf4c9d$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$0c49c351e4bf4c9d$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $0c49c351e4bf4c9d$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $0c49c351e4bf4c9d$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $0c49c351e4bf4c9d$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($0c49c351e4bf4c9d$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($0c49c351e4bf4c9d$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $0c49c351e4bf4c9d$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($0c49c351e4bf4c9d$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $0c49c351e4bf4c9d$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $0c49c351e4bf4c9d$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $0c49c351e4bf4c9d$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $0c49c351e4bf4c9d$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $0c49c351e4bf4c9d$var$pushHiddenContext(workInProgress, prevState) : $0c49c351e4bf4c9d$var$reuseHiddenContextOnStack(), $0c49c351e4bf4c9d$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $0c49c351e4bf4c9d$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($0c49c351e4bf4c9d$var$pushTransition(workInProgress, prevState.cachePool), $0c49c351e4bf4c9d$var$pushHiddenContext(workInProgress, prevState), $0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $0c49c351e4bf4c9d$var$pushTransition(workInProgress, null), $0c49c351e4bf4c9d$var$reuseHiddenContextOnStack(), $0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(workInProgress));
    $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $0c49c351e4bf4c9d$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $0c49c351e4bf4c9d$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $0c49c351e4bf4c9d$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $0c49c351e4bf4c9d$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $0c49c351e4bf4c9d$var$pushTransition(workInProgress, null);
    $0c49c351e4bf4c9d$var$reuseHiddenContextOnStack();
    $0c49c351e4bf4c9d$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $0c49c351e4bf4c9d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $0c49c351e4bf4c9d$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $0c49c351e4bf4c9d$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $0c49c351e4bf4c9d$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $0c49c351e4bf4c9d$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $0c49c351e4bf4c9d$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $0c49c351e4bf4c9d$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($0c49c351e4bf4c9d$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $0c49c351e4bf4c9d$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $0c49c351e4bf4c9d$var$bailoutOffscreenComponent(null, current);
            $0c49c351e4bf4c9d$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $0c49c351e4bf4c9d$var$nextHydratableInstance) ? (current = $0c49c351e4bf4c9d$var$canHydrateHydrationBoundary(current, $0c49c351e4bf4c9d$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $0c49c351e4bf4c9d$var$treeContextProvider ? {
                    id: $0c49c351e4bf4c9d$var$treeContextId,
                    overflow: $0c49c351e4bf4c9d$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $0c49c351e4bf4c9d$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress, $0c49c351e4bf4c9d$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $0c49c351e4bf4c9d$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $0c49c351e4bf4c9d$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $0c49c351e4bf4c9d$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(558));
        } else if ($0c49c351e4bf4c9d$var$didReceiveUpdate || $0c49c351e4bf4c9d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $0c49c351e4bf4c9d$var$didReceiveUpdate || didSuspend) {
            nextProps = $0c49c351e4bf4c9d$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $0c49c351e4bf4c9d$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(current, dehydrated), $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $0c49c351e4bf4c9d$var$SelectiveHydrationException;
            $0c49c351e4bf4c9d$var$renderDidSuspendDelayIfPossible();
            workInProgress = $0c49c351e4bf4c9d$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratable(dehydrated.nextSibling), $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress, $0c49c351e4bf4c9d$var$isHydrating = !0, $0c49c351e4bf4c9d$var$hydrationErrors = null, $0c49c351e4bf4c9d$var$rootOrSingletonContext = !1, null !== current && $0c49c351e4bf4c9d$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $0c49c351e4bf4c9d$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $0c49c351e4bf4c9d$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $0c49c351e4bf4c9d$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $0c49c351e4bf4c9d$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $0c49c351e4bf4c9d$var$prepareToReadContext(workInProgress);
    Component = $0c49c351e4bf4c9d$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $0c49c351e4bf4c9d$var$checkDidRenderIdHook();
    if (null !== current && !$0c49c351e4bf4c9d$var$didReceiveUpdate) return $0c49c351e4bf4c9d$var$bailoutHooks(current, workInProgress, renderLanes), $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $0c49c351e4bf4c9d$var$isHydrating && nextProps && $0c49c351e4bf4c9d$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $0c49c351e4bf4c9d$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $0c49c351e4bf4c9d$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $0c49c351e4bf4c9d$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $0c49c351e4bf4c9d$var$finishRenderingHooks(current);
    Component = $0c49c351e4bf4c9d$var$checkDidRenderIdHook();
    if (null !== current && !$0c49c351e4bf4c9d$var$didReceiveUpdate) return $0c49c351e4bf4c9d$var$bailoutHooks(current, workInProgress, renderLanes), $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $0c49c351e4bf4c9d$var$isHydrating && Component && $0c49c351e4bf4c9d$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $0c49c351e4bf4c9d$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $0c49c351e4bf4c9d$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $0c49c351e4bf4c9d$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $0c49c351e4bf4c9d$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $0c49c351e4bf4c9d$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $0c49c351e4bf4c9d$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $0c49c351e4bf4c9d$var$readContext(contextType) : $0c49c351e4bf4c9d$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($0c49c351e4bf4c9d$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $0c49c351e4bf4c9d$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $0c49c351e4bf4c9d$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $0c49c351e4bf4c9d$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $0c49c351e4bf4c9d$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $0c49c351e4bf4c9d$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $0c49c351e4bf4c9d$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $0c49c351e4bf4c9d$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $0c49c351e4bf4c9d$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $0c49c351e4bf4c9d$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $0c49c351e4bf4c9d$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $0c49c351e4bf4c9d$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($0c49c351e4bf4c9d$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $0c49c351e4bf4c9d$var$hasForceUpdate || $0c49c351e4bf4c9d$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $0c49c351e4bf4c9d$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $0c49c351e4bf4c9d$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $0c49c351e4bf4c9d$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $0c49c351e4bf4c9d$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $0c49c351e4bf4c9d$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $0c49c351e4bf4c9d$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $0c49c351e4bf4c9d$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $0c49c351e4bf4c9d$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $0c49c351e4bf4c9d$var$hasForceUpdate || null !== current && null !== current.dependencies && $0c49c351e4bf4c9d$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($0c49c351e4bf4c9d$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $0c49c351e4bf4c9d$var$hasForceUpdate || $0c49c351e4bf4c9d$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $0c49c351e4bf4c9d$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $0c49c351e4bf4c9d$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $0c49c351e4bf4c9d$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $0c49c351e4bf4c9d$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $0c49c351e4bf4c9d$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $0c49c351e4bf4c9d$var$resetHydrationState();
    workInProgress.flags |= 256;
    $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $0c49c351e4bf4c9d$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $0c49c351e4bf4c9d$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $0c49c351e4bf4c9d$var$getSuspendedCache()
    };
}
function $0c49c351e4bf4c9d$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $0c49c351e4bf4c9d$var$workInProgressDeferredLane);
    return current;
}
function $0c49c351e4bf4c9d$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($0c49c351e4bf4c9d$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($0c49c351e4bf4c9d$var$isHydrating) {
            showFallback ? $0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $0c49c351e4bf4c9d$var$nextHydratableInstance) ? (current = $0c49c351e4bf4c9d$var$canHydrateHydrationBoundary(current, $0c49c351e4bf4c9d$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $0c49c351e4bf4c9d$var$treeContextProvider ? {
                    id: $0c49c351e4bf4c9d$var$treeContextId,
                    overflow: $0c49c351e4bf4c9d$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $0c49c351e4bf4c9d$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress, $0c49c351e4bf4c9d$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(workInProgress);
            $0c49c351e4bf4c9d$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $0c49c351e4bf4c9d$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $0c49c351e4bf4c9d$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $0c49c351e4bf4c9d$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $0c49c351e4bf4c9d$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $0c49c351e4bf4c9d$var$SUSPENDED_MARKER, $0c49c351e4bf4c9d$var$bailoutOffscreenComponent(null, nextProps);
        $0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $0c49c351e4bf4c9d$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $0c49c351e4bf4c9d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $0c49c351e4bf4c9d$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $0c49c351e4bf4c9d$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $0c49c351e4bf4c9d$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $0c49c351e4bf4c9d$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $0c49c351e4bf4c9d$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $0c49c351e4bf4c9d$var$SUSPENDED_MARKER, workInProgress = $0c49c351e4bf4c9d$var$bailoutOffscreenComponent(null, nextProps));
        else if ($0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress), $0c49c351e4bf4c9d$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $0c49c351e4bf4c9d$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $0c49c351e4bf4c9d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($0c49c351e4bf4c9d$var$didReceiveUpdate || $0c49c351e4bf4c9d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $0c49c351e4bf4c9d$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $0c49c351e4bf4c9d$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $0c49c351e4bf4c9d$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(current, nextProps), $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $0c49c351e4bf4c9d$var$SelectiveHydrationException;
            $0c49c351e4bf4c9d$var$isSuspenseInstancePending(nextPrimaryChildren) || $0c49c351e4bf4c9d$var$renderDidSuspendDelayIfPossible();
            workInProgress = $0c49c351e4bf4c9d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $0c49c351e4bf4c9d$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratable(nextPrimaryChildren.nextSibling), $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress, $0c49c351e4bf4c9d$var$isHydrating = !0, $0c49c351e4bf4c9d$var$hydrationErrors = null, $0c49c351e4bf4c9d$var$rootOrSingletonContext = !1, null !== current && $0c49c351e4bf4c9d$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $0c49c351e4bf4c9d$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $0c49c351e4bf4c9d$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $0c49c351e4bf4c9d$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $0c49c351e4bf4c9d$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $0c49c351e4bf4c9d$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $0c49c351e4bf4c9d$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $0c49c351e4bf4c9d$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $0c49c351e4bf4c9d$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $0c49c351e4bf4c9d$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $0c49c351e4bf4c9d$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $0c49c351e4bf4c9d$var$SUSPENDED_MARKER, $0c49c351e4bf4c9d$var$bailoutOffscreenComponent(current.child, nextProps);
    $0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $0c49c351e4bf4c9d$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $0c49c351e4bf4c9d$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $0c49c351e4bf4c9d$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $0c49c351e4bf4c9d$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $0c49c351e4bf4c9d$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $0c49c351e4bf4c9d$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $0c49c351e4bf4c9d$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $0c49c351e4bf4c9d$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $0c49c351e4bf4c9d$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $0c49c351e4bf4c9d$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $0c49c351e4bf4c9d$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $0c49c351e4bf4c9d$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $0c49c351e4bf4c9d$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, suspenseContext);
    $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $0c49c351e4bf4c9d$var$isHydrating ? $0c49c351e4bf4c9d$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $0c49c351e4bf4c9d$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $0c49c351e4bf4c9d$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $0c49c351e4bf4c9d$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $0c49c351e4bf4c9d$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $0c49c351e4bf4c9d$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $0c49c351e4bf4c9d$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $0c49c351e4bf4c9d$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($0c49c351e4bf4c9d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $0c49c351e4bf4c9d$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $0c49c351e4bf4c9d$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $0c49c351e4bf4c9d$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $0c49c351e4bf4c9d$var$checkIfContextChanged(current) ? !0 : !1;
}
function $0c49c351e4bf4c9d$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $0c49c351e4bf4c9d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $0c49c351e4bf4c9d$var$pushProvider(workInProgress, $0c49c351e4bf4c9d$var$CacheContext, current.memoizedState.cache);
            $0c49c351e4bf4c9d$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $0c49c351e4bf4c9d$var$pushHostContext(workInProgress);
            break;
        case 4:
            $0c49c351e4bf4c9d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $0c49c351e4bf4c9d$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $0c49c351e4bf4c9d$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $0c49c351e4bf4c9d$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $0c49c351e4bf4c9d$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($0c49c351e4bf4c9d$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $0c49c351e4bf4c9d$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, $0c49c351e4bf4c9d$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $0c49c351e4bf4c9d$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $0c49c351e4bf4c9d$var$pushProvider(workInProgress, $0c49c351e4bf4c9d$var$CacheContext, current.memoizedState.cache);
    }
    return $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $0c49c351e4bf4c9d$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $0c49c351e4bf4c9d$var$didReceiveUpdate = !0;
        else {
            if (!$0c49c351e4bf4c9d$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $0c49c351e4bf4c9d$var$didReceiveUpdate = !1, $0c49c351e4bf4c9d$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $0c49c351e4bf4c9d$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $0c49c351e4bf4c9d$var$didReceiveUpdate = !1, $0c49c351e4bf4c9d$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $0c49c351e4bf4c9d$var$pushTreeId(workInProgress, $0c49c351e4bf4c9d$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $0c49c351e4bf4c9d$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $0c49c351e4bf4c9d$var$shouldConstruct(current) ? (props = $0c49c351e4bf4c9d$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $0c49c351e4bf4c9d$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $0c49c351e4bf4c9d$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $0c49c351e4bf4c9d$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $0c49c351e4bf4c9d$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $0c49c351e4bf4c9d$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $0c49c351e4bf4c9d$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $0c49c351e4bf4c9d$var$getComponentNameFromType(current) || current;
                    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $0c49c351e4bf4c9d$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $0c49c351e4bf4c9d$var$resolveClassComponentProps(props, workInProgress.pendingProps), $0c49c351e4bf4c9d$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $0c49c351e4bf4c9d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $0c49c351e4bf4c9d$var$cloneUpdateQueue(current, workInProgress);
                $0c49c351e4bf4c9d$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $0c49c351e4bf4c9d$var$pushProvider(workInProgress, $0c49c351e4bf4c9d$var$CacheContext, props);
                props !== prevState.cache && $0c49c351e4bf4c9d$var$propagateContextChanges(workInProgress, [
                    $0c49c351e4bf4c9d$var$CacheContext
                ], renderLanes, !0);
                $0c49c351e4bf4c9d$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $0c49c351e4bf4c9d$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(424)), workInProgress);
                        $0c49c351e4bf4c9d$var$queueHydrationError($$typeof);
                        workInProgress = $0c49c351e4bf4c9d$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratable(current.firstChild);
                        $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress;
                        $0c49c351e4bf4c9d$var$isHydrating = !0;
                        $0c49c351e4bf4c9d$var$hydrationErrors = null;
                        $0c49c351e4bf4c9d$var$rootOrSingletonContext = !0;
                        renderLanes = $0c49c351e4bf4c9d$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $0c49c351e4bf4c9d$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $0c49c351e4bf4c9d$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $0c49c351e4bf4c9d$var$markRef(current, workInProgress), null === current ? (renderLanes = $0c49c351e4bf4c9d$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $0c49c351e4bf4c9d$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $0c49c351e4bf4c9d$var$getOwnerDocumentFromRootContainer($0c49c351e4bf4c9d$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$0c49c351e4bf4c9d$var$internalInstanceKey] = workInProgress, props[$0c49c351e4bf4c9d$var$internalPropsKey] = current, $0c49c351e4bf4c9d$var$setInitialProperties(props, renderLanes, current), $0c49c351e4bf4c9d$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $0c49c351e4bf4c9d$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $0c49c351e4bf4c9d$var$pushHostContext(workInProgress), null === current && $0c49c351e4bf4c9d$var$isHydrating && (props = workInProgress.stateNode = $0c49c351e4bf4c9d$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $0c49c351e4bf4c9d$var$rootInstanceStackCursor.current), $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress, $0c49c351e4bf4c9d$var$rootOrSingletonContext = !0, $$typeof = $0c49c351e4bf4c9d$var$nextHydratableInstance, $0c49c351e4bf4c9d$var$isSingletonScope(workInProgress.type) ? ($0c49c351e4bf4c9d$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratable(props.firstChild)) : $0c49c351e4bf4c9d$var$nextHydratableInstance = $$typeof), $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $0c49c351e4bf4c9d$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $0c49c351e4bf4c9d$var$isHydrating) {
                if ($$typeof = props = $0c49c351e4bf4c9d$var$nextHydratableInstance) props = $0c49c351e4bf4c9d$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $0c49c351e4bf4c9d$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress, $0c49c351e4bf4c9d$var$nextHydratableInstance = $0c49c351e4bf4c9d$var$getNextHydratable(props.firstChild), $0c49c351e4bf4c9d$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(workInProgress);
            }
            $0c49c351e4bf4c9d$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $0c49c351e4bf4c9d$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $0c49c351e4bf4c9d$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $0c49c351e4bf4c9d$var$renderWithHooks(current, workInProgress, $0c49c351e4bf4c9d$var$TransitionAwareHostComponent, null, null, renderLanes), $0c49c351e4bf4c9d$var$HostTransitionContext._currentValue = $$typeof);
            $0c49c351e4bf4c9d$var$markRef(current, workInProgress);
            $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $0c49c351e4bf4c9d$var$isHydrating) {
                if (current = renderLanes = $0c49c351e4bf4c9d$var$nextHydratableInstance) renderLanes = $0c49c351e4bf4c9d$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $0c49c351e4bf4c9d$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $0c49c351e4bf4c9d$var$hydrationParentFiber = workInProgress, $0c49c351e4bf4c9d$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $0c49c351e4bf4c9d$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $0c49c351e4bf4c9d$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $0c49c351e4bf4c9d$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $0c49c351e4bf4c9d$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $0c49c351e4bf4c9d$var$pushProvider(workInProgress, workInProgress.type, props.value), $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $0c49c351e4bf4c9d$var$prepareToReadContext(workInProgress), $$typeof = $0c49c351e4bf4c9d$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $0c49c351e4bf4c9d$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $0c49c351e4bf4c9d$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $0c49c351e4bf4c9d$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $0c49c351e4bf4c9d$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $0c49c351e4bf4c9d$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $0c49c351e4bf4c9d$var$prepareToReadContext(workInProgress), props = $0c49c351e4bf4c9d$var$readContext($0c49c351e4bf4c9d$var$CacheContext), null === current ? ($$typeof = $0c49c351e4bf4c9d$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $0c49c351e4bf4c9d$var$workInProgressRoot, prevState = $0c49c351e4bf4c9d$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $0c49c351e4bf4c9d$var$initializeUpdateQueue(workInProgress), $0c49c351e4bf4c9d$var$pushProvider(workInProgress, $0c49c351e4bf4c9d$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($0c49c351e4bf4c9d$var$cloneUpdateQueue(current, workInProgress), $0c49c351e4bf4c9d$var$processUpdateQueue(workInProgress, null, null, renderLanes), $0c49c351e4bf4c9d$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $0c49c351e4bf4c9d$var$pushProvider(workInProgress, $0c49c351e4bf4c9d$var$CacheContext, props)) : (props = prevState.cache, $0c49c351e4bf4c9d$var$pushProvider(workInProgress, $0c49c351e4bf4c9d$var$CacheContext, props), props !== $$typeof.cache && $0c49c351e4bf4c9d$var$propagateContextChanges(workInProgress, [
                $0c49c351e4bf4c9d$var$CacheContext
            ], renderLanes, !0))), $0c49c351e4bf4c9d$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $0c49c351e4bf4c9d$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $0c49c351e4bf4c9d$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($0c49c351e4bf4c9d$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $0c49c351e4bf4c9d$var$suspendedThenable = $0c49c351e4bf4c9d$var$noopSuspenseyCommitThenable, $0c49c351e4bf4c9d$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $0c49c351e4bf4c9d$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$0c49c351e4bf4c9d$var$preloadResource(resource)) {
        if ($0c49c351e4bf4c9d$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $0c49c351e4bf4c9d$var$suspendedThenable = $0c49c351e4bf4c9d$var$noopSuspenseyCommitThenable, $0c49c351e4bf4c9d$var$SuspenseyCommitException;
    }
}
function $0c49c351e4bf4c9d$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $0c49c351e4bf4c9d$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $0c49c351e4bf4c9d$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $0c49c351e4bf4c9d$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$0c49c351e4bf4c9d$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $0c49c351e4bf4c9d$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $0c49c351e4bf4c9d$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $0c49c351e4bf4c9d$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), null;
        case 1:
            return $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $0c49c351e4bf4c9d$var$popProvider($0c49c351e4bf4c9d$var$CacheContext);
            $0c49c351e4bf4c9d$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $0c49c351e4bf4c9d$var$popHydrationState(workInProgress) ? $0c49c351e4bf4c9d$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $0c49c351e4bf4c9d$var$upgradeHydrationErrorsToRecoverable());
            $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($0c49c351e4bf4c9d$var$markUpdate(workInProgress), null !== nextResource ? ($0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), $0c49c351e4bf4c9d$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), $0c49c351e4bf4c9d$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($0c49c351e4bf4c9d$var$markUpdate(workInProgress), $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), $0c49c351e4bf4c9d$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $0c49c351e4bf4c9d$var$markUpdate(workInProgress), $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), $0c49c351e4bf4c9d$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $0c49c351e4bf4c9d$var$popHostContext(workInProgress);
            renderLanes = $0c49c351e4bf4c9d$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $0c49c351e4bf4c9d$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(166));
                    $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $0c49c351e4bf4c9d$var$contextStackCursor.current;
                $0c49c351e4bf4c9d$var$popHydrationState(workInProgress) ? $0c49c351e4bf4c9d$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $0c49c351e4bf4c9d$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $0c49c351e4bf4c9d$var$markUpdate(workInProgress));
            }
            $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $0c49c351e4bf4c9d$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $0c49c351e4bf4c9d$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(166));
                    $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $0c49c351e4bf4c9d$var$contextStackCursor.current;
                if ($0c49c351e4bf4c9d$var$popHydrationState(workInProgress)) $0c49c351e4bf4c9d$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $0c49c351e4bf4c9d$var$getOwnerDocumentFromRootContainer($0c49c351e4bf4c9d$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$0c49c351e4bf4c9d$var$internalInstanceKey] = workInProgress;
                    nextResource[$0c49c351e4bf4c9d$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($0c49c351e4bf4c9d$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $0c49c351e4bf4c9d$var$markUpdate(workInProgress);
                }
            }
            $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
            $0c49c351e4bf4c9d$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $0c49c351e4bf4c9d$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(166));
                current = $0c49c351e4bf4c9d$var$rootInstanceStackCursor.current;
                if ($0c49c351e4bf4c9d$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $0c49c351e4bf4c9d$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$0c49c351e4bf4c9d$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $0c49c351e4bf4c9d$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $0c49c351e4bf4c9d$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $0c49c351e4bf4c9d$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$0c49c351e4bf4c9d$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $0c49c351e4bf4c9d$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(557));
                        current[$0c49c351e4bf4c9d$var$internalInstanceKey] = workInProgress;
                    } else $0c49c351e4bf4c9d$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $0c49c351e4bf4c9d$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress), workInProgress;
                    $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(558));
            }
            $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $0c49c351e4bf4c9d$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(317));
                        type[$0c49c351e4bf4c9d$var$internalInstanceKey] = workInProgress;
                    } else $0c49c351e4bf4c9d$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $0c49c351e4bf4c9d$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress), workInProgress;
                    $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $0c49c351e4bf4c9d$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $0c49c351e4bf4c9d$var$popHostContainer(), null === current && $0c49c351e4bf4c9d$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), null;
        case 10:
            return $0c49c351e4bf4c9d$var$popProvider(workInProgress.type), $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), null;
        case 19:
            $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $0c49c351e4bf4c9d$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $0c49c351e4bf4c9d$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $0c49c351e4bf4c9d$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $0c49c351e4bf4c9d$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $0c49c351e4bf4c9d$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$0c49c351e4bf4c9d$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, $0c49c351e4bf4c9d$var$suspenseStackCursor.current & 1 | 2);
                            $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $0c49c351e4bf4c9d$var$now() > $0c49c351e4bf4c9d$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $0c49c351e4bf4c9d$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $0c49c351e4bf4c9d$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $0c49c351e4bf4c9d$var$scheduleRetryEffect(workInProgress, current), $0c49c351e4bf4c9d$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$0c49c351e4bf4c9d$var$isHydrating) return $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), null;
                    } else 2 * $0c49c351e4bf4c9d$var$now() - newProps.renderingStartTime > $0c49c351e4bf4c9d$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $0c49c351e4bf4c9d$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $0c49c351e4bf4c9d$var$now(), current.sibling = null, renderLanes = $0c49c351e4bf4c9d$var$suspenseStackCursor.current, $0c49c351e4bf4c9d$var$push($0c49c351e4bf4c9d$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $0c49c351e4bf4c9d$var$isHydrating && $0c49c351e4bf4c9d$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress), $0c49c351e4bf4c9d$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $0c49c351e4bf4c9d$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $0c49c351e4bf4c9d$var$popProvider($0c49c351e4bf4c9d$var$CacheContext), $0c49c351e4bf4c9d$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $0c49c351e4bf4c9d$var$unwindWork(current, workInProgress) {
    $0c49c351e4bf4c9d$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $0c49c351e4bf4c9d$var$popProvider($0c49c351e4bf4c9d$var$CacheContext), $0c49c351e4bf4c9d$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $0c49c351e4bf4c9d$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(340));
                $0c49c351e4bf4c9d$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(340));
                $0c49c351e4bf4c9d$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$suspenseStackCursor), null;
        case 4:
            return $0c49c351e4bf4c9d$var$popHostContainer(), null;
        case 10:
            return $0c49c351e4bf4c9d$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $0c49c351e4bf4c9d$var$popSuspenseHandler(workInProgress), $0c49c351e4bf4c9d$var$popHiddenContext(), null !== current && $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $0c49c351e4bf4c9d$var$popProvider($0c49c351e4bf4c9d$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $0c49c351e4bf4c9d$var$unwindInterruptedWork(current, interruptedWork) {
    $0c49c351e4bf4c9d$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $0c49c351e4bf4c9d$var$popProvider($0c49c351e4bf4c9d$var$CacheContext);
            $0c49c351e4bf4c9d$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $0c49c351e4bf4c9d$var$popHostContext(interruptedWork);
            break;
        case 4:
            $0c49c351e4bf4c9d$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $0c49c351e4bf4c9d$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $0c49c351e4bf4c9d$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$suspenseStackCursor);
            break;
        case 10:
            $0c49c351e4bf4c9d$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $0c49c351e4bf4c9d$var$popSuspenseHandler(interruptedWork);
            $0c49c351e4bf4c9d$var$popHiddenContext();
            null !== current && $0c49c351e4bf4c9d$var$pop($0c49c351e4bf4c9d$var$resumedCache);
            break;
        case 24:
            $0c49c351e4bf4c9d$var$popProvider($0c49c351e4bf4c9d$var$CacheContext);
    }
}
function $0c49c351e4bf4c9d$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $0c49c351e4bf4c9d$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c49c351e4bf4c9d$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $0c49c351e4bf4c9d$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $0c49c351e4bf4c9d$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $0c49c351e4bf4c9d$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $0c49c351e4bf4c9d$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $0c49c351e4bf4c9d$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $0c49c351e4bf4c9d$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $0c49c351e4bf4c9d$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $0c49c351e4bf4c9d$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c49c351e4bf4c9d$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $0c49c351e4bf4c9d$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$0c49c351e4bf4c9d$var$internalPropsKey] = newProps;
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c49c351e4bf4c9d$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $0c49c351e4bf4c9d$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $0c49c351e4bf4c9d$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $0c49c351e4bf4c9d$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $0c49c351e4bf4c9d$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $0c49c351e4bf4c9d$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $0c49c351e4bf4c9d$var$noop$1));
    else if (4 !== tag && (27 === tag && $0c49c351e4bf4c9d$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($0c49c351e4bf4c9d$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$0c49c351e4bf4c9d$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $0c49c351e4bf4c9d$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $0c49c351e4bf4c9d$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($0c49c351e4bf4c9d$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$0c49c351e4bf4c9d$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $0c49c351e4bf4c9d$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $0c49c351e4bf4c9d$var$setInitialProperties(singleton, type, props);
        singleton[$0c49c351e4bf4c9d$var$internalInstanceKey] = finishedWork;
        singleton[$0c49c351e4bf4c9d$var$internalPropsKey] = props;
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden = !1, $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden = !1, $0c49c351e4bf4c9d$var$needsFormReset = !1, $0c49c351e4bf4c9d$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $0c49c351e4bf4c9d$var$nextEffect = null;
function $0c49c351e4bf4c9d$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $0c49c351e4bf4c9d$var$eventsEnabled = $0c49c351e4bf4c9d$var$_enabled;
    root = $0c49c351e4bf4c9d$var$getActiveElementDeep(root);
    if ($0c49c351e4bf4c9d$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $0c49c351e4bf4c9d$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $0c49c351e4bf4c9d$var$_enabled = !1;
    for($0c49c351e4bf4c9d$var$nextEffect = firstChild; null !== $0c49c351e4bf4c9d$var$nextEffect;)if (firstChild = $0c49c351e4bf4c9d$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $0c49c351e4bf4c9d$var$nextEffect = root;
    else for(; null !== $0c49c351e4bf4c9d$var$nextEffect;){
        firstChild = $0c49c351e4bf4c9d$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $0c49c351e4bf4c9d$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $0c49c351e4bf4c9d$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $0c49c351e4bf4c9d$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $0c49c351e4bf4c9d$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $0c49c351e4bf4c9d$var$nextEffect = root;
            break;
        }
        $0c49c351e4bf4c9d$var$nextEffect = firstChild.return;
    }
}
function $0c49c351e4bf4c9d$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $0c49c351e4bf4c9d$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $0c49c351e4bf4c9d$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $0c49c351e4bf4c9d$var$commitClassCallbacks(finishedWork);
            flags & 512 && $0c49c351e4bf4c9d$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $0c49c351e4bf4c9d$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $0c49c351e4bf4c9d$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $0c49c351e4bf4c9d$var$commitHostMount(finishedWork);
            flags & 512 && $0c49c351e4bf4c9d$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $0c49c351e4bf4c9d$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $0c49c351e4bf4c9d$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $0c49c351e4bf4c9d$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $0c49c351e4bf4c9d$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden;
                prevProps = $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden;
                $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden = flags;
                ($0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden = prevProps;
                $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $0c49c351e4bf4c9d$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $0c49c351e4bf4c9d$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $0c49c351e4bf4c9d$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $0c49c351e4bf4c9d$var$hostParent = null, $0c49c351e4bf4c9d$var$hostParentIsContainer = !1;
function $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$0c49c351e4bf4c9d$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $0c49c351e4bf4c9d$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($0c49c351e4bf4c9d$var$injectedHook && "function" === typeof $0c49c351e4bf4c9d$var$injectedHook.onCommitFiberUnmount) try {
        $0c49c351e4bf4c9d$var$injectedHook.onCommitFiberUnmount($0c49c351e4bf4c9d$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || $0c49c351e4bf4c9d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || $0c49c351e4bf4c9d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $0c49c351e4bf4c9d$var$hostParent, prevHostParentIsContainer = $0c49c351e4bf4c9d$var$hostParentIsContainer;
            $0c49c351e4bf4c9d$var$isSingletonScope(deletedFiber.type) && ($0c49c351e4bf4c9d$var$hostParent = deletedFiber.stateNode, $0c49c351e4bf4c9d$var$hostParentIsContainer = !1);
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c49c351e4bf4c9d$var$releaseSingletonInstance(deletedFiber.stateNode);
            $0c49c351e4bf4c9d$var$hostParent = prevHostParent;
            $0c49c351e4bf4c9d$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || $0c49c351e4bf4c9d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $0c49c351e4bf4c9d$var$hostParent;
            prevHostParentIsContainer = $0c49c351e4bf4c9d$var$hostParentIsContainer;
            $0c49c351e4bf4c9d$var$hostParent = null;
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c49c351e4bf4c9d$var$hostParent = prevHostParent;
            $0c49c351e4bf4c9d$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $0c49c351e4bf4c9d$var$hostParent) {
                if ($0c49c351e4bf4c9d$var$hostParentIsContainer) try {
                    (9 === $0c49c351e4bf4c9d$var$hostParent.nodeType ? $0c49c351e4bf4c9d$var$hostParent.body : "HTML" === $0c49c351e4bf4c9d$var$hostParent.nodeName ? $0c49c351e4bf4c9d$var$hostParent.ownerDocument.body : $0c49c351e4bf4c9d$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $0c49c351e4bf4c9d$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $0c49c351e4bf4c9d$var$hostParent && ($0c49c351e4bf4c9d$var$hostParentIsContainer ? (finishedRoot = $0c49c351e4bf4c9d$var$hostParent, $0c49c351e4bf4c9d$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $0c49c351e4bf4c9d$var$retryIfBlockedOn(finishedRoot)) : $0c49c351e4bf4c9d$var$clearHydrationBoundary($0c49c351e4bf4c9d$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $0c49c351e4bf4c9d$var$hostParent;
            prevHostParentIsContainer = $0c49c351e4bf4c9d$var$hostParentIsContainer;
            $0c49c351e4bf4c9d$var$hostParent = deletedFiber.stateNode.containerInfo;
            $0c49c351e4bf4c9d$var$hostParentIsContainer = !0;
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c49c351e4bf4c9d$var$hostParent = prevHostParent;
            $0c49c351e4bf4c9d$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || ($0c49c351e4bf4c9d$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $0c49c351e4bf4c9d$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden = (prevHostParent = $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $0c49c351e4bf4c9d$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $0c49c351e4bf4c9d$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $0c49c351e4bf4c9d$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $0c49c351e4bf4c9d$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $0c49c351e4bf4c9d$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c49c351e4bf4c9d$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $0c49c351e4bf4c9d$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $0c49c351e4bf4c9d$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $0c49c351e4bf4c9d$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $0c49c351e4bf4c9d$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $0c49c351e4bf4c9d$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($0c49c351e4bf4c9d$var$isSingletonScope(parent.type)) {
                        $0c49c351e4bf4c9d$var$hostParent = parent.stateNode;
                        $0c49c351e4bf4c9d$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $0c49c351e4bf4c9d$var$hostParent = parent.stateNode;
                    $0c49c351e4bf4c9d$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $0c49c351e4bf4c9d$var$hostParent = parent.stateNode.containerInfo;
                    $0c49c351e4bf4c9d$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $0c49c351e4bf4c9d$var$hostParent) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(160));
        $0c49c351e4bf4c9d$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $0c49c351e4bf4c9d$var$hostParent = null;
        $0c49c351e4bf4c9d$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c49c351e4bf4c9d$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $0c49c351e4bf4c9d$var$currentHoistableRoot = null;
function $0c49c351e4bf4c9d$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($0c49c351e4bf4c9d$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $0c49c351e4bf4c9d$var$commitHookEffectListMount(3, finishedWork), $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || null === current || $0c49c351e4bf4c9d$var$safelyDetachRef(current, current.return));
            flags & 64 && $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $0c49c351e4bf4c9d$var$currentHoistableRoot;
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || null === current || $0c49c351e4bf4c9d$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$0c49c351e4bf4c9d$var$internalHoistableMarker] || currentResource[$0c49c351e4bf4c9d$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $0c49c351e4bf4c9d$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$0c49c351e4bf4c9d$var$internalInstanceKey] = finishedWork;
                                        $0c49c351e4bf4c9d$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $0c49c351e4bf4c9d$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $0c49c351e4bf4c9d$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $0c49c351e4bf4c9d$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $0c49c351e4bf4c9d$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$0c49c351e4bf4c9d$var$internalInstanceKey] = finishedWork;
                                $0c49c351e4bf4c9d$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $0c49c351e4bf4c9d$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $0c49c351e4bf4c9d$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $0c49c351e4bf4c9d$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $0c49c351e4bf4c9d$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $0c49c351e4bf4c9d$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || null === current || $0c49c351e4bf4c9d$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $0c49c351e4bf4c9d$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || null === current || $0c49c351e4bf4c9d$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $0c49c351e4bf4c9d$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $0c49c351e4bf4c9d$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($0c49c351e4bf4c9d$var$needsFormReset = !0);
            break;
        case 6:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $0c49c351e4bf4c9d$var$tagCaches = null;
            hoistableRoot = $0c49c351e4bf4c9d$var$currentHoistableRoot;
            $0c49c351e4bf4c9d$var$currentHoistableRoot = $0c49c351e4bf4c9d$var$getHoistableRoot(root.containerInfo);
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$currentHoistableRoot = hoistableRoot;
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $0c49c351e4bf4c9d$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $0c49c351e4bf4c9d$var$needsFormReset && ($0c49c351e4bf4c9d$var$needsFormReset = !1, $0c49c351e4bf4c9d$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $0c49c351e4bf4c9d$var$currentHoistableRoot;
            $0c49c351e4bf4c9d$var$currentHoistableRoot = $0c49c351e4bf4c9d$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            $0c49c351e4bf4c9d$var$currentHoistableRoot = flags;
            break;
        case 12:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $0c49c351e4bf4c9d$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($0c49c351e4bf4c9d$var$globalMostRecentFallbackTime = $0c49c351e4bf4c9d$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $0c49c351e4bf4c9d$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden;
            $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $0c49c351e4bf4c9d$var$offscreenSubtreeIsHidden || $0c49c351e4bf4c9d$var$offscreenSubtreeWasHidden || $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $0c49c351e4bf4c9d$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $0c49c351e4bf4c9d$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $0c49c351e4bf4c9d$var$hideOrUnhideDehydratedBoundary(instance, !0) : $0c49c351e4bf4c9d$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $0c49c351e4bf4c9d$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $0c49c351e4bf4c9d$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $0c49c351e4bf4c9d$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $0c49c351e4bf4c9d$var$recursivelyTraverseMutationEffects(root, finishedWork), $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork);
    }
}
function $0c49c351e4bf4c9d$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($0c49c351e4bf4c9d$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $0c49c351e4bf4c9d$var$getHostSibling(finishedWork);
                    $0c49c351e4bf4c9d$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($0c49c351e4bf4c9d$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $0c49c351e4bf4c9d$var$getHostSibling(finishedWork);
                    $0c49c351e4bf4c9d$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $0c49c351e4bf4c9d$var$getHostSibling(finishedWork);
                    $0c49c351e4bf4c9d$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $0c49c351e4bf4c9d$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $0c49c351e4bf4c9d$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $0c49c351e4bf4c9d$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c49c351e4bf4c9d$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $0c49c351e4bf4c9d$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $0c49c351e4bf4c9d$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $0c49c351e4bf4c9d$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $0c49c351e4bf4c9d$var$safelyDetachRef(finishedWork, finishedWork.return);
                $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $0c49c351e4bf4c9d$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $0c49c351e4bf4c9d$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$0c49c351e4bf4c9d$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $0c49c351e4bf4c9d$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $0c49c351e4bf4c9d$var$commitClassCallbacks(finishedWork);
                $0c49c351e4bf4c9d$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $0c49c351e4bf4c9d$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $0c49c351e4bf4c9d$var$commitHostMount(finishedWork);
                $0c49c351e4bf4c9d$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $0c49c351e4bf4c9d$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $0c49c351e4bf4c9d$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $0c49c351e4bf4c9d$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c49c351e4bf4c9d$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $0c49c351e4bf4c9d$var$releaseCache(previousCache));
}
function $0c49c351e4bf4c9d$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $0c49c351e4bf4c9d$var$releaseCache(current));
}
function $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c49c351e4bf4c9d$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $0c49c351e4bf4c9d$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $0c49c351e4bf4c9d$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $0c49c351e4bf4c9d$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $0c49c351e4bf4c9d$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $0c49c351e4bf4c9d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $0c49c351e4bf4c9d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $0c49c351e4bf4c9d$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $0c49c351e4bf4c9d$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $0c49c351e4bf4c9d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $0c49c351e4bf4c9d$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $0c49c351e4bf4c9d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $0c49c351e4bf4c9d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $0c49c351e4bf4c9d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $0c49c351e4bf4c9d$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $0c49c351e4bf4c9d$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $0c49c351e4bf4c9d$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c49c351e4bf4c9d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $0c49c351e4bf4c9d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $0c49c351e4bf4c9d$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $0c49c351e4bf4c9d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $0c49c351e4bf4c9d$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $0c49c351e4bf4c9d$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $0c49c351e4bf4c9d$var$suspenseyCommitFlag = 8192;
function $0c49c351e4bf4c9d$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $0c49c351e4bf4c9d$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c49c351e4bf4c9d$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $0c49c351e4bf4c9d$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $0c49c351e4bf4c9d$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $0c49c351e4bf4c9d$var$suspenseyCommitFlag && null !== fiber.memoizedState && $0c49c351e4bf4c9d$var$suspendResource(suspendedState, $0c49c351e4bf4c9d$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $0c49c351e4bf4c9d$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $0c49c351e4bf4c9d$var$currentHoistableRoot;
            $0c49c351e4bf4c9d$var$currentHoistableRoot = $0c49c351e4bf4c9d$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $0c49c351e4bf4c9d$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $0c49c351e4bf4c9d$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $0c49c351e4bf4c9d$var$suspenseyCommitFlag, $0c49c351e4bf4c9d$var$suspenseyCommitFlag = 16777216, $0c49c351e4bf4c9d$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $0c49c351e4bf4c9d$var$suspenseyCommitFlag = previousHoistableRoot) : $0c49c351e4bf4c9d$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $0c49c351e4bf4c9d$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $0c49c351e4bf4c9d$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $0c49c351e4bf4c9d$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $0c49c351e4bf4c9d$var$nextEffect = childToDelete;
            $0c49c351e4bf4c9d$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $0c49c351e4bf4c9d$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c49c351e4bf4c9d$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $0c49c351e4bf4c9d$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $0c49c351e4bf4c9d$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $0c49c351e4bf4c9d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $0c49c351e4bf4c9d$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $0c49c351e4bf4c9d$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $0c49c351e4bf4c9d$var$nextEffect = childToDelete;
            $0c49c351e4bf4c9d$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $0c49c351e4bf4c9d$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $0c49c351e4bf4c9d$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $0c49c351e4bf4c9d$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $0c49c351e4bf4c9d$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c49c351e4bf4c9d$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $0c49c351e4bf4c9d$var$nextEffect;){
        var fiber = $0c49c351e4bf4c9d$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $0c49c351e4bf4c9d$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $0c49c351e4bf4c9d$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $0c49c351e4bf4c9d$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $0c49c351e4bf4c9d$var$nextEffect;){
            cache = $0c49c351e4bf4c9d$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $0c49c351e4bf4c9d$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $0c49c351e4bf4c9d$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $0c49c351e4bf4c9d$var$nextEffect = sibling;
                break a;
            }
            $0c49c351e4bf4c9d$var$nextEffect = returnFiber;
        }
    }
}
var $0c49c351e4bf4c9d$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $0c49c351e4bf4c9d$var$readContext($0c49c351e4bf4c9d$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $0c49c351e4bf4c9d$var$readContext($0c49c351e4bf4c9d$var$CacheContext).controller.signal;
    }
}, $0c49c351e4bf4c9d$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $0c49c351e4bf4c9d$var$executionContext = 0, $0c49c351e4bf4c9d$var$workInProgressRoot = null, $0c49c351e4bf4c9d$var$workInProgress = null, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes = 0, $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0, $0c49c351e4bf4c9d$var$workInProgressThrownValue = null, $0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings = !1, $0c49c351e4bf4c9d$var$workInProgressRootIsPrerendering = !1, $0c49c351e4bf4c9d$var$workInProgressRootDidAttachPingListener = !1, $0c49c351e4bf4c9d$var$entangledRenderLanes = 0, $0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 0, $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes = 0, $0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes = 0, $0c49c351e4bf4c9d$var$workInProgressRootPingedLanes = 0, $0c49c351e4bf4c9d$var$workInProgressDeferredLane = 0, $0c49c351e4bf4c9d$var$workInProgressSuspendedRetryLanes = 0, $0c49c351e4bf4c9d$var$workInProgressRootConcurrentErrors = null, $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors = null, $0c49c351e4bf4c9d$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $0c49c351e4bf4c9d$var$globalMostRecentFallbackTime = 0, $0c49c351e4bf4c9d$var$globalMostRecentTransitionTime = 0, $0c49c351e4bf4c9d$var$workInProgressRootRenderTargetTime = Infinity, $0c49c351e4bf4c9d$var$workInProgressTransitions = null, $0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed = null, $0c49c351e4bf4c9d$var$pendingEffectsStatus = 0, $0c49c351e4bf4c9d$var$pendingEffectsRoot = null, $0c49c351e4bf4c9d$var$pendingFinishedWork = null, $0c49c351e4bf4c9d$var$pendingEffectsLanes = 0, $0c49c351e4bf4c9d$var$pendingEffectsRemainingLanes = 0, $0c49c351e4bf4c9d$var$pendingPassiveTransitions = null, $0c49c351e4bf4c9d$var$pendingRecoverableErrors = null, $0c49c351e4bf4c9d$var$nestedUpdateCount = 0, $0c49c351e4bf4c9d$var$rootWithNestedUpdates = null;
function $0c49c351e4bf4c9d$var$requestUpdateLane() {
    return 0 !== ($0c49c351e4bf4c9d$var$executionContext & 2) && 0 !== $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes ? $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & -$0c49c351e4bf4c9d$var$workInProgressRootRenderLanes : null !== $0c49c351e4bf4c9d$var$ReactSharedInternals.T ? $0c49c351e4bf4c9d$var$requestTransitionLane() : $0c49c351e4bf4c9d$var$resolveUpdatePriority();
}
function $0c49c351e4bf4c9d$var$requestDeferredLane() {
    if (0 === $0c49c351e4bf4c9d$var$workInProgressDeferredLane) {
        if (0 === ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 536870912) || $0c49c351e4bf4c9d$var$isHydrating) {
            var lane = $0c49c351e4bf4c9d$var$nextTransitionDeferredLane;
            $0c49c351e4bf4c9d$var$nextTransitionDeferredLane <<= 1;
            0 === ($0c49c351e4bf4c9d$var$nextTransitionDeferredLane & 3932160) && ($0c49c351e4bf4c9d$var$nextTransitionDeferredLane = 262144);
            $0c49c351e4bf4c9d$var$workInProgressDeferredLane = lane;
        } else $0c49c351e4bf4c9d$var$workInProgressDeferredLane = 536870912;
    }
    lane = $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $0c49c351e4bf4c9d$var$workInProgressDeferredLane;
}
function $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $0c49c351e4bf4c9d$var$workInProgressRoot && (2 === $0c49c351e4bf4c9d$var$workInProgressSuspendedReason || 9 === $0c49c351e4bf4c9d$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $0c49c351e4bf4c9d$var$prepareFreshStack(root, 0), $0c49c351e4bf4c9d$var$markRootSuspended(root, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes, $0c49c351e4bf4c9d$var$workInProgressDeferredLane, !1);
    $0c49c351e4bf4c9d$var$markRootUpdated$1(root, lane);
    if (0 === ($0c49c351e4bf4c9d$var$executionContext & 2) || root !== $0c49c351e4bf4c9d$var$workInProgressRoot) root === $0c49c351e4bf4c9d$var$workInProgressRoot && (0 === ($0c49c351e4bf4c9d$var$executionContext & 2) && ($0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $0c49c351e4bf4c9d$var$workInProgressRootExitStatus && $0c49c351e4bf4c9d$var$markRootSuspended(root, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes, $0c49c351e4bf4c9d$var$workInProgressDeferredLane, !1)), $0c49c351e4bf4c9d$var$ensureRootIsScheduled(root);
}
function $0c49c351e4bf4c9d$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($0c49c351e4bf4c9d$var$executionContext & 6)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $0c49c351e4bf4c9d$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $0c49c351e4bf4c9d$var$renderRootConcurrent(root$jscomp$0, lanes) : $0c49c351e4bf4c9d$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $0c49c351e4bf4c9d$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $0c49c351e4bf4c9d$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$0c49c351e4bf4c9d$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $0c49c351e4bf4c9d$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $0c49c351e4bf4c9d$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($0c49c351e4bf4c9d$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $0c49c351e4bf4c9d$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($0c49c351e4bf4c9d$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors;
                            $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors ? $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors.push.apply($0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $0c49c351e4bf4c9d$var$prepareFreshStack(root$jscomp$0, 0);
                $0c49c351e4bf4c9d$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $0c49c351e4bf4c9d$var$markRootSuspended(shouldTimeSlice, lanes, $0c49c351e4bf4c9d$var$workInProgressDeferredLane, !$0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $0c49c351e4bf4c9d$var$globalMostRecentFallbackTime + 300 - $0c49c351e4bf4c9d$var$now(), 10 < exitStatus)) {
                    $0c49c351e4bf4c9d$var$markRootSuspended(shouldTimeSlice, lanes, $0c49c351e4bf4c9d$var$workInProgressDeferredLane, !$0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $0c49c351e4bf4c9d$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $0c49c351e4bf4c9d$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $0c49c351e4bf4c9d$var$scheduleTimeout($0c49c351e4bf4c9d$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors, $0c49c351e4bf4c9d$var$workInProgressTransitions, $0c49c351e4bf4c9d$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $0c49c351e4bf4c9d$var$workInProgressDeferredLane, $0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes, $0c49c351e4bf4c9d$var$workInProgressSuspendedRetryLanes, $0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $0c49c351e4bf4c9d$var$commitRootWhenReady(shouldTimeSlice, forceSync, $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors, $0c49c351e4bf4c9d$var$workInProgressTransitions, $0c49c351e4bf4c9d$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $0c49c351e4bf4c9d$var$workInProgressDeferredLane, $0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes, $0c49c351e4bf4c9d$var$workInProgressSuspendedRetryLanes, $0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $0c49c351e4bf4c9d$var$ensureRootIsScheduled(root$jscomp$0);
}
function $0c49c351e4bf4c9d$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $0c49c351e4bf4c9d$var$noop$1
        };
        $0c49c351e4bf4c9d$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $0c49c351e4bf4c9d$var$globalMostRecentFallbackTime - $0c49c351e4bf4c9d$var$now() : (lanes & 4194048) === lanes ? $0c49c351e4bf4c9d$var$globalMostRecentTransitionTime - $0c49c351e4bf4c9d$var$now() : 0;
        timeoutOffset = $0c49c351e4bf4c9d$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $0c49c351e4bf4c9d$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($0c49c351e4bf4c9d$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $0c49c351e4bf4c9d$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $0c49c351e4bf4c9d$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $0c49c351e4bf4c9d$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$0c49c351e4bf4c9d$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $0c49c351e4bf4c9d$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$0c49c351e4bf4c9d$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $0c49c351e4bf4c9d$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $0c49c351e4bf4c9d$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $0c49c351e4bf4c9d$var$flushSyncWork$1() {
    return 0 === ($0c49c351e4bf4c9d$var$executionContext & 6) ? ($0c49c351e4bf4c9d$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $0c49c351e4bf4c9d$var$resetWorkInProgressStack() {
    if (null !== $0c49c351e4bf4c9d$var$workInProgress) {
        if (0 === $0c49c351e4bf4c9d$var$workInProgressSuspendedReason) var interruptedWork = $0c49c351e4bf4c9d$var$workInProgress.return;
        else interruptedWork = $0c49c351e4bf4c9d$var$workInProgress, $0c49c351e4bf4c9d$var$lastContextDependency = $0c49c351e4bf4c9d$var$currentlyRenderingFiber$1 = null, $0c49c351e4bf4c9d$var$resetHooksOnUnwind(interruptedWork), $0c49c351e4bf4c9d$var$thenableState$1 = null, $0c49c351e4bf4c9d$var$thenableIndexCounter$1 = 0, interruptedWork = $0c49c351e4bf4c9d$var$workInProgress;
        for(; null !== interruptedWork;)$0c49c351e4bf4c9d$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $0c49c351e4bf4c9d$var$workInProgress = null;
    }
}
function $0c49c351e4bf4c9d$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $0c49c351e4bf4c9d$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $0c49c351e4bf4c9d$var$pendingEffectsLanes = 0;
    $0c49c351e4bf4c9d$var$resetWorkInProgressStack();
    $0c49c351e4bf4c9d$var$workInProgressRoot = root;
    $0c49c351e4bf4c9d$var$workInProgress = timeoutHandle = $0c49c351e4bf4c9d$var$createWorkInProgress(root.current, null);
    $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes = lanes;
    $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0;
    $0c49c351e4bf4c9d$var$workInProgressThrownValue = null;
    $0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $0c49c351e4bf4c9d$var$workInProgressRootIsPrerendering = $0c49c351e4bf4c9d$var$checkIfRootIsPrerendering(root, lanes);
    $0c49c351e4bf4c9d$var$workInProgressRootDidAttachPingListener = !1;
    $0c49c351e4bf4c9d$var$workInProgressSuspendedRetryLanes = $0c49c351e4bf4c9d$var$workInProgressDeferredLane = $0c49c351e4bf4c9d$var$workInProgressRootPingedLanes = $0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes = $0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes = $0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 0;
    $0c49c351e4bf4c9d$var$workInProgressRootRecoverableErrors = $0c49c351e4bf4c9d$var$workInProgressRootConcurrentErrors = null;
    $0c49c351e4bf4c9d$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $0c49c351e4bf4c9d$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $0c49c351e4bf4c9d$var$entangledRenderLanes = lanes;
    $0c49c351e4bf4c9d$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $0c49c351e4bf4c9d$var$handleThrow(root, thrownValue) {
    $0c49c351e4bf4c9d$var$currentlyRenderingFiber = null;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.H = $0c49c351e4bf4c9d$var$ContextOnlyDispatcher;
    thrownValue === $0c49c351e4bf4c9d$var$SuspenseException || thrownValue === $0c49c351e4bf4c9d$var$SuspenseActionException ? (thrownValue = $0c49c351e4bf4c9d$var$getSuspendedThenable(), $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 3) : thrownValue === $0c49c351e4bf4c9d$var$SuspenseyCommitException ? (thrownValue = $0c49c351e4bf4c9d$var$getSuspendedThenable(), $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 4) : $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = thrownValue === $0c49c351e4bf4c9d$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $0c49c351e4bf4c9d$var$workInProgressThrownValue = thrownValue;
    null === $0c49c351e4bf4c9d$var$workInProgress && ($0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 1, $0c49c351e4bf4c9d$var$logUncaughtError(root, $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $0c49c351e4bf4c9d$var$shouldRemainOnPreviousScreen() {
    var handler = $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 4194048) === $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes ? null === $0c49c351e4bf4c9d$var$shellBoundary ? !0 : !1 : ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 62914560) === $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes || 0 !== ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 536870912) ? handler === $0c49c351e4bf4c9d$var$shellBoundary : !1;
}
function $0c49c351e4bf4c9d$var$pushDispatcher() {
    var prevDispatcher = $0c49c351e4bf4c9d$var$ReactSharedInternals.H;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.H = $0c49c351e4bf4c9d$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $0c49c351e4bf4c9d$var$ContextOnlyDispatcher : prevDispatcher;
}
function $0c49c351e4bf4c9d$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $0c49c351e4bf4c9d$var$ReactSharedInternals.A;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.A = $0c49c351e4bf4c9d$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $0c49c351e4bf4c9d$var$renderDidSuspendDelayIfPossible() {
    $0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 4;
    $0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings || ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 4194048) !== $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes && null !== $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current || ($0c49c351e4bf4c9d$var$workInProgressRootIsPrerendering = !0);
    0 === ($0c49c351e4bf4c9d$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($0c49c351e4bf4c9d$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $0c49c351e4bf4c9d$var$workInProgressRoot || $0c49c351e4bf4c9d$var$markRootSuspended($0c49c351e4bf4c9d$var$workInProgressRoot, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes, $0c49c351e4bf4c9d$var$workInProgressDeferredLane, !1);
}
function $0c49c351e4bf4c9d$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $0c49c351e4bf4c9d$var$executionContext;
    $0c49c351e4bf4c9d$var$executionContext |= 2;
    var prevDispatcher = $0c49c351e4bf4c9d$var$pushDispatcher(), prevAsyncDispatcher = $0c49c351e4bf4c9d$var$pushAsyncDispatcher();
    if ($0c49c351e4bf4c9d$var$workInProgressRoot !== root || $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes !== lanes) $0c49c351e4bf4c9d$var$workInProgressTransitions = null, $0c49c351e4bf4c9d$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $0c49c351e4bf4c9d$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $0c49c351e4bf4c9d$var$workInProgressSuspendedReason && null !== $0c49c351e4bf4c9d$var$workInProgress) {
            var unitOfWork = $0c49c351e4bf4c9d$var$workInProgress, thrownValue = $0c49c351e4bf4c9d$var$workInProgressThrownValue;
            switch($0c49c351e4bf4c9d$var$workInProgressSuspendedReason){
                case 8:
                    $0c49c351e4bf4c9d$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $0c49c351e4bf4c9d$var$workInProgressSuspendedReason;
                    $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0;
                    $0c49c351e4bf4c9d$var$workInProgressThrownValue = null;
                    $0c49c351e4bf4c9d$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $0c49c351e4bf4c9d$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $0c49c351e4bf4c9d$var$workInProgressSuspendedReason, $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0, $0c49c351e4bf4c9d$var$workInProgressThrownValue = null, $0c49c351e4bf4c9d$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $0c49c351e4bf4c9d$var$workLoopSync();
        exitStatus = $0c49c351e4bf4c9d$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $0c49c351e4bf4c9d$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $0c49c351e4bf4c9d$var$lastContextDependency = $0c49c351e4bf4c9d$var$currentlyRenderingFiber$1 = null;
    $0c49c351e4bf4c9d$var$executionContext = prevExecutionContext;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.H = prevDispatcher;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $0c49c351e4bf4c9d$var$workInProgress && ($0c49c351e4bf4c9d$var$workInProgressRoot = null, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes = 0, $0c49c351e4bf4c9d$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $0c49c351e4bf4c9d$var$workLoopSync() {
    for(; null !== $0c49c351e4bf4c9d$var$workInProgress;)$0c49c351e4bf4c9d$var$performUnitOfWork($0c49c351e4bf4c9d$var$workInProgress);
}
function $0c49c351e4bf4c9d$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $0c49c351e4bf4c9d$var$executionContext;
    $0c49c351e4bf4c9d$var$executionContext |= 2;
    var prevDispatcher = $0c49c351e4bf4c9d$var$pushDispatcher(), prevAsyncDispatcher = $0c49c351e4bf4c9d$var$pushAsyncDispatcher();
    $0c49c351e4bf4c9d$var$workInProgressRoot !== root || $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes !== lanes ? ($0c49c351e4bf4c9d$var$workInProgressTransitions = null, $0c49c351e4bf4c9d$var$workInProgressRootRenderTargetTime = $0c49c351e4bf4c9d$var$now() + 500, $0c49c351e4bf4c9d$var$prepareFreshStack(root, lanes)) : $0c49c351e4bf4c9d$var$workInProgressRootIsPrerendering = $0c49c351e4bf4c9d$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $0c49c351e4bf4c9d$var$workInProgressSuspendedReason && null !== $0c49c351e4bf4c9d$var$workInProgress) {
            lanes = $0c49c351e4bf4c9d$var$workInProgress;
            var thrownValue = $0c49c351e4bf4c9d$var$workInProgressThrownValue;
            b: switch($0c49c351e4bf4c9d$var$workInProgressSuspendedReason){
                case 1:
                    $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0;
                    $0c49c351e4bf4c9d$var$workInProgressThrownValue = null;
                    $0c49c351e4bf4c9d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($0c49c351e4bf4c9d$var$isThenableResolved(thrownValue)) {
                        $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0;
                        $0c49c351e4bf4c9d$var$workInProgressThrownValue = null;
                        $0c49c351e4bf4c9d$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $0c49c351e4bf4c9d$var$workInProgressSuspendedReason && 9 !== $0c49c351e4bf4c9d$var$workInProgressSuspendedReason || $0c49c351e4bf4c9d$var$workInProgressRoot !== root || ($0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 7);
                        $0c49c351e4bf4c9d$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $0c49c351e4bf4c9d$var$isThenableResolved(thrownValue) ? ($0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0, $0c49c351e4bf4c9d$var$workInProgressThrownValue = null, $0c49c351e4bf4c9d$var$replaySuspendedUnitOfWork(lanes)) : ($0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0, $0c49c351e4bf4c9d$var$workInProgressThrownValue = null, $0c49c351e4bf4c9d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($0c49c351e4bf4c9d$var$workInProgress.tag){
                        case 26:
                            resource = $0c49c351e4bf4c9d$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $0c49c351e4bf4c9d$var$workInProgress;
                            if (resource ? $0c49c351e4bf4c9d$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0;
                                $0c49c351e4bf4c9d$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $0c49c351e4bf4c9d$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($0c49c351e4bf4c9d$var$workInProgress = returnFiber, $0c49c351e4bf4c9d$var$completeUnitOfWork(returnFiber)) : $0c49c351e4bf4c9d$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0;
                    $0c49c351e4bf4c9d$var$workInProgressThrownValue = null;
                    $0c49c351e4bf4c9d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $0c49c351e4bf4c9d$var$workInProgressSuspendedReason = 0;
                    $0c49c351e4bf4c9d$var$workInProgressThrownValue = null;
                    $0c49c351e4bf4c9d$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $0c49c351e4bf4c9d$var$resetWorkInProgressStack();
                    $0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(462));
            }
        }
        $0c49c351e4bf4c9d$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $0c49c351e4bf4c9d$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $0c49c351e4bf4c9d$var$lastContextDependency = $0c49c351e4bf4c9d$var$currentlyRenderingFiber$1 = null;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.H = prevDispatcher;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $0c49c351e4bf4c9d$var$executionContext = prevExecutionContext;
    if (null !== $0c49c351e4bf4c9d$var$workInProgress) return 0;
    $0c49c351e4bf4c9d$var$workInProgressRoot = null;
    $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes = 0;
    $0c49c351e4bf4c9d$var$finishQueueingConcurrentUpdates();
    return $0c49c351e4bf4c9d$var$workInProgressRootExitStatus;
}
function $0c49c351e4bf4c9d$var$workLoopConcurrentByScheduler() {
    for(; null !== $0c49c351e4bf4c9d$var$workInProgress && !$0c49c351e4bf4c9d$var$shouldYield();)$0c49c351e4bf4c9d$var$performUnitOfWork($0c49c351e4bf4c9d$var$workInProgress);
}
function $0c49c351e4bf4c9d$var$performUnitOfWork(unitOfWork) {
    var next = $0c49c351e4bf4c9d$var$beginWork(unitOfWork.alternate, unitOfWork, $0c49c351e4bf4c9d$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $0c49c351e4bf4c9d$var$completeUnitOfWork(unitOfWork) : $0c49c351e4bf4c9d$var$workInProgress = next;
}
function $0c49c351e4bf4c9d$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $0c49c351e4bf4c9d$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $0c49c351e4bf4c9d$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $0c49c351e4bf4c9d$var$resetHooksOnUnwind(next);
        default:
            $0c49c351e4bf4c9d$var$unwindInterruptedWork(current, next), next = $0c49c351e4bf4c9d$var$workInProgress = $0c49c351e4bf4c9d$var$resetWorkInProgress(next, $0c49c351e4bf4c9d$var$entangledRenderLanes), next = $0c49c351e4bf4c9d$var$beginWork(current, next, $0c49c351e4bf4c9d$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $0c49c351e4bf4c9d$var$completeUnitOfWork(unitOfWork) : $0c49c351e4bf4c9d$var$workInProgress = next;
}
function $0c49c351e4bf4c9d$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $0c49c351e4bf4c9d$var$lastContextDependency = $0c49c351e4bf4c9d$var$currentlyRenderingFiber$1 = null;
    $0c49c351e4bf4c9d$var$resetHooksOnUnwind(unitOfWork);
    $0c49c351e4bf4c9d$var$thenableState$1 = null;
    $0c49c351e4bf4c9d$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($0c49c351e4bf4c9d$var$throwException(root, returnFiber, unitOfWork, thrownValue, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes)) {
            $0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 1;
            $0c49c351e4bf4c9d$var$logUncaughtError(root, $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(thrownValue, root.current));
            $0c49c351e4bf4c9d$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $0c49c351e4bf4c9d$var$workInProgress = returnFiber, error;
        $0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 1;
        $0c49c351e4bf4c9d$var$logUncaughtError(root, $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(thrownValue, root.current));
        $0c49c351e4bf4c9d$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($0c49c351e4bf4c9d$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($0c49c351e4bf4c9d$var$workInProgressRootIsPrerendering || 0 !== ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $0c49c351e4bf4c9d$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $0c49c351e4bf4c9d$var$unwindUnitOfWork(unitOfWork, root);
    } else $0c49c351e4bf4c9d$var$completeUnitOfWork(unitOfWork);
}
function $0c49c351e4bf4c9d$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $0c49c351e4bf4c9d$var$unwindUnitOfWork(completedWork, $0c49c351e4bf4c9d$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $0c49c351e4bf4c9d$var$completeWork(completedWork.alternate, completedWork, $0c49c351e4bf4c9d$var$entangledRenderLanes);
        if (null !== next) {
            $0c49c351e4bf4c9d$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $0c49c351e4bf4c9d$var$workInProgress = completedWork;
            return;
        }
        $0c49c351e4bf4c9d$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $0c49c351e4bf4c9d$var$workInProgressRootExitStatus && ($0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 5);
}
function $0c49c351e4bf4c9d$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $0c49c351e4bf4c9d$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $0c49c351e4bf4c9d$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $0c49c351e4bf4c9d$var$workInProgress = unitOfWork;
            return;
        }
        $0c49c351e4bf4c9d$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $0c49c351e4bf4c9d$var$workInProgressRootExitStatus = 6;
    $0c49c351e4bf4c9d$var$workInProgress = null;
}
function $0c49c351e4bf4c9d$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $0c49c351e4bf4c9d$var$flushPendingEffects();
    while (0 !== $0c49c351e4bf4c9d$var$pendingEffectsStatus);
    if (0 !== ($0c49c351e4bf4c9d$var$executionContext & 6)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $0c49c351e4bf4c9d$var$concurrentlyUpdatedLanes;
        $0c49c351e4bf4c9d$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $0c49c351e4bf4c9d$var$workInProgressRoot && ($0c49c351e4bf4c9d$var$workInProgress = $0c49c351e4bf4c9d$var$workInProgressRoot = null, $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes = 0);
        $0c49c351e4bf4c9d$var$pendingFinishedWork = finishedWork;
        $0c49c351e4bf4c9d$var$pendingEffectsRoot = root;
        $0c49c351e4bf4c9d$var$pendingEffectsLanes = lanes;
        $0c49c351e4bf4c9d$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $0c49c351e4bf4c9d$var$pendingPassiveTransitions = transitions;
        $0c49c351e4bf4c9d$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $0c49c351e4bf4c9d$var$scheduleCallback$1($0c49c351e4bf4c9d$var$NormalPriority$1, function() {
            $0c49c351e4bf4c9d$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $0c49c351e4bf4c9d$var$ReactSharedInternals.T;
            $0c49c351e4bf4c9d$var$ReactSharedInternals.T = null;
            transitions = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
            $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $0c49c351e4bf4c9d$var$executionContext;
            $0c49c351e4bf4c9d$var$executionContext |= 4;
            try {
                $0c49c351e4bf4c9d$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $0c49c351e4bf4c9d$var$executionContext = spawnedLane, $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = transitions, $0c49c351e4bf4c9d$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $0c49c351e4bf4c9d$var$pendingEffectsStatus = 1;
        $0c49c351e4bf4c9d$var$flushMutationEffects();
        $0c49c351e4bf4c9d$var$flushLayoutEffects();
        $0c49c351e4bf4c9d$var$flushSpawnedWork();
    }
}
function $0c49c351e4bf4c9d$var$flushMutationEffects() {
    if (1 === $0c49c351e4bf4c9d$var$pendingEffectsStatus) {
        $0c49c351e4bf4c9d$var$pendingEffectsStatus = 0;
        var root = $0c49c351e4bf4c9d$var$pendingEffectsRoot, finishedWork = $0c49c351e4bf4c9d$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $0c49c351e4bf4c9d$var$ReactSharedInternals.T;
            $0c49c351e4bf4c9d$var$ReactSharedInternals.T = null;
            var previousPriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
            $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $0c49c351e4bf4c9d$var$executionContext;
            $0c49c351e4bf4c9d$var$executionContext |= 4;
            try {
                $0c49c351e4bf4c9d$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $0c49c351e4bf4c9d$var$selectionInformation, curFocusedElem = $0c49c351e4bf4c9d$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $0c49c351e4bf4c9d$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $0c49c351e4bf4c9d$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $0c49c351e4bf4c9d$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $0c49c351e4bf4c9d$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $0c49c351e4bf4c9d$var$_enabled = !!$0c49c351e4bf4c9d$var$eventsEnabled;
                $0c49c351e4bf4c9d$var$selectionInformation = $0c49c351e4bf4c9d$var$eventsEnabled = null;
            } finally{
                $0c49c351e4bf4c9d$var$executionContext = prevExecutionContext, $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = previousPriority, $0c49c351e4bf4c9d$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $0c49c351e4bf4c9d$var$pendingEffectsStatus = 2;
    }
}
function $0c49c351e4bf4c9d$var$flushLayoutEffects() {
    if (2 === $0c49c351e4bf4c9d$var$pendingEffectsStatus) {
        $0c49c351e4bf4c9d$var$pendingEffectsStatus = 0;
        var root = $0c49c351e4bf4c9d$var$pendingEffectsRoot, finishedWork = $0c49c351e4bf4c9d$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $0c49c351e4bf4c9d$var$ReactSharedInternals.T;
            $0c49c351e4bf4c9d$var$ReactSharedInternals.T = null;
            var previousPriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
            $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $0c49c351e4bf4c9d$var$executionContext;
            $0c49c351e4bf4c9d$var$executionContext |= 4;
            try {
                $0c49c351e4bf4c9d$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $0c49c351e4bf4c9d$var$executionContext = prevExecutionContext, $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = previousPriority, $0c49c351e4bf4c9d$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $0c49c351e4bf4c9d$var$pendingEffectsStatus = 3;
    }
}
function $0c49c351e4bf4c9d$var$flushSpawnedWork() {
    if (4 === $0c49c351e4bf4c9d$var$pendingEffectsStatus || 3 === $0c49c351e4bf4c9d$var$pendingEffectsStatus) {
        $0c49c351e4bf4c9d$var$pendingEffectsStatus = 0;
        $0c49c351e4bf4c9d$var$requestPaint();
        var root = $0c49c351e4bf4c9d$var$pendingEffectsRoot, finishedWork = $0c49c351e4bf4c9d$var$pendingFinishedWork, lanes = $0c49c351e4bf4c9d$var$pendingEffectsLanes, recoverableErrors = $0c49c351e4bf4c9d$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $0c49c351e4bf4c9d$var$pendingEffectsStatus = 5 : ($0c49c351e4bf4c9d$var$pendingEffectsStatus = 0, $0c49c351e4bf4c9d$var$pendingFinishedWork = $0c49c351e4bf4c9d$var$pendingEffectsRoot = null, $0c49c351e4bf4c9d$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $0c49c351e4bf4c9d$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($0c49c351e4bf4c9d$var$injectedHook && "function" === typeof $0c49c351e4bf4c9d$var$injectedHook.onCommitFiberRoot) try {
            $0c49c351e4bf4c9d$var$injectedHook.onCommitFiberRoot($0c49c351e4bf4c9d$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $0c49c351e4bf4c9d$var$ReactSharedInternals.T;
            remainingLanes = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
            $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 2;
            $0c49c351e4bf4c9d$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $0c49c351e4bf4c9d$var$ReactSharedInternals.T = finishedWork, $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($0c49c351e4bf4c9d$var$pendingEffectsLanes & 3) && $0c49c351e4bf4c9d$var$flushPendingEffects();
        $0c49c351e4bf4c9d$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $0c49c351e4bf4c9d$var$rootWithNestedUpdates ? $0c49c351e4bf4c9d$var$nestedUpdateCount++ : ($0c49c351e4bf4c9d$var$nestedUpdateCount = 0, $0c49c351e4bf4c9d$var$rootWithNestedUpdates = root) : $0c49c351e4bf4c9d$var$nestedUpdateCount = 0;
        $0c49c351e4bf4c9d$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $0c49c351e4bf4c9d$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $0c49c351e4bf4c9d$var$releaseCache(remainingLanes)));
}
function $0c49c351e4bf4c9d$var$flushPendingEffects() {
    $0c49c351e4bf4c9d$var$flushMutationEffects();
    $0c49c351e4bf4c9d$var$flushLayoutEffects();
    $0c49c351e4bf4c9d$var$flushSpawnedWork();
    return $0c49c351e4bf4c9d$var$flushPassiveEffects();
}
function $0c49c351e4bf4c9d$var$flushPassiveEffects() {
    if (5 !== $0c49c351e4bf4c9d$var$pendingEffectsStatus) return !1;
    var root = $0c49c351e4bf4c9d$var$pendingEffectsRoot, remainingLanes = $0c49c351e4bf4c9d$var$pendingEffectsRemainingLanes;
    $0c49c351e4bf4c9d$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $0c49c351e4bf4c9d$var$lanesToEventPriority($0c49c351e4bf4c9d$var$pendingEffectsLanes), prevTransition = $0c49c351e4bf4c9d$var$ReactSharedInternals.T, previousPriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
    try {
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $0c49c351e4bf4c9d$var$ReactSharedInternals.T = null;
        renderPriority = $0c49c351e4bf4c9d$var$pendingPassiveTransitions;
        $0c49c351e4bf4c9d$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $0c49c351e4bf4c9d$var$pendingEffectsRoot, lanes = $0c49c351e4bf4c9d$var$pendingEffectsLanes;
        $0c49c351e4bf4c9d$var$pendingEffectsStatus = 0;
        $0c49c351e4bf4c9d$var$pendingFinishedWork = $0c49c351e4bf4c9d$var$pendingEffectsRoot = null;
        $0c49c351e4bf4c9d$var$pendingEffectsLanes = 0;
        if (0 !== ($0c49c351e4bf4c9d$var$executionContext & 6)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(331));
        var prevExecutionContext = $0c49c351e4bf4c9d$var$executionContext;
        $0c49c351e4bf4c9d$var$executionContext |= 4;
        $0c49c351e4bf4c9d$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $0c49c351e4bf4c9d$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $0c49c351e4bf4c9d$var$executionContext = prevExecutionContext;
        $0c49c351e4bf4c9d$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($0c49c351e4bf4c9d$var$injectedHook && "function" === typeof $0c49c351e4bf4c9d$var$injectedHook.onPostCommitFiberRoot) try {
            $0c49c351e4bf4c9d$var$injectedHook.onPostCommitFiberRoot($0c49c351e4bf4c9d$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = previousPriority, $0c49c351e4bf4c9d$var$ReactSharedInternals.T = prevTransition, $0c49c351e4bf4c9d$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $0c49c351e4bf4c9d$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $0c49c351e4bf4c9d$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $0c49c351e4bf4c9d$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($0c49c351e4bf4c9d$var$markRootUpdated$1(rootFiber, 2), $0c49c351e4bf4c9d$var$ensureRootIsScheduled(rootFiber));
}
function $0c49c351e4bf4c9d$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $0c49c351e4bf4c9d$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $0c49c351e4bf4c9d$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed || !$0c49c351e4bf4c9d$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $0c49c351e4bf4c9d$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $0c49c351e4bf4c9d$var$createClassErrorUpdate(2);
                instance = $0c49c351e4bf4c9d$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($0c49c351e4bf4c9d$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $0c49c351e4bf4c9d$var$markRootUpdated$1(instance, 2), $0c49c351e4bf4c9d$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $0c49c351e4bf4c9d$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $0c49c351e4bf4c9d$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($0c49c351e4bf4c9d$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $0c49c351e4bf4c9d$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $0c49c351e4bf4c9d$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $0c49c351e4bf4c9d$var$workInProgressRoot === root && ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $0c49c351e4bf4c9d$var$workInProgressRootExitStatus || 3 === $0c49c351e4bf4c9d$var$workInProgressRootExitStatus && ($0c49c351e4bf4c9d$var$workInProgressRootRenderLanes & 62914560) === $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes && 300 > $0c49c351e4bf4c9d$var$now() - $0c49c351e4bf4c9d$var$globalMostRecentFallbackTime ? 0 === ($0c49c351e4bf4c9d$var$executionContext & 2) && $0c49c351e4bf4c9d$var$prepareFreshStack(root, 0) : $0c49c351e4bf4c9d$var$workInProgressRootPingedLanes |= pingedLanes, $0c49c351e4bf4c9d$var$workInProgressSuspendedRetryLanes === $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes && ($0c49c351e4bf4c9d$var$workInProgressSuspendedRetryLanes = 0));
    $0c49c351e4bf4c9d$var$ensureRootIsScheduled(root);
}
function $0c49c351e4bf4c9d$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $0c49c351e4bf4c9d$var$claimNextRetryLane());
    boundaryFiber = $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($0c49c351e4bf4c9d$var$markRootUpdated$1(boundaryFiber, retryLane), $0c49c351e4bf4c9d$var$ensureRootIsScheduled(boundaryFiber));
}
function $0c49c351e4bf4c9d$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $0c49c351e4bf4c9d$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $0c49c351e4bf4c9d$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $0c49c351e4bf4c9d$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $0c49c351e4bf4c9d$var$scheduleCallback$1(priorityLevel, callback) {
    return $0c49c351e4bf4c9d$var$scheduleCallback$3(priorityLevel, callback);
}
var $0c49c351e4bf4c9d$var$firstScheduledRoot = null, $0c49c351e4bf4c9d$var$lastScheduledRoot = null, $0c49c351e4bf4c9d$var$didScheduleMicrotask = !1, $0c49c351e4bf4c9d$var$mightHavePendingSyncWork = !1, $0c49c351e4bf4c9d$var$isFlushingWork = !1, $0c49c351e4bf4c9d$var$currentEventTransitionLane = 0;
function $0c49c351e4bf4c9d$var$ensureRootIsScheduled(root) {
    root !== $0c49c351e4bf4c9d$var$lastScheduledRoot && null === root.next && (null === $0c49c351e4bf4c9d$var$lastScheduledRoot ? $0c49c351e4bf4c9d$var$firstScheduledRoot = $0c49c351e4bf4c9d$var$lastScheduledRoot = root : $0c49c351e4bf4c9d$var$lastScheduledRoot = $0c49c351e4bf4c9d$var$lastScheduledRoot.next = root);
    $0c49c351e4bf4c9d$var$mightHavePendingSyncWork = !0;
    $0c49c351e4bf4c9d$var$didScheduleMicrotask || ($0c49c351e4bf4c9d$var$didScheduleMicrotask = !0, $0c49c351e4bf4c9d$var$scheduleImmediateRootScheduleTask());
}
function $0c49c351e4bf4c9d$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$0c49c351e4bf4c9d$var$isFlushingWork && $0c49c351e4bf4c9d$var$mightHavePendingSyncWork) {
        $0c49c351e4bf4c9d$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $0c49c351e4bf4c9d$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $0c49c351e4bf4c9d$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $0c49c351e4bf4c9d$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $0c49c351e4bf4c9d$var$getNextLanes(root$170, root$170 === $0c49c351e4bf4c9d$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $0c49c351e4bf4c9d$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $0c49c351e4bf4c9d$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $0c49c351e4bf4c9d$var$isFlushingWork = !1;
    }
}
function $0c49c351e4bf4c9d$var$processRootScheduleInImmediateTask() {
    $0c49c351e4bf4c9d$var$processRootScheduleInMicrotask();
}
function $0c49c351e4bf4c9d$var$processRootScheduleInMicrotask() {
    $0c49c351e4bf4c9d$var$mightHavePendingSyncWork = $0c49c351e4bf4c9d$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $0c49c351e4bf4c9d$var$currentEventTransitionLane && $0c49c351e4bf4c9d$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $0c49c351e4bf4c9d$var$currentEventTransitionLane);
    for(var currentTime = $0c49c351e4bf4c9d$var$now(), prev = null, root = $0c49c351e4bf4c9d$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $0c49c351e4bf4c9d$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $0c49c351e4bf4c9d$var$firstScheduledRoot = next : prev.next = next, null === next && ($0c49c351e4bf4c9d$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $0c49c351e4bf4c9d$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $0c49c351e4bf4c9d$var$pendingEffectsStatus && 5 !== $0c49c351e4bf4c9d$var$pendingEffectsStatus || $0c49c351e4bf4c9d$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $0c49c351e4bf4c9d$var$currentEventTransitionLane && ($0c49c351e4bf4c9d$var$currentEventTransitionLane = 0);
}
function $0c49c351e4bf4c9d$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $0c49c351e4bf4c9d$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $0c49c351e4bf4c9d$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $0c49c351e4bf4c9d$var$workInProgressRoot;
    suspendedLanes = $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes;
    suspendedLanes = $0c49c351e4bf4c9d$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $0c49c351e4bf4c9d$var$workInProgressSuspendedReason || 9 === $0c49c351e4bf4c9d$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $0c49c351e4bf4c9d$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $0c49c351e4bf4c9d$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $0c49c351e4bf4c9d$var$cancelCallback$1(pingedLanes);
        switch($0c49c351e4bf4c9d$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $0c49c351e4bf4c9d$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $0c49c351e4bf4c9d$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $0c49c351e4bf4c9d$var$IdlePriority;
                break;
            default:
                suspendedLanes = $0c49c351e4bf4c9d$var$NormalPriority$1;
        }
        pingedLanes = $0c49c351e4bf4c9d$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $0c49c351e4bf4c9d$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $0c49c351e4bf4c9d$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $0c49c351e4bf4c9d$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $0c49c351e4bf4c9d$var$pendingEffectsStatus && 5 !== $0c49c351e4bf4c9d$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($0c49c351e4bf4c9d$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $0c49c351e4bf4c9d$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $0c49c351e4bf4c9d$var$getNextLanes(root, root === $0c49c351e4bf4c9d$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $0c49c351e4bf4c9d$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $0c49c351e4bf4c9d$var$scheduleTaskForRootDuringMicrotask(root, $0c49c351e4bf4c9d$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $0c49c351e4bf4c9d$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $0c49c351e4bf4c9d$var$performSyncWorkOnRoot(root, lanes) {
    if ($0c49c351e4bf4c9d$var$flushPendingEffects()) return null;
    $0c49c351e4bf4c9d$var$performWorkOnRoot(root, lanes, !0);
}
function $0c49c351e4bf4c9d$var$scheduleImmediateRootScheduleTask() {
    $0c49c351e4bf4c9d$var$scheduleMicrotask(function() {
        0 !== ($0c49c351e4bf4c9d$var$executionContext & 6) ? $0c49c351e4bf4c9d$var$scheduleCallback$3($0c49c351e4bf4c9d$var$ImmediatePriority, $0c49c351e4bf4c9d$var$processRootScheduleInImmediateTask) : $0c49c351e4bf4c9d$var$processRootScheduleInMicrotask();
    });
}
function $0c49c351e4bf4c9d$var$requestTransitionLane() {
    if (0 === $0c49c351e4bf4c9d$var$currentEventTransitionLane) {
        var actionScopeLane = $0c49c351e4bf4c9d$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $0c49c351e4bf4c9d$var$nextTransitionUpdateLane, $0c49c351e4bf4c9d$var$nextTransitionUpdateLane <<= 1, 0 === ($0c49c351e4bf4c9d$var$nextTransitionUpdateLane & 261888) && ($0c49c351e4bf4c9d$var$nextTransitionUpdateLane = 256));
        $0c49c351e4bf4c9d$var$currentEventTransitionLane = actionScopeLane;
    }
    return $0c49c351e4bf4c9d$var$currentEventTransitionLane;
}
function $0c49c351e4bf4c9d$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $0c49c351e4bf4c9d$var$sanitizeURL("" + actionProp);
}
function $0c49c351e4bf4c9d$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $0c49c351e4bf4c9d$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $0c49c351e4bf4c9d$var$coerceFormActionProp((nativeEventTarget[$0c49c351e4bf4c9d$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$0c49c351e4bf4c9d$var$internalPropsKey] || null) ? $0c49c351e4bf4c9d$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $0c49c351e4bf4c9d$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $0c49c351e4bf4c9d$var$currentEventTransitionLane) {
                                var formData = submitter ? $0c49c351e4bf4c9d$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $0c49c351e4bf4c9d$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $0c49c351e4bf4c9d$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $0c49c351e4bf4c9d$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $0c49c351e4bf4c9d$var$i$jscomp$inline_1577 = 0; $0c49c351e4bf4c9d$var$i$jscomp$inline_1577 < $0c49c351e4bf4c9d$var$simpleEventPluginEvents.length; $0c49c351e4bf4c9d$var$i$jscomp$inline_1577++){
    var $0c49c351e4bf4c9d$var$eventName$jscomp$inline_1578 = $0c49c351e4bf4c9d$var$simpleEventPluginEvents[$0c49c351e4bf4c9d$var$i$jscomp$inline_1577], $0c49c351e4bf4c9d$var$domEventName$jscomp$inline_1579 = $0c49c351e4bf4c9d$var$eventName$jscomp$inline_1578.toLowerCase(), $0c49c351e4bf4c9d$var$capitalizedEvent$jscomp$inline_1580 = $0c49c351e4bf4c9d$var$eventName$jscomp$inline_1578[0].toUpperCase() + $0c49c351e4bf4c9d$var$eventName$jscomp$inline_1578.slice(1);
    $0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$domEventName$jscomp$inline_1579, "on" + $0c49c351e4bf4c9d$var$capitalizedEvent$jscomp$inline_1580);
}
$0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$ANIMATION_END, "onAnimationEnd");
$0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$ANIMATION_ITERATION, "onAnimationIteration");
$0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$ANIMATION_START, "onAnimationStart");
$0c49c351e4bf4c9d$var$registerSimpleEvent("dblclick", "onDoubleClick");
$0c49c351e4bf4c9d$var$registerSimpleEvent("focusin", "onFocus");
$0c49c351e4bf4c9d$var$registerSimpleEvent("focusout", "onBlur");
$0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$TRANSITION_RUN, "onTransitionRun");
$0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$TRANSITION_START, "onTransitionStart");
$0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$TRANSITION_CANCEL, "onTransitionCancel");
$0c49c351e4bf4c9d$var$registerSimpleEvent($0c49c351e4bf4c9d$var$TRANSITION_END, "onTransitionEnd");
$0c49c351e4bf4c9d$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0c49c351e4bf4c9d$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0c49c351e4bf4c9d$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0c49c351e4bf4c9d$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0c49c351e4bf4c9d$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0c49c351e4bf4c9d$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0c49c351e4bf4c9d$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0c49c351e4bf4c9d$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0c49c351e4bf4c9d$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0c49c351e4bf4c9d$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0c49c351e4bf4c9d$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0c49c351e4bf4c9d$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($0c49c351e4bf4c9d$var$mediaEventTypes));
function $0c49c351e4bf4c9d$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $0c49c351e4bf4c9d$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $0c49c351e4bf4c9d$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$0c49c351e4bf4c9d$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$0c49c351e4bf4c9d$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($0c49c351e4bf4c9d$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $0c49c351e4bf4c9d$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $0c49c351e4bf4c9d$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $0c49c351e4bf4c9d$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $0c49c351e4bf4c9d$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$0c49c351e4bf4c9d$var$listeningMarker]) {
        rootContainerElement[$0c49c351e4bf4c9d$var$listeningMarker] = !0;
        $0c49c351e4bf4c9d$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($0c49c351e4bf4c9d$var$nonDelegatedEvents.has(domEventName) || $0c49c351e4bf4c9d$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $0c49c351e4bf4c9d$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$0c49c351e4bf4c9d$var$listeningMarker] || (ownerDocument[$0c49c351e4bf4c9d$var$listeningMarker] = !0, $0c49c351e4bf4c9d$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $0c49c351e4bf4c9d$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($0c49c351e4bf4c9d$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $0c49c351e4bf4c9d$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $0c49c351e4bf4c9d$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $0c49c351e4bf4c9d$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$0c49c351e4bf4c9d$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $0c49c351e4bf4c9d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $0c49c351e4bf4c9d$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $0c49c351e4bf4c9d$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $0c49c351e4bf4c9d$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $0c49c351e4bf4c9d$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $0c49c351e4bf4c9d$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticTouchEvent;
                        break;
                    case $0c49c351e4bf4c9d$var$ANIMATION_END:
                    case $0c49c351e4bf4c9d$var$ANIMATION_ITERATION:
                    case $0c49c351e4bf4c9d$var$ANIMATION_START:
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticAnimationEvent;
                        break;
                    case $0c49c351e4bf4c9d$var$TRANSITION_END:
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $0c49c351e4bf4c9d$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $0c49c351e4bf4c9d$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($0c49c351e4bf4c9d$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $0c49c351e4bf4c9d$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($0c49c351e4bf4c9d$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$0c49c351e4bf4c9d$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $0c49c351e4bf4c9d$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $0c49c351e4bf4c9d$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $0c49c351e4bf4c9d$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $0c49c351e4bf4c9d$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $0c49c351e4bf4c9d$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $0c49c351e4bf4c9d$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $0c49c351e4bf4c9d$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $0c49c351e4bf4c9d$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $0c49c351e4bf4c9d$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $0c49c351e4bf4c9d$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $0c49c351e4bf4c9d$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $0c49c351e4bf4c9d$var$getTargetInstForChangeEvent;
                else if ($0c49c351e4bf4c9d$var$isTextInputElement(reactName)) {
                    if ($0c49c351e4bf4c9d$var$isInputEventSupported) getTargetInstFunc = $0c49c351e4bf4c9d$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $0c49c351e4bf4c9d$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $0c49c351e4bf4c9d$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $0c49c351e4bf4c9d$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $0c49c351e4bf4c9d$var$getTargetInstForChangeEvent) : getTargetInstFunc = $0c49c351e4bf4c9d$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $0c49c351e4bf4c9d$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $0c49c351e4bf4c9d$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $0c49c351e4bf4c9d$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($0c49c351e4bf4c9d$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $0c49c351e4bf4c9d$var$activeElement = handleEventFunc, $0c49c351e4bf4c9d$var$activeElementInst = targetInst, $0c49c351e4bf4c9d$var$lastSelection = null;
                    break;
                case "focusout":
                    $0c49c351e4bf4c9d$var$lastSelection = $0c49c351e4bf4c9d$var$activeElementInst = $0c49c351e4bf4c9d$var$activeElement = null;
                    break;
                case "mousedown":
                    $0c49c351e4bf4c9d$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0c49c351e4bf4c9d$var$mouseDown = !1;
                    $0c49c351e4bf4c9d$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($0c49c351e4bf4c9d$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $0c49c351e4bf4c9d$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($0c49c351e4bf4c9d$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $0c49c351e4bf4c9d$var$isComposing ? $0c49c351e4bf4c9d$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($0c49c351e4bf4c9d$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($0c49c351e4bf4c9d$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $0c49c351e4bf4c9d$var$isComposing && (fallbackData = $0c49c351e4bf4c9d$var$getData()) : ($0c49c351e4bf4c9d$var$root = nativeEventTarget, $0c49c351e4bf4c9d$var$startText = "value" in $0c49c351e4bf4c9d$var$root ? $0c49c351e4bf4c9d$var$root.value : $0c49c351e4bf4c9d$var$root.textContent, $0c49c351e4bf4c9d$var$isComposing = !0)), handleEventFunc = $0c49c351e4bf4c9d$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $0c49c351e4bf4c9d$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $0c49c351e4bf4c9d$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $0c49c351e4bf4c9d$var$canUseTextInputEvent ? $0c49c351e4bf4c9d$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $0c49c351e4bf4c9d$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $0c49c351e4bf4c9d$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $0c49c351e4bf4c9d$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $0c49c351e4bf4c9d$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $0c49c351e4bf4c9d$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $0c49c351e4bf4c9d$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $0c49c351e4bf4c9d$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $0c49c351e4bf4c9d$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($0c49c351e4bf4c9d$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $0c49c351e4bf4c9d$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($0c49c351e4bf4c9d$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $0c49c351e4bf4c9d$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $0c49c351e4bf4c9d$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $0c49c351e4bf4c9d$var$getListener(target, registrationName), null != stateNode && listeners.unshift($0c49c351e4bf4c9d$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $0c49c351e4bf4c9d$var$getListener(target, registrationName), null != stateNode && listeners.push($0c49c351e4bf4c9d$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $0c49c351e4bf4c9d$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $0c49c351e4bf4c9d$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $0c49c351e4bf4c9d$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($0c49c351e4bf4c9d$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($0c49c351e4bf4c9d$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $0c49c351e4bf4c9d$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $0c49c351e4bf4c9d$var$normalizeMarkupForTextOrAttribute(clientText);
    return $0c49c351e4bf4c9d$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $0c49c351e4bf4c9d$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $0c49c351e4bf4c9d$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $0c49c351e4bf4c9d$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $0c49c351e4bf4c9d$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $0c49c351e4bf4c9d$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $0c49c351e4bf4c9d$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $0c49c351e4bf4c9d$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $0c49c351e4bf4c9d$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $0c49c351e4bf4c9d$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $0c49c351e4bf4c9d$var$setProp(domElement, tag, "name", props.name, props, null), $0c49c351e4bf4c9d$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $0c49c351e4bf4c9d$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $0c49c351e4bf4c9d$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($0c49c351e4bf4c9d$var$setProp(domElement, tag, "encType", props.encType, props, null), $0c49c351e4bf4c9d$var$setProp(domElement, tag, "method", props.method, props, null), $0c49c351e4bf4c9d$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $0c49c351e4bf4c9d$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $0c49c351e4bf4c9d$var$noop$1);
            break;
        case "onScroll":
            null != value && $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $0c49c351e4bf4c9d$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("toggle", domElement);
            $0c49c351e4bf4c9d$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $0c49c351e4bf4c9d$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $0c49c351e4bf4c9d$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $0c49c351e4bf4c9d$var$aliases.get(key) || key, $0c49c351e4bf4c9d$var$setValueForAttribute(domElement, key, value);
    }
}
function $0c49c351e4bf4c9d$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $0c49c351e4bf4c9d$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $0c49c351e4bf4c9d$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $0c49c351e4bf4c9d$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $0c49c351e4bf4c9d$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$0c49c351e4bf4c9d$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$0c49c351e4bf4c9d$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $0c49c351e4bf4c9d$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $0c49c351e4bf4c9d$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("error", domElement);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(137, tag));
                    default:
                        $0c49c351e4bf4c9d$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $0c49c351e4bf4c9d$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $0c49c351e4bf4c9d$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $0c49c351e4bf4c9d$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $0c49c351e4bf4c9d$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $0c49c351e4bf4c9d$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $0c49c351e4bf4c9d$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(91));
                    break;
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $0c49c351e4bf4c9d$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("toggle", domElement);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("cancel", domElement);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $0c49c351e4bf4c9d$var$mediaEventTypes.length; hasSrc++)$0c49c351e4bf4c9d$var$listenToNonDelegatedEvent($0c49c351e4bf4c9d$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("error", domElement);
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("error", domElement), $0c49c351e4bf4c9d$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(137, tag));
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($0c49c351e4bf4c9d$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $0c49c351e4bf4c9d$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $0c49c351e4bf4c9d$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $0c49c351e4bf4c9d$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $0c49c351e4bf4c9d$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $0c49c351e4bf4c9d$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $0c49c351e4bf4c9d$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $0c49c351e4bf4c9d$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $0c49c351e4bf4c9d$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $0c49c351e4bf4c9d$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $0c49c351e4bf4c9d$var$updateOptions(domElement, !!lastProps, tag, !0) : $0c49c351e4bf4c9d$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $0c49c351e4bf4c9d$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $0c49c351e4bf4c9d$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $0c49c351e4bf4c9d$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $0c49c351e4bf4c9d$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($0c49c351e4bf4c9d$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $0c49c351e4bf4c9d$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $0c49c351e4bf4c9d$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $0c49c351e4bf4c9d$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $0c49c351e4bf4c9d$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $0c49c351e4bf4c9d$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $0c49c351e4bf4c9d$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $0c49c351e4bf4c9d$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $0c49c351e4bf4c9d$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $0c49c351e4bf4c9d$var$eventsEnabled = null, $0c49c351e4bf4c9d$var$selectionInformation = null;
function $0c49c351e4bf4c9d$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $0c49c351e4bf4c9d$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $0c49c351e4bf4c9d$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $0c49c351e4bf4c9d$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $0c49c351e4bf4c9d$var$currentPopstateTransitionEvent = null;
function $0c49c351e4bf4c9d$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $0c49c351e4bf4c9d$var$currentPopstateTransitionEvent) return !1;
        $0c49c351e4bf4c9d$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $0c49c351e4bf4c9d$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $0c49c351e4bf4c9d$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $0c49c351e4bf4c9d$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $0c49c351e4bf4c9d$var$localPromise = "function" === typeof Promise ? Promise : void 0, $0c49c351e4bf4c9d$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0c49c351e4bf4c9d$var$localPromise ? function(callback) {
    return $0c49c351e4bf4c9d$var$localPromise.resolve(null).then(callback).catch($0c49c351e4bf4c9d$var$handleErrorInNextTick);
} : $0c49c351e4bf4c9d$var$scheduleTimeout;
function $0c49c351e4bf4c9d$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $0c49c351e4bf4c9d$var$isSingletonScope(type) {
    return "head" === type;
}
function $0c49c351e4bf4c9d$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $0c49c351e4bf4c9d$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $0c49c351e4bf4c9d$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $0c49c351e4bf4c9d$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$0c49c351e4bf4c9d$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $0c49c351e4bf4c9d$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $0c49c351e4bf4c9d$var$retryIfBlockedOn(hydrationInstance);
}
function $0c49c351e4bf4c9d$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $0c49c351e4bf4c9d$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $0c49c351e4bf4c9d$var$clearContainerSparingly(node);
                $0c49c351e4bf4c9d$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $0c49c351e4bf4c9d$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$0c49c351e4bf4c9d$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $0c49c351e4bf4c9d$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $0c49c351e4bf4c9d$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $0c49c351e4bf4c9d$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $0c49c351e4bf4c9d$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $0c49c351e4bf4c9d$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $0c49c351e4bf4c9d$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $0c49c351e4bf4c9d$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $0c49c351e4bf4c9d$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $0c49c351e4bf4c9d$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $0c49c351e4bf4c9d$var$previousHydratableOnEnteringScopedSingleton = null;
function $0c49c351e4bf4c9d$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $0c49c351e4bf4c9d$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $0c49c351e4bf4c9d$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $0c49c351e4bf4c9d$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $0c49c351e4bf4c9d$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(451));
    }
}
function $0c49c351e4bf4c9d$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $0c49c351e4bf4c9d$var$detachDeletedInstance(instance);
}
var $0c49c351e4bf4c9d$var$preloadPropsMap = new Map(), $0c49c351e4bf4c9d$var$preconnectsSet = new Set();
function $0c49c351e4bf4c9d$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $0c49c351e4bf4c9d$var$previousDispatcher = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.d;
$0c49c351e4bf4c9d$var$ReactDOMSharedInternals.d = {
    f: $0c49c351e4bf4c9d$var$flushSyncWork,
    r: $0c49c351e4bf4c9d$var$requestFormReset,
    D: $0c49c351e4bf4c9d$var$prefetchDNS,
    C: $0c49c351e4bf4c9d$var$preconnect,
    L: $0c49c351e4bf4c9d$var$preload,
    m: $0c49c351e4bf4c9d$var$preloadModule,
    X: $0c49c351e4bf4c9d$var$preinitScript,
    S: $0c49c351e4bf4c9d$var$preinitStyle,
    M: $0c49c351e4bf4c9d$var$preinitModuleScript
};
function $0c49c351e4bf4c9d$var$flushSyncWork() {
    var previousWasRendering = $0c49c351e4bf4c9d$var$previousDispatcher.f(), wasRendering = $0c49c351e4bf4c9d$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $0c49c351e4bf4c9d$var$requestFormReset(form) {
    var formInst = $0c49c351e4bf4c9d$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $0c49c351e4bf4c9d$var$requestFormReset$1(formInst) : $0c49c351e4bf4c9d$var$previousDispatcher.r(form);
}
var $0c49c351e4bf4c9d$var$globalDocument = "undefined" === typeof document ? null : document;
function $0c49c351e4bf4c9d$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $0c49c351e4bf4c9d$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $0c49c351e4bf4c9d$var$preconnectsSet.has(limitedEscapedHref) || ($0c49c351e4bf4c9d$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $0c49c351e4bf4c9d$var$setInitialProperties(href, "link", rel), $0c49c351e4bf4c9d$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $0c49c351e4bf4c9d$var$prefetchDNS(href) {
    $0c49c351e4bf4c9d$var$previousDispatcher.D(href);
    $0c49c351e4bf4c9d$var$preconnectAs("dns-prefetch", href, null);
}
function $0c49c351e4bf4c9d$var$preconnect(href, crossOrigin) {
    $0c49c351e4bf4c9d$var$previousDispatcher.C(href, crossOrigin);
    $0c49c351e4bf4c9d$var$preconnectAs("preconnect", href, crossOrigin);
}
function $0c49c351e4bf4c9d$var$preload(href, as, options) {
    $0c49c351e4bf4c9d$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $0c49c351e4bf4c9d$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $0c49c351e4bf4c9d$var$getStyleKey(href);
                break;
            case "script":
                key = $0c49c351e4bf4c9d$var$getScriptKey(href);
        }
        $0c49c351e4bf4c9d$var$preloadPropsMap.has(key) || (href = $0c49c351e4bf4c9d$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $0c49c351e4bf4c9d$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($0c49c351e4bf4c9d$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($0c49c351e4bf4c9d$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $0c49c351e4bf4c9d$var$setInitialProperties(as, "link", href), $0c49c351e4bf4c9d$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $0c49c351e4bf4c9d$var$preloadModule(href, options) {
    $0c49c351e4bf4c9d$var$previousDispatcher.m(href, options);
    var ownerDocument = $0c49c351e4bf4c9d$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $0c49c351e4bf4c9d$var$getScriptKey(href);
        }
        if (!$0c49c351e4bf4c9d$var$preloadPropsMap.has(key) && (href = $0c49c351e4bf4c9d$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $0c49c351e4bf4c9d$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($0c49c351e4bf4c9d$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $0c49c351e4bf4c9d$var$setInitialProperties(as, "link", href);
            $0c49c351e4bf4c9d$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $0c49c351e4bf4c9d$var$preinitStyle(href, precedence, options) {
    $0c49c351e4bf4c9d$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $0c49c351e4bf4c9d$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $0c49c351e4bf4c9d$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $0c49c351e4bf4c9d$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($0c49c351e4bf4c9d$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $0c49c351e4bf4c9d$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $0c49c351e4bf4c9d$var$preloadPropsMap.get(key)) && $0c49c351e4bf4c9d$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $0c49c351e4bf4c9d$var$markNodeAsHoistable(link);
                $0c49c351e4bf4c9d$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $0c49c351e4bf4c9d$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $0c49c351e4bf4c9d$var$preinitScript(src, options) {
    $0c49c351e4bf4c9d$var$previousDispatcher.X(src, options);
    var ownerDocument = $0c49c351e4bf4c9d$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $0c49c351e4bf4c9d$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $0c49c351e4bf4c9d$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($0c49c351e4bf4c9d$var$getScriptSelectorFromKey(key)), resource || (src = $0c49c351e4bf4c9d$var$assign({
            src: src,
            async: !0
        }, options), (options = $0c49c351e4bf4c9d$var$preloadPropsMap.get(key)) && $0c49c351e4bf4c9d$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $0c49c351e4bf4c9d$var$markNodeAsHoistable(resource), $0c49c351e4bf4c9d$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $0c49c351e4bf4c9d$var$preinitModuleScript(src, options) {
    $0c49c351e4bf4c9d$var$previousDispatcher.M(src, options);
    var ownerDocument = $0c49c351e4bf4c9d$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $0c49c351e4bf4c9d$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $0c49c351e4bf4c9d$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($0c49c351e4bf4c9d$var$getScriptSelectorFromKey(key)), resource || (src = $0c49c351e4bf4c9d$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $0c49c351e4bf4c9d$var$preloadPropsMap.get(key)) && $0c49c351e4bf4c9d$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $0c49c351e4bf4c9d$var$markNodeAsHoistable(resource), $0c49c351e4bf4c9d$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $0c49c351e4bf4c9d$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $0c49c351e4bf4c9d$var$rootInstanceStackCursor.current) ? $0c49c351e4bf4c9d$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $0c49c351e4bf4c9d$var$getStyleKey(pendingProps.href), pendingProps = $0c49c351e4bf4c9d$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $0c49c351e4bf4c9d$var$getStyleKey(pendingProps.href);
                var styles$243 = $0c49c351e4bf4c9d$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($0c49c351e4bf4c9d$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $0c49c351e4bf4c9d$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $0c49c351e4bf4c9d$var$preloadPropsMap.set(type, pendingProps), styles$243 || $0c49c351e4bf4c9d$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $0c49c351e4bf4c9d$var$getScriptKey(pendingProps), pendingProps = $0c49c351e4bf4c9d$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(444, type));
    }
}
function $0c49c351e4bf4c9d$var$getStyleKey(href) {
    return 'href="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $0c49c351e4bf4c9d$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $0c49c351e4bf4c9d$var$stylesheetPropsFromRawProps(rawProps) {
    return $0c49c351e4bf4c9d$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $0c49c351e4bf4c9d$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $0c49c351e4bf4c9d$var$setInitialProperties(key, "link", preloadProps), $0c49c351e4bf4c9d$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $0c49c351e4bf4c9d$var$getScriptKey(src) {
    return '[src="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $0c49c351e4bf4c9d$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $0c49c351e4bf4c9d$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $0c49c351e4bf4c9d$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $0c49c351e4bf4c9d$var$markNodeAsHoistable(instance), instance;
            var styleProps = $0c49c351e4bf4c9d$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $0c49c351e4bf4c9d$var$markNodeAsHoistable(instance);
            $0c49c351e4bf4c9d$var$setInitialProperties(instance, "style", styleProps);
            $0c49c351e4bf4c9d$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $0c49c351e4bf4c9d$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($0c49c351e4bf4c9d$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $0c49c351e4bf4c9d$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $0c49c351e4bf4c9d$var$stylesheetPropsFromRawProps(props);
            (styleProps = $0c49c351e4bf4c9d$var$preloadPropsMap.get(styleProps)) && $0c49c351e4bf4c9d$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $0c49c351e4bf4c9d$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $0c49c351e4bf4c9d$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $0c49c351e4bf4c9d$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $0c49c351e4bf4c9d$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($0c49c351e4bf4c9d$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $0c49c351e4bf4c9d$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $0c49c351e4bf4c9d$var$preloadPropsMap.get(instance$249)) instance = $0c49c351e4bf4c9d$var$assign({}, props), $0c49c351e4bf4c9d$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $0c49c351e4bf4c9d$var$markNodeAsHoistable(styleProps);
            $0c49c351e4bf4c9d$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $0c49c351e4bf4c9d$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $0c49c351e4bf4c9d$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $0c49c351e4bf4c9d$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $0c49c351e4bf4c9d$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $0c49c351e4bf4c9d$var$tagCaches = null;
function $0c49c351e4bf4c9d$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $0c49c351e4bf4c9d$var$tagCaches) {
        var cache = new Map();
        var caches = $0c49c351e4bf4c9d$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $0c49c351e4bf4c9d$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$0c49c351e4bf4c9d$var$internalHoistableMarker] || node[$0c49c351e4bf4c9d$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $0c49c351e4bf4c9d$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $0c49c351e4bf4c9d$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $0c49c351e4bf4c9d$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $0c49c351e4bf4c9d$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $0c49c351e4bf4c9d$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($0c49c351e4bf4c9d$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $0c49c351e4bf4c9d$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $0c49c351e4bf4c9d$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $0c49c351e4bf4c9d$var$stylesheetPropsFromRawProps(props);
            (key = $0c49c351e4bf4c9d$var$preloadPropsMap.get(key)) && $0c49c351e4bf4c9d$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $0c49c351e4bf4c9d$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $0c49c351e4bf4c9d$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $0c49c351e4bf4c9d$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $0c49c351e4bf4c9d$var$estimatedBytesWithinLimit = 0;
function $0c49c351e4bf4c9d$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $0c49c351e4bf4c9d$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $0c49c351e4bf4c9d$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $0c49c351e4bf4c9d$var$estimatedBytesWithinLimit && ($0c49c351e4bf4c9d$var$estimatedBytesWithinLimit = 62500 * $0c49c351e4bf4c9d$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $0c49c351e4bf4c9d$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $0c49c351e4bf4c9d$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $0c49c351e4bf4c9d$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $0c49c351e4bf4c9d$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $0c49c351e4bf4c9d$var$precedencesByRoot = null;
function $0c49c351e4bf4c9d$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $0c49c351e4bf4c9d$var$precedencesByRoot = new Map(), resources.forEach($0c49c351e4bf4c9d$var$insertStylesheetIntoRoot, state), $0c49c351e4bf4c9d$var$precedencesByRoot = null, $0c49c351e4bf4c9d$var$onUnsuspend.call(state));
}
function $0c49c351e4bf4c9d$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $0c49c351e4bf4c9d$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $0c49c351e4bf4c9d$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $0c49c351e4bf4c9d$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $0c49c351e4bf4c9d$var$HostTransitionContext = {
    $$typeof: $0c49c351e4bf4c9d$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $0c49c351e4bf4c9d$var$sharedNotPendingObject,
    _currentValue2: $0c49c351e4bf4c9d$var$sharedNotPendingObject,
    _threadCount: 0
};
function $0c49c351e4bf4c9d$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $0c49c351e4bf4c9d$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0c49c351e4bf4c9d$var$createLaneMap(0);
    this.hiddenUpdates = $0c49c351e4bf4c9d$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $0c49c351e4bf4c9d$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $0c49c351e4bf4c9d$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $0c49c351e4bf4c9d$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $0c49c351e4bf4c9d$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $0c49c351e4bf4c9d$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $0c49c351e4bf4c9d$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $0c49c351e4bf4c9d$var$emptyContextObject;
    parentComponent = $0c49c351e4bf4c9d$var$emptyContextObject;
    return parentComponent;
}
function $0c49c351e4bf4c9d$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $0c49c351e4bf4c9d$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $0c49c351e4bf4c9d$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $0c49c351e4bf4c9d$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(element, rootFiber, lane), $0c49c351e4bf4c9d$var$entangleTransitions(element, rootFiber, lane));
}
function $0c49c351e4bf4c9d$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $0c49c351e4bf4c9d$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $0c49c351e4bf4c9d$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $0c49c351e4bf4c9d$var$markRetryLaneImpl(fiber, retryLane);
}
function $0c49c351e4bf4c9d$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $0c49c351e4bf4c9d$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $0c49c351e4bf4c9d$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $0c49c351e4bf4c9d$var$requestUpdateLane();
        lane = $0c49c351e4bf4c9d$var$getBumpedLaneForHydrationByLane(lane);
        var root = $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(root, fiber, lane);
        $0c49c351e4bf4c9d$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $0c49c351e4bf4c9d$var$_enabled = !0;
function $0c49c351e4bf4c9d$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $0c49c351e4bf4c9d$var$ReactSharedInternals.T;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.T = null;
    var previousPriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
    try {
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 2, $0c49c351e4bf4c9d$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = previousPriority, $0c49c351e4bf4c9d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $0c49c351e4bf4c9d$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $0c49c351e4bf4c9d$var$ReactSharedInternals.T;
    $0c49c351e4bf4c9d$var$ReactSharedInternals.T = null;
    var previousPriority = $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p;
    try {
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = 8, $0c49c351e4bf4c9d$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $0c49c351e4bf4c9d$var$ReactDOMSharedInternals.p = previousPriority, $0c49c351e4bf4c9d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $0c49c351e4bf4c9d$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($0c49c351e4bf4c9d$var$_enabled) {
        var blockedOn = $0c49c351e4bf4c9d$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $0c49c351e4bf4c9d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $0c49c351e4bf4c9d$var$return_targetInst, targetContainer), $0c49c351e4bf4c9d$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($0c49c351e4bf4c9d$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($0c49c351e4bf4c9d$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $0c49c351e4bf4c9d$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $0c49c351e4bf4c9d$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $0c49c351e4bf4c9d$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $0c49c351e4bf4c9d$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $0c49c351e4bf4c9d$var$ensureRootIsScheduled(fiber);
                                0 === ($0c49c351e4bf4c9d$var$executionContext & 6) && ($0c49c351e4bf4c9d$var$workInProgressRootRenderTargetTime = $0c49c351e4bf4c9d$var$now() + 500, $0c49c351e4bf4c9d$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $0c49c351e4bf4c9d$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $0c49c351e4bf4c9d$var$scheduleUpdateOnFiber(root, fiber, 2), $0c49c351e4bf4c9d$var$flushSyncWork$1(), $0c49c351e4bf4c9d$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $0c49c351e4bf4c9d$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $0c49c351e4bf4c9d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $0c49c351e4bf4c9d$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $0c49c351e4bf4c9d$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $0c49c351e4bf4c9d$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $0c49c351e4bf4c9d$var$getEventTarget(nativeEvent);
    return $0c49c351e4bf4c9d$var$findInstanceBlockingTarget(nativeEvent);
}
var $0c49c351e4bf4c9d$var$return_targetInst = null;
function $0c49c351e4bf4c9d$var$findInstanceBlockingTarget(targetNode) {
    $0c49c351e4bf4c9d$var$return_targetInst = null;
    targetNode = $0c49c351e4bf4c9d$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $0c49c351e4bf4c9d$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $0c49c351e4bf4c9d$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $0c49c351e4bf4c9d$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $0c49c351e4bf4c9d$var$return_targetInst = targetNode;
    return null;
}
function $0c49c351e4bf4c9d$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($0c49c351e4bf4c9d$var$getCurrentPriorityLevel()){
                case $0c49c351e4bf4c9d$var$ImmediatePriority:
                    return 2;
                case $0c49c351e4bf4c9d$var$UserBlockingPriority:
                    return 8;
                case $0c49c351e4bf4c9d$var$NormalPriority$1:
                case $0c49c351e4bf4c9d$var$LowPriority:
                    return 32;
                case $0c49c351e4bf4c9d$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $0c49c351e4bf4c9d$var$hasScheduledReplayAttempt = !1, $0c49c351e4bf4c9d$var$queuedFocus = null, $0c49c351e4bf4c9d$var$queuedDrag = null, $0c49c351e4bf4c9d$var$queuedMouse = null, $0c49c351e4bf4c9d$var$queuedPointers = new Map(), $0c49c351e4bf4c9d$var$queuedPointerCaptures = new Map(), $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets = [], $0c49c351e4bf4c9d$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $0c49c351e4bf4c9d$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $0c49c351e4bf4c9d$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $0c49c351e4bf4c9d$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $0c49c351e4bf4c9d$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $0c49c351e4bf4c9d$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0c49c351e4bf4c9d$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $0c49c351e4bf4c9d$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $0c49c351e4bf4c9d$var$getInstanceFromNode(blockedOn), null !== blockedOn && $0c49c351e4bf4c9d$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $0c49c351e4bf4c9d$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $0c49c351e4bf4c9d$var$queuedFocus = $0c49c351e4bf4c9d$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c49c351e4bf4c9d$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $0c49c351e4bf4c9d$var$queuedDrag = $0c49c351e4bf4c9d$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c49c351e4bf4c9d$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $0c49c351e4bf4c9d$var$queuedMouse = $0c49c351e4bf4c9d$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c49c351e4bf4c9d$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $0c49c351e4bf4c9d$var$queuedPointers.set(pointerId, $0c49c351e4bf4c9d$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c49c351e4bf4c9d$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $0c49c351e4bf4c9d$var$queuedPointerCaptures.set(pointerId, $0c49c351e4bf4c9d$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c49c351e4bf4c9d$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $0c49c351e4bf4c9d$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $0c49c351e4bf4c9d$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $0c49c351e4bf4c9d$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $0c49c351e4bf4c9d$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $0c49c351e4bf4c9d$var$runWithPriority(queuedTarget.priority, function() {
                        $0c49c351e4bf4c9d$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $0c49c351e4bf4c9d$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $0c49c351e4bf4c9d$var$runWithPriority(queuedTarget.priority, function() {
                        $0c49c351e4bf4c9d$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $0c49c351e4bf4c9d$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $0c49c351e4bf4c9d$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $0c49c351e4bf4c9d$var$currentReplayingEvent = null;
        } else return targetContainers = $0c49c351e4bf4c9d$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $0c49c351e4bf4c9d$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $0c49c351e4bf4c9d$var$replayUnblockedEvents() {
    $0c49c351e4bf4c9d$var$hasScheduledReplayAttempt = !1;
    null !== $0c49c351e4bf4c9d$var$queuedFocus && $0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEvent($0c49c351e4bf4c9d$var$queuedFocus) && ($0c49c351e4bf4c9d$var$queuedFocus = null);
    null !== $0c49c351e4bf4c9d$var$queuedDrag && $0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEvent($0c49c351e4bf4c9d$var$queuedDrag) && ($0c49c351e4bf4c9d$var$queuedDrag = null);
    null !== $0c49c351e4bf4c9d$var$queuedMouse && $0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEvent($0c49c351e4bf4c9d$var$queuedMouse) && ($0c49c351e4bf4c9d$var$queuedMouse = null);
    $0c49c351e4bf4c9d$var$queuedPointers.forEach($0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEventInMap);
    $0c49c351e4bf4c9d$var$queuedPointerCaptures.forEach($0c49c351e4bf4c9d$var$attemptReplayContinuousQueuedEventInMap);
}
function $0c49c351e4bf4c9d$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $0c49c351e4bf4c9d$var$hasScheduledReplayAttempt || ($0c49c351e4bf4c9d$var$hasScheduledReplayAttempt = !0, $aDD22.unstable_scheduleCallback($aDD22.unstable_NormalPriority, $0c49c351e4bf4c9d$var$replayUnblockedEvents)));
}
var $0c49c351e4bf4c9d$var$lastScheduledReplayQueue = null;
function $0c49c351e4bf4c9d$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $0c49c351e4bf4c9d$var$lastScheduledReplayQueue !== formReplayingQueue && ($0c49c351e4bf4c9d$var$lastScheduledReplayQueue = formReplayingQueue, $aDD22.unstable_scheduleCallback($aDD22.unstable_NormalPriority, function() {
        $0c49c351e4bf4c9d$var$lastScheduledReplayQueue === formReplayingQueue && ($0c49c351e4bf4c9d$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $0c49c351e4bf4c9d$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $0c49c351e4bf4c9d$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $0c49c351e4bf4c9d$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $0c49c351e4bf4c9d$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $0c49c351e4bf4c9d$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $0c49c351e4bf4c9d$var$queuedFocus && $0c49c351e4bf4c9d$var$scheduleCallbackIfUnblocked($0c49c351e4bf4c9d$var$queuedFocus, unblocked);
    null !== $0c49c351e4bf4c9d$var$queuedDrag && $0c49c351e4bf4c9d$var$scheduleCallbackIfUnblocked($0c49c351e4bf4c9d$var$queuedDrag, unblocked);
    null !== $0c49c351e4bf4c9d$var$queuedMouse && $0c49c351e4bf4c9d$var$scheduleCallbackIfUnblocked($0c49c351e4bf4c9d$var$queuedMouse, unblocked);
    $0c49c351e4bf4c9d$var$queuedPointers.forEach(unblock);
    $0c49c351e4bf4c9d$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets.length && (i = $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$0c49c351e4bf4c9d$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$0c49c351e4bf4c9d$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $0c49c351e4bf4c9d$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$0c49c351e4bf4c9d$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $0c49c351e4bf4c9d$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $0c49c351e4bf4c9d$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $0c49c351e4bf4c9d$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $0c49c351e4bf4c9d$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$0c49c351e4bf4c9d$var$ReactDOMHydrationRoot.prototype.render = $0c49c351e4bf4c9d$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(409));
    var current = root.current, lane = $0c49c351e4bf4c9d$var$requestUpdateLane();
    $0c49c351e4bf4c9d$var$updateContainerImpl(current, lane, children, root, null, null);
};
$0c49c351e4bf4c9d$var$ReactDOMHydrationRoot.prototype.unmount = $0c49c351e4bf4c9d$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $0c49c351e4bf4c9d$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $0c49c351e4bf4c9d$var$flushSyncWork$1();
        container[$0c49c351e4bf4c9d$var$internalContainerInstanceKey] = null;
    }
};
function $0c49c351e4bf4c9d$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$0c49c351e4bf4c9d$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $0c49c351e4bf4c9d$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets[i].priority; i++);
        $0c49c351e4bf4c9d$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $0c49c351e4bf4c9d$var$attemptExplicitHydrationTarget(target);
    }
};
var $0c49c351e4bf4c9d$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $c56K2.version;
if ("19.2.5" !== $0c49c351e4bf4c9d$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(527, $0c49c351e4bf4c9d$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.5"));
$0c49c351e4bf4c9d$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $0c49c351e4bf4c9d$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $0c49c351e4bf4c9d$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $0c49c351e4bf4c9d$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.5",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $0c49c351e4bf4c9d$var$ReactSharedInternals,
    reconcilerVersion: "19.2.5"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0c49c351e4bf4c9d$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0c49c351e4bf4c9d$var$hook$jscomp$inline_2348.isDisabled && $0c49c351e4bf4c9d$var$hook$jscomp$inline_2348.supportsFiber) try {
        $0c49c351e4bf4c9d$var$rendererID = $0c49c351e4bf4c9d$var$hook$jscomp$inline_2348.inject($0c49c351e4bf4c9d$var$internals$jscomp$inline_2347), $0c49c351e4bf4c9d$var$injectedHook = $0c49c351e4bf4c9d$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$0c49c351e4bf4c9d$export$882461b6382ed46c = function(container, options) {
    if (!$0c49c351e4bf4c9d$var$isValidContainer(container)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $0c49c351e4bf4c9d$var$defaultOnUncaughtError, onCaughtError = $0c49c351e4bf4c9d$var$defaultOnCaughtError, onRecoverableError = $0c49c351e4bf4c9d$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $0c49c351e4bf4c9d$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $0c49c351e4bf4c9d$var$defaultOnDefaultTransitionIndicator);
    container[$0c49c351e4bf4c9d$var$internalContainerInstanceKey] = options.current;
    $0c49c351e4bf4c9d$var$listenToAllSupportedEvents(container);
    return new $0c49c351e4bf4c9d$var$ReactDOMRoot(options);
};
$0c49c351e4bf4c9d$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$0c49c351e4bf4c9d$var$isValidContainer(container)) throw Error($0c49c351e4bf4c9d$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $0c49c351e4bf4c9d$var$defaultOnUncaughtError, onCaughtError = $0c49c351e4bf4c9d$var$defaultOnCaughtError, onRecoverableError = $0c49c351e4bf4c9d$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $0c49c351e4bf4c9d$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $0c49c351e4bf4c9d$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $0c49c351e4bf4c9d$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $0c49c351e4bf4c9d$var$requestUpdateLane();
    isStrictMode = $0c49c351e4bf4c9d$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $0c49c351e4bf4c9d$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $0c49c351e4bf4c9d$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $0c49c351e4bf4c9d$var$markRootUpdated$1(initialChildren, options);
    $0c49c351e4bf4c9d$var$ensureRootIsScheduled(initialChildren);
    container[$0c49c351e4bf4c9d$var$internalContainerInstanceKey] = initialChildren.current;
    $0c49c351e4bf4c9d$var$listenToAllSupportedEvents(container);
    return new $0c49c351e4bf4c9d$var$ReactDOMHydrationRoot(initialChildren);
};
$0c49c351e4bf4c9d$export$83d89fbfd8236492 = "19.2.5";

});
parcelRegister("aDD22", function(module, exports) {
'use strict';

module.exports = (parcelRequire("MaVvO"));

});
parcelRegister("MaVvO", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $090cf59b76a5ebbc$export$c4744153514ff05d; }, function (v) { return $090cf59b76a5ebbc$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $090cf59b76a5ebbc$export$3e506c1ccc9cc1a7; }, function (v) { return $090cf59b76a5ebbc$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $090cf59b76a5ebbc$export$e26fe2ed2fa76875; }, function (v) { return $090cf59b76a5ebbc$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $090cf59b76a5ebbc$export$502329bbf4b505b1; }, function (v) { return $090cf59b76a5ebbc$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $090cf59b76a5ebbc$export$6e3807111c4874c4; }, function (v) { return $090cf59b76a5ebbc$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $090cf59b76a5ebbc$export$c27134553091fb3a; }, function (v) { return $090cf59b76a5ebbc$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $090cf59b76a5ebbc$export$33ee1acdc04fd2a2; }, function (v) { return $090cf59b76a5ebbc$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $090cf59b76a5ebbc$export$b00a404bbd5edef2; }, function (v) { return $090cf59b76a5ebbc$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $090cf59b76a5ebbc$export$d66a1c1c77bd778b; }, function (v) { return $090cf59b76a5ebbc$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $090cf59b76a5ebbc$export$d3dfb8e4810cb555; }, function (v) { return $090cf59b76a5ebbc$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $090cf59b76a5ebbc$export$72fdf0e06517287b; }, function (v) { return $090cf59b76a5ebbc$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $090cf59b76a5ebbc$export$816d2913ae6b83b1; }, function (v) { return $090cf59b76a5ebbc$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $090cf59b76a5ebbc$export$61bcfe829111a1d0; }, function (v) { return $090cf59b76a5ebbc$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $090cf59b76a5ebbc$export$7ee8c9beb337bc3f; }, function (v) { return $090cf59b76a5ebbc$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $090cf59b76a5ebbc$export$b5836b71941fa3ed; }, function (v) { return $090cf59b76a5ebbc$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $090cf59b76a5ebbc$export$cf845f2c119da08a; }, function (v) { return $090cf59b76a5ebbc$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $090cf59b76a5ebbc$export$c4744153514ff05d;
var $090cf59b76a5ebbc$export$3e506c1ccc9cc1a7;
var $090cf59b76a5ebbc$export$e26fe2ed2fa76875;
var $090cf59b76a5ebbc$export$502329bbf4b505b1;
var $090cf59b76a5ebbc$export$6e3807111c4874c4;
var $090cf59b76a5ebbc$export$c27134553091fb3a;
var $090cf59b76a5ebbc$export$33ee1acdc04fd2a2;
var $090cf59b76a5ebbc$export$b00a404bbd5edef2;
var $090cf59b76a5ebbc$export$d66a1c1c77bd778b;
var $090cf59b76a5ebbc$export$d3dfb8e4810cb555;
var $090cf59b76a5ebbc$export$72fdf0e06517287b;
var $090cf59b76a5ebbc$export$816d2913ae6b83b1;
var $090cf59b76a5ebbc$export$61bcfe829111a1d0;
var $090cf59b76a5ebbc$export$7ee8c9beb337bc3f;
var $090cf59b76a5ebbc$export$b5836b71941fa3ed;
var $090cf59b76a5ebbc$export$cf845f2c119da08a;
"use strict";
function $090cf59b76a5ebbc$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $090cf59b76a5ebbc$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $090cf59b76a5ebbc$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $090cf59b76a5ebbc$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $090cf59b76a5ebbc$var$compare(left, last)) rightIndex < length && 0 > $090cf59b76a5ebbc$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $090cf59b76a5ebbc$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $090cf59b76a5ebbc$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$090cf59b76a5ebbc$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $090cf59b76a5ebbc$var$localPerformance = performance;
    $090cf59b76a5ebbc$export$c4744153514ff05d = function() {
        return $090cf59b76a5ebbc$var$localPerformance.now();
    };
} else {
    var $090cf59b76a5ebbc$var$localDate = Date, $090cf59b76a5ebbc$var$initialTime = $090cf59b76a5ebbc$var$localDate.now();
    $090cf59b76a5ebbc$export$c4744153514ff05d = function() {
        return $090cf59b76a5ebbc$var$localDate.now() - $090cf59b76a5ebbc$var$initialTime;
    };
}
var $090cf59b76a5ebbc$var$taskQueue = [], $090cf59b76a5ebbc$var$timerQueue = [], $090cf59b76a5ebbc$var$taskIdCounter = 1, $090cf59b76a5ebbc$var$currentTask = null, $090cf59b76a5ebbc$var$currentPriorityLevel = 3, $090cf59b76a5ebbc$var$isPerformingWork = !1, $090cf59b76a5ebbc$var$isHostCallbackScheduled = !1, $090cf59b76a5ebbc$var$isHostTimeoutScheduled = !1, $090cf59b76a5ebbc$var$needsPaint = !1, $090cf59b76a5ebbc$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $090cf59b76a5ebbc$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $090cf59b76a5ebbc$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $090cf59b76a5ebbc$var$advanceTimers(currentTime) {
    for(var timer = $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$timerQueue); null !== timer;){
        if (null === timer.callback) $090cf59b76a5ebbc$var$pop($090cf59b76a5ebbc$var$timerQueue);
        else if (timer.startTime <= currentTime) $090cf59b76a5ebbc$var$pop($090cf59b76a5ebbc$var$timerQueue), timer.sortIndex = timer.expirationTime, $090cf59b76a5ebbc$var$push($090cf59b76a5ebbc$var$taskQueue, timer);
        else break;
        timer = $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$timerQueue);
    }
}
function $090cf59b76a5ebbc$var$handleTimeout(currentTime) {
    $090cf59b76a5ebbc$var$isHostTimeoutScheduled = !1;
    $090cf59b76a5ebbc$var$advanceTimers(currentTime);
    if (!$090cf59b76a5ebbc$var$isHostCallbackScheduled) {
        if (null !== $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$taskQueue)) $090cf59b76a5ebbc$var$isHostCallbackScheduled = !0, $090cf59b76a5ebbc$var$isMessageLoopRunning || ($090cf59b76a5ebbc$var$isMessageLoopRunning = !0, $090cf59b76a5ebbc$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$timerQueue);
            null !== firstTimer && $090cf59b76a5ebbc$var$requestHostTimeout($090cf59b76a5ebbc$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $090cf59b76a5ebbc$var$isMessageLoopRunning = !1, $090cf59b76a5ebbc$var$taskTimeoutID = -1, $090cf59b76a5ebbc$var$frameInterval = 5, $090cf59b76a5ebbc$var$startTime = -1;
function $090cf59b76a5ebbc$var$shouldYieldToHost() {
    return $090cf59b76a5ebbc$var$needsPaint ? !0 : $090cf59b76a5ebbc$export$c4744153514ff05d() - $090cf59b76a5ebbc$var$startTime < $090cf59b76a5ebbc$var$frameInterval ? !1 : !0;
}
function $090cf59b76a5ebbc$var$performWorkUntilDeadline() {
    $090cf59b76a5ebbc$var$needsPaint = !1;
    if ($090cf59b76a5ebbc$var$isMessageLoopRunning) {
        var currentTime = $090cf59b76a5ebbc$export$c4744153514ff05d();
        $090cf59b76a5ebbc$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $090cf59b76a5ebbc$var$isHostCallbackScheduled = !1;
                $090cf59b76a5ebbc$var$isHostTimeoutScheduled && ($090cf59b76a5ebbc$var$isHostTimeoutScheduled = !1, $090cf59b76a5ebbc$var$localClearTimeout($090cf59b76a5ebbc$var$taskTimeoutID), $090cf59b76a5ebbc$var$taskTimeoutID = -1);
                $090cf59b76a5ebbc$var$isPerformingWork = !0;
                var previousPriorityLevel = $090cf59b76a5ebbc$var$currentPriorityLevel;
                try {
                    b: {
                        $090cf59b76a5ebbc$var$advanceTimers(currentTime);
                        for($090cf59b76a5ebbc$var$currentTask = $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$taskQueue); null !== $090cf59b76a5ebbc$var$currentTask && !($090cf59b76a5ebbc$var$currentTask.expirationTime > currentTime && $090cf59b76a5ebbc$var$shouldYieldToHost());){
                            var callback = $090cf59b76a5ebbc$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $090cf59b76a5ebbc$var$currentTask.callback = null;
                                $090cf59b76a5ebbc$var$currentPriorityLevel = $090cf59b76a5ebbc$var$currentTask.priorityLevel;
                                var continuationCallback = callback($090cf59b76a5ebbc$var$currentTask.expirationTime <= currentTime);
                                currentTime = $090cf59b76a5ebbc$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $090cf59b76a5ebbc$var$currentTask.callback = continuationCallback;
                                    $090cf59b76a5ebbc$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $090cf59b76a5ebbc$var$currentTask === $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$taskQueue) && $090cf59b76a5ebbc$var$pop($090cf59b76a5ebbc$var$taskQueue);
                                $090cf59b76a5ebbc$var$advanceTimers(currentTime);
                            } else $090cf59b76a5ebbc$var$pop($090cf59b76a5ebbc$var$taskQueue);
                            $090cf59b76a5ebbc$var$currentTask = $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$taskQueue);
                        }
                        if (null !== $090cf59b76a5ebbc$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$timerQueue);
                            null !== firstTimer && $090cf59b76a5ebbc$var$requestHostTimeout($090cf59b76a5ebbc$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $090cf59b76a5ebbc$var$currentTask = null, $090cf59b76a5ebbc$var$currentPriorityLevel = previousPriorityLevel, $090cf59b76a5ebbc$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $090cf59b76a5ebbc$var$schedulePerformWorkUntilDeadline() : $090cf59b76a5ebbc$var$isMessageLoopRunning = !1;
        }
    }
}
var $090cf59b76a5ebbc$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $090cf59b76a5ebbc$var$localSetImmediate) $090cf59b76a5ebbc$var$schedulePerformWorkUntilDeadline = function() {
    $090cf59b76a5ebbc$var$localSetImmediate($090cf59b76a5ebbc$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $090cf59b76a5ebbc$var$channel = new MessageChannel(), $090cf59b76a5ebbc$var$port = $090cf59b76a5ebbc$var$channel.port2;
    $090cf59b76a5ebbc$var$channel.port1.onmessage = $090cf59b76a5ebbc$var$performWorkUntilDeadline;
    $090cf59b76a5ebbc$var$schedulePerformWorkUntilDeadline = function() {
        $090cf59b76a5ebbc$var$port.postMessage(null);
    };
} else $090cf59b76a5ebbc$var$schedulePerformWorkUntilDeadline = function() {
    $090cf59b76a5ebbc$var$localSetTimeout($090cf59b76a5ebbc$var$performWorkUntilDeadline, 0);
};
function $090cf59b76a5ebbc$var$requestHostTimeout(callback, ms) {
    $090cf59b76a5ebbc$var$taskTimeoutID = $090cf59b76a5ebbc$var$localSetTimeout(function() {
        callback($090cf59b76a5ebbc$export$c4744153514ff05d());
    }, ms);
}
$090cf59b76a5ebbc$export$3e506c1ccc9cc1a7 = 5;
$090cf59b76a5ebbc$export$e26fe2ed2fa76875 = 1;
$090cf59b76a5ebbc$export$502329bbf4b505b1 = 4;
$090cf59b76a5ebbc$export$6e3807111c4874c4 = 3;
$090cf59b76a5ebbc$export$c27134553091fb3a = null;
$090cf59b76a5ebbc$export$33ee1acdc04fd2a2 = 2;
$090cf59b76a5ebbc$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$090cf59b76a5ebbc$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $090cf59b76a5ebbc$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$090cf59b76a5ebbc$export$d3dfb8e4810cb555 = function() {
    return $090cf59b76a5ebbc$var$currentPriorityLevel;
};
$090cf59b76a5ebbc$export$72fdf0e06517287b = function(eventHandler) {
    switch($090cf59b76a5ebbc$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $090cf59b76a5ebbc$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $090cf59b76a5ebbc$var$currentPriorityLevel;
    $090cf59b76a5ebbc$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $090cf59b76a5ebbc$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$090cf59b76a5ebbc$export$816d2913ae6b83b1 = function() {
    $090cf59b76a5ebbc$var$needsPaint = !0;
};
$090cf59b76a5ebbc$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $090cf59b76a5ebbc$var$currentPriorityLevel;
    $090cf59b76a5ebbc$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $090cf59b76a5ebbc$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$090cf59b76a5ebbc$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $090cf59b76a5ebbc$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $090cf59b76a5ebbc$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $090cf59b76a5ebbc$var$push($090cf59b76a5ebbc$var$timerQueue, priorityLevel), null === $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$taskQueue) && priorityLevel === $090cf59b76a5ebbc$var$peek($090cf59b76a5ebbc$var$timerQueue) && ($090cf59b76a5ebbc$var$isHostTimeoutScheduled ? ($090cf59b76a5ebbc$var$localClearTimeout($090cf59b76a5ebbc$var$taskTimeoutID), $090cf59b76a5ebbc$var$taskTimeoutID = -1) : $090cf59b76a5ebbc$var$isHostTimeoutScheduled = !0, $090cf59b76a5ebbc$var$requestHostTimeout($090cf59b76a5ebbc$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $090cf59b76a5ebbc$var$push($090cf59b76a5ebbc$var$taskQueue, priorityLevel), $090cf59b76a5ebbc$var$isHostCallbackScheduled || $090cf59b76a5ebbc$var$isPerformingWork || ($090cf59b76a5ebbc$var$isHostCallbackScheduled = !0, $090cf59b76a5ebbc$var$isMessageLoopRunning || ($090cf59b76a5ebbc$var$isMessageLoopRunning = !0, $090cf59b76a5ebbc$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$090cf59b76a5ebbc$export$b5836b71941fa3ed = $090cf59b76a5ebbc$var$shouldYieldToHost;
$090cf59b76a5ebbc$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $090cf59b76a5ebbc$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $090cf59b76a5ebbc$var$currentPriorityLevel;
        $090cf59b76a5ebbc$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $090cf59b76a5ebbc$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("c56K2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3GUo0"));

});
parcelRegister("3GUo0", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $2b010875baece68b$export$9c16c1426311996d; }, function (v) { return $2b010875baece68b$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $2b010875baece68b$export$dca3b0875bd9a954; }, function (v) { return $2b010875baece68b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $2b010875baece68b$export$16fa2f45be04daa8; }, function (v) { return $2b010875baece68b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2b010875baece68b$export$ffb0004e005737fa; }, function (v) { return $2b010875baece68b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $2b010875baece68b$export$e2c29f18771995cb; }, function (v) { return $2b010875baece68b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $2b010875baece68b$export$221d75b3f55bb0bd; }, function (v) { return $2b010875baece68b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2b010875baece68b$export$5f8d39834fd61797; }, function (v) { return $2b010875baece68b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2b010875baece68b$export$74bf444e3cd11ea5; }, function (v) { return $2b010875baece68b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $2b010875baece68b$export$1ced07cd6b1985ce; }, function (v) { return $2b010875baece68b$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $2b010875baece68b$export$abd8e32b826d7ea7; }, function (v) { return $2b010875baece68b$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $2b010875baece68b$export$69a3209f1a06c04d; }, function (v) { return $2b010875baece68b$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $2b010875baece68b$export$8c538325882c7eec; }, function (v) { return $2b010875baece68b$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $2b010875baece68b$export$e530037191fcd5d7; }, function (v) { return $2b010875baece68b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $2b010875baece68b$export$fd42f52fd3ae1109; }, function (v) { return $2b010875baece68b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $2b010875baece68b$export$c8a8987d4410bf2d; }, function (v) { return $2b010875baece68b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $2b010875baece68b$export$7d1e3a5e95ceca43; }, function (v) { return $2b010875baece68b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $2b010875baece68b$export$257a8862b851cb5b; }, function (v) { return $2b010875baece68b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $2b010875baece68b$export$a8257692ac88316c; }, function (v) { return $2b010875baece68b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $2b010875baece68b$export$488013bae63b21da; }, function (v) { return $2b010875baece68b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $2b010875baece68b$export$7c73462e0d25e514; }, function (v) { return $2b010875baece68b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $2b010875baece68b$export$7568632d0d33d16d; }, function (v) { return $2b010875baece68b$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $2b010875baece68b$export$f93f40ac0ca7e3a8; }, function (v) { return $2b010875baece68b$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $2b010875baece68b$export$1f96ae73734a86cc; }, function (v) { return $2b010875baece68b$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $2b010875baece68b$export$9a47ced3238df325; }, function (v) { return $2b010875baece68b$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $2b010875baece68b$export$35808ee640e87ca7; }, function (v) { return $2b010875baece68b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $2b010875baece68b$export$fae74005e78b1a27; }, function (v) { return $2b010875baece68b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $2b010875baece68b$export$dc8fbce3eb94dc1e; }, function (v) { return $2b010875baece68b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $2b010875baece68b$export$6a7bc4e911dc01cf; }, function (v) { return $2b010875baece68b$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $2b010875baece68b$export$6d9c69b0de29b591; }, function (v) { return $2b010875baece68b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $2b010875baece68b$export$7f54fc3180508a52; }, function (v) { return $2b010875baece68b$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $2b010875baece68b$export$f680877a34711e37; }, function (v) { return $2b010875baece68b$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $2b010875baece68b$export$d5a552a76deda3c2; }, function (v) { return $2b010875baece68b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $2b010875baece68b$export$aaabe4eda9ed9969; }, function (v) { return $2b010875baece68b$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $2b010875baece68b$export$e5c5a5f917a5871c; }, function (v) { return $2b010875baece68b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $2b010875baece68b$export$1538c33de8887b59; }, function (v) { return $2b010875baece68b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $2b010875baece68b$export$fca7f784ae7a249a; }, function (v) { return $2b010875baece68b$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $2b010875baece68b$export$13e3392192263954; }, function (v) { return $2b010875baece68b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $2b010875baece68b$export$b8f5890fc79d6aca; }, function (v) { return $2b010875baece68b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $2b010875baece68b$export$60241385465d0a34; }, function (v) { return $2b010875baece68b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $2b010875baece68b$export$306c0aa65ff9ec16; }, function (v) { return $2b010875baece68b$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $2b010875baece68b$export$7b286972b8d8ccbf; }, function (v) { return $2b010875baece68b$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $2b010875baece68b$export$83d89fbfd8236492; }, function (v) { return $2b010875baece68b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2b010875baece68b$export$9c16c1426311996d;
var $2b010875baece68b$export$dca3b0875bd9a954;
var $2b010875baece68b$export$16fa2f45be04daa8;
var $2b010875baece68b$export$ffb0004e005737fa;
var $2b010875baece68b$export$e2c29f18771995cb;
var $2b010875baece68b$export$221d75b3f55bb0bd;
var $2b010875baece68b$export$5f8d39834fd61797;
var $2b010875baece68b$export$74bf444e3cd11ea5;
var $2b010875baece68b$export$1ced07cd6b1985ce;
var $2b010875baece68b$export$abd8e32b826d7ea7;
var $2b010875baece68b$export$69a3209f1a06c04d;
var $2b010875baece68b$export$8c538325882c7eec;
var $2b010875baece68b$export$e530037191fcd5d7;
var $2b010875baece68b$export$fd42f52fd3ae1109;
var $2b010875baece68b$export$c8a8987d4410bf2d;
var $2b010875baece68b$export$7d1e3a5e95ceca43;
var $2b010875baece68b$export$257a8862b851cb5b;
var $2b010875baece68b$export$a8257692ac88316c;
var $2b010875baece68b$export$488013bae63b21da;
var $2b010875baece68b$export$7c73462e0d25e514;
var $2b010875baece68b$export$7568632d0d33d16d;
var $2b010875baece68b$export$f93f40ac0ca7e3a8;
var $2b010875baece68b$export$1f96ae73734a86cc;
var $2b010875baece68b$export$9a47ced3238df325;
var $2b010875baece68b$export$35808ee640e87ca7;
var $2b010875baece68b$export$fae74005e78b1a27;
var $2b010875baece68b$export$dc8fbce3eb94dc1e;
var $2b010875baece68b$export$6a7bc4e911dc01cf;
var $2b010875baece68b$export$6d9c69b0de29b591;
var $2b010875baece68b$export$7f54fc3180508a52;
var $2b010875baece68b$export$f680877a34711e37;
var $2b010875baece68b$export$d5a552a76deda3c2;
var $2b010875baece68b$export$aaabe4eda9ed9969;
var $2b010875baece68b$export$e5c5a5f917a5871c;
var $2b010875baece68b$export$1538c33de8887b59;
var $2b010875baece68b$export$fca7f784ae7a249a;
var $2b010875baece68b$export$13e3392192263954;
var $2b010875baece68b$export$b8f5890fc79d6aca;
var $2b010875baece68b$export$60241385465d0a34;
var $2b010875baece68b$export$306c0aa65ff9ec16;
var $2b010875baece68b$export$7b286972b8d8ccbf;
var $2b010875baece68b$export$83d89fbfd8236492;
"use strict";
var $2b010875baece68b$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2b010875baece68b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2b010875baece68b$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2b010875baece68b$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2b010875baece68b$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2b010875baece68b$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2b010875baece68b$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2b010875baece68b$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2b010875baece68b$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2b010875baece68b$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2b010875baece68b$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $2b010875baece68b$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $2b010875baece68b$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2b010875baece68b$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2b010875baece68b$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2b010875baece68b$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2b010875baece68b$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2b010875baece68b$var$assign = Object.assign, $2b010875baece68b$var$emptyObject = {};
function $2b010875baece68b$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2b010875baece68b$var$emptyObject;
    this.updater = updater || $2b010875baece68b$var$ReactNoopUpdateQueue;
}
$2b010875baece68b$var$Component.prototype.isReactComponent = {};
$2b010875baece68b$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$2b010875baece68b$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $2b010875baece68b$var$ComponentDummy() {}
$2b010875baece68b$var$ComponentDummy.prototype = $2b010875baece68b$var$Component.prototype;
function $2b010875baece68b$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2b010875baece68b$var$emptyObject;
    this.updater = updater || $2b010875baece68b$var$ReactNoopUpdateQueue;
}
var $2b010875baece68b$var$pureComponentPrototype = $2b010875baece68b$var$PureComponent.prototype = new $2b010875baece68b$var$ComponentDummy();
$2b010875baece68b$var$pureComponentPrototype.constructor = $2b010875baece68b$var$PureComponent;
$2b010875baece68b$var$assign($2b010875baece68b$var$pureComponentPrototype, $2b010875baece68b$var$Component.prototype);
$2b010875baece68b$var$pureComponentPrototype.isPureReactComponent = !0;
var $2b010875baece68b$var$isArrayImpl = Array.isArray;
function $2b010875baece68b$var$noop() {}
var $2b010875baece68b$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $2b010875baece68b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2b010875baece68b$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $2b010875baece68b$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $2b010875baece68b$var$cloneAndReplaceKey(oldElement, newKey) {
    return $2b010875baece68b$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $2b010875baece68b$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $2b010875baece68b$var$REACT_ELEMENT_TYPE;
}
function $2b010875baece68b$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $2b010875baece68b$var$userProvidedKeyEscapeRegex = /\/+/g;
function $2b010875baece68b$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $2b010875baece68b$var$escape("" + element.key) : index.toString(36);
}
function $2b010875baece68b$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($2b010875baece68b$var$noop, $2b010875baece68b$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $2b010875baece68b$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $2b010875baece68b$var$REACT_ELEMENT_TYPE:
                case $2b010875baece68b$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $2b010875baece68b$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $2b010875baece68b$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $2b010875baece68b$var$getElementKey(children, 0) : nameSoFar, $2b010875baece68b$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($2b010875baece68b$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $2b010875baece68b$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($2b010875baece68b$var$isValidElement(callback) && (callback = $2b010875baece68b$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($2b010875baece68b$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($2b010875baece68b$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $2b010875baece68b$var$getElementKey(nameSoFar, i), invokeCallback += $2b010875baece68b$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $2b010875baece68b$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $2b010875baece68b$var$getElementKey(nameSoFar, i++), invokeCallback += $2b010875baece68b$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $2b010875baece68b$var$mapIntoArray($2b010875baece68b$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $2b010875baece68b$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $2b010875baece68b$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $2b010875baece68b$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $2b010875baece68b$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $2b010875baece68b$var$Children = {
    map: $2b010875baece68b$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $2b010875baece68b$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $2b010875baece68b$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $2b010875baece68b$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$2b010875baece68b$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$2b010875baece68b$export$9c16c1426311996d = $2b010875baece68b$var$REACT_ACTIVITY_TYPE;
$2b010875baece68b$export$dca3b0875bd9a954 = $2b010875baece68b$var$Children;
$2b010875baece68b$export$16fa2f45be04daa8 = $2b010875baece68b$var$Component;
$2b010875baece68b$export$ffb0004e005737fa = $2b010875baece68b$var$REACT_FRAGMENT_TYPE;
$2b010875baece68b$export$e2c29f18771995cb = $2b010875baece68b$var$REACT_PROFILER_TYPE;
$2b010875baece68b$export$221d75b3f55bb0bd = $2b010875baece68b$var$PureComponent;
$2b010875baece68b$export$5f8d39834fd61797 = $2b010875baece68b$var$REACT_STRICT_MODE_TYPE;
$2b010875baece68b$export$74bf444e3cd11ea5 = $2b010875baece68b$var$REACT_SUSPENSE_TYPE;
$2b010875baece68b$export$1ced07cd6b1985ce = $2b010875baece68b$var$ReactSharedInternals;
$2b010875baece68b$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $2b010875baece68b$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$2b010875baece68b$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$2b010875baece68b$export$8c538325882c7eec = function() {
    return null;
};
$2b010875baece68b$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $2b010875baece68b$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$2b010875baece68b$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $2b010875baece68b$var$ReactElement(element.type, key, props);
};
$2b010875baece68b$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $2b010875baece68b$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $2b010875baece68b$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$2b010875baece68b$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$2b010875baece68b$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $2b010875baece68b$var$ReactElement(type, key, props);
};
$2b010875baece68b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$2b010875baece68b$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $2b010875baece68b$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$2b010875baece68b$export$a8257692ac88316c = $2b010875baece68b$var$isValidElement;
$2b010875baece68b$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $2b010875baece68b$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $2b010875baece68b$var$lazyInitializer
    };
};
$2b010875baece68b$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $2b010875baece68b$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$2b010875baece68b$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $2b010875baece68b$var$ReactSharedInternals.T, currentTransition = {};
    $2b010875baece68b$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $2b010875baece68b$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($2b010875baece68b$var$noop, $2b010875baece68b$var$reportGlobalError);
    } catch (error) {
        $2b010875baece68b$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2b010875baece68b$var$ReactSharedInternals.T = prevTransition;
    }
};
$2b010875baece68b$export$f93f40ac0ca7e3a8 = function() {
    return $2b010875baece68b$var$ReactSharedInternals.H.useCacheRefresh();
};
$2b010875baece68b$export$1f96ae73734a86cc = function(usable) {
    return $2b010875baece68b$var$ReactSharedInternals.H.use(usable);
};
$2b010875baece68b$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$2b010875baece68b$export$35808ee640e87ca7 = function(callback, deps) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$2b010875baece68b$export$fae74005e78b1a27 = function(Context) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useContext(Context);
};
$2b010875baece68b$export$dc8fbce3eb94dc1e = function() {};
$2b010875baece68b$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$2b010875baece68b$export$6d9c69b0de29b591 = function(create, deps) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useEffect(create, deps);
};
$2b010875baece68b$export$7f54fc3180508a52 = function(callback) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$2b010875baece68b$export$f680877a34711e37 = function() {
    return $2b010875baece68b$var$ReactSharedInternals.H.useId();
};
$2b010875baece68b$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$2b010875baece68b$export$aaabe4eda9ed9969 = function(create, deps) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$2b010875baece68b$export$e5c5a5f917a5871c = function(create, deps) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$2b010875baece68b$export$1538c33de8887b59 = function(create, deps) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useMemo(create, deps);
};
$2b010875baece68b$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$2b010875baece68b$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$2b010875baece68b$export$b8f5890fc79d6aca = function(initialValue) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useRef(initialValue);
};
$2b010875baece68b$export$60241385465d0a34 = function(initialState) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useState(initialState);
};
$2b010875baece68b$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $2b010875baece68b$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$2b010875baece68b$export$7b286972b8d8ccbf = function() {
    return $2b010875baece68b$var$ReactSharedInternals.H.useTransition();
};
$2b010875baece68b$export$83d89fbfd8236492 = "19.2.5";

});


parcelRegister("dg2Np", function(module, exports) {
'use strict';
function $9a6ef02ed3b13529$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9a6ef02ed3b13529$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9a6ef02ed3b13529$var$checkDCE();

module.exports = (parcelRequire("1y9jr"));

});
parcelRegister("1y9jr", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $121030b11cb46473$export$69ce8ef3fe5cead0; }, function (v) { return $121030b11cb46473$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $121030b11cb46473$export$d39a5bbd09211389; }, function (v) { return $121030b11cb46473$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $121030b11cb46473$export$cd75ccfd720a3cd4; }, function (v) { return $121030b11cb46473$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $121030b11cb46473$export$a0816fa17a9e79be; }, function (v) { return $121030b11cb46473$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $121030b11cb46473$export$7292efcadded39f3; }, function (v) { return $121030b11cb46473$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $121030b11cb46473$export$da407abadb9b8f86; }, function (v) { return $121030b11cb46473$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $121030b11cb46473$export$314cfea32580671c; }, function (v) { return $121030b11cb46473$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $121030b11cb46473$export$513ccb98c53b8039; }, function (v) { return $121030b11cb46473$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $121030b11cb46473$export$dbca993bc2d264a; }, function (v) { return $121030b11cb46473$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $121030b11cb46473$export$4797a8006f0655d0; }, function (v) { return $121030b11cb46473$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $121030b11cb46473$export$c78a37762a8d58e1; }, function (v) { return $121030b11cb46473$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $121030b11cb46473$export$606f11b2eb45ecc6; }, function (v) { return $121030b11cb46473$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $121030b11cb46473$export$f7e8a0bf92324b1e; }, function (v) { return $121030b11cb46473$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $121030b11cb46473$export$83d89fbfd8236492; }, function (v) { return $121030b11cb46473$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $121030b11cb46473$export$69ce8ef3fe5cead0;
var $121030b11cb46473$export$d39a5bbd09211389;
var $121030b11cb46473$export$cd75ccfd720a3cd4;
var $121030b11cb46473$export$a0816fa17a9e79be;
var $121030b11cb46473$export$7292efcadded39f3;
var $121030b11cb46473$export$da407abadb9b8f86;
var $121030b11cb46473$export$314cfea32580671c;
var $121030b11cb46473$export$513ccb98c53b8039;
var $121030b11cb46473$export$dbca993bc2d264a;
var $121030b11cb46473$export$4797a8006f0655d0;
var $121030b11cb46473$export$c78a37762a8d58e1;
var $121030b11cb46473$export$606f11b2eb45ecc6;
var $121030b11cb46473$export$f7e8a0bf92324b1e;
var $121030b11cb46473$export$83d89fbfd8236492;
"use strict";

var $c56K2 = parcelRequire("c56K2");
function $121030b11cb46473$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $121030b11cb46473$var$noop() {}
var $121030b11cb46473$var$Internals = {
    d: {
        f: $121030b11cb46473$var$noop,
        r: function() {
            throw Error($121030b11cb46473$var$formatProdErrorMessage(522));
        },
        D: $121030b11cb46473$var$noop,
        C: $121030b11cb46473$var$noop,
        L: $121030b11cb46473$var$noop,
        m: $121030b11cb46473$var$noop,
        X: $121030b11cb46473$var$noop,
        S: $121030b11cb46473$var$noop,
        M: $121030b11cb46473$var$noop
    },
    p: 0,
    findDOMNode: null
}, $121030b11cb46473$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $121030b11cb46473$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $121030b11cb46473$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $121030b11cb46473$var$ReactSharedInternals = $c56K2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $121030b11cb46473$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$121030b11cb46473$export$69ce8ef3fe5cead0 = $121030b11cb46473$var$Internals;
$121030b11cb46473$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($121030b11cb46473$var$formatProdErrorMessage(299));
    return $121030b11cb46473$var$createPortal$1(children, container, null, key);
};
$121030b11cb46473$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $121030b11cb46473$var$ReactSharedInternals.T, previousUpdatePriority = $121030b11cb46473$var$Internals.p;
    try {
        if ($121030b11cb46473$var$ReactSharedInternals.T = null, $121030b11cb46473$var$Internals.p = 2, fn) return fn();
    } finally{
        $121030b11cb46473$var$ReactSharedInternals.T = previousTransition, $121030b11cb46473$var$Internals.p = previousUpdatePriority, $121030b11cb46473$var$Internals.d.f();
    }
};
$121030b11cb46473$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $121030b11cb46473$var$Internals.d.C(href, options));
};
$121030b11cb46473$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $121030b11cb46473$var$Internals.d.D(href);
};
$121030b11cb46473$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $121030b11cb46473$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $121030b11cb46473$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $121030b11cb46473$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$121030b11cb46473$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $121030b11cb46473$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $121030b11cb46473$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $121030b11cb46473$var$Internals.d.M(href);
    }
};
$121030b11cb46473$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $121030b11cb46473$var$getCrossOriginStringAs(as, options.crossOrigin);
        $121030b11cb46473$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$121030b11cb46473$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $121030b11cb46473$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $121030b11cb46473$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $121030b11cb46473$var$Internals.d.m(href);
    }
};
$121030b11cb46473$export$4797a8006f0655d0 = function(form) {
    $121030b11cb46473$var$Internals.d.r(form);
};
$121030b11cb46473$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$121030b11cb46473$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $121030b11cb46473$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$121030b11cb46473$export$f7e8a0bf92324b1e = function() {
    return $121030b11cb46473$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$121030b11cb46473$export$83d89fbfd8236492 = "19.2.5";

});



parcelRegister("let0R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7516924ef6f67ff$export$2e2bcd8739ae039; });
var $f7516924ef6f67ff$var$isProduction = true;
var $f7516924ef6f67ff$var$prefix = 'Invariant failed';
function $f7516924ef6f67ff$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($f7516924ef6f67ff$var$isProduction) throw new Error($f7516924ef6f67ff$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($f7516924ef6f67ff$var$prefix, ": ").concat(provided) : $f7516924ef6f67ff$var$prefix;
    throw new Error(value);
}

});

parcelRegister("aY4lk", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $7fc2e06c42e69fb5$export$bf730a2d8bf68b42; }, function (v) { return $7fc2e06c42e69fb5$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7fc2e06c42e69fb5$export$bf730a2d8bf68b42;
"use strict";

var $c56K2 = parcelRequire("c56K2");
function $7fc2e06c42e69fb5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $7fc2e06c42e69fb5$var$objectIs = "function" === typeof Object.is ? Object.is : $7fc2e06c42e69fb5$var$is, $7fc2e06c42e69fb5$var$useSyncExternalStore = $c56K2.useSyncExternalStore, $7fc2e06c42e69fb5$var$useRef = $c56K2.useRef, $7fc2e06c42e69fb5$var$useEffect = $c56K2.useEffect, $7fc2e06c42e69fb5$var$useMemo = $c56K2.useMemo, $7fc2e06c42e69fb5$var$useDebugValue = $c56K2.useDebugValue;
$7fc2e06c42e69fb5$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $7fc2e06c42e69fb5$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $7fc2e06c42e69fb5$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($7fc2e06c42e69fb5$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $7fc2e06c42e69fb5$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $7fc2e06c42e69fb5$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $7fc2e06c42e69fb5$var$useDebugValue(value);
    return value;
};

});

parcelRegister("2k2dg", function(module, exports) {
module.exports = $parcel$import("7xhmB").then(()=>parcelRequire('fsmFS'));

});

var $f85d00099a3cae35$exports = {};
$parcel$extendImportMap({
    "7xhmB": "footnotes.1544e326.js"
});

var $782cc9fb2a36dc63$exports = {};
'use strict';

$782cc9fb2a36dc63$exports = (parcelRequire("k3E3u"));


var $9dfd74aff40bc7d6$exports = {};
'use strict';
function $9dfd74aff40bc7d6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9dfd74aff40bc7d6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9dfd74aff40bc7d6$var$checkDCE();

$9dfd74aff40bc7d6$exports = (parcelRequire("13pnY"));



var $let0R = parcelRequire("let0R");


var $c56K2 = parcelRequire("c56K2");

var $dg2Np = parcelRequire("dg2Np");


var $c56K2 = parcelRequire("c56K2");
var $5db93c425b4f2ea2$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($5db93c425b4f2ea2$export$4b0075e5ea5e1f26 || {});



var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");
var $df79d31ec2535066$var$i = Object.defineProperty;
var $df79d31ec2535066$var$d = (t, e, n)=>e in t ? $df79d31ec2535066$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $df79d31ec2535066$var$r = (t, e, n)=>($df79d31ec2535066$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $df79d31ec2535066$var$o {
    constructor(){
        $df79d31ec2535066$var$r(this, "current", this.detect());
        $df79d31ec2535066$var$r(this, "handoffState", "pending");
        $df79d31ec2535066$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $df79d31ec2535066$export$a7b6bc01c63cdfc3 = new $df79d31ec2535066$var$o;


let $485146febb523711$export$ce5ed857c741fd71 = (e, t)=>{
    (0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isServer ? (0, $c56K2.useEffect)(e, t) : (0, $c56K2.useLayoutEffect)(e, t);
};


function $a51df5cf480cb374$export$86c4283a11f23f95(e) {
    let r = (0, $c56K2.useRef)(e);
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


function $cb31d3146223040a$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(a);
    (0, $c56K2.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}



var $c56K2 = parcelRequire("c56K2");
class $08363dc7bffa1623$export$674cd7dcb504ac5c extends Map {
    constructor(t){
        super();
        this.factory = t;
    }
    get(t) {
        let e = super.get(t);
        return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
    }
}


function $5f6a10e3018e6fa4$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $a1511df59d6e26ec$export$12b26c28a05aa001() {
    let s = [], r = {
        addEventListener (e, t, n, i) {
            return e.addEventListener(t, n, i), r.add(()=>e.removeEventListener(t, n, i));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $5f6a10e3018e6fa4$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, n) {
            let i = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: n
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: i
                });
            });
        },
        group (e) {
            let t = $a1511df59d6e26ec$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return s.includes(e) || s.push(e), ()=>{
                let t = s.indexOf(e);
                if (t >= 0) for (let n of s.splice(t, 1))n();
            };
        },
        dispose () {
            for (let e of s.splice(0))e();
        }
    };
    return r;
}



var $de3d24966fd59e11$var$h = Object.defineProperty;
var $de3d24966fd59e11$var$v = (t, e, r)=>e in t ? $de3d24966fd59e11$var$h(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r;
var $de3d24966fd59e11$var$S = (t, e, r)=>($de3d24966fd59e11$var$v(t, typeof e != "symbol" ? e + "" : e, r), r), $de3d24966fd59e11$var$b = (t, e, r)=>{
    if (!e.has(t)) throw TypeError("Cannot " + r);
};
var $de3d24966fd59e11$var$i = (t, e, r)=>($de3d24966fd59e11$var$b(t, e, "read from private field"), r ? r.call(t) : e.get(t)), $de3d24966fd59e11$var$c = (t, e, r)=>{
    if (e.has(t)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, $de3d24966fd59e11$var$u = (t, e, r, s)=>($de3d24966fd59e11$var$b(t, e, "write to private field"), s ? s.call(t, r) : e.set(t, r), r);
var $de3d24966fd59e11$var$n, $de3d24966fd59e11$var$a, $de3d24966fd59e11$var$o;
class $de3d24966fd59e11$export$f391db14ff2d9279 {
    constructor(e){
        $de3d24966fd59e11$var$c(this, $de3d24966fd59e11$var$n, {});
        $de3d24966fd59e11$var$c(this, $de3d24966fd59e11$var$a, new (0, $08363dc7bffa1623$export$674cd7dcb504ac5c)(()=>new Set));
        $de3d24966fd59e11$var$c(this, $de3d24966fd59e11$var$o, new Set);
        $de3d24966fd59e11$var$S(this, "disposables", (0, $a1511df59d6e26ec$export$12b26c28a05aa001)());
        $de3d24966fd59e11$var$u(this, $de3d24966fd59e11$var$n, e), (0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isServer && this.disposables.microTask(()=>{
            this.dispose();
        });
    }
    dispose() {
        this.disposables.dispose();
    }
    get state() {
        return $de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$n);
    }
    subscribe(e, r) {
        if ((0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isServer) return ()=>{};
        let s = {
            selector: e,
            callback: r,
            current: e($de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$n))
        };
        return $de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$o).add(s), this.disposables.add(()=>{
            $de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$o).delete(s);
        });
    }
    on(e, r) {
        return (0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isServer ? ()=>{} : ($de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$a).get(e).add(r), this.disposables.add(()=>{
            $de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$a).get(e).delete(r);
        }));
    }
    send(e) {
        let r = this.reduce($de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$n), e);
        if (r !== $de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$n)) {
            $de3d24966fd59e11$var$u(this, $de3d24966fd59e11$var$n, r);
            for (let s of $de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$o)){
                let l = s.selector($de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$n));
                $de3d24966fd59e11$export$d36bdfa510afb180(s.current, l) || (s.current = l, s.callback(l));
            }
            for (let s of $de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$a).get(e.type))s($de3d24966fd59e11$var$i(this, $de3d24966fd59e11$var$n), e);
        }
    }
}
$de3d24966fd59e11$var$n = new WeakMap, $de3d24966fd59e11$var$a = new WeakMap, $de3d24966fd59e11$var$o = new WeakMap;
function $de3d24966fd59e11$export$d36bdfa510afb180(t, e) {
    return Object.is(t, e) ? !0 : typeof t != "object" || t === null || typeof e != "object" || e === null ? !1 : Array.isArray(t) && Array.isArray(e) ? t.length !== e.length ? !1 : $de3d24966fd59e11$var$f(t[Symbol.iterator](), e[Symbol.iterator]()) : t instanceof Map && e instanceof Map || t instanceof Set && e instanceof Set ? t.size !== e.size ? !1 : $de3d24966fd59e11$var$f(t.entries(), e.entries()) : $de3d24966fd59e11$var$p(t) && $de3d24966fd59e11$var$p(e) ? $de3d24966fd59e11$var$f(Object.entries(t)[Symbol.iterator](), Object.entries(e)[Symbol.iterator]()) : !1;
}
function $de3d24966fd59e11$var$f(t, e) {
    do {
        let r = t.next(), s = e.next();
        if (r.done && s.done) return !0;
        if (r.done || s.done || !Object.is(r.value, s.value)) return !1;
    }while (!0);
}
function $de3d24966fd59e11$var$p(t) {
    if (Object.prototype.toString.call(t) !== "[object Object]") return !1;
    let e = Object.getPrototypeOf(t);
    return e === null || Object.getPrototypeOf(e) === null;
}
function $de3d24966fd59e11$export$712ea50be43a7858(t) {
    let [e, r] = t(), s = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
    return (...l)=>{
        e(...l), s.dispose(), s.microTask(r);
    };
}



function $c1ca8b69c3a050c3$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $c1ca8b69c3a050c3$export$4659b591c19bdf3d), t;
}


var $cd6058473eaf339d$var$a = Object.defineProperty;
var $cd6058473eaf339d$var$r = (e, c, t)=>c in e ? $cd6058473eaf339d$var$a(e, c, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[c] = t;
var $cd6058473eaf339d$var$p = (e, c, t)=>($cd6058473eaf339d$var$r(e, typeof c != "symbol" ? c + "" : c, t), t);
var $cd6058473eaf339d$export$1385d81a6c6bbcd4 = ((t)=>(t[t.Push = 0] = "Push", t[t.Pop = 1] = "Pop", t))($cd6058473eaf339d$export$1385d81a6c6bbcd4 || {});
let $cd6058473eaf339d$var$y = {
    [0] (e, c) {
        let t = c.id, s = e.stack, i = e.stack.indexOf(t);
        if (i !== -1) {
            let n = e.stack.slice();
            return n.splice(i, 1), n.push(t), s = n, {
                ...e,
                stack: s
            };
        }
        return {
            ...e,
            stack: [
                ...e.stack,
                t
            ]
        };
    },
    [1] (e, c) {
        let t = c.id, s = e.stack.indexOf(t);
        if (s === -1) return e;
        let i = e.stack.slice();
        return i.splice(s, 1), {
            ...e,
            stack: i
        };
    }
};
class $cd6058473eaf339d$var$o extends (0, $de3d24966fd59e11$export$f391db14ff2d9279) {
    constructor(){
        super(...arguments);
        $cd6058473eaf339d$var$p(this, "actions", {
            push: (t)=>this.send({
                    type: 0,
                    id: t
                }),
            pop: (t)=>this.send({
                    type: 1,
                    id: t
                })
        });
        $cd6058473eaf339d$var$p(this, "selectors", {
            isTop: (t, s)=>t.stack[t.stack.length - 1] === s,
            inStack: (t, s)=>t.stack.includes(s)
        });
    }
    static new() {
        return new $cd6058473eaf339d$var$o({
            stack: []
        });
    }
    reduce(t, s) {
        return (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(s.type, $cd6058473eaf339d$var$y, t, s);
    }
}
const $cd6058473eaf339d$export$151359021f43c28a = new (0, $08363dc7bffa1623$export$674cd7dcb504ac5c)(()=>$cd6058473eaf339d$var$o.new());


var $956ee0438ff8cb05$exports = {};
'use strict';

$956ee0438ff8cb05$exports = (parcelRequire("aY4lk"));



var $c56K2 = parcelRequire("c56K2");

let $1c09c694ceff33d2$export$90fc3a17d93f704c = function(t) {
    let e = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};



function $193c4d61ee9eb975$export$89d3cfa2bf31e31a(e, n, r = (0, $de3d24966fd59e11$export$d36bdfa510afb180)) {
    return (0, $956ee0438ff8cb05$exports.useSyncExternalStoreWithSelector)((0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>e.subscribe($193c4d61ee9eb975$var$s, i)), (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>e.state), (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>e.state), (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(n), r);
}
function $193c4d61ee9eb975$var$s(e) {
    return e;
}



function $15c71767d8d4901b$export$5f5dd115998e0b80(o, s) {
    let t = (0, $c56K2.useId)(), r = (0, $cd6058473eaf339d$export$151359021f43c28a).get(s), [i, c] = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(r, (0, $c56K2.useCallback)((e)=>[
            r.selectors.isTop(e, t),
            r.selectors.inStack(e, t)
        ], [
        r,
        t
    ]));
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (o) return r.actions.push(t), ()=>r.actions.pop(t);
    }, [
        r,
        o,
        t
    ]), o ? c ? i : !0 : !1;
}


function $8db81e634b065a32$export$3875fddb67014c13(o, r = typeof document != "undefined" ? document.defaultView : null, t) {
    let n = (0, $15c71767d8d4901b$export$5f5dd115998e0b80)(o, "escape");
    (0, $cb31d3146223040a$export$7080b3e976bc91ab)(r, "keydown", (e)=>{
        n && (e.defaultPrevented || e.key === (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Escape && t(e));
    });
}




var $c56K2 = parcelRequire("c56K2");


function $874591f6f1a15c7a$export$b204af158042fbac(n) {
    var u;
    return (0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isServer ? null : n == null ? document : (u = n == null ? void 0 : n.ownerDocument) != null ? u : document;
}
function $874591f6f1a15c7a$export$9bfe85d84666e58(n) {
    var u, o;
    return (0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isServer ? null : n == null ? document : (o = (u = n == null ? void 0 : n.getRootNode) == null ? void 0 : u.call(n)) != null ? o : document;
}
function $874591f6f1a15c7a$export$cd4e5573fbe2b576(n) {
    var u, o;
    return (o = (u = $874591f6f1a15c7a$export$9bfe85d84666e58(n)) == null ? void 0 : u.activeElement) != null ? o : null;
}
function $874591f6f1a15c7a$export$8a2eb51c14bb8899(n) {
    return $874591f6f1a15c7a$export$cd4e5573fbe2b576(n) === n;
}




let $45f770423adace2b$var$f = new Map, $45f770423adace2b$var$u = new Map;
function $45f770423adace2b$var$h(t) {
    var e;
    let r = (e = $45f770423adace2b$var$u.get(t)) != null ? e : 0;
    return $45f770423adace2b$var$u.set(t, r + 1), r !== 0 ? ()=>$45f770423adace2b$var$m(t) : ($45f770423adace2b$var$f.set(t, {
        "aria-hidden": t.getAttribute("aria-hidden"),
        inert: t.inert
    }), t.setAttribute("aria-hidden", "true"), t.inert = !0, ()=>$45f770423adace2b$var$m(t));
}
function $45f770423adace2b$var$m(t) {
    var i;
    let r = (i = $45f770423adace2b$var$u.get(t)) != null ? i : 1;
    if (r === 1 ? $45f770423adace2b$var$u.delete(t) : $45f770423adace2b$var$u.set(t, r - 1), r !== 1) return;
    let e = $45f770423adace2b$var$f.get(t);
    e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, $45f770423adace2b$var$f.delete(t));
}
function $45f770423adace2b$export$af489fa7e5283cc3(t, { allowed: r, disallowed: e } = {}) {
    let i = (0, $15c71767d8d4901b$export$5f5dd115998e0b80)(t, "inert-others");
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        var d, c;
        if (!i) return;
        let a = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
        for (let n of (d = e == null ? void 0 : e()) != null ? d : [])n && a.add($45f770423adace2b$var$h(n));
        let s = (c = r == null ? void 0 : r()) != null ? c : [];
        for (let n of s){
            if (!n) continue;
            let l = (0, $874591f6f1a15c7a$export$b204af158042fbac)(n);
            if (!l) continue;
            let o = n.parentElement;
            for(; o && o !== l.body;){
                for (let p of o.children)s.some((E)=>p.contains(E)) || a.add($45f770423adace2b$var$h(p));
                o = o.parentElement;
            }
        }
        return a.dispose;
    }, [
        i,
        r,
        e
    ]);
}



var $c56K2 = parcelRequire("c56K2");

function $5074034a47ac9f32$export$2706b359107dd58d() {
    var t;
    let [e] = (0, $c56K2.useState)(()=>typeof window != "undefined" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [o, c] = (0, $c56K2.useState)((t = e == null ? void 0 : e.matches) != null ? t : !1);
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (!e) return;
        function n(r) {
            c(r.matches);
        }
        return e.addEventListener("change", n), ()=>e.removeEventListener("change", n);
    }, [
        e
    ]), o;
}




var $c56K2 = parcelRequire("c56K2");

function $72273189d405b787$export$8ee0fc9ee280b4ee(e) {
    return typeof e != "object" || e === null ? !1 : "nodeType" in e;
}
function $72273189d405b787$export$45a5e7f76e0caa8d(e) {
    return $72273189d405b787$export$8ee0fc9ee280b4ee(e) && "tagName" in e;
}
function $72273189d405b787$export$1b3bfaa9684536aa(e) {
    return $72273189d405b787$export$45a5e7f76e0caa8d(e) && "accessKey" in e;
}
function $72273189d405b787$export$79c619c6018bbb44(e) {
    return $72273189d405b787$export$45a5e7f76e0caa8d(e) && "tabIndex" in e;
}
function $72273189d405b787$export$62c830b63044c679(e) {
    return $72273189d405b787$export$45a5e7f76e0caa8d(e) && "style" in e;
}
function $72273189d405b787$export$8b613183536fc004(e) {
    return $72273189d405b787$export$1b3bfaa9684536aa(e) && e.nodeName === "IFRAME";
}
function $72273189d405b787$export$88a6ceeed5737ba3(e) {
    return $72273189d405b787$export$1b3bfaa9684536aa(e) && e.nodeName === "INPUT";
}
function $72273189d405b787$export$b7395b0e7f36a30b(e) {
    return $72273189d405b787$export$1b3bfaa9684536aa(e) && e.nodeName === "TEXTAREA";
}
function $72273189d405b787$export$42dc0115f0e5e4fc(e) {
    return $72273189d405b787$export$1b3bfaa9684536aa(e) && e.nodeName === "LABEL";
}
function $72273189d405b787$export$224ee1e631187c8e(e) {
    return $72273189d405b787$export$1b3bfaa9684536aa(e) && e.nodeName === "FIELDSET";
}
function $72273189d405b787$export$b5145d164c8e27ab(e) {
    return $72273189d405b787$export$1b3bfaa9684536aa(e) && e.nodeName === "LEGEND";
}
function $72273189d405b787$export$3dee5e4542c672d9(e) {
    return $72273189d405b787$export$45a5e7f76e0caa8d(e) ? e.matches('a[href],audio[controls],button,details,embed,iframe,img[usemap],input:not([type="hidden"]),label,select,textarea,video[controls]') : !1;
}



function $271d62a22f8321aa$export$b41b9097915aa006(s, n, o) {
    let i = (0, $a51df5cf480cb374$export$86c4283a11f23f95)((t)=>{
        let e = t.getBoundingClientRect();
        e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && o();
    });
    (0, $c56K2.useEffect)(()=>{
        if (!s) return;
        let t = n === null ? null : $72273189d405b787$export$1b3bfaa9684536aa(n) ? n : n.current;
        if (!t) return;
        let e = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
        if (typeof ResizeObserver != "undefined") {
            let r = new ResizeObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        if (typeof IntersectionObserver != "undefined") {
            let r = new IntersectionObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        return ()=>e.dispose();
    }, [
        n,
        i,
        s
    ]);
}



var $c56K2 = parcelRequire("c56K2");





let $fe570d29719c408c$export$acea64b1933eb668 = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "details>summary",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(","), $fe570d29719c408c$var$S = [
    "[data-autofocus]"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $fe570d29719c408c$export$807a7eae502106e7 = ((o)=>(o[o.First = 1] = "First", o[o.Previous = 2] = "Previous", o[o.Next = 4] = "Next", o[o.Last = 8] = "Last", o[o.WrapAround = 16] = "WrapAround", o[o.NoScroll = 32] = "NoScroll", o[o.AutoFocus = 64] = "AutoFocus", o))($fe570d29719c408c$export$807a7eae502106e7 || {}), $fe570d29719c408c$export$abf286375dfa6dbd = ((n)=>(n[n.Error = 0] = "Error", n[n.Overflow = 1] = "Overflow", n[n.Success = 2] = "Success", n[n.Underflow = 3] = "Underflow", n))($fe570d29719c408c$export$abf286375dfa6dbd || {}), $fe570d29719c408c$var$O = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($fe570d29719c408c$var$O || {});
function $fe570d29719c408c$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($fe570d29719c408c$export$acea64b1933eb668)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function $fe570d29719c408c$export$89622d0e8d475962(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($fe570d29719c408c$var$S)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $fe570d29719c408c$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($fe570d29719c408c$export$27112a34f2f8402d || {});
function $fe570d29719c408c$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $874591f6f1a15c7a$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($fe570d29719c408c$export$acea64b1933eb668);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($fe570d29719c408c$export$acea64b1933eb668)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $fe570d29719c408c$export$46388676ec35ab85(e) {
    (0, $a1511df59d6e26ec$export$12b26c28a05aa001)().nextFrame(()=>{
        let r = (0, $874591f6f1a15c7a$export$cd4e5573fbe2b576)(e);
        r && $72273189d405b787$export$79c619c6018bbb44(r) && !$fe570d29719c408c$export$ff1ec1c740b3c8d5(r, 0) && $fe570d29719c408c$export$5fed9cc43865dc7e(e);
    });
}
var $fe570d29719c408c$var$g = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($fe570d29719c408c$var$g || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $fe570d29719c408c$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $fe570d29719c408c$var$_ = [
    "textarea",
    "input"
].join(",");
function $fe570d29719c408c$var$P(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $fe570d29719c408c$var$_)) != null ? t : !1;
}
function $fe570d29719c408c$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let n = r(t), a = r(l);
        if (n === null || a === null) return 0;
        let u = n.compareDocumentPosition(a);
        return u & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : u & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $fe570d29719c408c$export$7fb6c844b485e870(e, r, t = e === null ? document.body : (0, $874591f6f1a15c7a$export$9bfe85d84666e58)(e)) {
    return $fe570d29719c408c$export$82e1f4f412218a1d($fe570d29719c408c$export$433aaa1f216cf32d(t), r, {
        relativeTo: e
    });
}
function $fe570d29719c408c$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: n = [] } = {}) {
    let a = Array.isArray(e) ? e.length > 0 ? (0, $874591f6f1a15c7a$export$9bfe85d84666e58)(e[0]) : document : (0, $874591f6f1a15c7a$export$9bfe85d84666e58)(e), u = Array.isArray(e) ? t ? $fe570d29719c408c$export$20305e96f91bf103(e) : e : r & 64 ? $fe570d29719c408c$export$89622d0e8d475962(e) : $fe570d29719c408c$export$433aaa1f216cf32d(e);
    n.length > 0 && u.length > 1 && (u = u.filter((i)=>!n.some((d)=>d != null && "current" in d ? (d == null ? void 0 : d.current) === i : d === i))), l = l != null ? l : a == null ? void 0 : a.activeElement;
    let o = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), M = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, u.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, u.indexOf(l)) + 1;
        if (r & 8) return u.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), N = r & 32 ? {
        preventScroll: !0
    } : {}, m = 0, c = u.length, s;
    do {
        if (m >= c || m + c <= 0) return 0;
        let i = M + m;
        if (r & 16) i = (i + c) % c;
        else {
            if (i < 0) return 3;
            if (i >= c) return 1;
        }
        s = u[i], s == null || s.focus(N), m += o;
    }while (s !== (0, $874591f6f1a15c7a$export$cd4e5573fbe2b576)(s));
    return r & 6 && $fe570d29719c408c$var$P(s) && s.select(), 2;
}


function $35664940b37da715$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $35664940b37da715$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $35664940b37da715$export$d0a8044dce8ff2fc() {
    return $35664940b37da715$export$fedb369cb70207f1() || $35664940b37da715$export$a11b0059900ceec8();
}



var $c56K2 = parcelRequire("c56K2");

function $b9cb2bcf7c441d0d$export$55d2b5df396a097b(t, e, o, n) {
    let u = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(o);
    (0, $c56K2.useEffect)(()=>{
        if (!t) return;
        function r(m) {
            u.current(m);
        }
        return document.addEventListener(e, r, n), ()=>document.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}




var $c56K2 = parcelRequire("c56K2");

function $afc1f5612f9f0288$export$ee579bb285b8d4aa(t, e, o, n) {
    let i = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(o);
    (0, $c56K2.useEffect)(()=>{
        if (!t) return;
        function r(d) {
            i.current(d);
        }
        return window.addEventListener(e, r, n), ()=>window.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}


const $709911b5ca379297$var$C = 30;
function $709911b5ca379297$export$71b2224f1ce5e08e(o, f, h) {
    let m = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(h), s = (0, $c56K2.useCallback)(function(e, c) {
        if (e.defaultPrevented) return;
        let r = c(e);
        if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
        let M = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(f);
        for (let u of M)if (u !== null && (u.contains(r) || e.composed && e.composedPath().includes(u))) return;
        return !(0, $fe570d29719c408c$export$ff1ec1c740b3c8d5)(r, (0, $fe570d29719c408c$export$27112a34f2f8402d).Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
    }, [
        m,
        f
    ]), i = (0, $c56K2.useRef)(null);
    (0, $b9cb2bcf7c441d0d$export$55d2b5df396a097b)(o, "pointerdown", (t)=>{
        var e, c;
        (0, $35664940b37da715$export$d0a8044dce8ff2fc)() || (i.current = ((c = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : c[0]) || t.target);
    }, !0), (0, $b9cb2bcf7c441d0d$export$55d2b5df396a097b)(o, "pointerup", (t)=>{
        if ((0, $35664940b37da715$export$d0a8044dce8ff2fc)() || !i.current) return;
        let e = i.current;
        return i.current = null, s(t, ()=>e);
    }, !0);
    let l = (0, $c56K2.useRef)({
        x: 0,
        y: 0
    });
    (0, $b9cb2bcf7c441d0d$export$55d2b5df396a097b)(o, "touchstart", (t)=>{
        l.current.x = t.touches[0].clientX, l.current.y = t.touches[0].clientY;
    }, !0), (0, $b9cb2bcf7c441d0d$export$55d2b5df396a097b)(o, "touchend", (t)=>{
        let e = {
            x: t.changedTouches[0].clientX,
            y: t.changedTouches[0].clientY
        };
        if (!(Math.abs(e.x - l.current.x) >= $709911b5ca379297$var$C || Math.abs(e.y - l.current.y) >= $709911b5ca379297$var$C)) return s(t, ()=>$72273189d405b787$export$79c619c6018bbb44(t.target) ? t.target : null);
    }, !0), (0, $afc1f5612f9f0288$export$ee579bb285b8d4aa)(o, "blur", (t)=>s(t, ()=>$72273189d405b787$export$8b613183536fc004(window.document.activeElement) ? window.document.activeElement : null), !0);
}



var $c56K2 = parcelRequire("c56K2");

function $71d996aa44864848$export$dd9fbcea3de0ae36(...e) {
    return (0, $c56K2.useMemo)(()=>(0, $874591f6f1a15c7a$export$b204af158042fbac)(...e), [
        ...e
    ]);
}
function $71d996aa44864848$export$f6e818c9976ebbf2(...e) {
    return (0, $c56K2.useMemo)(()=>(0, $874591f6f1a15c7a$export$9bfe85d84666e58)(...e), [
        ...e
    ]);
}



var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");
function $399cce7eeea4f69c$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}



var $bc193d85907afa60$export$ba0ea3f20e7bf777 = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($bc193d85907afa60$export$ba0ea3f20e7bf777 || {}), $bc193d85907afa60$export$80c0a745e59f7989 = ((t)=>(t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))($bc193d85907afa60$export$80c0a745e59f7989 || {});
function $bc193d85907afa60$export$e25bb1e5b53cbdff() {
    let e = $bc193d85907afa60$var$I();
    return (0, $c56K2.useCallback)((r)=>$bc193d85907afa60$var$U({
            mergeRefs: e,
            ...r
        }), [
        e
    ]);
}
function $bc193d85907afa60$var$U({ ourProps: e, theirProps: r, slot: t, defaultTag: a, features: o, visible: n = !0, name: i, mergeRefs: l }) {
    l = l != null ? l : $bc193d85907afa60$var$H;
    let s = $bc193d85907afa60$var$P(r, e);
    if (n) return $bc193d85907afa60$var$F(s, t, a, i, l);
    let y = o != null ? o : 0;
    if (y & 2) {
        let { static: f = !1, ...u } = s;
        if (f) return $bc193d85907afa60$var$F(u, t, a, i, l);
    }
    if (y & 1) {
        let { unmount: f = !0, ...u } = s;
        return (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(f ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $bc193d85907afa60$var$F({
                    ...u,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, t, a, i, l);
            }
        });
    }
    return $bc193d85907afa60$var$F(s, t, a, i, l);
}
function $bc193d85907afa60$var$F(e, r = {}, t, a, o) {
    let { as: n = t, children: i, refName: l = "ref", ...s } = $bc193d85907afa60$var$h(e, [
        "unmount",
        "static"
    ]), y = e.ref !== void 0 ? {
        [l]: e.ref
    } : {}, f = typeof i == "function" ? i(r) : i;
    f = $bc193d85907afa60$var$E(f), "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(r)), s["aria-labelledby"] && s["aria-labelledby"] === s.id && (s["aria-labelledby"] = void 0);
    let u = {};
    if (r) {
        let d = !1, p = [];
        for (let [c, T] of Object.entries(r))typeof T == "boolean" && (d = !0), T === !0 && p.push(c.replace(/([A-Z])/g, (g)=>`-${g.toLowerCase()}`));
        if (d) {
            u["data-headlessui-state"] = p.join(" ");
            for (let c of p)u[`data-${c}`] = "";
        }
    }
    if ($bc193d85907afa60$export$9522e17588c12572(n) && (Object.keys($bc193d85907afa60$export$8e16b83750b44988(s)).length > 0 || Object.keys($bc193d85907afa60$export$8e16b83750b44988(u)).length > 0)) {
        if (!(0, $c56K2.isValidElement)(f) || Array.isArray(f) && f.length > 1 || $bc193d85907afa60$export$b4a42ffad0473d5d(f)) {
            if (Object.keys($bc193d85907afa60$export$8e16b83750b44988(s)).length > 0) throw new Error([
                'Passing props on "Fragment"!',
                "",
                `The current component <${a} /> is rendering a "Fragment".`,
                "However we need to passthrough the following props:",
                Object.keys($bc193d85907afa60$export$8e16b83750b44988(s)).concat(Object.keys($bc193d85907afa60$export$8e16b83750b44988(u))).map((d)=>`  - ${d}`).join(`
`),
                "",
                "You can apply a few solutions:",
                [
                    'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                    "Render a single element as the child so that we can forward the props onto that element."
                ].map((d)=>`  - ${d}`).join(`
`)
            ].join(`
`));
        } else {
            let d = f.props, p = d == null ? void 0 : d.className, c = typeof p == "function" ? (...R)=>(0, $399cce7eeea4f69c$export$ce4ab0c55987d1ff)(p(...R), s.className) : (0, $399cce7eeea4f69c$export$ce4ab0c55987d1ff)(p, s.className), T = c ? {
                className: c
            } : {}, g = $bc193d85907afa60$var$P(f.props, $bc193d85907afa60$export$8e16b83750b44988($bc193d85907afa60$var$h(s, [
                "ref"
            ])));
            for(let R in u)R in g && delete u[R];
            return (0, $c56K2.cloneElement)(f, Object.assign({}, g, u, y, {
                ref: o($bc193d85907afa60$var$D(f), y.ref)
            }, T));
        }
    }
    return (0, $c56K2.createElement)(n, Object.assign({}, $bc193d85907afa60$var$h(s, [
        "ref"
    ]), !$bc193d85907afa60$export$9522e17588c12572(n) && y, !$bc193d85907afa60$export$9522e17588c12572(n) && u), f);
}
function $bc193d85907afa60$var$I() {
    let e = (0, $c56K2.useRef)([]), r = (0, $c56K2.useCallback)((t)=>{
        for (let a of e.current)a != null && (typeof a == "function" ? a(t) : a.current = t);
    }, []);
    return (...t)=>{
        if (!t.every((a)=>a == null)) return e.current = t, r;
    };
}
function $bc193d85907afa60$var$H(...e) {
    return e.every((r)=>r == null) ? void 0 : (r)=>{
        for (let t of e)t != null && (typeof t == "function" ? t(r) : t.current = r);
    };
}
function $bc193d85907afa60$var$P(...e) {
    var a;
    if (e.length === 0) return {};
    if (e.length === 1) return e[0];
    let r = {}, t = {};
    for (let o of e)for(let n in o)n.startsWith("on") && typeof o[n] == "function" ? ((a = t[n]) != null || (t[n] = []), t[n].push(o[n])) : r[n] = o[n];
    if (r.disabled || r["aria-disabled"]) for(let o in t)/^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(o) && (t[o] = [
        (n)=>{
            var i;
            return (i = n == null ? void 0 : n.preventDefault) == null ? void 0 : i.call(n);
        }
    ]);
    for(let o in t)Object.assign(r, {
        [o] (n, ...i) {
            let l = t[o];
            for (let s of l){
                if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
                s(n, ...i);
            }
        }
    });
    return r;
}
function $bc193d85907afa60$export$9d1611c77c2fe928(...e) {
    var a;
    if (e.length === 0) return {};
    if (e.length === 1) return e[0];
    let r = {}, t = {};
    for (let o of e)for(let n in o)n.startsWith("on") && typeof o[n] == "function" ? ((a = t[n]) != null || (t[n] = []), t[n].push(o[n])) : r[n] = o[n];
    for(let o in t)Object.assign(r, {
        [o] (...n) {
            let i = t[o];
            for (let l of i)l == null || l(...n);
        }
    });
    return r;
}
function $bc193d85907afa60$export$e43f39796049410c(e) {
    var r;
    return Object.assign((0, $c56K2.forwardRef)(e), {
        displayName: (r = e.displayName) != null ? r : e.name
    });
}
function $bc193d85907afa60$export$8e16b83750b44988(e) {
    let r = Object.assign({}, e);
    for(let t in r)r[t] === void 0 && delete r[t];
    return r;
}
function $bc193d85907afa60$var$h(e, r = []) {
    let t = Object.assign({}, e);
    for (let a of r)a in t && delete t[a];
    return t;
}
function $bc193d85907afa60$var$D(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
function $bc193d85907afa60$var$E(e) {
    if (e != null && e.$$typeof === Symbol.for("react.lazy")) {
        let r = e._payload;
        if (r != null && r.status === "fulfilled") return $bc193d85907afa60$var$E(r.value);
    }
    return e;
}
function $bc193d85907afa60$export$9522e17588c12572(e) {
    return e === (0, $c56K2.Fragment) || e === Symbol.for("react.fragment");
}
function $bc193d85907afa60$export$b4a42ffad0473d5d(e) {
    return $bc193d85907afa60$export$9522e17588c12572(e.type);
}


let $e4c31d8a11c9202b$var$a = "span";
var $e4c31d8a11c9202b$export$4e7f8864c6a16d8a = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($e4c31d8a11c9202b$export$4e7f8864c6a16d8a || {});
function $e4c31d8a11c9202b$var$l(t, r) {
    var n;
    let { features: d = 1, ...e } = t, o = {
        ref: r,
        "aria-hidden": (d & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (d & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(d & 4) === 4 && (d & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: o,
        theirProps: e,
        slot: {},
        defaultTag: $e4c31d8a11c9202b$var$a,
        name: "Hidden"
    });
}
let $e4c31d8a11c9202b$export$8dc98ba7eadeaa56 = (0, $bc193d85907afa60$export$e43f39796049410c)($e4c31d8a11c9202b$var$l);





function $1e135805a380f57b$export$445f2d1a3d9b1b9f({ defaultContainers: l = [], portals: n, mainTreeNode: o } = {}) {
    let c = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        var r, u;
        let i = (0, $874591f6f1a15c7a$export$b204af158042fbac)(o), t = [];
        for (let e of l)e !== null && ($72273189d405b787$export$45a5e7f76e0caa8d(e) ? t.push(e) : "current" in e && $72273189d405b787$export$45a5e7f76e0caa8d(e.current) && t.push(e.current));
        if (n != null && n.current) for (let e of n.current)t.push(e);
        for (let e of (r = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? r : [])e !== document.body && e !== document.head && $72273189d405b787$export$45a5e7f76e0caa8d(e) && e.id !== "headlessui-portal-root" && (o && (e.contains(o) || e.contains((u = o == null ? void 0 : o.getRootNode()) == null ? void 0 : u.host)) || t.some((E)=>e.contains(E)) || t.push(e));
        return t;
    });
    return {
        resolveContainers: c,
        contains: (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>c().some((t)=>t.contains(i)))
    };
}
let $1e135805a380f57b$var$d = (0, $c56K2.createContext)(null);
function $1e135805a380f57b$export$61c2c570df73dc80({ children: l, node: n }) {
    let [o, c] = (0, $c56K2.useState)(null), i = $1e135805a380f57b$export$64db24433d7f4942(n != null ? n : o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($1e135805a380f57b$var$d.Provider, {
        value: i
    }, l, i === null && (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $e4c31d8a11c9202b$export$8dc98ba7eadeaa56), {
        features: (0, $e4c31d8a11c9202b$export$4e7f8864c6a16d8a).Hidden,
        ref: (t)=>{
            var r, u;
            if (t) {
                for (let e of (u = (r = (0, $874591f6f1a15c7a$export$b204af158042fbac)(t)) == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? u : [])if (e !== document.body && e !== document.head && $72273189d405b787$export$45a5e7f76e0caa8d(e) && e != null && e.contains(t)) {
                    c(e);
                    break;
                }
            }
        }
    }));
}
function $1e135805a380f57b$export$64db24433d7f4942(l = null) {
    var n;
    return (n = (0, $c56K2.useContext)($1e135805a380f57b$var$d)) != null ? n : l;
}



var $c56K2 = parcelRequire("c56K2");
function $a60fccd208c90cdc$export$6ccbb43953eebf8(t) {
    return (0, $c56K2.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}




function $c7ed7e5e86ecac84$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $ff3b2b6750116caa$export$110627fb35ef9205() {
    let r;
    return {
        before ({ doc: e }) {
            var l;
            let o = e.documentElement, t = (l = e.defaultView) != null ? l : window;
            r = Math.max(0, t.innerWidth - o.clientWidth);
        },
        after ({ doc: e, d: o }) {
            let t = e.documentElement, l = Math.max(0, t.clientWidth - t.offsetWidth), n = Math.max(0, r - l);
            o.style(t, "paddingRight", `${n}px`);
        }
    };
}





function $246329600a57f617$export$e3a523dfabf27286() {
    return (0, $35664940b37da715$export$fedb369cb70207f1)() ? {
        before ({ doc: o, d: r, meta: m }) {
            function a(s) {
                for (let l of m().containers)for (let c of l())if (c.contains(s)) return !0;
                return !1;
            }
            r.microTask(()=>{
                var c;
                if (window.getComputedStyle(o.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
                    t.style(o.documentElement, "scrollBehavior", "auto"), r.add(()=>r.microTask(()=>t.dispose()));
                }
                let s = (c = window.scrollY) != null ? c : window.pageYOffset, l = null;
                r.addEventListener(o, "click", (t)=>{
                    if ($72273189d405b787$export$79c619c6018bbb44(t.target)) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: n } = new URL(e.href), f = o.querySelector(n);
                        $72273189d405b787$export$79c619c6018bbb44(f) && !a(f) && (l = f);
                    } catch  {}
                }, !0), r.group((t)=>{
                    r.addEventListener(o, "touchstart", (e)=>{
                        if (t.dispose(), $72273189d405b787$export$79c619c6018bbb44(e.target) && $72273189d405b787$export$62c830b63044c679(e.target)) {
                            if (a(e.target)) {
                                let n = e.target;
                                for(; n.parentElement && a(n.parentElement);)n = n.parentElement;
                                t.style(n, "overscrollBehavior", "contain");
                            } else t.style(e.target, "touchAction", "none");
                        }
                    });
                }), r.addEventListener(o, "touchmove", (t)=>{
                    if ($72273189d405b787$export$79c619c6018bbb44(t.target)) {
                        if ($72273189d405b787$export$88a6ceeed5737ba3(t.target)) return;
                        if (a(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), r.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    s !== t && window.scrollTo(0, s), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}


function $54e566d1f6cee009$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $59d2d92f0139e91b$var$r(e) {
    let o = {};
    for (let t of e)Object.assign(o, t(o));
    return o;
}
let $59d2d92f0139e91b$export$a4161f418919b5aa = (0, $c7ed7e5e86ecac84$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, o) {
        var n;
        let t = (n = this.get(e)) != null ? n : {
            doc: e,
            count: 0,
            d: (0, $a1511df59d6e26ec$export$12b26c28a05aa001)(),
            meta: new Set,
            computedMeta: {}
        };
        return t.count++, t.meta.add(o), t.computedMeta = $59d2d92f0139e91b$var$r(t.meta), this.set(e, t), this;
    },
    POP (e, o) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(o), t.computedMeta = $59d2d92f0139e91b$var$r(t.meta)), this;
    },
    SCROLL_PREVENT (e) {
        let o = {
            doc: e.doc,
            d: e.d,
            meta () {
                return e.computedMeta;
            }
        }, t = [
            (0, $246329600a57f617$export$e3a523dfabf27286)(),
            (0, $ff3b2b6750116caa$export$110627fb35ef9205)(),
            (0, $54e566d1f6cee009$export$d8b6ff28805e84e9)()
        ];
        t.forEach(({ before: n })=>n == null ? void 0 : n(o)), t.forEach(({ after: n })=>n == null ? void 0 : n(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$59d2d92f0139e91b$export$a4161f418919b5aa.subscribe(()=>{
    let e = $59d2d92f0139e91b$export$a4161f418919b5aa.getSnapshot(), o = new Map;
    for (let [t] of e)o.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let n = o.get(t.doc) === "hidden", a = t.count !== 0;
        (a && !n || !a && n) && $59d2d92f0139e91b$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $59d2d92f0139e91b$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $8b1e1f8c1ac5ca02$export$bb0ae4a42bcd9e0(r, e, n = ()=>({
        containers: []
    })) {
    let f = (0, $a60fccd208c90cdc$export$6ccbb43953eebf8)((0, $59d2d92f0139e91b$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $59d2d92f0139e91b$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $59d2d92f0139e91b$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}



function $ad60b3b67ac8c8ab$export$e47ba1b900da5d3b(e, c, n = ()=>[
        document.body
    ]) {
    let r = (0, $15c71767d8d4901b$export$5f5dd115998e0b80)(e, "scroll-lock");
    (0, $8b1e1f8c1ac5ca02$export$bb0ae4a42bcd9e0)(r, c, (t)=>{
        var o;
        return {
            containers: [
                ...(o = t.containers) != null ? o : [],
                n
            ]
        };
    });
}



var $c56K2 = parcelRequire("c56K2");

function $777f929a9f85f16b$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $c56K2 ? ((o)=>o.useSyncExternalStore)($c56K2)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $777f929a9f85f16b$export$44ab2b9f2d09b0fa() {
    let r = $777f929a9f85f16b$var$s(), [e, n] = $c56K2.useState((0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $c56K2.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $c56K2.useEffect(()=>(0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}



var $c56K2 = parcelRequire("c56K2");
function $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8(e) {
    return (0, $c56K2.useMemo)(()=>e, Object.values(e));
}



var $c56K2 = parcelRequire("c56K2");

let $a67d248eafae96c4$var$u = Symbol();
function $a67d248eafae96c4$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$a67d248eafae96c4$var$u]: n
    });
}
function $a67d248eafae96c4$export$f6a25a78204acc7e(...t) {
    let n = (0, $c56K2.useRef)(t);
    (0, $c56K2.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$a67d248eafae96c4$var$u])) ? void 0 : c;
}



var $c56K2 = parcelRequire("c56K2");
"use client";
let $b7b29e70ac6b2beb$var$e = (0, $c56K2.createContext)(()=>{});
function $b7b29e70ac6b2beb$export$4e99330e6f37bca2() {
    return (0, $c56K2.useContext)($b7b29e70ac6b2beb$var$e);
}
function $b7b29e70ac6b2beb$export$dd2a80b78bebbe1d({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($b7b29e70ac6b2beb$var$e.Provider, {
        value: t
    }, o);
}



var $c56K2 = parcelRequire("c56K2");
let $081f425c3e48d631$var$n = (0, $c56K2.createContext)(null);
$081f425c3e48d631$var$n.displayName = "OpenClosedContext";
var $081f425c3e48d631$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($081f425c3e48d631$export$7254cc27399e90bd || {});
function $081f425c3e48d631$export$fc6fdf0ecf360e() {
    return (0, $c56K2.useContext)($081f425c3e48d631$var$n);
}
function $081f425c3e48d631$export$2a0ed818b175f558({ value: o, children: t }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($081f425c3e48d631$var$n.Provider, {
        value: o
    }, t);
}
function $081f425c3e48d631$export$6748feed729c7cf3({ children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($081f425c3e48d631$var$n.Provider, {
        value: null
    }, o);
}



var $c56K2 = parcelRequire("c56K2");
let $2bfd3103c6429fe4$var$e = (0, $c56K2.createContext)(!1);
function $2bfd3103c6429fe4$export$6ecd3efa4eebe261() {
    return (0, $c56K2.useContext)($2bfd3103c6429fe4$var$e);
}
function $2bfd3103c6429fe4$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($2bfd3103c6429fe4$var$e.Provider, {
        value: o.force
    }, o.children);
}







var $c56K2 = parcelRequire("c56K2");


var $c56K2 = parcelRequire("c56K2");




var $c56K2 = parcelRequire("c56K2");
let $4f0e83537aaf78fb$var$e = (0, $c56K2.createContext)(void 0);
function $4f0e83537aaf78fb$export$c763bb7a184a0f11() {
    return (0, $c56K2.useContext)($4f0e83537aaf78fb$var$e);
}
function $4f0e83537aaf78fb$export$a4d3bd77f4efe5ad({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($4f0e83537aaf78fb$var$e.Provider, {
        value: t
    }, o);
}



"use client";
let $39fd9e43e376396c$var$a = (0, $c56K2.createContext)(null);
$39fd9e43e376396c$var$a.displayName = "DescriptionContext";
function $39fd9e43e376396c$var$f() {
    let r = (0, $c56K2.useContext)($39fd9e43e376396c$var$a);
    if (r === null) {
        let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(e, $39fd9e43e376396c$var$f), e;
    }
    return r;
}
function $39fd9e43e376396c$export$899851af1363628() {
    var r, e;
    return (e = (r = (0, $c56K2.useContext)($39fd9e43e376396c$var$a)) == null ? void 0 : r.value) != null ? e : void 0;
}
function $39fd9e43e376396c$export$babde88292020af7() {
    let [r, e] = (0, $c56K2.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $c56K2.useMemo)(()=>function(t) {
                let i = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((n)=>(e((o)=>[
                            ...o,
                            n
                        ]), ()=>e((o)=>{
                            let s = o.slice(), p = s.indexOf(n);
                            return p !== -1 && s.splice(p, 1), s;
                        }))), l = (0, $c56K2.useMemo)(()=>({
                        register: i,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    i,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($39fd9e43e376396c$var$a.Provider, {
                    value: l
                }, t.children);
            }, [
            e
        ])
    ];
}
let $39fd9e43e376396c$var$I = "p";
function $39fd9e43e376396c$var$C(r, e) {
    let c = (0, $c56K2.useId)(), t = (0, $4f0e83537aaf78fb$export$c763bb7a184a0f11)(), { id: i = `headlessui-description-${c}`, ...l } = r, n = $39fd9e43e376396c$var$f(), o = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(e);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>n.register(i), [
        i,
        n.register
    ]);
    let s = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        ...n.slot,
        disabled: t || !1
    }), p = {
        ref: o,
        ...n.props,
        id: i
    };
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: p,
        theirProps: l,
        slot: s,
        defaultTag: $39fd9e43e376396c$var$I,
        name: n.name || "Description"
    });
}
let $39fd9e43e376396c$var$_ = (0, $bc193d85907afa60$export$e43f39796049410c)($39fd9e43e376396c$var$C), $39fd9e43e376396c$export$393edc798c47379d = Object.assign($39fd9e43e376396c$var$_, {});



var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");

function $3517a9b6093b86b1$export$fd183955ff4b45d9() {
    let [e] = (0, $c56K2.useState)((0, $a1511df59d6e26ec$export$12b26c28a05aa001));
    return (0, $c56K2.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}





var $c56K2 = parcelRequire("c56K2");

function $3b411db186b904b8$export$80c2a3957bcb42ea() {
    let e = (0, $c56K2.useRef)(!1);
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}




var $c56K2 = parcelRequire("c56K2");


function $c25897243d7c7050$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(t), e = (0, $c56K2.useRef)(!1);
    (0, $c56K2.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $5f6a10e3018e6fa4$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}






var $c56K2 = parcelRequire("c56K2");

var $6b1e83feacbb9024$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($6b1e83feacbb9024$export$cacd6541cfeeb6c1 || {});
function $6b1e83feacbb9024$export$19b797546aece48f() {
    let e = (0, $c56K2.useRef)(0);
    return (0, $afc1f5612f9f0288$export$ee579bb285b8d4aa)(!0, "keydown", (r)=>{
        r.key === "Tab" && (e.current = r.shiftKey ? 1 : 0);
    }, !0), e;
}



var $c56K2 = parcelRequire("c56K2");

function $06900f3a45aaee37$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $c56K2.useRef)([]), r = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(u);
    (0, $c56K2.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [a, l] of t.entries())if (e.current[a] !== l) {
            let n = r(t, o);
            return e.current = t, n;
        }
    }, [
        r,
        ...t
    ]);
}



function $c73edd86cd8d679b$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}




let $28b122e1ea9b786e$export$55abd4691b317664 = [];
(0, $c73edd86cd8d679b$export$a6a2315df743a26b)(()=>{
    function e(t) {
        if (!$72273189d405b787$export$79c619c6018bbb44(t.target) || t.target === document.body || $28b122e1ea9b786e$export$55abd4691b317664[0] === t.target) return;
        let r = t.target;
        r = r.closest((0, $fe570d29719c408c$export$acea64b1933eb668)), $28b122e1ea9b786e$export$55abd4691b317664.unshift(r != null ? r : t.target), $28b122e1ea9b786e$export$55abd4691b317664 = $28b122e1ea9b786e$export$55abd4691b317664.filter((o)=>o != null && o.isConnected), $28b122e1ea9b786e$export$55abd4691b317664.splice(10);
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});








"use client";
function $b1771255947d08cf$var$x(o) {
    if (!o) return new Set;
    if (typeof o == "function") return new Set(o());
    let t = new Set;
    for (let e of o.current)$72273189d405b787$export$45a5e7f76e0caa8d(e.current) && t.add(e.current);
    return t;
}
let $b1771255947d08cf$var$$ = "div";
var $b1771255947d08cf$export$a5e9a012c73650bd = ((n)=>(n[n.None = 0] = "None", n[n.InitialFocus = 1] = "InitialFocus", n[n.TabLock = 2] = "TabLock", n[n.FocusLock = 4] = "FocusLock", n[n.RestoreFocus = 8] = "RestoreFocus", n[n.AutoFocus = 16] = "AutoFocus", n))($b1771255947d08cf$export$a5e9a012c73650bd || {});
function $b1771255947d08cf$var$w(o, t) {
    let e = (0, $c56K2.useRef)(null), r = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(e, t), { initialFocus: u, initialFocusFallback: a, containers: n, features: s = 15, ...f } = o;
    (0, $777f929a9f85f16b$export$44ab2b9f2d09b0fa)() || (s = 0);
    let l = (0, $71d996aa44864848$export$dd9fbcea3de0ae36)(e.current);
    $b1771255947d08cf$var$re(s, {
        ownerDocument: l
    });
    let T = $b1771255947d08cf$var$ne(s, {
        ownerDocument: l,
        container: e,
        initialFocus: u,
        initialFocusFallback: a
    });
    $b1771255947d08cf$var$oe(s, {
        ownerDocument: l,
        container: e,
        containers: n,
        previousActiveElement: T
    });
    let g = (0, $6b1e83feacbb9024$export$19b797546aece48f)(), A = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((c)=>{
        if (!$72273189d405b787$export$1b3bfaa9684536aa(e.current)) return;
        let E = e.current;
        ((V)=>V())(()=>{
            (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(g.current, {
                [(0, $6b1e83feacbb9024$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).First, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                },
                [(0, $6b1e83feacbb9024$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).Last, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                }
            });
        });
    }), v = (0, $15c71767d8d4901b$export$5f5dd115998e0b80)(!!(s & 2), "focus-trap#tab-lock"), N = (0, $3517a9b6093b86b1$export$fd183955ff4b45d9)(), b = (0, $c56K2.useRef)(!1), k = {
        ref: r,
        onKeyDown (c) {
            c.key == "Tab" && (b.current = !0, N.requestAnimationFrame(()=>{
                b.current = !1;
            }));
        },
        onBlur (c) {
            if (!(s & 4)) return;
            let E = $b1771255947d08cf$var$x(n);
            $72273189d405b787$export$1b3bfaa9684536aa(e.current) && E.add(e.current);
            let L = c.relatedTarget;
            $72273189d405b787$export$79c619c6018bbb44(L) && L.dataset.headlessuiFocusGuard !== "true" && ($b1771255947d08cf$var$I(E, L) || (b.current ? (0, $fe570d29719c408c$export$82e1f4f412218a1d)(e.current, (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(g.current, {
                [(0, $6b1e83feacbb9024$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $fe570d29719c408c$export$807a7eae502106e7).Next,
                [(0, $6b1e83feacbb9024$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $fe570d29719c408c$export$807a7eae502106e7).Previous
            }) | (0, $fe570d29719c408c$export$807a7eae502106e7).WrapAround, {
                relativeTo: c.target
            }) : $72273189d405b787$export$79c619c6018bbb44(c.target) && (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(c.target)));
        }
    }, B = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).Fragment, null, v && (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $e4c31d8a11c9202b$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: A,
        features: (0, $e4c31d8a11c9202b$export$4e7f8864c6a16d8a).Focusable
    }), B({
        ourProps: k,
        theirProps: f,
        defaultTag: $b1771255947d08cf$var$$,
        name: "FocusTrap"
    }), v && (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $e4c31d8a11c9202b$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: A,
        features: (0, $e4c31d8a11c9202b$export$4e7f8864c6a16d8a).Focusable
    }));
}
let $b1771255947d08cf$var$ee = (0, $bc193d85907afa60$export$e43f39796049410c)($b1771255947d08cf$var$w), $b1771255947d08cf$export$34eba2437817a67b = Object.assign($b1771255947d08cf$var$ee, {
    features: $b1771255947d08cf$export$a5e9a012c73650bd
});
function $b1771255947d08cf$var$te(o = !0) {
    let t = (0, $c56K2.useRef)((0, $28b122e1ea9b786e$export$55abd4691b317664).slice());
    return (0, $06900f3a45aaee37$export$3c773aa2b84f29e0)(([e], [r])=>{
        r === !0 && e === !1 && (0, $5f6a10e3018e6fa4$export$a5ff0d6a738703ca)(()=>{
            t.current.splice(0);
        }), r === !1 && e === !0 && (t.current = (0, $28b122e1ea9b786e$export$55abd4691b317664).slice());
    }, [
        o,
        (0, $28b122e1ea9b786e$export$55abd4691b317664),
        t
    ]), (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        var e;
        return (e = t.current.find((r)=>r != null && r.isConnected)) != null ? e : null;
    });
}
function $b1771255947d08cf$var$re(o, { ownerDocument: t }) {
    let e = !!(o & 8), r = $b1771255947d08cf$var$te(e);
    (0, $06900f3a45aaee37$export$3c773aa2b84f29e0)(()=>{
        e || (0, $874591f6f1a15c7a$export$8a2eb51c14bb8899)(t == null ? void 0 : t.body) && (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(r());
    }, [
        e
    ]), (0, $c25897243d7c7050$export$cd059ee7fd0e9f3d)(()=>{
        e && (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(r());
    });
}
function $b1771255947d08cf$var$ne(o, { ownerDocument: t, container: e, initialFocus: r, initialFocusFallback: u }) {
    let a = (0, $c56K2.useRef)(null), n = (0, $15c71767d8d4901b$export$5f5dd115998e0b80)(!!(o & 1), "focus-trap#initial-focus"), s = (0, $3b411db186b904b8$export$80c2a3957bcb42ea)();
    return (0, $06900f3a45aaee37$export$3c773aa2b84f29e0)(()=>{
        if (o === 0) return;
        if (!n) {
            u != null && u.current && (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(u.current);
            return;
        }
        let f = e.current;
        f && (0, $5f6a10e3018e6fa4$export$a5ff0d6a738703ca)(()=>{
            if (!s.current) return;
            let l = t == null ? void 0 : t.activeElement;
            if (r != null && r.current) {
                if ((r == null ? void 0 : r.current) === l) {
                    a.current = l;
                    return;
                }
            } else if (f.contains(l)) {
                a.current = l;
                return;
            }
            if (r != null && r.current) (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(r.current);
            else {
                if (o & 16) {
                    if ((0, $fe570d29719c408c$export$82e1f4f412218a1d)(f, (0, $fe570d29719c408c$export$807a7eae502106e7).First | (0, $fe570d29719c408c$export$807a7eae502106e7).AutoFocus) !== (0, $fe570d29719c408c$export$abf286375dfa6dbd).Error) return;
                } else if ((0, $fe570d29719c408c$export$82e1f4f412218a1d)(f, (0, $fe570d29719c408c$export$807a7eae502106e7).First) !== (0, $fe570d29719c408c$export$abf286375dfa6dbd).Error) return;
                if (u != null && u.current && ((0, $fe570d29719c408c$export$5fed9cc43865dc7e)(u.current), (t == null ? void 0 : t.activeElement) === u.current)) return;
                console.warn("There are no focusable elements inside the <FocusTrap />");
            }
            a.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        u,
        n,
        o
    ]), a;
}
function $b1771255947d08cf$var$oe(o, { ownerDocument: t, container: e, containers: r, previousActiveElement: u }) {
    let a = (0, $3b411db186b904b8$export$80c2a3957bcb42ea)(), n = !!(o & 4);
    (0, $cb31d3146223040a$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "focus", (s)=>{
        if (!n || !a.current) return;
        let f = $b1771255947d08cf$var$x(r);
        $72273189d405b787$export$1b3bfaa9684536aa(e.current) && f.add(e.current);
        let l = u.current;
        if (!l) return;
        let T = s.target;
        $72273189d405b787$export$1b3bfaa9684536aa(T) ? $b1771255947d08cf$var$I(f, T) ? (u.current = T, (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(T)) : (s.preventDefault(), s.stopPropagation(), (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(l)) : (0, $fe570d29719c408c$export$5fed9cc43865dc7e)(u.current);
    }, !0);
}
function $b1771255947d08cf$var$I(o, t) {
    for (let e of o)if (e.contains(t)) return !0;
    return !1;
}



var $c56K2 = parcelRequire("c56K2");

var $dg2Np = parcelRequire("dg2Np");









"use client";
function $b0504cce4db6877e$var$j(e) {
    let o = (0, $2bfd3103c6429fe4$export$6ecd3efa4eebe261)(), l = (0, $c56K2.useContext)($b0504cce4db6877e$var$c), [r, p] = (0, $c56K2.useState)(()=>{
        var s;
        if (!o && l !== null) return (s = l.current) != null ? s : null;
        if ((0, $df79d31ec2535066$export$a7b6bc01c63cdfc3).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let n = e.createElement("div");
        return n.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(n);
    });
    return (0, $c56K2.useEffect)(()=>{
        r !== null && (e != null && e.body.contains(r) || e == null || e.body.appendChild(r));
    }, [
        r,
        e
    ]), (0, $c56K2.useEffect)(()=>{
        o || l !== null && p(l.current);
    }, [
        l,
        p,
        o
    ]), r;
}
let $b0504cce4db6877e$var$_ = (0, $c56K2.Fragment), $b0504cce4db6877e$var$I = (0, $bc193d85907afa60$export$e43f39796049410c)(function(o, l) {
    let { ownerDocument: r = null, ...p } = o, t = (0, $c56K2.useRef)(null), n = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)((0, $a67d248eafae96c4$export$7029785b750eb74)((a)=>{
        t.current = a;
    }), l), s = (0, $71d996aa44864848$export$dd9fbcea3de0ae36)(t.current), C = r != null ? r : s, u = $b0504cce4db6877e$var$j(C), y = (0, $c56K2.useContext)($b0504cce4db6877e$var$m), g = (0, $3517a9b6093b86b1$export$fd183955ff4b45d9)(), v = (0, $777f929a9f85f16b$export$44ab2b9f2d09b0fa)(), M = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, $c25897243d7c7050$export$cd059ee7fd0e9f3d)(()=>{
        var a;
        u && u.childNodes.length <= 0 && ((a = u.parentElement) == null || a.removeChild(u));
    }), !u || !v ? null : (0, $dg2Np.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement("div", {
        "data-headlessui-portal": "",
        ref: (a)=>{
            g.dispose(), y && a && g.add(y.register(a));
        }
    }, M({
        ourProps: {
            ref: n
        },
        theirProps: p,
        slot: {},
        defaultTag: $b0504cce4db6877e$var$_,
        name: "Portal"
    })), u);
});
function $b0504cce4db6877e$var$D(e, o) {
    let l = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(o), { enabled: r = !0, ownerDocument: p, ...t } = e, n = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return r ? (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($b0504cce4db6877e$var$I, {
        ...t,
        ownerDocument: p,
        ref: l
    }) : n({
        ourProps: {
            ref: l
        },
        theirProps: t,
        slot: {},
        defaultTag: $b0504cce4db6877e$var$_,
        name: "Portal"
    });
}
let $b0504cce4db6877e$var$J = (0, $c56K2.Fragment), $b0504cce4db6877e$var$c = (0, $c56K2.createContext)(null);
function $b0504cce4db6877e$var$X(e, o) {
    let { target: l, ...r } = e, t = {
        ref: (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(o)
    }, n = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($b0504cce4db6877e$var$c.Provider, {
        value: l
    }, n({
        ourProps: t,
        theirProps: r,
        defaultTag: $b0504cce4db6877e$var$J,
        name: "Popover.Group"
    }));
}
let $b0504cce4db6877e$var$m = (0, $c56K2.createContext)(null);
function $b0504cce4db6877e$export$26b8c35244a70b37() {
    let e = (0, $c56K2.useContext)($b0504cce4db6877e$var$m), o = (0, $c56K2.useRef)([]), l = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>(o.current.push(t), e && e.register(t), ()=>r(t))), r = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>{
        let n = o.current.indexOf(t);
        n !== -1 && o.current.splice(n, 1), e && e.unregister(t);
    }), p = (0, $c56K2.useMemo)(()=>({
            register: l,
            unregister: r,
            portals: o
        }), [
        l,
        r,
        o
    ]);
    return [
        o,
        (0, $c56K2.useMemo)(()=>function({ children: n }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($b0504cce4db6877e$var$m.Provider, {
                    value: p
                }, n);
            }, [
            p
        ])
    ];
}
let $b0504cce4db6877e$var$k = (0, $bc193d85907afa60$export$e43f39796049410c)($b0504cce4db6877e$var$D), $b0504cce4db6877e$export$84c667e5e4409848 = (0, $bc193d85907afa60$export$e43f39796049410c)($b0504cce4db6877e$var$X), $b0504cce4db6877e$export$602eac185826482c = Object.assign($b0504cce4db6877e$var$k, {
    Group: $b0504cce4db6877e$export$84c667e5e4409848
});



var $c56K2 = parcelRequire("c56K2");








var $c56K2 = parcelRequire("c56K2");



var $c56K2 = parcelRequire("c56K2");
function $ed3bf13e1a23da89$export$2879604e6aec4ab(u = 0) {
    let [r, a] = (0, $c56K2.useState)(u), g = (0, $c56K2.useCallback)((e)=>a(e), []), s = (0, $c56K2.useCallback)((e)=>a((l)=>l | e), []), m = (0, $c56K2.useCallback)((e)=>(r & e) === e, [
        r
    ]), n = (0, $c56K2.useCallback)((e)=>a((l)=>l & ~e), []), F = (0, $c56K2.useCallback)((e)=>a((l)=>l ^ e), []);
    return {
        flags: r,
        setFlag: g,
        addFlag: s,
        hasFlag: m,
        removeFlag: n,
        toggleFlag: F
    };
}



var $2f3cfd664d133d0e$var$T, $2f3cfd664d133d0e$var$S;
var $2f3cfd664d133d0e$var$A = ((i)=>(i[i.None = 0] = "None", i[i.Closed = 1] = "Closed", i[i.Enter = 2] = "Enter", i[i.Leave = 4] = "Leave", i))($2f3cfd664d133d0e$var$A || {});
function $2f3cfd664d133d0e$export$c291d481c40a2fc3(e) {
    let r = {};
    for(let t in e)e[t] === !0 && (r[`data-${t}`] = "");
    return r;
}
function $2f3cfd664d133d0e$export$7b286972b8d8ccbf(e, r, t, n) {
    let [i, a] = (0, $c56K2.useState)(t), { hasFlag: s, addFlag: o, removeFlag: l } = (0, $ed3bf13e1a23da89$export$2879604e6aec4ab)(e && i ? 3 : 0), u = (0, $c56K2.useRef)(!1), f = (0, $c56K2.useRef)(!1), E = (0, $3517a9b6093b86b1$export$fd183955ff4b45d9)();
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        var d;
        if (e) {
            if (t && a(!0), !r) {
                t && o(3);
                return;
            }
            return (d = n == null ? void 0 : n.start) == null || d.call(n, t), $2f3cfd664d133d0e$var$C(r, {
                inFlight: u,
                prepare () {
                    f.current ? f.current = !1 : f.current = u.current, u.current = !0, !f.current && (t ? (o(3), l(4)) : (o(4), l(2)));
                },
                run () {
                    f.current ? t ? (l(3), o(4)) : (l(4), o(3)) : t ? l(1) : o(1);
                },
                done () {
                    var p;
                    f.current && $2f3cfd664d133d0e$var$D(r) || (u.current = !1, l(7), t || a(!1), (p = n == null ? void 0 : n.end) == null || p.call(n, t));
                }
            });
        }
    }, [
        e,
        t,
        r,
        E
    ]), e ? [
        i,
        {
            closed: s(1),
            enter: s(2),
            leave: s(4),
            transition: s(2) || s(4)
        }
    ] : [
        t,
        {
            closed: void 0,
            enter: void 0,
            leave: void 0,
            transition: void 0
        }
    ];
}
function $2f3cfd664d133d0e$var$C(e, { prepare: r, run: t, done: n, inFlight: i }) {
    let a = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
    return $2f3cfd664d133d0e$var$j(e, {
        prepare: r,
        inFlight: i
    }), a.nextFrame(()=>{
        t(), a.requestAnimationFrame(()=>{
            a.add($2f3cfd664d133d0e$var$M(e, n));
        });
    }), a.dispose;
}
function $2f3cfd664d133d0e$var$M(e, r) {
    var a, s;
    let t = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
    if (!e) return t.dispose;
    let n = !1;
    t.add(()=>{
        n = !0;
    });
    let i = (s = (a = e.getAnimations) == null ? void 0 : a.call(e).filter((o)=>o instanceof CSSTransition)) != null ? s : [];
    return i.length === 0 ? (r(), t.dispose) : (Promise.allSettled(i.map((o)=>o.finished)).then(()=>{
        n || r();
    }), t.dispose);
}
function $2f3cfd664d133d0e$var$j(e, { inFlight: r, prepare: t }) {
    if (r != null && r.current) {
        t();
        return;
    }
    let n = e.style.transition;
    e.style.transition = "none", t(), e.offsetHeight, e.style.transition = n;
}
function $2f3cfd664d133d0e$var$D(e) {
    var t, n;
    return ((n = (t = e.getAnimations) == null ? void 0 : t.call(e)) != null ? n : []).some((i)=>i instanceof CSSTransition && i.playState !== "finished");
}






"use client";
function $a7ee497b70cfad78$var$ue(e) {
    var t;
    return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || !(0, $bc193d85907afa60$export$9522e17588c12572)((t = e.as) != null ? t : $a7ee497b70cfad78$var$de) || (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).Children.count(e.children) === 1;
}
let $a7ee497b70cfad78$var$V = (0, $c56K2.createContext)(null);
$a7ee497b70cfad78$var$V.displayName = "TransitionContext";
var $a7ee497b70cfad78$var$De = ((n)=>(n.Visible = "visible", n.Hidden = "hidden", n))($a7ee497b70cfad78$var$De || {});
function $a7ee497b70cfad78$var$He() {
    let e = (0, $c56K2.useContext)($a7ee497b70cfad78$var$V);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function $a7ee497b70cfad78$var$Ae() {
    let e = (0, $c56K2.useContext)($a7ee497b70cfad78$var$w);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
let $a7ee497b70cfad78$var$w = (0, $c56K2.createContext)(null);
$a7ee497b70cfad78$var$w.displayName = "NestingContext";
function $a7ee497b70cfad78$var$M(e) {
    return "children" in e ? $a7ee497b70cfad78$var$M(e.children) : e.current.filter(({ el: t })=>t.current !== null).filter(({ state: t })=>t === "visible").length > 0;
}
function $a7ee497b70cfad78$var$Te(e, t) {
    let n = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(e), l = (0, $c56K2.useRef)([]), S = (0, $3b411db186b904b8$export$80c2a3957bcb42ea)(), R = (0, $3517a9b6093b86b1$export$fd183955ff4b45d9)(), d = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((o, i = (0, $bc193d85907afa60$export$80c0a745e59f7989).Hidden)=>{
        let a = l.current.findIndex(({ el: s })=>s === o);
        a !== -1 && ((0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(i, {
            [(0, $bc193d85907afa60$export$80c0a745e59f7989).Unmount] () {
                l.current.splice(a, 1);
            },
            [(0, $bc193d85907afa60$export$80c0a745e59f7989).Hidden] () {
                l.current[a].state = "hidden";
            }
        }), R.microTask(()=>{
            var s;
            !$a7ee497b70cfad78$var$M(l) && S.current && ((s = n.current) == null || s.call(n));
        }));
    }), y = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((o)=>{
        let i = l.current.find(({ el: a })=>a === o);
        return i ? i.state !== "visible" && (i.state = "visible") : l.current.push({
            el: o,
            state: "visible"
        }), ()=>d(o, (0, $bc193d85907afa60$export$80c0a745e59f7989).Unmount);
    }), C = (0, $c56K2.useRef)([]), p = (0, $c56K2.useRef)(Promise.resolve()), h = (0, $c56K2.useRef)({
        enter: [],
        leave: []
    }), g = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((o, i, a)=>{
        C.current.splice(0), t && (t.chains.current[i] = t.chains.current[i].filter(([s])=>s !== o)), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                C.current.push(s);
            })
        ]), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                Promise.all(h.current[i].map(([r, f])=>f)).then(()=>s());
            })
        ]), i === "enter" ? p.current = p.current.then(()=>t == null ? void 0 : t.wait.current).then(()=>a(i)) : a(i);
    }), v = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((o, i, a)=>{
        Promise.all(h.current[i].splice(0).map(([s, r])=>r)).then(()=>{
            var s;
            (s = C.current.shift()) == null || s();
        }).then(()=>a(i));
    });
    return (0, $c56K2.useMemo)(()=>({
            children: l,
            register: y,
            unregister: d,
            onStart: g,
            onStop: v,
            wait: p,
            chains: h
        }), [
        y,
        d,
        l,
        g,
        v,
        h,
        p
    ]);
}
let $a7ee497b70cfad78$var$de = (0, $c56K2.Fragment), $a7ee497b70cfad78$var$fe = (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).RenderStrategy;
function $a7ee497b70cfad78$var$Fe(e, t) {
    var ee, te;
    let { transition: n = !0, beforeEnter: l, afterEnter: S, beforeLeave: R, afterLeave: d, enter: y, enterFrom: C, enterTo: p, entered: h, leave: g, leaveFrom: v, leaveTo: o, ...i } = e, [a, s] = (0, $c56K2.useState)(null), r = (0, $c56K2.useRef)(null), f = $a7ee497b70cfad78$var$ue(e), U = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(...f ? [
        r,
        t,
        s
    ] : t === null ? [] : [
        t
    ]), H = (ee = i.unmount) == null || ee ? (0, $bc193d85907afa60$export$80c0a745e59f7989).Unmount : (0, $bc193d85907afa60$export$80c0a745e59f7989).Hidden, { show: u, appear: z, initial: K } = $a7ee497b70cfad78$var$He(), [m, j] = (0, $c56K2.useState)(u ? "visible" : "hidden"), Q = $a7ee497b70cfad78$var$Ae(), { register: A, unregister: F } = Q;
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>A(r), [
        A,
        r
    ]), (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (H === (0, $bc193d85907afa60$export$80c0a745e59f7989).Hidden && r.current) {
            if (u && m !== "visible") {
                j("visible");
                return;
            }
            return (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(m, {
                ["hidden"]: ()=>F(r),
                ["visible"]: ()=>A(r)
            });
        }
    }, [
        m,
        r,
        A,
        F,
        u,
        H
    ]);
    let G = (0, $777f929a9f85f16b$export$44ab2b9f2d09b0fa)();
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (f && G && m === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        r,
        m,
        G,
        f
    ]);
    let ce = K && !z, Y = z && u && K, B = (0, $c56K2.useRef)(!1), I = $a7ee497b70cfad78$var$Te(()=>{
        B.current || (j("hidden"), F(r));
    }, Q), Z = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((W)=>{
        B.current = !0;
        let L = W ? "enter" : "leave";
        I.onStart(r, L, (_)=>{
            _ === "enter" ? l == null || l() : _ === "leave" && (R == null || R());
        });
    }), $ = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((W)=>{
        let L = W ? "enter" : "leave";
        B.current = !1, I.onStop(r, L, (_)=>{
            _ === "enter" ? S == null || S() : _ === "leave" && (d == null || d());
        }), L === "leave" && !$a7ee497b70cfad78$var$M(I) && (j("hidden"), F(r));
    });
    (0, $c56K2.useEffect)(()=>{
        f && n || (Z(u), $(u));
    }, [
        u,
        f,
        n
    ]);
    let pe = (()=>!(!n || !f || !G || ce))(), [, T] = (0, $2f3cfd664d133d0e$export$7b286972b8d8ccbf)(pe, a, u, {
        start: Z,
        end: $
    }), Ce = (0, $bc193d85907afa60$export$8e16b83750b44988)({
        ref: U,
        className: ((te = (0, $399cce7eeea4f69c$export$ce4ab0c55987d1ff)(i.className, Y && y, Y && C, T.enter && y, T.enter && T.closed && C, T.enter && !T.closed && p, T.leave && g, T.leave && !T.closed && v, T.leave && T.closed && o, !T.transition && u && h)) == null ? void 0 : te.trim()) || void 0,
        ...(0, $2f3cfd664d133d0e$export$c291d481c40a2fc3)(T)
    }), N = 0;
    m === "visible" && (N |= (0, $081f425c3e48d631$export$7254cc27399e90bd).Open), m === "hidden" && (N |= (0, $081f425c3e48d631$export$7254cc27399e90bd).Closed), u && m === "hidden" && (N |= (0, $081f425c3e48d631$export$7254cc27399e90bd).Opening), !u && m === "visible" && (N |= (0, $081f425c3e48d631$export$7254cc27399e90bd).Closing);
    let he = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($a7ee497b70cfad78$var$w.Provider, {
        value: I
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $081f425c3e48d631$export$2a0ed818b175f558), {
        value: N
    }, he({
        ourProps: Ce,
        theirProps: i,
        defaultTag: $a7ee497b70cfad78$var$de,
        features: $a7ee497b70cfad78$var$fe,
        visible: m === "visible",
        name: "Transition.Child"
    })));
}
function $a7ee497b70cfad78$var$Ie(e, t) {
    let { show: n, appear: l = !1, unmount: S = !0, ...R } = e, d = (0, $c56K2.useRef)(null), y = $a7ee497b70cfad78$var$ue(e), C = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(...y ? [
        d,
        t
    ] : t === null ? [] : [
        t
    ]);
    (0, $777f929a9f85f16b$export$44ab2b9f2d09b0fa)();
    let p = (0, $081f425c3e48d631$export$fc6fdf0ecf360e)();
    if (n === void 0 && p !== null && (n = (p & (0, $081f425c3e48d631$export$7254cc27399e90bd).Open) === (0, $081f425c3e48d631$export$7254cc27399e90bd).Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [h, g] = (0, $c56K2.useState)(n ? "visible" : "hidden"), v = $a7ee497b70cfad78$var$Te(()=>{
        n || g("hidden");
    }), [o, i] = (0, $c56K2.useState)(!0), a = (0, $c56K2.useRef)([
        n
    ]);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        o !== !1 && a.current[a.current.length - 1] !== n && (a.current.push(n), i(!1));
    }, [
        a,
        n
    ]);
    let s = (0, $c56K2.useMemo)(()=>({
            show: n,
            appear: l,
            initial: o
        }), [
        n,
        l,
        o
    ]);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        n ? g("visible") : !$a7ee497b70cfad78$var$M(v) && d.current !== null && g("hidden");
    }, [
        n,
        v
    ]);
    let r = {
        unmount: S
    }, f = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        var u;
        o && i(!1), (u = e.beforeEnter) == null || u.call(e);
    }), U = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        var u;
        o && i(!1), (u = e.beforeLeave) == null || u.call(e);
    }), H = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($a7ee497b70cfad78$var$w.Provider, {
        value: v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($a7ee497b70cfad78$var$V.Provider, {
        value: s
    }, H({
        ourProps: {
            ...r,
            as: (0, $c56K2.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($a7ee497b70cfad78$var$me, {
                ref: C,
                ...r,
                ...R,
                beforeEnter: f,
                beforeLeave: U
            })
        },
        theirProps: {},
        defaultTag: (0, $c56K2.Fragment),
        features: $a7ee497b70cfad78$var$fe,
        visible: h === "visible",
        name: "Transition"
    })));
}
function $a7ee497b70cfad78$var$Le(e, t) {
    let n = (0, $c56K2.useContext)($a7ee497b70cfad78$var$V) !== null, l = (0, $081f425c3e48d631$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).Fragment, null, !n && l ? (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($a7ee497b70cfad78$var$X, {
        ref: t,
        ...e
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($a7ee497b70cfad78$var$me, {
        ref: t,
        ...e
    }));
}
let $a7ee497b70cfad78$var$X = (0, $bc193d85907afa60$export$e43f39796049410c)($a7ee497b70cfad78$var$Ie), $a7ee497b70cfad78$var$me = (0, $bc193d85907afa60$export$e43f39796049410c)($a7ee497b70cfad78$var$Fe), $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d = (0, $bc193d85907afa60$export$e43f39796049410c)($a7ee497b70cfad78$var$Le), $a7ee497b70cfad78$export$be58926105124dd4 = Object.assign($a7ee497b70cfad78$var$X, {
    Child: $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d,
    Root: $a7ee497b70cfad78$var$X
});


"use client";
var $6747f844ef3fa432$var$we = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($6747f844ef3fa432$var$we || {}), $6747f844ef3fa432$var$Be = ((t)=>(t[t.SetTitleId = 0] = "SetTitleId", t))($6747f844ef3fa432$var$Be || {});
let $6747f844ef3fa432$var$Ue = {
    [0] (e, t) {
        return e.titleId === t.id ? e : {
            ...e,
            titleId: t.id
        };
    }
}, $6747f844ef3fa432$var$w = (0, $c56K2.createContext)(null);
$6747f844ef3fa432$var$w.displayName = "DialogContext";
function $6747f844ef3fa432$var$O(e) {
    let t = (0, $c56K2.useContext)($6747f844ef3fa432$var$w);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $6747f844ef3fa432$var$O), o;
    }
    return t;
}
function $6747f844ef3fa432$var$He(e, t) {
    return (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(t.type, $6747f844ef3fa432$var$Ue, e, t);
}
let $6747f844ef3fa432$var$z = (0, $bc193d85907afa60$export$e43f39796049410c)(function(t, o) {
    let a = (0, $c56K2.useId)(), { id: n = `headlessui-dialog-${a}`, open: i, onClose: p, initialFocus: d, role: s = "dialog", autoFocus: f = !0, __demoMode: u = !1, unmount: y = !1, ...S } = t, R = (0, $c56K2.useRef)(!1);
    s = function() {
        return s === "dialog" || s === "alertdialog" ? s : (R.current || (R.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let g = (0, $081f425c3e48d631$export$fc6fdf0ecf360e)();
    i === void 0 && g !== null && (i = (g & (0, $081f425c3e48d631$export$7254cc27399e90bd).Open) === (0, $081f425c3e48d631$export$7254cc27399e90bd).Open);
    let T = (0, $c56K2.useRef)(null), I = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(T, o), F = (0, $71d996aa44864848$export$dd9fbcea3de0ae36)(T.current), c = i ? 0 : 1, [b, Q] = (0, $c56K2.useReducer)($6747f844ef3fa432$var$He, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $c56K2.createRef)()
    }), m = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>p(!1)), B = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((r)=>Q({
            type: 0,
            id: r
        })), D = (0, $777f929a9f85f16b$export$44ab2b9f2d09b0fa)() ? c === 0 : !1, [Z, ee] = (0, $b0504cce4db6877e$export$26b8c35244a70b37)(), te = {
        get current () {
            var r;
            return (r = b.panelRef.current) != null ? r : T.current;
        }
    }, v = (0, $1e135805a380f57b$export$64db24433d7f4942)(), { resolveContainers: M } = (0, $1e135805a380f57b$export$445f2d1a3d9b1b9f)({
        mainTreeNode: v,
        portals: Z,
        defaultContainers: [
            te
        ]
    }), U = g !== null ? (g & (0, $081f425c3e48d631$export$7254cc27399e90bd).Closing) === (0, $081f425c3e48d631$export$7254cc27399e90bd).Closing : !1;
    (0, $45f770423adace2b$export$af489fa7e5283cc3)(u || U ? !1 : D, {
        allowed: (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
            var r, W;
            return [
                (W = (r = T.current) == null ? void 0 : r.closest("[data-headlessui-portal]")) != null ? W : null
            ];
        }),
        disallowed: (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
            var r;
            return [
                (r = v == null ? void 0 : v.closest("body > *:not(#headlessui-portal-root)")) != null ? r : null
            ];
        })
    });
    let P = (0, $cd6058473eaf339d$export$151359021f43c28a).get(null);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (D) return P.actions.push(n), ()=>P.actions.pop(n);
    }, [
        P,
        n,
        D
    ]);
    let H = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(P, (0, $c56K2.useCallback)((r)=>P.selectors.isTop(r, n), [
        P,
        n
    ]));
    (0, $709911b5ca379297$export$71b2224f1ce5e08e)(H, M, (r)=>{
        r.preventDefault(), m();
    }), (0, $8db81e634b065a32$export$3875fddb67014c13)(H, F == null ? void 0 : F.defaultView, (r)=>{
        r.preventDefault(), r.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), m();
    }), (0, $ad60b3b67ac8c8ab$export$e47ba1b900da5d3b)(u || U ? !1 : D, F, M), (0, $271d62a22f8321aa$export$b41b9097915aa006)(D, T, m);
    let [oe, ne] = (0, $39fd9e43e376396c$export$babde88292020af7)(), re = (0, $c56K2.useMemo)(()=>[
            {
                dialogState: c,
                close: m,
                setTitleId: B,
                unmount: y
            },
            b
        ], [
        c,
        m,
        B,
        y,
        b
    ]), N = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: c === 0
    }), le = {
        ref: I,
        id: n,
        role: s,
        tabIndex: -1,
        "aria-modal": u ? void 0 : c === 0 ? !0 : void 0,
        "aria-labelledby": b.titleId,
        "aria-describedby": oe,
        unmount: y
    }, ae = !(0, $5074034a47ac9f32$export$2706b359107dd58d)(), E = (0, $b1771255947d08cf$export$a5e9a012c73650bd).None;
    D && !u && (E |= (0, $b1771255947d08cf$export$a5e9a012c73650bd).RestoreFocus, E |= (0, $b1771255947d08cf$export$a5e9a012c73650bd).TabLock, f && (E |= (0, $b1771255947d08cf$export$a5e9a012c73650bd).AutoFocus), ae && (E |= (0, $b1771255947d08cf$export$a5e9a012c73650bd).InitialFocus));
    let ie = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $081f425c3e48d631$export$6748feed729c7cf3), null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $2bfd3103c6429fe4$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $b0504cce4db6877e$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($6747f844ef3fa432$var$w.Provider, {
        value: re
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $b0504cce4db6877e$export$84c667e5e4409848), {
        target: T
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $2bfd3103c6429fe4$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement(ne, {
        slot: N
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement(ee, null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $b1771255947d08cf$export$34eba2437817a67b), {
        initialFocus: d,
        initialFocusFallback: T,
        containers: M,
        features: E
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $b7b29e70ac6b2beb$export$dd2a80b78bebbe1d), {
        value: m
    }, ie({
        ourProps: le,
        theirProps: S,
        slot: N,
        defaultTag: $6747f844ef3fa432$var$Ne,
        features: $6747f844ef3fa432$var$We,
        visible: c === 0,
        name: "Dialog"
    })))))))))));
}), $6747f844ef3fa432$var$Ne = "div", $6747f844ef3fa432$var$We = (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).RenderStrategy | (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).Static;
function $6747f844ef3fa432$var$$e(e, t) {
    let { transition: o = !1, open: a, ...n } = e, i = (0, $081f425c3e48d631$export$fc6fdf0ecf360e)(), p = e.hasOwnProperty("open") || i !== null, d = e.hasOwnProperty("onClose");
    if (!p && !d) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!p) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!d) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (!i && typeof e.open != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
    if (typeof e.onClose != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
    return (a !== void 0 || o) && !n.static ? (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $1e135805a380f57b$export$61c2c570df73dc80), null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $a7ee497b70cfad78$export$be58926105124dd4), {
        show: a,
        transition: o,
        unmount: n.unmount
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($6747f844ef3fa432$var$z, {
        ref: t,
        ...n
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $1e135805a380f57b$export$61c2c570df73dc80), null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($6747f844ef3fa432$var$z, {
        ref: t,
        open: a,
        ...n
    }));
}
let $6747f844ef3fa432$var$je = "div";
function $6747f844ef3fa432$var$Ye(e, t) {
    let o = (0, $c56K2.useId)(), { id: a = `headlessui-dialog-panel-${o}`, transition: n = !1, ...i } = e, [{ dialogState: p, unmount: d }, s] = $6747f844ef3fa432$var$O("Dialog.Panel"), f = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(t, s.panelRef), u = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: p === 0
    }), y = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((I)=>{
        I.stopPropagation();
    }), S = {
        ref: f,
        id: a,
        onClick: y
    }, R = n ? (0, $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d) : (0, $c56K2.Fragment), g = n ? {
        unmount: d
    } : {}, T = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement(R, {
        ...g
    }, T({
        ourProps: S,
        theirProps: i,
        slot: u,
        defaultTag: $6747f844ef3fa432$var$je,
        name: "Dialog.Panel"
    }));
}
let $6747f844ef3fa432$var$Je = "div";
function $6747f844ef3fa432$var$Ke(e, t) {
    let { transition: o = !1, ...a } = e, [{ dialogState: n, unmount: i }] = $6747f844ef3fa432$var$O("Dialog.Backdrop"), p = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: n === 0
    }), d = {
        ref: t,
        "aria-hidden": !0
    }, s = o ? (0, $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d) : (0, $c56K2.Fragment), f = o ? {
        unmount: i
    } : {}, u = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement(s, {
        ...f
    }, u({
        ourProps: d,
        theirProps: a,
        slot: p,
        defaultTag: $6747f844ef3fa432$var$Je,
        name: "Dialog.Backdrop"
    }));
}
let $6747f844ef3fa432$var$Xe = "h2";
function $6747f844ef3fa432$var$Ve(e, t) {
    let o = (0, $c56K2.useId)(), { id: a = `headlessui-dialog-title-${o}`, ...n } = e, [{ dialogState: i, setTitleId: p }] = $6747f844ef3fa432$var$O("Dialog.Title"), d = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(t);
    (0, $c56K2.useEffect)(()=>(p(a), ()=>p(null)), [
        a,
        p
    ]);
    let s = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: i === 0
    }), f = {
        ref: d,
        id: a
    };
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: f,
        theirProps: n,
        slot: s,
        defaultTag: $6747f844ef3fa432$var$Xe,
        name: "Dialog.Title"
    });
}
let $6747f844ef3fa432$var$qe = (0, $bc193d85907afa60$export$e43f39796049410c)($6747f844ef3fa432$var$$e), $6747f844ef3fa432$export$46512663428d955a = (0, $bc193d85907afa60$export$e43f39796049410c)($6747f844ef3fa432$var$Ye), $6747f844ef3fa432$export$91fffd879a9415f4 = (0, $bc193d85907afa60$export$e43f39796049410c)($6747f844ef3fa432$var$Ke), $6747f844ef3fa432$export$16f7638e4a34b909 = (0, $bc193d85907afa60$export$e43f39796049410c)($6747f844ef3fa432$var$Ve), $6747f844ef3fa432$export$94e94c2ec2c954d5 = (0, $39fd9e43e376396c$export$393edc798c47379d), $6747f844ef3fa432$export$3ddf2d174ce01153 = Object.assign($6747f844ef3fa432$var$qe, {
    Panel: $6747f844ef3fa432$export$46512663428d955a,
    Title: $6747f844ef3fa432$export$16f7638e4a34b909,
    Description: (0, $39fd9e43e376396c$export$393edc798c47379d)
});



var $c56K2 = parcelRequire("c56K2");


var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");
function $2ac6685d93f5eb7b$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $c56K2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $c56K2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $c56K2.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    }));
}
const $2ac6685d93f5eb7b$var$ForwardRef = /*#__PURE__*/ $c56K2.forwardRef($2ac6685d93f5eb7b$var$MagnifyingGlassIcon);
var $2ac6685d93f5eb7b$export$2e2bcd8739ae039 = $2ac6685d93f5eb7b$var$ForwardRef;



var $c56K2 = parcelRequire("c56K2");
const $e55f5946e67ab9f3$export$ae85633f8b51022a = (0, $c56K2.createContext)({});
const $e55f5946e67ab9f3$export$8d6bf6257d5e67d2 = (0, $c56K2.createContext)({});
const $e55f5946e67ab9f3$export$d665dd135a51b28a = (0, $c56K2.createContext)({});



const $ca563244bcfc37c7$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $ca563244bcfc37c7$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $ca563244bcfc37c7$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/**
 * Type guard that checks if a value is a Node. Verifies the presence and type of the nodeType property.
 */ function $ca563244bcfc37c7$var$$cc3c3666b64debad$var$isNode(value) {
    return value !== null && typeof value === 'object' && 'nodeType' in value && typeof value.nodeType === 'number';
}
function $ca563244bcfc37c7$export$af51f0f06c0f328a(node) {
    return $ca563244bcfc37c7$var$$cc3c3666b64debad$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && 'host' in node;
}


/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $11c288bb830a6914$var$$ed892adb18214553$var$_tableNestedRows = false;
let $11c288bb830a6914$var$$ed892adb18214553$var$_shadowDOM = false;
function $11c288bb830a6914$export$d9d8a0f82de49530() {
    $11c288bb830a6914$var$$ed892adb18214553$var$_tableNestedRows = true;
}
function $11c288bb830a6914$export$1b00cb14a96194e6() {
    return $11c288bb830a6914$var$$ed892adb18214553$var$_tableNestedRows;
}
function $11c288bb830a6914$export$12b151d9882e9985() {
    $11c288bb830a6914$var$$ed892adb18214553$var$_shadowDOM = true;
}
function $11c288bb830a6914$export$98658e8c59125e6a() {
    return $11c288bb830a6914$var$$ed892adb18214553$var$_shadowDOM;
}


// Source: https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/DOMFunctions.ts#L16
/* eslint-disable rsp-rules/no-non-shadow-contains, rsp-rules/safe-event-target */ function $23cf47a115a53e4b$export$4282f70798064fe0(node, otherNode) {
    if (!(0, $11c288bb830a6914$export$98658e8c59125e6a)()) return otherNode && node ? node.contains(otherNode) : false;
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode !== null){
        if (currentNode === node) return true;
        if (currentNode.tagName === 'SLOT' && currentNode.assignedSlot) currentNode = currentNode.assignedSlot.parentNode;
        else if ((0, $ca563244bcfc37c7$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
const $23cf47a115a53e4b$export$cd4e5573fbe2b576 = (doc = document)=>{
    var _activeElement_shadowRoot;
    if (!(0, $11c288bb830a6914$export$98658e8c59125e6a)()) return doc.activeElement;
    let activeElement = doc.activeElement;
    while(activeElement && 'shadowRoot' in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement))activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
};
function $23cf47a115a53e4b$export$e58f029f0fbfdb29(event) {
    if ((0, $11c288bb830a6914$export$98658e8c59125e6a)() && event.target instanceof Element && event.target.shadowRoot) {
        var _event_composedPath_, _event_nativeEvent_composedPath_;
        if ('composedPath' in event) return (_event_composedPath_ = event.composedPath()[0]) !== null && _event_composedPath_ !== void 0 ? _event_composedPath_ : null;
        else if ('composedPath' in event.nativeEvent) return (_event_nativeEvent_composedPath_ = event.nativeEvent.composedPath()[0]) !== null && _event_nativeEvent_composedPath_ !== void 0 ? _event_nativeEvent_composedPath_ : null;
    }
    return event.target;
}
function $23cf47a115a53e4b$export$b4f377a2b6254582(node) {
    if (!node) return false;
    // Get the active element within the node's parent shadow root (or the document). Can return null.
    let root = node.getRootNode();
    let ownerWindow = (0, $ca563244bcfc37c7$export$f21a1ffae260145a)(node);
    if (!(root instanceof ownerWindow.Document || root instanceof ownerWindow.ShadowRoot)) return false;
    let activeElement = root.activeElement;
    // Check if the active element is within this node. These nodes are within the same shadow root.
    return activeElement != null && node.contains(activeElement);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9b5e9779a654a984$export$de79e2c695e052f3(element) {
    if ($9b5e9779a654a984$var$$d559d872031c749f$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $9b5e9779a654a984$var$$d559d872031c749f$var$getScrollableElements(element);
        element.focus();
        $9b5e9779a654a984$var$$d559d872031c749f$var$restoreScrollPosition(scrollableElements);
    }
}
let $9b5e9779a654a984$var$$d559d872031c749f$var$supportsPreventScrollCached = null;
function $9b5e9779a654a984$var$$d559d872031c749f$var$supportsPreventScroll() {
    if ($9b5e9779a654a984$var$$d559d872031c749f$var$supportsPreventScrollCached == null) {
        $9b5e9779a654a984$var$$d559d872031c749f$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $9b5e9779a654a984$var$$d559d872031c749f$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch  {
        // Ignore
        }
    }
    return $9b5e9779a654a984$var$$d559d872031c749f$var$supportsPreventScrollCached;
}
function $9b5e9779a654a984$var$$d559d872031c749f$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $9b5e9779a654a984$var$$d559d872031c749f$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}





/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0aeff3b51e3913bc$var$$7570c7c1cd2bea0b$var$supportsCheckVisibility = typeof Element !== 'undefined' && 'checkVisibility' in Element.prototype;
function $0aeff3b51e3913bc$var$$7570c7c1cd2bea0b$var$isStyleVisible(element) {
    const windowObject = (0, $ca563244bcfc37c7$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $0aeff3b51e3913bc$var$$7570c7c1cd2bea0b$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $0aeff3b51e3913bc$export$e989c0fffaa6b27a(element, childElement) {
    if ($0aeff3b51e3913bc$var$$7570c7c1cd2bea0b$var$supportsCheckVisibility) return element.checkVisibility({
        visibilityProperty: true
    }) && !element.closest('[data-react-aria-prevent-focus]');
    return element.nodeName !== '#comment' && $0aeff3b51e3913bc$var$$7570c7c1cd2bea0b$var$isStyleVisible(element) && $0aeff3b51e3913bc$var$$7570c7c1cd2bea0b$var$isAttributeVisible(element, childElement) && (!element.parentElement || $0aeff3b51e3913bc$export$e989c0fffaa6b27a(element.parentElement, element));
}


/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c04fc6479fa9caef$var$$ee5e22534121197a$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable^="false"])',
    'permission'
];
const $c04fc6479fa9caef$var$$ee5e22534121197a$var$FOCUSABLE_ELEMENT_SELECTOR = $c04fc6479fa9caef$var$$ee5e22534121197a$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$c04fc6479fa9caef$var$$ee5e22534121197a$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $c04fc6479fa9caef$var$$ee5e22534121197a$var$TABBABLE_ELEMENT_SELECTOR = $c04fc6479fa9caef$var$$ee5e22534121197a$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $c04fc6479fa9caef$export$4c063cf1350e6fed(element, options) {
    return element.matches($c04fc6479fa9caef$var$$ee5e22534121197a$var$FOCUSABLE_ELEMENT_SELECTOR) && !$c04fc6479fa9caef$var$$ee5e22534121197a$var$isInert(element) && ((options === null || options === void 0 ? void 0 : options.skipVisibilityCheck) || (0, $0aeff3b51e3913bc$export$e989c0fffaa6b27a)(element));
}
function $c04fc6479fa9caef$export$bebd5a1431fec25d(element) {
    return element.matches($c04fc6479fa9caef$var$$ee5e22534121197a$var$TABBABLE_ELEMENT_SELECTOR) && (0, $0aeff3b51e3913bc$export$e989c0fffaa6b27a)(element) && !$c04fc6479fa9caef$var$$ee5e22534121197a$var$isInert(element);
}
function $c04fc6479fa9caef$var$$ee5e22534121197a$var$isInert(element) {
    let node = element;
    while(node != null){
        if (node instanceof node.ownerDocument.defaultView.HTMLElement && node.inert) return true;
        node = node.parentElement;
    }
    return false;
}



var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cc78a7747df68f17$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).useLayoutEffect : ()=>{};



var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $154fd3858b03ef50$export$525bc4921d56d4a(nativeEvent) {
    let event = nativeEvent;
    event.nativeEvent = nativeEvent;
    event.isDefaultPrevented = ()=>event.defaultPrevented;
    // cancelBubble is technically deprecated in the spec, but still supported in all browsers.
    event.isPropagationStopped = ()=>event.cancelBubble;
    event.persist = ()=>{};
    return event;
}
function $154fd3858b03ef50$export$c2b7abe5d61ec696(event, target) {
    Object.defineProperty(event, 'target', {
        value: target
    });
    Object.defineProperty(event, 'currentTarget', {
        value: target
    });
}
function $154fd3858b03ef50$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $c56K2.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $cc78a7747df68f17$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (0, $c56K2.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        let eventTarget = (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e);
        if (eventTarget instanceof HTMLButtonElement || eventTarget instanceof HTMLInputElement || eventTarget instanceof HTMLTextAreaElement || eventTarget instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = eventTarget;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) {
                    // For backward compatibility, dispatch a (fake) React synthetic event.
                    let event = $154fd3858b03ef50$export$525bc4921d56d4a(e);
                    onBlur === null || onBlur === void 0 || onBlur(event);
                }
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === (0, $23cf47a115a53e4b$export$cd4e5573fbe2b576)() ? null : (0, $23cf47a115a53e4b$export$cd4e5573fbe2b576)();
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        onBlur
    ]);
}
let $154fd3858b03ef50$export$fda7da73ab5d4c48 = false;
function $154fd3858b03ef50$export$cabe61c495ee3649(target) {
    // The browser will focus the nearest focusable ancestor of our target.
    while(target && !(0, $c04fc6479fa9caef$export$4c063cf1350e6fed)(target, {
        skipVisibilityCheck: true
    }))target = target.parentElement;
    let window = (0, $ca563244bcfc37c7$export$f21a1ffae260145a)(target);
    let activeElement = window.document.activeElement;
    if (!activeElement || activeElement === target) return;
    $154fd3858b03ef50$export$fda7da73ab5d4c48 = true;
    let isRefocusing = false;
    let onBlur = (e)=>{
        if ((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) === activeElement || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusOut = (e)=>{
        if ((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) === activeElement || isRefocusing) {
            e.stopImmediatePropagation();
            // If there was no focusable ancestor, we don't expect a focus event.
            // Re-focus the original active element here.
            if (!target && !isRefocusing) {
                isRefocusing = true;
                (0, $9b5e9779a654a984$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    let onFocus = (e)=>{
        if ((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) === target || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusIn = (e)=>{
        if ((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) === target || isRefocusing) {
            e.stopImmediatePropagation();
            if (!isRefocusing) {
                isRefocusing = true;
                (0, $9b5e9779a654a984$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    window.addEventListener('blur', onBlur, true);
    window.addEventListener('focusout', onFocusOut, true);
    window.addEventListener('focusin', onFocusIn, true);
    window.addEventListener('focus', onFocus, true);
    let cleanup = ()=>{
        cancelAnimationFrame(raf);
        window.removeEventListener('blur', onBlur, true);
        window.removeEventListener('focusout', onFocusOut, true);
        window.removeEventListener('focusin', onFocusIn, true);
        window.removeEventListener('focus', onFocus, true);
        $154fd3858b03ef50$export$fda7da73ab5d4c48 = false;
        isRefocusing = false;
    };
    let raf = requestAnimationFrame(cleanup);
    return cleanup;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    let brands = (_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands;
    return Array.isArray(brands) && brands.some((brand)=>re.test(brand.brand)) || re.test(window.navigator.userAgent);
}
function $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $ef9b1a3ae1416903$export$9ac100e40613ea10 = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testPlatform(/^Mac/i);
});
const $ef9b1a3ae1416903$export$186c6964ca17d99 = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testPlatform(/^iPhone/i);
});
const $ef9b1a3ae1416903$export$7bef049ce92e4224 = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $ef9b1a3ae1416903$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $ef9b1a3ae1416903$export$fedb369cb70207f1 = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$export$186c6964ca17d99() || $ef9b1a3ae1416903$export$7bef049ce92e4224();
});
const $ef9b1a3ae1416903$export$e1865c3bedcd822b = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$export$9ac100e40613ea10() || $ef9b1a3ae1416903$export$fedb369cb70207f1();
});
const $ef9b1a3ae1416903$export$78551043582a6a98 = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testUserAgent(/AppleWebKit/i) && !$ef9b1a3ae1416903$export$6446a186d09e379e();
});
const $ef9b1a3ae1416903$export$6446a186d09e379e = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testUserAgent(/Chrome/i);
});
const $ef9b1a3ae1416903$export$a11b0059900ceec8 = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testUserAgent(/Android/i);
});
const $ef9b1a3ae1416903$export$b7d78993b74f766d = $ef9b1a3ae1416903$var$$d5a2be505488529f$var$cached(function() {
    return $ef9b1a3ae1416903$var$$d5a2be505488529f$var$testUserAgent(/Firefox/i);
});



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ff04d008f0b95c29$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.pointerType === '' && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $ef9b1a3ae1416903$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $ff04d008f0b95c29$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $ef9b1a3ae1416903$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}





var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4de5482c7b6690d7$var$$044d3c97ce5d6621$var$RouterContext = (0, $c56K2.createContext)({
    isNative: true,
    open: $4de5482c7b6690d7$var$$044d3c97ce5d6621$var$openSyntheticLink,
    useHref: (href)=>href
});
function $4de5482c7b6690d7$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $c56K2.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $4de5482c7b6690d7$var$$044d3c97ce5d6621$var$getSyntheticLink(target, (link)=>{
                    if ($4de5482c7b6690d7$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $4de5482c7b6690d7$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($4de5482c7b6690d7$var$$044d3c97ce5d6621$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $4de5482c7b6690d7$export$9a302a45f65d0572() {
    return (0, $c56K2.useContext)($4de5482c7b6690d7$var$$044d3c97ce5d6621$var$RouterContext);
}
function $4de5482c7b6690d7$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute('target');
    return (!target || target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $4de5482c7b6690d7$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $ef9b1a3ae1416903$export$b7d78993b74f766d)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith('key')) && target.target === '_blank') {
        if ((0, $ef9b1a3ae1416903$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $ef9b1a3ae1416903$export$78551043582a6a98)() && (0, $ef9b1a3ae1416903$export$9ac100e40613ea10)() && !(0, $ef9b1a3ae1416903$export$7bef049ce92e4224)() && true ? new KeyboardEvent('keydown', {
        keyIdentifier: 'Enter',
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent('click', {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        detail: 1,
        bubbles: true,
        cancelable: true
    });
    $4de5482c7b6690d7$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $9b5e9779a654a984$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $4de5482c7b6690d7$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$4de5482c7b6690d7$export$95185d699e05d4d7.isOpening = false;
function $4de5482c7b6690d7$var$$044d3c97ce5d6621$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute('data-href')) {
        let link = document.createElement('a');
        link.href = target.getAttribute('data-href');
        if (target.hasAttribute('data-target')) link.target = target.getAttribute('data-target');
        if (target.hasAttribute('data-rel')) link.rel = target.getAttribute('data-rel');
        if (target.hasAttribute('data-download')) link.download = target.getAttribute('data-download');
        if (target.hasAttribute('data-ping')) link.ping = target.getAttribute('data-ping');
        if (target.hasAttribute('data-referrer-policy')) link.referrerPolicy = target.getAttribute('data-referrer-policy');
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $4de5482c7b6690d7$var$$044d3c97ce5d6621$var$openSyntheticLink(target, modifiers) {
    $4de5482c7b6690d7$var$$044d3c97ce5d6621$var$getSyntheticLink(target, (link)=>$4de5482c7b6690d7$export$95185d699e05d4d7(link, modifiers));
}
function $4de5482c7b6690d7$export$bdc77b0c0a3a85d6(props) {
    let router = $4de5482c7b6690d7$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        'data-href': props.href ? href : undefined,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $4de5482c7b6690d7$export$51437d503373d223(props) {
    return {
        'data-href': props.href,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $4de5482c7b6690d7$export$7e924b3091a3bd18(props) {
    let router = $4de5482c7b6690d7$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props === null || props === void 0 ? void 0 : props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? href : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}
function $4de5482c7b6690d7$export$13aea1a3cb5e3f1f(e, router, href, routerOptions) {
    // If a custom router is provided, prevent default and forward if this link should client navigate.
    if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
    !e.isDefaultPrevented() && $4de5482c7b6690d7$export$efa8c9099e530235(e.currentTarget, e) && href) {
        e.preventDefault();
        router.open(e.currentTarget, e, href, routerOptions);
    }
}



var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $1364d0e16f616739$var$$85138adc03e1f057$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $1364d0e16f616739$var$$85138adc03e1f057$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createContext($1364d0e16f616739$var$$85138adc03e1f057$var$defaultContext);
const $1364d0e16f616739$var$$85138adc03e1f057$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createContext(false);
// This is only used in React < 18.
function $1364d0e16f616739$var$$85138adc03e1f057$var$LegacySSRProvider(props) {
    let cur = (0, $c56K2.useContext)($1364d0e16f616739$var$$85138adc03e1f057$var$SSRContext);
    let counter = $1364d0e16f616739$var$$85138adc03e1f057$var$useCounter(cur === $1364d0e16f616739$var$$85138adc03e1f057$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $c56K2.useState)(true);
    let value = (0, $c56K2.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $1364d0e16f616739$var$$85138adc03e1f057$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $c56K2.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($1364d0e16f616739$var$$85138adc03e1f057$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($1364d0e16f616739$var$$85138adc03e1f057$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $1364d0e16f616739$var$$85138adc03e1f057$var$warnedAboutSSRProvider = false;
function $1364d0e16f616739$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($c56K2)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($1364d0e16f616739$var$$85138adc03e1f057$var$LegacySSRProvider, props);
}
let $1364d0e16f616739$var$$85138adc03e1f057$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $1364d0e16f616739$var$$85138adc03e1f057$var$componentIds = new WeakMap();
function $1364d0e16f616739$var$$85138adc03e1f057$var$useCounter(isDisabled = false) {
    let ctx = (0, $c56K2.useContext)($1364d0e16f616739$var$$85138adc03e1f057$var$SSRContext);
    let ref = (0, $c56K2.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $1364d0e16f616739$var$$85138adc03e1f057$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $1364d0e16f616739$var$$85138adc03e1f057$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $1364d0e16f616739$var$$85138adc03e1f057$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $1364d0e16f616739$var$$85138adc03e1f057$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $c56K2.useContext)($1364d0e16f616739$var$$85138adc03e1f057$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $1364d0e16f616739$var$$85138adc03e1f057$var$defaultContext && $1364d0e16f616739$var$$85138adc03e1f057$var$canUseDOM;
    let counter = $1364d0e16f616739$var$$85138adc03e1f057$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $1364d0e16f616739$var$$85138adc03e1f057$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).useId();
    let [didSSR] = (0, $c56K2.useState)($1364d0e16f616739$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$1364d0e16f616739$var$$85138adc03e1f057$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $1364d0e16f616739$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($c56K2)))['useId'] === 'function' ? $1364d0e16f616739$var$$85138adc03e1f057$var$useModernSSRSafeId : $1364d0e16f616739$var$$85138adc03e1f057$var$useLegacySSRSafeId;
function $1364d0e16f616739$var$$85138adc03e1f057$var$getSnapshot() {
    return false;
}
function $1364d0e16f616739$var$$85138adc03e1f057$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $1364d0e16f616739$var$$85138adc03e1f057$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $1364d0e16f616739$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($c56K2)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2)))['useSyncExternalStore']($1364d0e16f616739$var$$85138adc03e1f057$var$subscribe, $1364d0e16f616739$var$$85138adc03e1f057$var$getSnapshot, $1364d0e16f616739$var$$85138adc03e1f057$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $c56K2.useContext)($1364d0e16f616739$var$$85138adc03e1f057$var$IsSSRContext);
}



var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality = null;
let $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentPointerType = 'keyboard';
const $e5fc808bf1e5af87$export$901e90a13c50a14e = new Set();
let $e5fc808bf1e5af87$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = false;
let $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$triggerChangeHandlers(modality, e) {
    for (let handler of $e5fc808bf1e5af87$export$901e90a13c50a14e)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $ef9b1a3ae1416903$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleKeyboardEvent(e) {
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
    if (!(0, $4de5482c7b6690d7$export$95185d699e05d4d7).isOpening && $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$isValidKey(e)) {
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality = 'keyboard';
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentPointerType = 'keyboard';
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$triggerChangeHandlers('keyboard', e);
    }
}
function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handlePointerEvent(e) {
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality = 'pointer';
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentPointerType = 'pointerType' in e ? e.pointerType : 'mouse';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$triggerChangeHandlers('pointer', e);
    }
}
function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleClickEvent(e) {
    if (!(0, $4de5482c7b6690d7$export$95185d699e05d4d7).isOpening && (0, $ff04d008f0b95c29$export$60278871457622de)(e)) {
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality = 'virtual';
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentPointerType = 'virtual';
    }
}
function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    let ownerWindow = (0, $ca563244bcfc37c7$export$f21a1ffae260145a)((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e));
    let ownerDocument = (0, $ca563244bcfc37c7$export$b204af158042fbac)((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e));
    if ((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) === ownerWindow || (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) === ownerDocument || (0, $154fd3858b03ef50$export$fda7da73ab5d4c48) || !e.isTrusted) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus && !$e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently) {
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality = 'virtual';
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentPointerType = 'virtual';
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$triggerChangeHandlers('virtual', e);
    }
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = false;
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently = false;
}
function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleWindowBlur() {
    if (0, $154fd3858b03ef50$export$fda7da73ab5d4c48) return;
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = false;
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents(element) {
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const windowObject = (0, $ca563244bcfc37c7$export$f21a1ffae260145a)(element);
    const documentObject = (0, $ca563244bcfc37c7$export$b204af158042fbac)(element);
    if ($e5fc808bf1e5af87$export$d90243b58daecda7.get(windowObject)) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $e5fc808bf1e5af87$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ca563244bcfc37c7$export$f21a1ffae260145a)(element);
    const documentObject = (0, $ca563244bcfc37c7$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$e5fc808bf1e5af87$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $e5fc808bf1e5af87$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$handlePointerEvent, true);
    }
    $e5fc808bf1e5af87$export$d90243b58daecda7.delete(windowObject);
};
function $e5fc808bf1e5af87$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ca563244bcfc37c7$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $e5fc808bf1e5af87$export$2f1888112f558a7d();
function $e5fc808bf1e5af87$export$b9b3dfddab17db27() {
    return $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality !== 'pointer';
}
function $e5fc808bf1e5af87$export$630ff653c5ada6a9() {
    return $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality;
}
function $e5fc808bf1e5af87$export$8397ddfc504fdb9a(modality) {
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality = modality;
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentPointerType = modality === 'pointer' ? 'mouse' : modality;
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$triggerChangeHandlers(modality, null);
}
function $e5fc808bf1e5af87$export$887a228355cf7d95() {
    return $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentPointerType;
}
function $e5fc808bf1e5af87$export$98e20ec92f614cfe() {
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $c56K2.useState)($e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality);
    (0, $c56K2.useEffect)(()=>{
        let handler = ()=>{
            setModality($e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$currentModality);
        };
        $e5fc808bf1e5af87$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $e5fc808bf1e5af87$export$901e90a13c50a14e.delete(handler);
        };
    }, []);
    return (0, $1364d0e16f616739$export$535bd6ca7f90a273)() ? null : modality;
}
const $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    let eventTarget = e ? (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) : undefined;
    let document1 = (0, $ca563244bcfc37c7$export$b204af158042fbac)(eventTarget);
    let ownerWindow = (0, $ca563244bcfc37c7$export$f21a1ffae260145a)(eventTarget);
    const IHTMLInputElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof ownerWindow !== 'undefined' ? ownerWindow.KeyboardEvent : KeyboardEvent;
    // For keyboard events that occur on a non-input element that will move focus into input element (aka ArrowLeft going from Datepicker button to the main input group)
    // we need to rely on the user passing isTextInput into here. This way we can skip toggling focus visiblity for said input element
    let activeElement = (0, $23cf47a115a53e4b$export$cd4e5573fbe2b576)(document1);
    isTextInput = isTextInput || activeElement instanceof IHTMLInputElement && !$e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$nonTextInputTypes.has(activeElement.type) || activeElement instanceof IHTMLTextAreaElement || activeElement instanceof IHTMLElement && activeElement.isContentEditable;
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $e5fc808bf1e5af87$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $c56K2.useState)(autoFocus || $e5fc808bf1e5af87$export$b9b3dfddab17db27());
    $e5fc808bf1e5af87$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $e5fc808bf1e5af87$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$setupGlobalFocusEvents();
    (0, $c56K2.useEffect)(()=>{
        if ((opts === null || opts === void 0 ? void 0 : opts.enabled) === false) return;
        let handler = (modality, e)=>{
            // We want to early return for any keyboard events that occur inside text inputs EXCEPT for Tab and Escape
            if (!$e5fc808bf1e5af87$var$$b50b1cc8a843ace7$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($e5fc808bf1e5af87$export$b9b3dfddab17db27());
        };
        $e5fc808bf1e5af87$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $e5fc808bf1e5af87$export$901e90a13c50a14e.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}






var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $16526cf4e89edf8e$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $c56K2.useCallback)((e)=>{
        if ((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e) === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $154fd3858b03ef50$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $c56K2.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e);
        const ownerDocument = (0, $ca563244bcfc37c7$export$b204af158042fbac)(eventTarget);
        const activeElement = ownerDocument ? (0, $23cf47a115a53e4b$export$cd4e5573fbe2b576)(ownerDocument) : (0, $23cf47a115a53e4b$export$cd4e5573fbe2b576)();
        if (eventTarget === e.currentTarget && eventTarget === activeElement) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}






var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $aa1cca439ff1fdd4$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $c56K2.useRef)(new Map());
    let addGlobalListener = (0, $c56K2.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, fn, options);
    }, []);
    let removeGlobalListener = (0, $c56K2.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $c56K2.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $c56K2.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}



var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $a6b0d0cf8c746cb6$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $c56K2.useRef)({
        isFocusWithin: false
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $aa1cca439ff1fdd4$export$4eaf04e54aa8eed6)();
    let onBlur = (0, $c56K2.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $23cf47a115a53e4b$export$4282f70798064fe0)(e.currentTarget, (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e))) return;
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !(0, $23cf47a115a53e4b$export$4282f70798064fe0)(e.currentTarget, e.relatedTarget)) {
            state.current.isFocusWithin = false;
            removeAllGlobalListeners();
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state,
        removeAllGlobalListeners
    ]);
    let onSyntheticFocus = (0, $154fd3858b03ef50$export$715c682d09d639cc)(onBlur);
    let onFocus = (0, $c56K2.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $23cf47a115a53e4b$export$4282f70798064fe0)(e.currentTarget, (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e))) return;
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e);
        const ownerDocument = (0, $ca563244bcfc37c7$export$b204af158042fbac)(eventTarget);
        const activeElement = (0, $23cf47a115a53e4b$export$cd4e5573fbe2b576)(ownerDocument);
        if (!state.current.isFocusWithin && activeElement === eventTarget) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
            // Browsers don't fire blur events when elements are removed from the DOM.
            // However, if a focus event occurs outside the element we're tracking, we
            // can manually fire onBlur.
            let currentTarget = e.currentTarget;
            addGlobalListener(ownerDocument, 'focus', (e)=>{
                let eventTarget = (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e);
                if (state.current.isFocusWithin && !(0, $23cf47a115a53e4b$export$4282f70798064fe0)(currentTarget, eventTarget)) {
                    let nativeEvent = new ownerDocument.defaultView.FocusEvent('blur', {
                        relatedTarget: eventTarget
                    });
                    (0, $154fd3858b03ef50$export$c2b7abe5d61ec696)(nativeEvent, currentTarget);
                    let event = (0, $154fd3858b03ef50$export$525bc4921d56d4a)(nativeEvent);
                    onBlur(event);
                }
            }, {
                capture: true
            });
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus,
        addGlobalListener,
        onBlur
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These cannot be null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $c56K2 = parcelRequire("c56K2");
function $c6173221ab826b78$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $c56K2.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $e5fc808bf1e5af87$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (0, $c56K2.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $c56K2.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $c56K2.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $c56K2.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        state.current.isFocusVisible = (0, $e5fc808bf1e5af87$export$b9b3dfddab17db27)();
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $e5fc808bf1e5af87$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [
        isTextInput,
        isFocused
    ], {
        enabled: isFocused,
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $16526cf4e89edf8e$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $a6b0d0cf8c746cb6$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}






var $c56K2 = parcelRequire("c56K2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$globalIgnoreEmulatedMouseEvents = false;
let $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$hoverCount = 0;
function $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$setGlobalIgnoreEmulatedMouseEvents() {
    $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$globalIgnoreEmulatedMouseEvents = false;
    }, 500);
}
function $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$setupGlobalTouchEvents() {
    let ownerDocument = (0, $ca563244bcfc37c7$export$b204af158042fbac)(null);
    if (typeof ownerDocument === 'undefined') return;
    if ($207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$hoverCount === 0) {
        if (typeof PointerEvent !== 'undefined') ownerDocument.addEventListener('pointerup', $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$handleGlobalPointerEvent);
    }
    $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$hoverCount++;
    return ()=>{
        $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$hoverCount--;
        if ($207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') ownerDocument.removeEventListener('pointerup', $207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$handleGlobalPointerEvent);
    };
}
function $207f2e029c99ee9c$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $c56K2.useState)(false);
    let state = (0, $c56K2.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $c56K2.useEffect)($207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$setupGlobalTouchEvents, []);
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $aa1cca439ff1fdd4$export$4eaf04e54aa8eed6)();
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $c56K2.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !(0, $23cf47a115a53e4b$export$4282f70798064fe0)(event.currentTarget, (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(event))) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            // When an element that is hovered over is removed, no pointerleave event is fired by the browser,
            // even though the originally hovered target may have shrunk in size so it is no longer hovered.
            // However, a pointerover event will be fired on the new target the mouse is over.
            // In Chrome this happens immediately. In Safari and Firefox, it happens upon moving the mouse one pixel.
            addGlobalListener((0, $ca563244bcfc37c7$export$b204af158042fbac)((0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(event)), 'pointerover', (e)=>{
                if (state.isHovered && state.target && !(0, $23cf47a115a53e4b$export$4282f70798064fe0)(state.target, (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e))) triggerHoverEnd(e, e.pointerType);
            }, {
                capture: true
            });
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            let target = state.target;
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered || !target) return;
            state.isHovered = false;
            removeAllGlobalListeners();
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($207f2e029c99ee9c$var$$f7f05710dfc01c4c$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && (0, $23cf47a115a53e4b$export$4282f70798064fe0)(e.currentTarget, (0, $23cf47a115a53e4b$export$e58f029f0fbfdb29)(e))) triggerHoverEnd(e, e.pointerType);
            };
        } else var e, e1;
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state,
        addGlobalListener,
        removeAllGlobalListeners
    ]);
    (0, $c56K2.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}



var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");



function $d03ea1a53b0cd3b8$var$E(e) {
    let t = e.width / 2, n = e.height / 2;
    return {
        top: e.clientY - n,
        right: e.clientX + t,
        bottom: e.clientY + n,
        left: e.clientX - t
    };
}
function $d03ea1a53b0cd3b8$var$P(e, t) {
    return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function $d03ea1a53b0cd3b8$export$73224eeef4bbe873({ disabled: e = !1 } = {}) {
    let t = (0, $c56K2.useRef)(null), [n, l] = (0, $c56K2.useState)(!1), r = (0, $3517a9b6093b86b1$export$fd183955ff4b45d9)(), o = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        t.current = null, l(!1), r.dispose();
    }), f = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((s)=>{
        if (r.dispose(), t.current === null) {
            t.current = s.currentTarget, l(!0);
            {
                let i = (0, $874591f6f1a15c7a$export$b204af158042fbac)(s.currentTarget);
                r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", (c)=>{
                    if (t.current) {
                        let p = $d03ea1a53b0cd3b8$var$E(c);
                        l($d03ea1a53b0cd3b8$var$P(p, t.current.getBoundingClientRect()));
                    }
                }, !1), r.addEventListener(i, "pointercancel", o, !1);
            }
        }
    });
    return {
        pressed: n,
        pressProps: e ? {} : {
            onPointerDown: f,
            onPointerUp: o,
            onClick: o
        }
    };
}




var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");
function $e45a94ef65e2bafd$export$53652b2b272efe9c(t, u) {
    return (0, $c56K2.useMemo)(()=>{
        var n;
        if (t.type) return t.type;
        let r = (n = t.as) != null ? n : "button";
        if (typeof r == "string" && r.toLowerCase() === "button" || (u == null ? void 0 : u.tagName) === "BUTTON" && !u.hasAttribute("type")) return "button";
    }, [
        t.type,
        t.as,
        u
    ]);
}








function $6fa4d41e8d55539a$export$db61f031a278447c(l) {
    let e = l.parentElement, t = null;
    for(; e && !$72273189d405b787$export$224ee1e631187c8e(e);)$72273189d405b787$export$b5145d164c8e27ab(e) && (t = e), e = e.parentElement;
    let i = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return i && $6fa4d41e8d55539a$var$r(t) ? !1 : i;
}
function $6fa4d41e8d55539a$var$r(l) {
    if (!l) return !1;
    let e = l.previousElementSibling;
    for(; e !== null;){
        if ($72273189d405b787$export$b5145d164c8e27ab(e)) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}







var $c56K2 = parcelRequire("c56K2");
var $e89fdc586db8a6d7$var$t;
let $e89fdc586db8a6d7$export$7568632d0d33d16d = ($e89fdc586db8a6d7$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).startTransition) != null ? $e89fdc586db8a6d7$var$t : function(i) {
    i();
};



"use client";
var $af1524c7fad304d2$var$me = ((l)=>(l[l.Open = 0] = "Open", l[l.Closed = 1] = "Closed", l))($af1524c7fad304d2$var$me || {}), $af1524c7fad304d2$var$fe = ((n)=>(n[n.ToggleDisclosure = 0] = "ToggleDisclosure", n[n.CloseDisclosure = 1] = "CloseDisclosure", n[n.SetButtonId = 2] = "SetButtonId", n[n.SetPanelId = 3] = "SetPanelId", n[n.SetButtonElement = 4] = "SetButtonElement", n[n.SetPanelElement = 5] = "SetPanelElement", n))($af1524c7fad304d2$var$fe || {});
let $af1524c7fad304d2$var$De = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [2] (e, t) {
        return e.buttonId === t.buttonId ? e : {
            ...e,
            buttonId: t.buttonId
        };
    },
    [3] (e, t) {
        return e.panelId === t.panelId ? e : {
            ...e,
            panelId: t.panelId
        };
    },
    [4] (e, t) {
        return e.buttonElement === t.element ? e : {
            ...e,
            buttonElement: t.element
        };
    },
    [5] (e, t) {
        return e.panelElement === t.element ? e : {
            ...e,
            panelElement: t.element
        };
    }
}, $af1524c7fad304d2$var$_ = (0, $c56K2.createContext)(null);
$af1524c7fad304d2$var$_.displayName = "DisclosureContext";
function $af1524c7fad304d2$var$M(e) {
    let t = (0, $c56K2.useContext)($af1524c7fad304d2$var$_);
    if (t === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $af1524c7fad304d2$var$M), l;
    }
    return t;
}
let $af1524c7fad304d2$var$F = (0, $c56K2.createContext)(null);
$af1524c7fad304d2$var$F.displayName = "DisclosureAPIContext";
function $af1524c7fad304d2$var$V(e) {
    let t = (0, $c56K2.useContext)($af1524c7fad304d2$var$F);
    if (t === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $af1524c7fad304d2$var$V), l;
    }
    return t;
}
let $af1524c7fad304d2$var$H = (0, $c56K2.createContext)(null);
$af1524c7fad304d2$var$H.displayName = "DisclosurePanelContext";
function $af1524c7fad304d2$var$ye() {
    return (0, $c56K2.useContext)($af1524c7fad304d2$var$H);
}
function $af1524c7fad304d2$var$Pe(e, t) {
    return (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(t.type, $af1524c7fad304d2$var$De, e, t);
}
let $af1524c7fad304d2$var$Ee = (0, $c56K2.Fragment);
function $af1524c7fad304d2$var$Se(e, t) {
    let { defaultOpen: l = !1, ...p } = e, a = (0, $c56K2.useRef)(null), c = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(t, (0, $a67d248eafae96c4$export$7029785b750eb74)((u)=>{
        a.current = u;
    }, e.as === void 0 || (0, $bc193d85907afa60$export$9522e17588c12572)(e.as))), n = (0, $c56K2.useReducer)($af1524c7fad304d2$var$Pe, {
        disclosureState: l ? 0 : 1,
        buttonElement: null,
        panelElement: null,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: o, buttonId: r }, f] = n, s = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((u)=>{
        f({
            type: 1
        });
        let m = (0, $874591f6f1a15c7a$export$b204af158042fbac)(a.current);
        if (!m || !r) return;
        let d = (()=>u ? $72273189d405b787$export$79c619c6018bbb44(u) ? u : "current" in u && $72273189d405b787$export$79c619c6018bbb44(u.current) ? u.current : m.getElementById(r) : m.getElementById(r))();
        d == null || d.focus();
    }), E = (0, $c56K2.useMemo)(()=>({
            close: s
        }), [
        s
    ]), T = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: o === 0,
        close: s
    }), D = {
        ref: c
    }, S = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($af1524c7fad304d2$var$_.Provider, {
        value: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($af1524c7fad304d2$var$F.Provider, {
        value: E
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $b7b29e70ac6b2beb$export$dd2a80b78bebbe1d), {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $081f425c3e48d631$export$2a0ed818b175f558), {
        value: (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(o, {
            [0]: (0, $081f425c3e48d631$export$7254cc27399e90bd).Open,
            [1]: (0, $081f425c3e48d631$export$7254cc27399e90bd).Closed
        })
    }, S({
        ourProps: D,
        theirProps: p,
        slot: T,
        defaultTag: $af1524c7fad304d2$var$Ee,
        name: "Disclosure"
    })))));
}
let $af1524c7fad304d2$var$ge = "button";
function $af1524c7fad304d2$var$Ae(e, t) {
    let l = (0, $c56K2.useId)(), { id: p = `headlessui-disclosure-button-${l}`, disabled: a = !1, autoFocus: c = !1, ...n } = e, [o, r] = $af1524c7fad304d2$var$M("Disclosure.Button"), f = $af1524c7fad304d2$var$ye(), s = f === null ? !1 : f === o.panelId, E = (0, $c56K2.useRef)(null), T = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(E, t, (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>{
        if (!s) return r({
            type: 4,
            element: i
        });
    }));
    (0, $c56K2.useEffect)(()=>{
        if (!s) return r({
            type: 2,
            buttonId: p
        }), ()=>{
            r({
                type: 2,
                buttonId: null
            });
        };
    }, [
        p,
        r,
        s
    ]);
    let D = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>{
        var g;
        if (s) {
            if (o.disclosureState === 1) return;
            switch(i.key){
                case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space:
                case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Enter:
                    i.preventDefault(), i.stopPropagation(), r({
                        type: 0
                    }), (g = o.buttonElement) == null || g.focus();
                    break;
            }
        } else switch(i.key){
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space:
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Enter:
                i.preventDefault(), i.stopPropagation(), r({
                    type: 0
                });
                break;
        }
    }), S = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>{
        switch(i.key){
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space:
                i.preventDefault();
                break;
        }
    }), u = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>{
        var g;
        (0, $6fa4d41e8d55539a$export$db61f031a278447c)(i.currentTarget) || a || (s ? (r({
            type: 0
        }), (g = o.buttonElement) == null || g.focus()) : r({
            type: 0
        }));
    }), { isFocusVisible: m, focusProps: d } = (0, $c6173221ab826b78$export$4e328f61c538687f)({
        autoFocus: c
    }), { isHovered: C, hoverProps: h } = (0, $207f2e029c99ee9c$export$ae780daf29e6d456)({
        isDisabled: a
    }), { pressed: $, pressProps: U } = (0, $d03ea1a53b0cd3b8$export$73224eeef4bbe873)({
        disabled: a
    }), J = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: o.disclosureState === 0,
        hover: C,
        active: $,
        disabled: a,
        focus: m,
        autofocus: c
    }), G = (0, $e45a94ef65e2bafd$export$53652b2b272efe9c)(e, o.buttonElement), X = s ? (0, $bc193d85907afa60$export$9d1611c77c2fe928)({
        ref: T,
        type: G,
        disabled: a || void 0,
        autoFocus: c,
        onKeyDown: D,
        onClick: u
    }, d, h, U) : (0, $bc193d85907afa60$export$9d1611c77c2fe928)({
        ref: T,
        id: p,
        type: G,
        "aria-expanded": o.disclosureState === 0,
        "aria-controls": o.panelElement ? o.panelId : void 0,
        disabled: a || void 0,
        autoFocus: c,
        onKeyDown: D,
        onKeyUp: S,
        onClick: u
    }, d, h, U);
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: X,
        theirProps: n,
        slot: J,
        defaultTag: $af1524c7fad304d2$var$ge,
        name: "Disclosure.Button"
    });
}
let $af1524c7fad304d2$var$be = "div", $af1524c7fad304d2$var$Ce = (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).RenderStrategy | (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).Static;
function $af1524c7fad304d2$var$Re(e, t) {
    let l = (0, $c56K2.useId)(), { id: p = `headlessui-disclosure-panel-${l}`, transition: a = !1, ...c } = e, [n, o] = $af1524c7fad304d2$var$M("Disclosure.Panel"), { close: r } = $af1524c7fad304d2$var$V("Disclosure.Panel"), [f, s] = (0, $c56K2.useState)(null), E = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(t, (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((C)=>{
        (0, $e89fdc586db8a6d7$export$7568632d0d33d16d)(()=>o({
                type: 5,
                element: C
            }));
    }), s);
    (0, $c56K2.useEffect)(()=>(o({
            type: 3,
            panelId: p
        }), ()=>{
            o({
                type: 3,
                panelId: null
            });
        }), [
        p,
        o
    ]);
    let T = (0, $081f425c3e48d631$export$fc6fdf0ecf360e)(), [D, S] = (0, $2f3cfd664d133d0e$export$7b286972b8d8ccbf)(a, f, T !== null ? (T & (0, $081f425c3e48d631$export$7254cc27399e90bd).Open) === (0, $081f425c3e48d631$export$7254cc27399e90bd).Open : n.disclosureState === 0), u = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: n.disclosureState === 0,
        close: r
    }), m = {
        ref: E,
        id: p,
        ...(0, $2f3cfd664d133d0e$export$c291d481c40a2fc3)(S)
    }, d = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $081f425c3e48d631$export$6748feed729c7cf3), null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($af1524c7fad304d2$var$H.Provider, {
        value: n.panelId
    }, d({
        ourProps: m,
        theirProps: c,
        slot: u,
        defaultTag: $af1524c7fad304d2$var$be,
        features: $af1524c7fad304d2$var$Ce,
        visible: D,
        name: "Disclosure.Panel"
    })));
}
let $af1524c7fad304d2$var$Ie = (0, $bc193d85907afa60$export$e43f39796049410c)($af1524c7fad304d2$var$Se), $af1524c7fad304d2$export$4edbb1575344e6fc = (0, $bc193d85907afa60$export$e43f39796049410c)($af1524c7fad304d2$var$Ae), $af1524c7fad304d2$export$feabaa331e1d464c = (0, $bc193d85907afa60$export$e43f39796049410c)($af1524c7fad304d2$var$Re), $af1524c7fad304d2$export$74a362b31437ec83 = Object.assign($af1524c7fad304d2$var$Ie, {
    Button: $af1524c7fad304d2$export$4edbb1575344e6fc,
    Panel: $af1524c7fad304d2$export$feabaa331e1d464c
});



var $c56K2 = parcelRequire("c56K2");





var $c56K2 = parcelRequire("c56K2");



var $c56K2 = parcelRequire("c56K2");






var $c56K2 = parcelRequire("c56K2");


function $c070bf39ce02b860$export$d700fc5421f49f8f({ onFocus: n }) {
    let [r, o] = (0, $c56K2.useState)(!0), u = (0, $3b411db186b904b8$export$80c2a3957bcb42ea)();
    return r ? (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $e4c31d8a11c9202b$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        features: (0, $e4c31d8a11c9202b$export$4e7f8864c6a16d8a).Focusable,
        onFocus: (a)=>{
            a.preventDefault();
            let e, i = 50;
            function t() {
                if (i-- <= 0) {
                    e && cancelAnimationFrame(e);
                    return;
                }
                if (n()) {
                    if (cancelAnimationFrame(e), !u.current) return;
                    o(!1);
                    return;
                }
                e = requestAnimationFrame(t);
            }
            e = requestAnimationFrame(t);
        }
    }) : null;
}









var $c56K2 = parcelRequire("c56K2");
const $75a4dda183d27675$var$s = $c56K2.createContext(null);
function $75a4dda183d27675$var$a() {
    return {
        groups: new Map,
        get (o, e) {
            var i;
            let t = this.groups.get(o);
            t || (t = new Map, this.groups.set(o, t));
            let n = (i = t.get(e)) != null ? i : 0;
            t.set(e, n + 1);
            let r = Array.from(t.keys()).indexOf(e);
            function u() {
                let c = t.get(e);
                c > 1 ? t.set(e, c - 1) : t.delete(e);
            }
            return [
                r,
                u
            ];
        }
    };
}
function $75a4dda183d27675$export$a9f7b2abf715ece3({ children: o }) {
    let e = $c56K2.useRef($75a4dda183d27675$var$a());
    return $c56K2.createElement($75a4dda183d27675$var$s.Provider, {
        value: e
    }, o);
}
function $75a4dda183d27675$export$4fba99d3e9fca1f0(o) {
    let e = $c56K2.useContext($75a4dda183d27675$var$s);
    if (!e) throw new Error("You must wrap your component in a <StableCollection>");
    let t = $c56K2.useId(), [n, r] = e.current.get(o, t);
    return $c56K2.useEffect(()=>r, []), n;
}



"use client";
var $c0df5d1e196685e0$var$Le = ((t)=>(t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))($c0df5d1e196685e0$var$Le || {}), $c0df5d1e196685e0$var$_e = ((l)=>(l[l.Less = -1] = "Less", l[l.Equal = 0] = "Equal", l[l.Greater = 1] = "Greater", l))($c0df5d1e196685e0$var$_e || {}), $c0df5d1e196685e0$var$Se = ((n)=>(n[n.SetSelectedIndex = 0] = "SetSelectedIndex", n[n.RegisterTab = 1] = "RegisterTab", n[n.UnregisterTab = 2] = "UnregisterTab", n[n.RegisterPanel = 3] = "RegisterPanel", n[n.UnregisterPanel = 4] = "UnregisterPanel", n))($c0df5d1e196685e0$var$Se || {});
let $c0df5d1e196685e0$var$De = {
    [0] (e, r) {
        var d;
        let t = (0, $fe570d29719c408c$export$20305e96f91bf103)(e.tabs, (u)=>u.current), l = (0, $fe570d29719c408c$export$20305e96f91bf103)(e.panels, (u)=>u.current), a = t.filter((u)=>{
            var T;
            return !((T = u.current) != null && T.hasAttribute("disabled"));
        }), n = {
            ...e,
            tabs: t,
            panels: l
        };
        if (r.index < 0 || r.index > t.length - 1) {
            let u = (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(Math.sign(r.index - e.selectedIndex), {
                [-1]: ()=>1,
                [0]: ()=>(0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(Math.sign(r.index), {
                        [-1]: ()=>0,
                        [0]: ()=>0,
                        [1]: ()=>1
                    }),
                [1]: ()=>0
            });
            if (a.length === 0) return n;
            let T = (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(u, {
                [0]: ()=>t.indexOf(a[0]),
                [1]: ()=>t.indexOf(a[a.length - 1])
            });
            return {
                ...n,
                selectedIndex: T === -1 ? e.selectedIndex : T
            };
        }
        let s = t.slice(0, r.index), f = [
            ...t.slice(r.index),
            ...s
        ].find((u)=>a.includes(u));
        if (!f) return n;
        let b = (d = t.indexOf(f)) != null ? d : e.selectedIndex;
        return b === -1 && (b = e.selectedIndex), {
            ...n,
            selectedIndex: b
        };
    },
    [1] (e, r) {
        if (e.tabs.includes(r.tab)) return e;
        let t = e.tabs[e.selectedIndex], l = (0, $fe570d29719c408c$export$20305e96f91bf103)([
            ...e.tabs,
            r.tab
        ], (n)=>n.current), a = e.selectedIndex;
        return e.info.current.isControlled || (a = l.indexOf(t), a === -1 && (a = e.selectedIndex)), {
            ...e,
            tabs: l,
            selectedIndex: a
        };
    },
    [2] (e, r) {
        return {
            ...e,
            tabs: e.tabs.filter((t)=>t !== r.tab)
        };
    },
    [3] (e, r) {
        return e.panels.includes(r.panel) ? e : {
            ...e,
            panels: (0, $fe570d29719c408c$export$20305e96f91bf103)([
                ...e.panels,
                r.panel
            ], (t)=>t.current)
        };
    },
    [4] (e, r) {
        return {
            ...e,
            panels: e.panels.filter((t)=>t !== r.panel)
        };
    }
}, $c0df5d1e196685e0$var$z = (0, $c56K2.createContext)(null);
$c0df5d1e196685e0$var$z.displayName = "TabsDataContext";
function $c0df5d1e196685e0$var$h(e) {
    let r = (0, $c56K2.useContext)($c0df5d1e196685e0$var$z);
    if (r === null) {
        let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $c0df5d1e196685e0$var$h), t;
    }
    return r;
}
let $c0df5d1e196685e0$var$V = (0, $c56K2.createContext)(null);
$c0df5d1e196685e0$var$V.displayName = "TabsActionsContext";
function $c0df5d1e196685e0$var$Q(e) {
    let r = (0, $c56K2.useContext)($c0df5d1e196685e0$var$V);
    if (r === null) {
        let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $c0df5d1e196685e0$var$Q), t;
    }
    return r;
}
function $c0df5d1e196685e0$var$Fe(e, r) {
    return (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(r.type, $c0df5d1e196685e0$var$De, e, r);
}
let $c0df5d1e196685e0$var$Ie = "div";
function $c0df5d1e196685e0$var$he(e, r) {
    let { defaultIndex: t = 0, vertical: l = !1, manual: a = !1, onChange: n, selectedIndex: s = null, ...g } = e;
    const f = l ? "vertical" : "horizontal", b = a ? "manual" : "auto";
    let d = s !== null, u = (0, $a51df5cf480cb374$export$86c4283a11f23f95)({
        isControlled: d
    }), T = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(r), [p, c] = (0, $c56K2.useReducer)($c0df5d1e196685e0$var$Fe, {
        info: u,
        selectedIndex: s != null ? s : t,
        tabs: [],
        panels: []
    }), v = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        selectedIndex: p.selectedIndex
    }), m = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(n || (()=>{})), C = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(p.tabs), D = (0, $c56K2.useMemo)(()=>({
            orientation: f,
            activation: b,
            ...p
        }), [
        f,
        b,
        p
    ]), P = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>(c({
            type: 1,
            tab: i
        }), ()=>c({
                type: 2,
                tab: i
            }))), R = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>(c({
            type: 3,
            panel: i
        }), ()=>c({
                type: 4,
                panel: i
            }))), A = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>{
        L.current !== i && m.current(i), d || c({
            type: 0,
            index: i
        });
    }), L = (0, $a51df5cf480cb374$export$86c4283a11f23f95)(d ? e.selectedIndex : p.selectedIndex), _ = (0, $c56K2.useMemo)(()=>({
            registerTab: P,
            registerPanel: R,
            change: A
        }), []);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        c({
            type: 0,
            index: s != null ? s : t
        });
    }, [
        s
    ]), (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (L.current === void 0 || p.tabs.length <= 0) return;
        let i = (0, $fe570d29719c408c$export$20305e96f91bf103)(p.tabs, (S)=>S.current);
        i.some((S, $)=>p.tabs[$] !== S) && A(i.indexOf(p.tabs[L.current]));
    });
    let J = {
        ref: T
    }, X = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $75a4dda183d27675$export$a9f7b2abf715ece3), null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($c0df5d1e196685e0$var$V.Provider, {
        value: _
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($c0df5d1e196685e0$var$z.Provider, {
        value: D
    }, D.tabs.length <= 0 && (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $c070bf39ce02b860$export$d700fc5421f49f8f), {
        onFocus: ()=>{
            var i, M;
            for (let S of C.current)if (((i = S.current) == null ? void 0 : i.tabIndex) === 0) return (M = S.current) == null || M.focus(), !0;
            return !1;
        }
    }), X({
        ourProps: J,
        theirProps: g,
        slot: v,
        defaultTag: $c0df5d1e196685e0$var$Ie,
        name: "Tabs"
    }))));
}
let $c0df5d1e196685e0$var$ve = "div";
function $c0df5d1e196685e0$var$Ce(e, r) {
    let { orientation: t, selectedIndex: l } = $c0df5d1e196685e0$var$h("Tab.List"), a = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(r), n = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        selectedIndex: l
    }), s = e, g = {
        ref: a,
        role: "tablist",
        "aria-orientation": t
    };
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: g,
        theirProps: s,
        slot: n,
        defaultTag: $c0df5d1e196685e0$var$ve,
        name: "Tabs.List"
    });
}
let $c0df5d1e196685e0$var$Me = "button";
function $c0df5d1e196685e0$var$Ge(e, r) {
    var Y, Z;
    let t = (0, $c56K2.useId)(), { id: l = `headlessui-tabs-tab-${t}`, disabled: a = !1, autoFocus: n = !1, ...s } = e, { orientation: g, activation: f, selectedIndex: b, tabs: d, panels: u } = $c0df5d1e196685e0$var$h("Tab"), T = $c0df5d1e196685e0$var$Q("Tab"), p = $c0df5d1e196685e0$var$h("Tab"), [c, v] = (0, $c56K2.useState)(null), m = (0, $c56K2.useRef)(null), C = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(m, r, v);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>T.registerTab(m), [
        T,
        m
    ]);
    let D = (0, $75a4dda183d27675$export$4fba99d3e9fca1f0)("tabs"), P = d.indexOf(m);
    P === -1 && (P = D);
    let R = P === b, A = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((o)=>{
        let E = o();
        if (E === (0, $fe570d29719c408c$export$abf286375dfa6dbd).Success && f === "auto") {
            let ee = (0, $874591f6f1a15c7a$export$cd4e5573fbe2b576)(m.current), B = p.tabs.findIndex((ce)=>ce.current === ee);
            B !== -1 && T.change(B);
        }
        return E;
    }), L = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((o)=>{
        let E = d.map((B)=>B.current).filter(Boolean);
        if (o.key === (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space || o.key === (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Enter) {
            o.preventDefault(), o.stopPropagation(), T.change(P);
            return;
        }
        switch(o.key){
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Home:
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).PageUp:
                return o.preventDefault(), o.stopPropagation(), A(()=>(0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).First));
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).End:
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).PageDown:
                return o.preventDefault(), o.stopPropagation(), A(()=>(0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).Last));
        }
        if (A(()=>(0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(g, {
                vertical () {
                    return o.key === (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowUp ? (0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).Previous | (0, $fe570d29719c408c$export$807a7eae502106e7).WrapAround) : o.key === (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowDown ? (0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).Next | (0, $fe570d29719c408c$export$807a7eae502106e7).WrapAround) : (0, $fe570d29719c408c$export$abf286375dfa6dbd).Error;
                },
                horizontal () {
                    return o.key === (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowLeft ? (0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).Previous | (0, $fe570d29719c408c$export$807a7eae502106e7).WrapAround) : o.key === (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowRight ? (0, $fe570d29719c408c$export$82e1f4f412218a1d)(E, (0, $fe570d29719c408c$export$807a7eae502106e7).Next | (0, $fe570d29719c408c$export$807a7eae502106e7).WrapAround) : (0, $fe570d29719c408c$export$abf286375dfa6dbd).Error;
                }
            })) === (0, $fe570d29719c408c$export$abf286375dfa6dbd).Success) return o.preventDefault();
    }), _ = (0, $c56K2.useRef)(!1), J = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        var o;
        _.current || (_.current = !0, (o = m.current) == null || o.focus({
            preventScroll: !0
        }), T.change(P), (0, $5f6a10e3018e6fa4$export$a5ff0d6a738703ca)(()=>{
            _.current = !1;
        }));
    }), X = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((o)=>{
        o.preventDefault();
    }), { isFocusVisible: i, focusProps: M } = (0, $c6173221ab826b78$export$4e328f61c538687f)({
        autoFocus: n
    }), { isHovered: S, hoverProps: $ } = (0, $207f2e029c99ee9c$export$ae780daf29e6d456)({
        isDisabled: a
    }), { pressed: pe, pressProps: ue } = (0, $d03ea1a53b0cd3b8$export$73224eeef4bbe873)({
        disabled: a
    }), Te = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        selected: R,
        hover: S,
        active: pe,
        focus: i,
        autofocus: n,
        disabled: a
    }), de = (0, $bc193d85907afa60$export$9d1611c77c2fe928)({
        ref: C,
        onKeyDown: L,
        onMouseDown: X,
        onClick: J,
        id: l,
        role: "tab",
        type: (0, $e45a94ef65e2bafd$export$53652b2b272efe9c)(e, c),
        "aria-controls": (Z = (Y = u[P]) == null ? void 0 : Y.current) == null ? void 0 : Z.id,
        "aria-selected": R,
        tabIndex: R ? 0 : -1,
        disabled: a || void 0,
        autoFocus: n
    }, M, $, ue);
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: de,
        theirProps: s,
        slot: Te,
        defaultTag: $c0df5d1e196685e0$var$Me,
        name: "Tabs.Tab"
    });
}
let $c0df5d1e196685e0$var$Ue = "div";
function $c0df5d1e196685e0$var$He(e, r) {
    let { selectedIndex: t } = $c0df5d1e196685e0$var$h("Tab.Panels"), l = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(r), a = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        selectedIndex: t
    }), n = e, s = {
        ref: l
    };
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: s,
        theirProps: n,
        slot: a,
        defaultTag: $c0df5d1e196685e0$var$Ue,
        name: "Tabs.Panels"
    });
}
let $c0df5d1e196685e0$var$we = "div", $c0df5d1e196685e0$var$Oe = (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).RenderStrategy | (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).Static;
function $c0df5d1e196685e0$var$Ne(e, r) {
    var R, A, L, _;
    let t = (0, $c56K2.useId)(), { id: l = `headlessui-tabs-panel-${t}`, tabIndex: a = 0, ...n } = e, { selectedIndex: s, tabs: g, panels: f } = $c0df5d1e196685e0$var$h("Tab.Panel"), b = $c0df5d1e196685e0$var$Q("Tab.Panel"), d = (0, $c56K2.useRef)(null), u = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(d, r);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>b.registerPanel(d), [
        b,
        d
    ]);
    let T = (0, $75a4dda183d27675$export$4fba99d3e9fca1f0)("panels"), p = f.indexOf(d);
    p === -1 && (p = T);
    let c = p === s, { isFocusVisible: v, focusProps: m } = (0, $c6173221ab826b78$export$4e328f61c538687f)(), C = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        selected: c,
        focus: v
    }), D = (0, $bc193d85907afa60$export$9d1611c77c2fe928)({
        ref: u,
        id: l,
        role: "tabpanel",
        "aria-labelledby": (A = (R = g[p]) == null ? void 0 : R.current) == null ? void 0 : A.id,
        tabIndex: c ? a : -1
    }, m), P = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return !c && ((L = n.unmount) == null || L) && !((_ = n.static) != null && _) ? (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $e4c31d8a11c9202b$export$8dc98ba7eadeaa56), {
        "aria-hidden": "true",
        ...D
    }) : P({
        ourProps: D,
        theirProps: n,
        slot: C,
        defaultTag: $c0df5d1e196685e0$var$we,
        features: $c0df5d1e196685e0$var$Oe,
        visible: c,
        name: "Tabs.Panel"
    });
}
let $c0df5d1e196685e0$var$ke = (0, $bc193d85907afa60$export$e43f39796049410c)($c0df5d1e196685e0$var$Ge), $c0df5d1e196685e0$export$85fd4ed3b8ca1010 = (0, $bc193d85907afa60$export$e43f39796049410c)($c0df5d1e196685e0$var$he), $c0df5d1e196685e0$export$e51a686c67fdaa2d = (0, $bc193d85907afa60$export$e43f39796049410c)($c0df5d1e196685e0$var$Ce), $c0df5d1e196685e0$export$5dae8d435677f210 = (0, $bc193d85907afa60$export$e43f39796049410c)($c0df5d1e196685e0$var$He), $c0df5d1e196685e0$export$3d96ec278d3efce4 = (0, $bc193d85907afa60$export$e43f39796049410c)($c0df5d1e196685e0$var$Ne), $c0df5d1e196685e0$export$3e41faf802a29e71 = Object.assign($c0df5d1e196685e0$var$ke, {
    Group: $c0df5d1e196685e0$export$85fd4ed3b8ca1010,
    List: $c0df5d1e196685e0$export$e51a686c67fdaa2d,
    Panels: $c0df5d1e196685e0$export$5dae8d435677f210,
    Panel: $c0df5d1e196685e0$export$3d96ec278d3efce4
});



var $c56K2 = parcelRequire("c56K2");

function $368fefc0ded317e5$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}



const $e5b2c9701f9dd6a8$var$Chapters = ({ chapters: chapters, link: link, bookButton: bookButton, title: title })=>{
    const { setLastOpenDisclosure: setLastOpenDisclosure, lastOpenDisclosure: lastOpenDisclosure, closeRef: closeRef } = (0, $c56K2.useContext)((0, $e55f5946e67ab9f3$export$d665dd135a51b28a));
    const lastChapter = (0, $c56K2.useRef)(null);
    (0, $c56K2.useLayoutEffect)(()=>{
        if (lastOpenDisclosure != bookButton) {
            lastOpenDisclosure?.click();
            if (bookButton?.ariaExpanded) setLastOpenDisclosure(bookButton);
            if (closeRef.current) closeRef.current(bookButton ?? undefined);
        }
        if (title === "Pw\xe4r\xe4t\xe4") setTimeout(()=>{
            lastChapter.current?.scrollIntoView({
                block: "end",
                behavior: "smooth"
            });
        }, 200);
    }, []);
    (0, $c56K2.useEffect)(()=>{
        if (!bookButton) return;
        if (title !== "Pw\xe4r\xe4t\xe4") bookButton.scrollIntoView({
            block: "nearest",
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$85fd4ed3b8ca1010), {
        as: "div",
        manual: true,
        onChange: (index)=>{
            // @ts-expect-error not sure how to type this
            window.location = index === 0 ? link : `${link}#ch-${index + 1}`;
        },
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$e51a686c67fdaa2d), {
            className: "grid grid-cols-5 px-2",
            children: Array(chapters).fill(null).map((_, i)=>/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$3e41faf802a29e71), {
                    as: "a",
                    href: i === 0 ? link : `${link}#ch-${i + 1}`,
                    className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)((0, $f48e7b6bfa5bf082$export$350fefbea921a78a), "flex h-12 items-center justify-center font-normal", "text-center text-xl focus-visible:ring-2 focus-visible:ring-inset"),
                    ref: chapters === i + 1 ? lastChapter : undefined,
                    children: i + 1
                }, `chapter-${i + 1}`))
        })
    });
};
var $e5b2c9701f9dd6a8$export$2e2bcd8739ae039 = $e5b2c9701f9dd6a8$var$Chapters;




const $a472d5ef01007e98$var$getRows = (chapters)=>{
    const cols = 5;
    const rows = Math.ceil(chapters / cols);
    return rows;
};
const $a472d5ef01007e98$var$Book = ({ title: title, link: link, chapters: chapters })=>{
    const ref = (0, $c56K2.useRef)(null);
    const { setLastOpenDisclosure: setLastOpenDisclosure, closeRef: closeRef } = (0, $c56K2.useContext)((0, $e55f5946e67ab9f3$export$d665dd135a51b28a));
    const rows = $a472d5ef01007e98$var$getRows(chapters);
    (0, $c56K2.useEffect)(()=>{
        if (ref.current) {
            if (ref.current.ariaExpanded === "true") setLastOpenDisclosure(ref.current);
        }
    }, []);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $af1524c7fad304d2$export$74a362b31437ec83), {
        as: "div",
        children: ({ open: open, close: close })=>/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $782cc9fb2a36dc63$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $af1524c7fad304d2$export$4edbb1575344e6fc), {
                        className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)(open ? "bg-slate-100" : "", (0, $f48e7b6bfa5bf082$export$350fefbea921a78a), "h-10 w-full cursor-pointer px-5 text-center text-xl text-sky-700", "focus-visible:ring-2 focus-visible:ring-inset"),
                        ref: ref,
                        onClick: ()=>{
                            if (open) // cache the currently open book's `close` action
                            closeRef.current = close;
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$be58926105124dd4), {
                        show: open,
                        as: "div",
                        className: "overflow-hidden",
                        enter: "transition transition-[max-height] duration-500 linear",
                        enterFrom: "transform max-h-0",
                        enterTo: `transform max-h-[--chapter-row-height]`,
                        leave: "transition transition-[max-height] duration-200 ease-out",
                        leaveFrom: `transform max-h-[--chapter-row-height]`,
                        leaveTo: "transform max-h-0",
                        style: {
                            ["--rows"]: rows,
                            ["--chapter-row-height"]: "calc(3rem * var(--rows) * 2)"
                        },
                        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $af1524c7fad304d2$export$feabaa331e1d464c), {
                            className: "border-b",
                            static: true,
                            children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $e5b2c9701f9dd6a8$export$2e2bcd8739ae039), {
                                chapters: chapters,
                                link: link,
                                title: title,
                                bookButton: ref.current
                            })
                        })
                    })
                ]
            })
    });
};
var $a472d5ef01007e98$export$2e2bcd8739ae039 = $a472d5ef01007e98$var$Book;



const $ab2ea9beb98d9064$export$114d6b2480ce204d = [
    {
        title: "Genesis",
        link: "Genesis.html",
        chapters: 50
    },
    {
        title: "Exodus",
        link: "Exodus.html",
        chapters: 40
    },
    {
        title: "Leviticus",
        link: "Leviticus.html",
        chapters: 27
    },
    {
        title: "Numbers",
        link: "Numbers.html",
        chapters: 36
    },
    {
        title: "Deuteronomy",
        link: "Deuteronomy.html",
        chapters: 34
    },
    {
        title: "Joshua",
        link: "Joshua.html",
        chapters: 24
    },
    {
        title: "Sou K\xf6pw\xfcng",
        link: "Sou%20Kopwung.html",
        chapters: 21
    },
    {
        title: "Ruth",
        link: "Ruth.html",
        chapters: 4
    },
    {
        title: "1 Samuel",
        link: "1%20Samuel.html",
        chapters: 31
    },
    {
        title: "2 Samuel",
        link: "2%20Samuel.html",
        chapters: 24
    },
    {
        title: "1 King",
        link: "1%20King.html",
        chapters: 22
    },
    {
        title: "2 King",
        link: "2%20King.html",
        chapters: 25
    },
    {
        title: "1 Kronika",
        link: "1%20Kronika.html",
        chapters: 29
    },
    {
        title: "2 Kronika",
        link: "2%20Kronika.html",
        chapters: 36
    },
    {
        title: "Ezra",
        link: "Ezra.html",
        chapters: 10
    },
    {
        title: "Nehemiah",
        link: "Nehemiah.html",
        chapters: 13
    },
    {
        title: "Esther",
        link: "Esther.html",
        chapters: 10
    },
    {
        title: "Job",
        link: "Job.html",
        chapters: 42
    },
    {
        title: "K\xf6\xf6lfel",
        link: "Koolfel.html",
        chapters: 150
    },
    {
        title: "Proverbs",
        link: "Proverbs.html",
        chapters: 31
    },
    {
        title: "Ekklesiastes",
        link: "Ekklesiastes.html",
        chapters: 12
    },
    {
        title: "\xc4n Solomon K\xf6\xf6l",
        link: "An%20Solomon%20Kool.html",
        chapters: 8
    },
    {
        title: "Isaiah",
        link: "Isaiah.html",
        chapters: 66
    },
    {
        title: "Jeremiah",
        link: "Jeremiah.html",
        chapters: 52
    },
    {
        title: "K\xf6\xf6l\xfcn Kechiw",
        link: "Koolun%20Kechiw.html",
        chapters: 5
    },
    {
        title: "Ezekiel",
        link: "Ezekiel.html",
        chapters: 48
    },
    {
        title: "Daniel",
        link: "Daniel.html",
        chapters: 12
    },
    {
        title: "Hosea",
        link: "Hosea.html",
        chapters: 14
    },
    {
        title: "Joel",
        link: "Joel.html",
        chapters: 3
    },
    {
        title: "Amos",
        link: "Amos.html",
        chapters: 9
    },
    {
        title: "Obadiah",
        link: "Obadiah.html",
        chapters: 1
    },
    {
        title: "Jonah",
        link: "Jonah.html",
        chapters: 4
    },
    {
        title: "Mika",
        link: "Mika.html",
        chapters: 7
    },
    {
        title: "Nahum",
        link: "Nahum.html",
        chapters: 3
    },
    {
        title: "Habakkuk",
        link: "Habakkuk.html",
        chapters: 3
    },
    {
        title: "Zefaniah",
        link: "Zefaniah.html",
        chapters: 3
    },
    {
        title: "Hakkai",
        link: "Hakkai.html",
        chapters: 2
    },
    {
        title: "Zekariah",
        link: "Zekariah.html",
        chapters: 14
    },
    {
        title: "Malakai",
        link: "Malakai.html",
        chapters: 4
    }
];
const $ab2ea9beb98d9064$export$28ed20359ee41c58 = [
    {
        title: "Matthew",
        link: "Matthew.html",
        chapters: 28
    },
    {
        title: "Mark",
        link: "Mark.html",
        chapters: 16
    },
    {
        title: "Luke",
        link: "Luke.html",
        chapters: 24
    },
    {
        title: "John",
        link: "John.html",
        chapters: 21
    },
    {
        title: "F\xf6ff\xf6r",
        link: "Foffor.html",
        chapters: 28
    },
    {
        title: "Rom",
        link: "Rom.html",
        chapters: 16
    },
    {
        title: "1 Korint",
        link: "1%20Korint.html",
        chapters: 16
    },
    {
        title: "2 Korint",
        link: "2%20Korint.html",
        chapters: 13
    },
    {
        title: "Kalatia",
        link: "Kalatia.html",
        chapters: 6
    },
    {
        title: "Efisos",
        link: "Efisos.html",
        chapters: 6
    },
    {
        title: "Filipai",
        link: "Filipai.html",
        chapters: 4
    },
    {
        title: "Kolose",
        link: "Kolose.html",
        chapters: 4
    },
    {
        title: "1 Tessalonika",
        link: "1%20Tessalonika.html",
        chapters: 5
    },
    {
        title: "2 Tessalonika",
        link: "2%20Tessalonika.html",
        chapters: 3
    },
    {
        title: "1 Timothy",
        link: "1%20Timothy.html",
        chapters: 6
    },
    {
        title: "2 Timothy",
        link: "2%20Timothy.html",
        chapters: 4
    },
    {
        title: "Titus",
        link: "Titus.html",
        chapters: 3
    },
    {
        title: "Filimon",
        link: "Filimon.html",
        chapters: 1
    },
    {
        title: "Hipru",
        link: "Hipru.html",
        chapters: 13
    },
    {
        title: "James",
        link: "James.html",
        chapters: 5
    },
    {
        title: "1 Peter",
        link: "1%20Peter.html",
        chapters: 5
    },
    {
        title: "2 Peter",
        link: "2%20Peter.html",
        chapters: 3
    },
    {
        title: "1 John",
        link: "1%20John.html",
        chapters: 5
    },
    {
        title: "2 John",
        link: "2%20John.html",
        chapters: 1
    },
    {
        title: "3 John",
        link: "3%20John.html",
        chapters: 1
    },
    {
        title: "Jude",
        link: "Jude.html",
        chapters: 1
    },
    {
        title: "Pw\xe4r\xe4t\xe4",
        link: "Pwarata.html",
        chapters: 22
    }
];
const $ab2ea9beb98d9064$export$5a1dbaa3e4449344 = [
    {
        section: [
            ...$ab2ea9beb98d9064$export$114d6b2480ce204d
        ],
        title: "Testamentin L\xf3m"
    },
    {
        section: [
            ...$ab2ea9beb98d9064$export$28ed20359ee41c58
        ],
        title: "Testament S\xf6 F\xf6"
    }
];
const $ab2ea9beb98d9064$var$allBookTitles = [
    ...$ab2ea9beb98d9064$export$114d6b2480ce204d.map((b)=>b.title),
    ...$ab2ea9beb98d9064$export$28ed20359ee41c58.map((b)=>b.title)
];


const $f48e7b6bfa5bf082$export$9c39420b86b46405 = (s)=>s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const $f48e7b6bfa5bf082$export$8e24544ddba725ee = "focus:outline-none focus:ring-sky-500";
const $f48e7b6bfa5bf082$export$350fefbea921a78a = "focus:outline-none focus-visible:ring-sky-500";
const $f48e7b6bfa5bf082$var$Section = ({ title: title, section: section, filter: filter })=>{
    const filtered = (0, $c56K2.useMemo)(()=>section.filter(({ title: title })=>$f48e7b6bfa5bf082$export$9c39420b86b46405(title).includes($f48e7b6bfa5bf082$export$9c39420b86b46405(filter))), [
        section,
        filter
    ]);
    if (filtered.length === 0) return null;
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $782cc9fb2a36dc63$exports.Fragment), {
        children: [
            filtered.length > 0 && title && /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("h3", {
                className: "h-8 text-center font-bold first-of-type:mt-0 last-of-type:mt-5",
                children: title
            }),
            filtered.map((book)=>/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a472d5ef01007e98$export$2e2bcd8739ae039), {
                    ...book
                }, book.title))
        ]
    });
};
// eslint-disable-next-line no-empty-pattern
const $f48e7b6bfa5bf082$var$BookNav = ({}, ref)=>{
    const [filter, setFilter] = (0, $c56K2.useState)("");
    const [scrollUnder, setScrollUnder] = (0, $c56K2.useState)(false);
    const [lastOpenDisclosure, setLastOpenDisclosure] = (0, $c56K2.useState)(null);
    const closeRef = (0, $c56K2.useRef)(null);
    const checkPosition = (0, $c56K2.useCallback)(({ currentTarget: currentTarget })=>{
        setScrollUnder(currentTarget.scrollTop > 0);
    }, []);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $e55f5946e67ab9f3$export$d665dd135a51b28a).Provider, {
        value: {
            setLastOpenDisclosure: setLastOpenDisclosure,
            lastOpenDisclosure: lastOpenDisclosure,
            closeRef: closeRef
        },
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("div", {
            ref: ref,
            className: "flex h-full flex-col",
            children: [
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                    className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("border-b-1 flex justify-stretch border-white -mt-px pb-4 transition-colors px-6 sm:px-8", scrollUnder ? "shadow-[0px_1px_1px_0px_rgba(0,0,0,0.2)]" : "shadow-none"),
                    children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("label", {
                        className: "relative mx-4 block w-full",
                        children: [
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Filter by book"
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("span", {
                                className: "absolute inset-y-0 left-0 flex items-center pl-2",
                                children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $2ac6685d93f5eb7b$export$2e2bcd8739ae039), {
                                    className: "size-5 text-slate-400"
                                })
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("input", {
                                className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("block w-full rounded-2xl border border-slate-300 bg-white", "py-2 pl-9 pr-3 shadow-sm placeholder:italic placeholder:text-slate-400", $f48e7b6bfa5bf082$export$8e24544ddba725ee, "focus:border-sky-500 focus:ring-1"),
                                value: filter,
                                type: "text",
                                onChange: (e)=>{
                                    setFilter(e.target.value);
                                },
                                placeholder: "Filter by book"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                    onScroll: checkPosition,
                    className: "z-30 min-h-0 w-full flex-1 overflow-y-auto overflow-x-hidden",
                    children: (0, $ab2ea9beb98d9064$export$5a1dbaa3e4449344).map((s)=>/*#__PURE__*/ (0, $c56K2.createElement)($f48e7b6bfa5bf082$var$Section, {
                            ...s,
                            key: s.title,
                            filter: filter
                        }))
                })
            ]
        })
    });
};
var $f48e7b6bfa5bf082$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $c56K2.forwardRef)($f48e7b6bfa5bf082$var$BookNav);



var $c56K2 = parcelRequire("c56K2");
function $aa19ed0988cb1fd6$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $c56K2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $c56K2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $c56K2.createElement("path", {
        d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
    }));
}
const $aa19ed0988cb1fd6$var$ForwardRef = /*#__PURE__*/ $c56K2.forwardRef($aa19ed0988cb1fd6$var$XMarkIcon);
var $aa19ed0988cb1fd6$export$2e2bcd8739ae039 = $aa19ed0988cb1fd6$var$ForwardRef;




const $edff944d21e04014$var$BookNavModal = ()=>{
    const { setIsOpen: setIsOpen, isOpen: isOpen } = (0, $c56K2.useContext)((0, $e55f5946e67ab9f3$export$8d6bf6257d5e67d2));
    const ref = (0, $c56K2.useRef)(null);
    const closeModal = (0, $c56K2.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$be58926105124dd4), {
        show: isOpen,
        as: "div",
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $6747f844ef3fa432$export$3ddf2d174ce01153), {
            onClose: closeModal,
            as: "div",
            className: "fixed inset-0 z-30",
            initialFocus: ref,
            children: [
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d), {
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                        className: "fixed inset-0 hidden bg-black/10 backdrop-blur-sm sm:block"
                    })
                }),
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d), {
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 scale-100",
                    leaveTo: "opacity-0 scale-95",
                    children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $6747f844ef3fa432$export$46512663428d955a), {
                        className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("prose prose-sm prose-a:no-underline opacity-100", "z-20 flex h-dvh w-full flex-col overflow-hidden bg-white font-sans text-base ring-1 ring-black/5", "sm:absolute sm:left-1/2 sm:top-8 sm:h-[80vh] sm:w-96 sm:-translate-x-1/2 sm:rounded-2xl sm:shadow-lg"),
                        children: [
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $6747f844ef3fa432$export$16f7638e4a34b909), {
                                as: "div",
                                className: "flex justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("h2", {
                                        className: "!mt-7 text-center text-2xl font-normal text-sky-700",
                                        children: "Read the Bible"
                                    }),
                                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("button", {
                                        type: "button",
                                        className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("absolute right-7 top-6 sm:top-7 inline-flex justify-center rounded-md", "border border-transparent p-1 text-sm", "font-medium text-blue-900 hover:bg-blue-200", "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"),
                                        onClick: closeModal,
                                        children: [
                                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $aa19ed0988cb1fd6$export$2e2bcd8739ae039), {
                                                className: "size-6"
                                            }),
                                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Close"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $f48e7b6bfa5bf082$export$2e2bcd8739ae039), {
                                ref: ref
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $edff944d21e04014$export$2e2bcd8739ae039 = $edff944d21e04014$var$BookNavModal;




var $c56K2 = parcelRequire("c56K2");
function $9f0f14c87231cb04$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $c56K2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $c56K2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $c56K2.createElement("path", {
        fillRule: "evenodd",
        d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
        clipRule: "evenodd"
    }));
}
const $9f0f14c87231cb04$var$ForwardRef = /*#__PURE__*/ $c56K2.forwardRef($9f0f14c87231cb04$var$ChevronLeftIcon);
var $9f0f14c87231cb04$export$2e2bcd8739ae039 = $9f0f14c87231cb04$var$ForwardRef;


var $c56K2 = parcelRequire("c56K2");
function $be2414d5ef244f6e$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $c56K2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $c56K2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $c56K2.createElement("path", {
        fillRule: "evenodd",
        d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $be2414d5ef244f6e$var$ForwardRef = /*#__PURE__*/ $c56K2.forwardRef($be2414d5ef244f6e$var$ChevronRightIcon);
var $be2414d5ef244f6e$export$2e2bcd8739ae039 = $be2414d5ef244f6e$var$ForwardRef;


const $b1ba1390ab07b77a$var$BookFooter = ({ previous: previous, next: next })=>{
    const bookLink = (title)=>`${encodeURIComponent(title.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))}.html`;
    const className = "flex items-center py-1 text-lg text-sky-700 no-underline";
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("footer", {
        className: "fixed bottom-0 z-10 flex w-full justify-between overflow-hidden bg-gradient-to-r from-white to-sky-50/90 px-4 py-2 shadow",
        children: [
            previous ? /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("a", {
                href: bookLink(previous),
                className: className + " pr-3",
                children: [
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $9f0f14c87231cb04$export$2e2bcd8739ae039), {
                        className: "size-8 text-sky-700/40"
                    }),
                    previous
                ]
            }) : /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("span", {}),
            next && /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("a", {
                href: bookLink(next),
                className: className + " pl-3",
                children: [
                    next,
                    " ",
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $be2414d5ef244f6e$export$2e2bcd8739ae039), {
                        className: "size-8 text-sky-700/40"
                    })
                ]
            })
        ]
    });
};
var $b1ba1390ab07b77a$export$2e2bcd8739ae039 = $b1ba1390ab07b77a$var$BookFooter;




var $c56K2 = parcelRequire("c56K2");


const $b5775686cc6bd89f$var$BookHeader = ()=>{
    const { setIsOpen: setIsOpen } = (0, $c56K2.useContext)((0, $e55f5946e67ab9f3$export$8d6bf6257d5e67d2));
    const chapterToNumber = (0, $c56K2.useCallback)((value)=>value ? value.replace(/#?ch-/, "") : "1", []);
    const [chapterNumber, setChapterNumber] = (0, $c56K2.useState)(chapterToNumber(window.location.hash));
    // @TODO: consider switching link updates with `pushState`
    (0, $c56K2.useEffect)(()=>{
        const hashChange = ()=>{
            const hash = window.location.hash;
            const newChapter = chapterToNumber(hash);
            // reset scrollRef so observer doesn't think this is scrolling up
            scrollRef.current = 0;
            setChapterNumber(newChapter);
        };
        window.addEventListener("hashchange", hashChange, false);
        return ()=>{
            window.removeEventListener("hashchange", hashChange);
        };
    }, [
        chapterToNumber
    ]);
    const scrollRef = (0, $c56K2.useRef)(0);
    const bookTitle = (0, $0115c9ead8780559$export$4051a07651545597).title;
    // @see https://reacthustle.com/blog/how-to-track-scroll-direction-inside-intersection-observer-in-react
    (0, $c56K2.useEffect)(()=>{
        const chapters = Array.from(document.querySelectorAll(".Chapter-number, .Psalm-Chapter-Title"));
        const ids = chapters.map((e)=>e.id);
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute("id") ?? "";
                if (entry.isIntersecting) {
                    setChapterNumber(chapterToNumber(id));
                    scrollRef.current = window.scrollY;
                    return;
                }
                const diff = scrollRef.current - window.scrollY;
                const isScrollingUp = diff > 0;
                const currentIndex = ids.indexOf(id);
                const prevEntry = ids[currentIndex - 1];
                if (isScrollingUp) {
                    const id = prevEntry;
                    setChapterNumber(chapterToNumber(id));
                }
            });
        }, {
            rootMargin: "0% 0% -77% 0%",
            threshold: 0.2
        });
        chapters.forEach((el)=>{
            observer.observe(el);
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("button", {
        className: "whitespace-nowrap rounded-md px-2 py-1",
        onClick: ()=>{
            setIsOpen(true);
        },
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("div", {
            className: "border-b-2 border-dotted border-white px-2 py-0 text-2xl text-white",
            children: [
                bookTitle,
                " ",
                chapterNumber
            ]
        })
    });
};
var $b5775686cc6bd89f$export$2e2bcd8739ae039 = $b5775686cc6bd89f$var$BookHeader;






var $c56K2 = parcelRequire("c56K2");
const $08d61d74174dc16c$var$HelpModal = ({ setIsOpen: setIsOpen, isOpen: isOpen })=>{
    const closeButtonRef = (0, $c56K2.useRef)(null);
    const closeModal = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $782cc9fb2a36dc63$exports.Fragment), {
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$be58926105124dd4), {
            appear: true,
            show: isOpen,
            as: "div",
            children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $6747f844ef3fa432$export$3ddf2d174ce01153), {
                as: "div",
                className: "prose fixed inset-0 z-30 font-sans",
                initialFocus: closeButtonRef,
                onClose: closeModal,
                children: [
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d), {
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                            className: "fixed inset-0 bg-black/10 backdrop-blur-sm"
                        })
                    }),
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                        className: "fixed inset-0 overflow-y-auto",
                        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                            className: "flex min-h-full items-center justify-center p-4 text-center",
                            children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$b8acc0f6b9e8ca5d), {
                                enter: "ease-out duration-300",
                                enterFrom: "opacity-0 scale-95",
                                enterTo: "opacity-100 scale-100",
                                leave: "ease-in duration-200",
                                leaveFrom: "opacity-100 scale-100",
                                leaveTo: "opacity-0 scale-95",
                                children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $6747f844ef3fa432$export$46512663428d955a), {
                                    className: "relative mx-8 w-full max-w-2xl overflow-hidden rounded-2xl bg-white px-6  pb-6 text-left align-middle shadow-xl transition-all",
                                    children: [
                                        /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $6747f844ef3fa432$export$16f7638e4a34b909), {
                                            className: "mt-6",
                                            children: "Help"
                                        }),
                                        /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("button", {
                                            ref: closeButtonRef,
                                            type: "button",
                                            className: "absolute right-5 top-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 p-1 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                                            onClick: closeModal,
                                            children: [
                                                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $aa19ed0988cb1fd6$export$2e2bcd8739ae039), {
                                                    className: "size-5"
                                                }),
                                                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $39fd9e43e376396c$export$393edc798c47379d), {
                                            className: "text-sm text-gray-500",
                                            children: "Watch this video to learn how you can use the Chuukese Bible website."
                                        }),
                                        /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("script", {
                                            src: "https://player.vimeo.com/api/player.js"
                                        }),
                                        /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                                            className: "relative mt-5 pt-[50%]",
                                            children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("iframe", {
                                                src: "https://player.vimeo.com/video/842945338/?h=18f3c5a1ea&badge=0&autopause=0&player_id=0&app_id=58479&loop=0",
                                                allow: "autoplay; fullscreen",
                                                allowFullScreen: true,
                                                title: "Chuukese Bible: Help",
                                                style: {
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    borderWidth: 0
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $08d61d74174dc16c$export$2e2bcd8739ae039 = $08d61d74174dc16c$var$HelpModal;




var $c56K2 = parcelRequire("c56K2");


const $3dbfb9a09cd9cef0$var$LanguageToggle = ()=>{
    const [selectedIndex, setSelectedIndex] = (0, $c56K2.useState)(0);
    const chuukBlock = (0, $c56K2.useRef)(document.getElementById("chuukese-translation"));
    const englishBlock = (0, $c56K2.useRef)(document.getElementById("english-translation"));
    const buttonBaseClass = "px-2.5 py-1.5 border-y border-sky-500 text-sm focus:z-10 focus:outline-none focus:ring-2";
    (0, $c56K2.useEffect)(()=>{
        if (selectedIndex === 0) {
            chuukBlock.current?.classList.remove("hidden");
            chuukBlock.current?.classList.add("flex");
            englishBlock.current?.classList.remove("flex");
            englishBlock.current?.classList.add("hidden");
        } else {
            chuukBlock.current?.classList.remove("flex");
            chuukBlock.current?.classList.add("hidden");
            englishBlock.current?.classList.remove("hidden");
            englishBlock.current?.classList.add("flex");
        }
    }, [
        selectedIndex
    ]);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$85fd4ed3b8ca1010), {
        as: "div",
        selectedIndex: selectedIndex,
        onChange: setSelectedIndex,
        manual: true,
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $c0df5d1e196685e0$export$e51a686c67fdaa2d), {
            className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("absolute right-6 mt-6 inline-flex text-gray-700 rounded-md"),
            children: [
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$3e41faf802a29e71), {
                    className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)(buttonBaseClass, "rounded-l-md border-l", selectedIndex === 0 ? "text-white bg-sky-500 font-bold" : "bg-white hover:bg-slate-100 hover:text-sky-500"),
                    children: "Chuukese"
                }),
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$3e41faf802a29e71), {
                    className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)(buttonBaseClass, "rounded-r-md border-x", selectedIndex === 1 ? "text-white bg-sky-500 font-bold" : "hover:bg-slate-100 hover:text-sky-500"),
                    children: "English"
                })
            ]
        })
    });
};
var $3dbfb9a09cd9cef0$export$2e2bcd8739ae039 = $3dbfb9a09cd9cef0$var$LanguageToggle;






var $c56K2 = parcelRequire("c56K2");

var $dg2Np = parcelRequire("dg2Np");



var $c56K2 = parcelRequire("c56K2");


function $e544cadd2233c923$var$h(i) {
    if (i === null) return {
        width: 0,
        height: 0
    };
    let { width: t, height: e } = i.getBoundingClientRect();
    return {
        width: t,
        height: e
    };
}
function $e544cadd2233c923$export$2b86bedf890eab8(i, t, e = !1) {
    let [r, f] = (0, $c56K2.useState)(()=>$e544cadd2233c923$var$h(t));
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (!t || !i) return;
        let n = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
        return n.requestAnimationFrame(function s() {
            n.requestAnimationFrame(s), f((u)=>{
                let o = $e544cadd2233c923$var$h(t);
                return o.width === u.width && o.height === u.height ? u : o;
            });
        }), ()=>{
            n.dispose();
        };
    }, [
        t,
        i
    ]), e ? {
        width: `${r.width}px`,
        height: `${r.height}px`
    } : r;
}




var $c56K2 = parcelRequire("c56K2");
var $7da49e98a288cae6$export$92850d9476e00eee = ((f)=>(f[f.Left = 0] = "Left", f[f.Right = 2] = "Right", f))($7da49e98a288cae6$export$92850d9476e00eee || {});




function $166d31fda7ba37f1$export$87bd167e79a089ba(t) {
    let r = (0, $c56K2.useRef)(null), u = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((e)=>{
        r.current = e.pointerType, !(0, $6fa4d41e8d55539a$export$db61f031a278447c)(e.currentTarget) && e.pointerType === "mouse" && e.button === (0, $7da49e98a288cae6$export$92850d9476e00eee).Left && (e.preventDefault(), t(e));
    }), i = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((e)=>{
        r.current !== "mouse" && ((0, $6fa4d41e8d55539a$export$db61f031a278447c)(e.currentTarget) || t(e));
    });
    return {
        onPointerDown: u,
        onClick: i
    };
}



var $c56K2 = parcelRequire("c56K2");






var $c56K2 = parcelRequire("c56K2");


var $9e20f4f433cb6952$var$H = ((e)=>(e[e.Ignore = 0] = "Ignore", e[e.Select = 1] = "Select", e[e.Close = 2] = "Close", e))($9e20f4f433cb6952$var$H || {});
const $9e20f4f433cb6952$export$e19cd5f9376f8cee = {
    Ignore: {
        kind: 0
    },
    Select: (r)=>({
            kind: 1,
            target: r
        }),
    Close: {
        kind: 2
    }
}, $9e20f4f433cb6952$var$M = 200, $9e20f4f433cb6952$var$f = 5;
function $9e20f4f433cb6952$export$a46c853b8b55573a(r, { trigger: n, action: T, close: e, select: p }) {
    let l = (0, $c56K2.useRef)(null), i = (0, $c56K2.useRef)(null), u = (0, $c56K2.useRef)(null);
    (0, $b9cb2bcf7c441d0d$export$55d2b5df396a097b)(r && n !== null, "pointerdown", (t)=>{
        $72273189d405b787$export$8ee0fc9ee280b4ee(t == null ? void 0 : t.target) && n != null && n.contains(t.target) && (i.current = t.x, u.current = t.y, l.current = t.timeStamp);
    }), (0, $b9cb2bcf7c441d0d$export$55d2b5df396a097b)(r && n !== null, "pointerup", (t)=>{
        var s, m;
        let c = l.current;
        if (c === null || (l.current = null, !$72273189d405b787$export$79c619c6018bbb44(t.target)) || Math.abs(t.x - ((s = i.current) != null ? s : t.x)) < $9e20f4f433cb6952$var$f && Math.abs(t.y - ((m = u.current) != null ? m : t.y)) < $9e20f4f433cb6952$var$f) return;
        let a = T(t);
        switch(a.kind){
            case 0:
                return;
            case 1:
                t.timeStamp - c > $9e20f4f433cb6952$var$M && (p(a.target), e());
                break;
            case 2:
                e();
                break;
        }
    }, {
        capture: !0
    });
}







var $c56K2 = parcelRequire("c56K2");

let $bb4fdaa48741f441$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $bb4fdaa48741f441$var$o(e) {
    var l, n;
    let i = (l = e.innerText) != null ? l : "", t = e.cloneNode(!0);
    if (!$72273189d405b787$export$1b3bfaa9684536aa(t)) return i;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let r = u ? (n = t.innerText) != null ? n : "" : i;
    return $bb4fdaa48741f441$var$a.test(r) && (r = r.replace($bb4fdaa48741f441$var$a, "")), r;
}
function $bb4fdaa48741f441$export$6ca03cb7b75bfa13(e) {
    let i = e.getAttribute("aria-label");
    if (typeof i == "string") return i.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((r)=>{
            let l = document.getElementById(r);
            if (l) {
                let n = l.getAttribute("aria-label");
                return typeof n == "string" ? n.trim() : $bb4fdaa48741f441$var$o(l).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $bb4fdaa48741f441$var$o(e).trim();
}



function $dfa4a89254ea6105$export$f6862afd851a1cf4(c) {
    let t = (0, $c56K2.useRef)(""), r = (0, $c56K2.useRef)("");
    return (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $bb4fdaa48741f441$export$6ca03cb7b75bfa13)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}



var $c56K2 = parcelRequire("c56K2");
function $cb40363295794194$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $cb40363295794194$export$24ebee078bde85c3() {
    let e = (0, $c56K2.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $cb40363295794194$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $cb40363295794194$var$t(r);
        }
    };
}




var $c56K2 = parcelRequire("c56K2");


function $635d76e34fc51215$export$b0abce39eb34b36(c, { container: e, accept: t, walk: r }) {
    let o = (0, $c56K2.useRef)(t), l = (0, $c56K2.useRef)(r);
    (0, $c56K2.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $874591f6f1a15c7a$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, i = Object.assign((m)=>f(m), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, i, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $08f09f43fc3adce0$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $08f09f43fc3adce0$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $08f09f43fc3adce0$export$803cd8101b6c182b = /*#__PURE__*/ $08f09f43fc3adce0$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $08f09f43fc3adce0$export$27b07d8a310ed8b5[0], side + "-" + $08f09f43fc3adce0$export$27b07d8a310ed8b5[1]), []);
const $08f09f43fc3adce0$export$96ec731ed4dcb222 = Math.min;
const $08f09f43fc3adce0$export$8960430cfd85939f = Math.max;
const $08f09f43fc3adce0$export$2077e0241d6afd3c = Math.round;
const $08f09f43fc3adce0$export$a3fe094919f356fd = Math.floor;
const $08f09f43fc3adce0$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $08f09f43fc3adce0$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $08f09f43fc3adce0$export$7d15b64cf5a3a4c4(start, value, end) {
    return $08f09f43fc3adce0$export$8960430cfd85939f(start, $08f09f43fc3adce0$export$96ec731ed4dcb222(value, end));
}
function $08f09f43fc3adce0$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $08f09f43fc3adce0$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $08f09f43fc3adce0$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $08f09f43fc3adce0$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $08f09f43fc3adce0$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $08f09f43fc3adce0$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $08f09f43fc3adce0$export$2b57e0052a6d6d4c(placement) {
    return $08f09f43fc3adce0$export$8a000a963141ac32($08f09f43fc3adce0$export$f28e8f882010718a(placement));
}
function $08f09f43fc3adce0$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $08f09f43fc3adce0$export$f0989780f32bfcda(placement);
    const alignmentAxis = $08f09f43fc3adce0$export$2b57e0052a6d6d4c(placement);
    const length = $08f09f43fc3adce0$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $08f09f43fc3adce0$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $08f09f43fc3adce0$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $08f09f43fc3adce0$export$496432a3699e50b1(placement) {
    const oppositePlacement = $08f09f43fc3adce0$export$9c5e28bad23365fa(placement);
    return [
        $08f09f43fc3adce0$export$2b182c584985588b(placement),
        oppositePlacement,
        $08f09f43fc3adce0$export$2b182c584985588b(oppositePlacement)
    ];
}
function $08f09f43fc3adce0$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $08f09f43fc3adce0$var$lrPlacement = [
    'left',
    'right'
];
const $08f09f43fc3adce0$var$rlPlacement = [
    'right',
    'left'
];
const $08f09f43fc3adce0$var$tbPlacement = [
    'top',
    'bottom'
];
const $08f09f43fc3adce0$var$btPlacement = [
    'bottom',
    'top'
];
function $08f09f43fc3adce0$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $08f09f43fc3adce0$var$rlPlacement : $08f09f43fc3adce0$var$lrPlacement;
            return isStart ? $08f09f43fc3adce0$var$lrPlacement : $08f09f43fc3adce0$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $08f09f43fc3adce0$var$tbPlacement : $08f09f43fc3adce0$var$btPlacement;
        default:
            return [];
    }
}
function $08f09f43fc3adce0$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $08f09f43fc3adce0$export$f0989780f32bfcda(placement);
    let list = $08f09f43fc3adce0$var$getSideList($08f09f43fc3adce0$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($08f09f43fc3adce0$export$2b182c584985588b));
    }
    return list;
}
function $08f09f43fc3adce0$export$9c5e28bad23365fa(placement) {
    const side = $08f09f43fc3adce0$export$3c915306cb7fc97a(placement);
    return $08f09f43fc3adce0$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $08f09f43fc3adce0$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $08f09f43fc3adce0$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $08f09f43fc3adce0$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $08f09f43fc3adce0$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $cf217ffebd7352a6$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $08f09f43fc3adce0$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $08f09f43fc3adce0$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $08f09f43fc3adce0$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $08f09f43fc3adce0$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $cf217ffebd7352a6$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $08f09f43fc3adce0$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $08f09f43fc3adce0$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $08f09f43fc3adce0$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $cf217ffebd7352a6$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $cf217ffebd7352a6$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $cf217ffebd7352a6$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $cf217ffebd7352a6$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $cf217ffebd7352a6$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $cf217ffebd7352a6$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $cf217ffebd7352a6$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $08f09f43fc3adce0$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $08f09f43fc3adce0$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $08f09f43fc3adce0$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $08f09f43fc3adce0$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $08f09f43fc3adce0$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $cf217ffebd7352a6$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $08f09f43fc3adce0$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $08f09f43fc3adce0$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $08f09f43fc3adce0$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $08f09f43fc3adce0$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $cf217ffebd7352a6$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $08f09f43fc3adce0$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $08f09f43fc3adce0$export$803cd8101b6c182b) ? $cf217ffebd7352a6$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $08f09f43fc3adce0$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $08f09f43fc3adce0$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $08f09f43fc3adce0$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $cf217ffebd7352a6$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $08f09f43fc3adce0$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $08f09f43fc3adce0$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $08f09f43fc3adce0$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $08f09f43fc3adce0$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $08f09f43fc3adce0$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $08f09f43fc3adce0$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $08f09f43fc3adce0$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $08f09f43fc3adce0$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $cf217ffebd7352a6$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $cf217ffebd7352a6$var$isAnySideFullyClipped(overflow) {
    return (0, $08f09f43fc3adce0$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $cf217ffebd7352a6$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $cf217ffebd7352a6$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $cf217ffebd7352a6$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $cf217ffebd7352a6$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $cf217ffebd7352a6$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $cf217ffebd7352a6$var$getBoundingRect(rects) {
    const minX = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $cf217ffebd7352a6$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $08f09f43fc3adce0$export$ee05aea0aeecbad4)($cf217ffebd7352a6$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $cf217ffebd7352a6$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $cf217ffebd7352a6$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $08f09f43fc3adce0$export$ee05aea0aeecbad4)($cf217ffebd7352a6$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $08f09f43fc3adce0$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $08f09f43fc3adce0$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $cf217ffebd7352a6$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $cf217ffebd7352a6$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $08f09f43fc3adce0$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $08f09f43fc3adce0$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $cf217ffebd7352a6$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $cf217ffebd7352a6$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $cf217ffebd7352a6$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $cf217ffebd7352a6$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $08f09f43fc3adce0$export$f28e8f882010718a)((0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $08f09f43fc3adce0$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $08f09f43fc3adce0$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $08f09f43fc3adce0$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $cf217ffebd7352a6$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $08f09f43fc3adce0$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $08f09f43fc3adce0$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $cf217ffebd7352a6$var$originSides.has((0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $cf217ffebd7352a6$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $08f09f43fc3adce0$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $08f09f43fc3adce0$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $08f09f43fc3adce0$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $08f09f43fc3adce0$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $08f09f43fc3adce0$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $d5ca47c9e734d524$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $d5ca47c9e734d524$export$651544f548703224(node) {
    if ($d5ca47c9e734d524$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $d5ca47c9e734d524$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $d5ca47c9e734d524$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($d5ca47c9e734d524$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $d5ca47c9e734d524$export$8ee0fc9ee280b4ee(value) {
    if (!$d5ca47c9e734d524$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $d5ca47c9e734d524$export$38b2d434cce3ea22(value).Node;
}
function $d5ca47c9e734d524$export$45a5e7f76e0caa8d(value) {
    if (!$d5ca47c9e734d524$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $d5ca47c9e734d524$export$38b2d434cce3ea22(value).Element;
}
function $d5ca47c9e734d524$export$1b3bfaa9684536aa(value) {
    if (!$d5ca47c9e734d524$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $d5ca47c9e734d524$export$38b2d434cce3ea22(value).HTMLElement;
}
function $d5ca47c9e734d524$export$af51f0f06c0f328a(value) {
    if (!$d5ca47c9e734d524$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $d5ca47c9e734d524$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $d5ca47c9e734d524$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $d5ca47c9e734d524$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $d5ca47c9e734d524$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($d5ca47c9e734d524$export$651544f548703224(element));
}
function $d5ca47c9e734d524$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $d5ca47c9e734d524$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $d5ca47c9e734d524$var$containRe = /paint|layout|strict|content/;
const $d5ca47c9e734d524$var$isNotNone = (value)=>!!value && value !== 'none';
let $d5ca47c9e734d524$var$isWebKitValue;
function $d5ca47c9e734d524$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $d5ca47c9e734d524$export$45a5e7f76e0caa8d(elementOrCss) ? $d5ca47c9e734d524$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $d5ca47c9e734d524$var$isNotNone(css.transform) || $d5ca47c9e734d524$var$isNotNone(css.translate) || $d5ca47c9e734d524$var$isNotNone(css.scale) || $d5ca47c9e734d524$var$isNotNone(css.rotate) || $d5ca47c9e734d524$var$isNotNone(css.perspective) || !$d5ca47c9e734d524$export$78551043582a6a98() && ($d5ca47c9e734d524$var$isNotNone(css.backdropFilter) || $d5ca47c9e734d524$var$isNotNone(css.filter)) || $d5ca47c9e734d524$var$willChangeRe.test(css.willChange || '') || $d5ca47c9e734d524$var$containRe.test(css.contain || '');
}
function $d5ca47c9e734d524$export$940d8225183e1404(element) {
    let currentNode = $d5ca47c9e734d524$export$4e12058fc4d51d56(element);
    while($d5ca47c9e734d524$export$1b3bfaa9684536aa(currentNode) && !$d5ca47c9e734d524$export$d1162fb0b6d4cd51(currentNode)){
        if ($d5ca47c9e734d524$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($d5ca47c9e734d524$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $d5ca47c9e734d524$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $d5ca47c9e734d524$export$78551043582a6a98() {
    if ($d5ca47c9e734d524$var$isWebKitValue == null) $d5ca47c9e734d524$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $d5ca47c9e734d524$var$isWebKitValue;
}
function $d5ca47c9e734d524$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($d5ca47c9e734d524$export$651544f548703224(node));
}
function $d5ca47c9e734d524$export$3735103072e4a80(element) {
    return $d5ca47c9e734d524$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $d5ca47c9e734d524$export$dc8fc79fa2800137(element) {
    if ($d5ca47c9e734d524$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $d5ca47c9e734d524$export$4e12058fc4d51d56(node) {
    if ($d5ca47c9e734d524$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $d5ca47c9e734d524$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $d5ca47c9e734d524$export$e495491855dc5418(node);
    return $d5ca47c9e734d524$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $d5ca47c9e734d524$export$7cd01a57c8ca906c(node) {
    const parentNode = $d5ca47c9e734d524$export$4e12058fc4d51d56(node);
    if ($d5ca47c9e734d524$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($d5ca47c9e734d524$export$1b3bfaa9684536aa(parentNode) && $d5ca47c9e734d524$export$989e911fa9af580a(parentNode)) return parentNode;
    return $d5ca47c9e734d524$export$7cd01a57c8ca906c(parentNode);
}
function $d5ca47c9e734d524$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $d5ca47c9e734d524$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $d5ca47c9e734d524$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $d5ca47c9e734d524$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $d5ca47c9e734d524$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $d5ca47c9e734d524$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $d5ca47c9e734d524$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $d5ca47c9e734d524$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $2f43b0e664909b14$var$getCssDimensions(element) {
    const css = (0, $d5ca47c9e734d524$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $08f09f43fc3adce0$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $08f09f43fc3adce0$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $2f43b0e664909b14$var$unwrapElement(element) {
    return !(0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $2f43b0e664909b14$var$getScale(element) {
    const domElement = $2f43b0e664909b14$var$unwrapElement(element);
    if (!(0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(domElement)) return (0, $08f09f43fc3adce0$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $2f43b0e664909b14$var$getCssDimensions(domElement);
    let x = ($ ? (0, $08f09f43fc3adce0$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $08f09f43fc3adce0$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $2f43b0e664909b14$var$noOffsets = /*#__PURE__*/ (0, $08f09f43fc3adce0$export$a397704b5e280835)(0);
function $2f43b0e664909b14$var$getVisualOffsets(element) {
    const win = (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(element);
    if (!(0, $d5ca47c9e734d524$export$78551043582a6a98)() || !win.visualViewport) return $2f43b0e664909b14$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $2f43b0e664909b14$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $2f43b0e664909b14$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $2f43b0e664909b14$var$unwrapElement(element);
    let scale = (0, $08f09f43fc3adce0$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(offsetParent)) scale = $2f43b0e664909b14$var$getScale(offsetParent);
        } else scale = $2f43b0e664909b14$var$getScale(element);
    }
    const visualOffsets = $2f43b0e664909b14$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $2f43b0e664909b14$var$getVisualOffsets(domElement) : (0, $08f09f43fc3adce0$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $d5ca47c9e734d524$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $2f43b0e664909b14$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $d5ca47c9e734d524$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $d5ca47c9e734d524$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $08f09f43fc3adce0$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $2f43b0e664909b14$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $d5ca47c9e734d524$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $2f43b0e664909b14$var$getBoundingClientRect((0, $d5ca47c9e734d524$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $2f43b0e664909b14$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $2f43b0e664909b14$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $2f43b0e664909b14$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $d5ca47c9e734d524$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $d5ca47c9e734d524$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $08f09f43fc3adce0$export$a397704b5e280835)(1);
    const offsets = (0, $08f09f43fc3adce0$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d5ca47c9e734d524$export$651544f548703224)(offsetParent) !== 'body' || (0, $d5ca47c9e734d524$export$989e911fa9af580a)(documentElement)) scroll = (0, $d5ca47c9e734d524$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $2f43b0e664909b14$var$getBoundingClientRect(offsetParent);
            scale = $2f43b0e664909b14$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $2f43b0e664909b14$var$getHTMLOffset(documentElement, scroll) : (0, $08f09f43fc3adce0$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $2f43b0e664909b14$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $2f43b0e664909b14$var$getDocumentRect(element) {
    const html = (0, $d5ca47c9e734d524$export$e495491855dc5418)(element);
    const scroll = (0, $d5ca47c9e734d524$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $2f43b0e664909b14$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $d5ca47c9e734d524$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $08f09f43fc3adce0$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $2f43b0e664909b14$var$SCROLLBAR_MAX = 25;
function $2f43b0e664909b14$var$getViewportRect(element, strategy) {
    const win = (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(element);
    const html = (0, $d5ca47c9e734d524$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $d5ca47c9e734d524$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $2f43b0e664909b14$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $2f43b0e664909b14$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $2f43b0e664909b14$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $2f43b0e664909b14$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $2f43b0e664909b14$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(element) ? $2f43b0e664909b14$var$getScale(element) : (0, $08f09f43fc3adce0$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $2f43b0e664909b14$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $2f43b0e664909b14$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $2f43b0e664909b14$var$getDocumentRect((0, $d5ca47c9e734d524$export$e495491855dc5418)(element));
    else if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $2f43b0e664909b14$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $2f43b0e664909b14$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $08f09f43fc3adce0$export$ee05aea0aeecbad4)(rect);
}
function $2f43b0e664909b14$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $d5ca47c9e734d524$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(parentNode) || (0, $d5ca47c9e734d524$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $d5ca47c9e734d524$export$3735103072e4a80)(parentNode).position === 'fixed' || $2f43b0e664909b14$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $2f43b0e664909b14$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $d5ca47c9e734d524$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(el) && (0, $d5ca47c9e734d524$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $d5ca47c9e734d524$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $d5ca47c9e734d524$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(currentNode) && !(0, $d5ca47c9e734d524$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $d5ca47c9e734d524$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $d5ca47c9e734d524$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $d5ca47c9e734d524$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $2f43b0e664909b14$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $d5ca47c9e734d524$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $2f43b0e664909b14$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $d5ca47c9e734d524$export$89e651af02346cd4)(element) ? [] : $2f43b0e664909b14$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $2f43b0e664909b14$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $2f43b0e664909b14$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(rect.top, top);
        right = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $2f43b0e664909b14$var$getDimensions(element) {
    const { width: width, height: height } = $2f43b0e664909b14$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $2f43b0e664909b14$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $d5ca47c9e734d524$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $2f43b0e664909b14$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $08f09f43fc3adce0$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $2f43b0e664909b14$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d5ca47c9e734d524$export$651544f548703224)(offsetParent) !== 'body' || (0, $d5ca47c9e734d524$export$989e911fa9af580a)(documentElement)) scroll = (0, $d5ca47c9e734d524$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $2f43b0e664909b14$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $2f43b0e664909b14$var$getHTMLOffset(documentElement, scroll) : (0, $08f09f43fc3adce0$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $2f43b0e664909b14$var$isStaticPositioned(element) {
    return (0, $d5ca47c9e734d524$export$3735103072e4a80)(element).position === 'static';
}
function $2f43b0e664909b14$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(element) || (0, $d5ca47c9e734d524$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $d5ca47c9e734d524$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $2f43b0e664909b14$var$getOffsetParent(element, polyfill) {
    const win = (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(element);
    if ((0, $d5ca47c9e734d524$export$89e651af02346cd4)(element)) return win;
    if (!(0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $d5ca47c9e734d524$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $d5ca47c9e734d524$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$2f43b0e664909b14$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $d5ca47c9e734d524$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $2f43b0e664909b14$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $d5ca47c9e734d524$export$71535ffaa902797f)(offsetParent) && $2f43b0e664909b14$var$isStaticPositioned(offsetParent))offsetParent = $2f43b0e664909b14$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $d5ca47c9e734d524$export$d1162fb0b6d4cd51)(offsetParent) && $2f43b0e664909b14$var$isStaticPositioned(offsetParent) && !(0, $d5ca47c9e734d524$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $d5ca47c9e734d524$export$940d8225183e1404)(element) || win;
}
const $2f43b0e664909b14$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $2f43b0e664909b14$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $2f43b0e664909b14$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $2f43b0e664909b14$var$isRTL(element) {
    return (0, $d5ca47c9e734d524$export$3735103072e4a80)(element).direction === 'rtl';
}
const $2f43b0e664909b14$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $2f43b0e664909b14$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $d5ca47c9e734d524$export$e495491855dc5418,
    getClippingRect: $2f43b0e664909b14$var$getClippingRect,
    getOffsetParent: $2f43b0e664909b14$var$getOffsetParent,
    getElementRects: $2f43b0e664909b14$var$getElementRects,
    getClientRects: $2f43b0e664909b14$var$getClientRects,
    getDimensions: $2f43b0e664909b14$var$getDimensions,
    getScale: $2f43b0e664909b14$var$getScale,
    isElement: $d5ca47c9e734d524$export$45a5e7f76e0caa8d,
    isRTL: $2f43b0e664909b14$var$isRTL
};
function $2f43b0e664909b14$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $2f43b0e664909b14$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $d5ca47c9e734d524$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $08f09f43fc3adce0$export$a3fe094919f356fd)(top);
        const insetRight = (0, $08f09f43fc3adce0$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $08f09f43fc3adce0$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $08f09f43fc3adce0$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $08f09f43fc3adce0$export$8960430cfd85939f)(0, (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$2f43b0e664909b14$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $2f43b0e664909b14$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $2f43b0e664909b14$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $d5ca47c9e734d524$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $d5ca47c9e734d524$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $2f43b0e664909b14$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $2f43b0e664909b14$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $2f43b0e664909b14$var$getBoundingClientRect(reference);
        if (prevRefRect && !$2f43b0e664909b14$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $2f43b0e664909b14$export$37b6bde19b108ecc = (0, $cf217ffebd7352a6$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $2f43b0e664909b14$export$cc800923e997bb8 = (0, $cf217ffebd7352a6$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $2f43b0e664909b14$export$91fb6ecbd551914 = (0, $cf217ffebd7352a6$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $2f43b0e664909b14$export$fba63a578e423eb = (0, $cf217ffebd7352a6$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $2f43b0e664909b14$export$8a83211c878a3f1f = (0, $cf217ffebd7352a6$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $2f43b0e664909b14$export$346677f925de839c = (0, $cf217ffebd7352a6$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $2f43b0e664909b14$export$fe8985bb6374093c = (0, $cf217ffebd7352a6$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $2f43b0e664909b14$export$f2120bbfa5450bd2 = (0, $cf217ffebd7352a6$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $2f43b0e664909b14$export$18c8ad048e32c7d5 = (0, $cf217ffebd7352a6$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $2f43b0e664909b14$export$7bf07e38f3dc4b69 = (0, $cf217ffebd7352a6$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $2f43b0e664909b14$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $2f43b0e664909b14$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cf217ffebd7352a6$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $c56K2 = parcelRequire("c56K2");

var $dg2Np = parcelRequire("dg2Np");
var $49265da98b96e02c$var$isClient = typeof document !== 'undefined';
var $49265da98b96e02c$var$noop = function noop() {};
var $49265da98b96e02c$var$index = $49265da98b96e02c$var$isClient ? (0, $c56K2.useLayoutEffect) : $49265da98b96e02c$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $49265da98b96e02c$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$49265da98b96e02c$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$49265da98b96e02c$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $49265da98b96e02c$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $49265da98b96e02c$var$roundByDPR(element, value) {
    const dpr = $49265da98b96e02c$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $49265da98b96e02c$var$useLatestRef(value) {
    const ref = $c56K2.useRef(value);
    $49265da98b96e02c$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $49265da98b96e02c$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $c56K2.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $c56K2.useState(middleware);
    if (!$49265da98b96e02c$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $c56K2.useState(null);
    const [_floating, _setFloating] = $c56K2.useState(null);
    const setReference = $c56K2.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $c56K2.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $c56K2.useRef(null);
    const floatingRef = $c56K2.useRef(null);
    const dataRef = $c56K2.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $49265da98b96e02c$var$useLatestRef(whileElementsMounted);
    const platformRef = $49265da98b96e02c$var$useLatestRef(platform);
    const openRef = $49265da98b96e02c$var$useLatestRef(open);
    const update = $c56K2.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $2f43b0e664909b14$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$49265da98b96e02c$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $dg2Np.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $49265da98b96e02c$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $c56K2.useRef(false);
    $49265da98b96e02c$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $49265da98b96e02c$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $c56K2.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $c56K2.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $c56K2.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $49265da98b96e02c$var$roundByDPR(elements.floating, data.x);
        const y = $49265da98b96e02c$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$49265da98b96e02c$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $c56K2.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $49265da98b96e02c$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $2f43b0e664909b14$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $2f43b0e664909b14$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $49265da98b96e02c$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $49265da98b96e02c$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $49265da98b96e02c$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $49265da98b96e02c$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $49265da98b96e02c$export$346677f925de839c = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $49265da98b96e02c$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $49265da98b96e02c$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $49265da98b96e02c$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $2f43b0e664909b14$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $49265da98b96e02c$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $49265da98b96e02c$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


var $c56K2 = parcelRequire("c56K2");

function $3567a0f9e185fb8e$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $3567a0f9e185fb8e$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $d5ca47c9e734d524$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $3567a0f9e185fb8e$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $3567a0f9e185fb8e$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $3567a0f9e185fb8e$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($3567a0f9e185fb8e$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $3567a0f9e185fb8e$export$29bf1b5f2c56cf63(event) {
    if ($3567a0f9e185fb8e$export$c8f880a2d81914c4()) return false;
    return !$3567a0f9e185fb8e$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $3567a0f9e185fb8e$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $3567a0f9e185fb8e$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $3567a0f9e185fb8e$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($3567a0f9e185fb8e$export$867a782338812cb4()) || re.test($3567a0f9e185fb8e$export$7935961ef7719cb0());
}
function $3567a0f9e185fb8e$export$9ac100e40613ea10() {
    return $3567a0f9e185fb8e$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $3567a0f9e185fb8e$export$c8f880a2d81914c4() {
    return $3567a0f9e185fb8e$export$7935961ef7719cb0().includes('jsdom/');
}
function $3567a0f9e185fb8e$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $3567a0f9e185fb8e$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $3567a0f9e185fb8e$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $3567a0f9e185fb8e$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $3567a0f9e185fb8e$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $3567a0f9e185fb8e$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $3567a0f9e185fb8e$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $3567a0f9e185fb8e$export$42ad131c32f0fb8d(element) {
    return (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(element) && element.matches($3567a0f9e185fb8e$export$78b3d091ff376bc);
}
function $3567a0f9e185fb8e$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $3567a0f9e185fb8e$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $3567a0f9e185fb8e$export$42ad131c32f0fb8d(element);
}




/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $82cd98eb5c062693$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $82cd98eb5c062693$var$candidateSelector = /* #__PURE__ */ $82cd98eb5c062693$var$candidateSelectors.join(',');
var $82cd98eb5c062693$var$NoElement = typeof Element === 'undefined';
var $82cd98eb5c062693$var$matches = $82cd98eb5c062693$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $82cd98eb5c062693$var$getRootNode = !$82cd98eb5c062693$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $82cd98eb5c062693$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $82cd98eb5c062693$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $82cd98eb5c062693$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $82cd98eb5c062693$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($82cd98eb5c062693$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($82cd98eb5c062693$var$candidateSelector));
    if (includeContainer && $82cd98eb5c062693$var$matches.call(el, $82cd98eb5c062693$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $82cd98eb5c062693$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($82cd98eb5c062693$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $82cd98eb5c062693$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $82cd98eb5c062693$var$matches.call(element, $82cd98eb5c062693$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$82cd98eb5c062693$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $82cd98eb5c062693$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $82cd98eb5c062693$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $82cd98eb5c062693$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $82cd98eb5c062693$var$isContentEditable(node)) && !$82cd98eb5c062693$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $82cd98eb5c062693$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $82cd98eb5c062693$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$82cd98eb5c062693$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $82cd98eb5c062693$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $82cd98eb5c062693$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $82cd98eb5c062693$var$isHiddenInput = function isHiddenInput(node) {
    return $82cd98eb5c062693$var$isInput(node) && node.type === 'hidden';
};
var $82cd98eb5c062693$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $82cd98eb5c062693$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $82cd98eb5c062693$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $82cd98eb5c062693$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $82cd98eb5c062693$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $82cd98eb5c062693$var$isRadio = function isRadio(node) {
    return $82cd98eb5c062693$var$isInput(node) && node.type === 'radio';
};
var $82cd98eb5c062693$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $82cd98eb5c062693$var$isRadio(node) && !$82cd98eb5c062693$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $82cd98eb5c062693$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $82cd98eb5c062693$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $82cd98eb5c062693$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $82cd98eb5c062693$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $82cd98eb5c062693$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $82cd98eb5c062693$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($82cd98eb5c062693$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $82cd98eb5c062693$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $82cd98eb5c062693$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($82cd98eb5c062693$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $82cd98eb5c062693$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $82cd98eb5c062693$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $82cd98eb5c062693$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $82cd98eb5c062693$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $82cd98eb5c062693$var$isHiddenInput(node) || $82cd98eb5c062693$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $82cd98eb5c062693$var$isDetailsWithSummary(node) || $82cd98eb5c062693$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $82cd98eb5c062693$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($82cd98eb5c062693$var$isNonTabbableRadio(node) || $82cd98eb5c062693$export$a4672efddb4181b8(node) < 0 || !$82cd98eb5c062693$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $82cd98eb5c062693$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $82cd98eb5c062693$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $82cd98eb5c062693$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $82cd98eb5c062693$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($82cd98eb5c062693$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $82cd98eb5c062693$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $82cd98eb5c062693$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $82cd98eb5c062693$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $82cd98eb5c062693$var$isShadowRootTabbable
    });
    else candidates = $82cd98eb5c062693$var$getCandidates(container, options.includeContainer, $82cd98eb5c062693$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $82cd98eb5c062693$var$_sortByOrder(candidates);
};
var $82cd98eb5c062693$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $82cd98eb5c062693$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $82cd98eb5c062693$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $82cd98eb5c062693$var$getCandidates(container, options.includeContainer, $82cd98eb5c062693$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $82cd98eb5c062693$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($82cd98eb5c062693$var$matches.call(node, $82cd98eb5c062693$var$candidateSelector) === false) return false;
    return $82cd98eb5c062693$var$isNodeMatchingSelectorTabbable(options, node);
};
var $82cd98eb5c062693$var$focusableCandidateSelector = /* #__PURE__ */ $82cd98eb5c062693$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $82cd98eb5c062693$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($82cd98eb5c062693$var$matches.call(node, $82cd98eb5c062693$var$focusableCandidateSelector) === false) return false;
    return $82cd98eb5c062693$var$isNodeMatchingSelectorFocusable(options, node);
};



var $dg2Np = parcelRequire("dg2Np");

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $9e31ee77d3f847c3$export$74665b213cb5c4cf(refs) {
    return $c56K2.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $9e31ee77d3f847c3$var$SafeReact = {
    ...$c56K2
};
const $9e31ee77d3f847c3$var$useInsertionEffect = $9e31ee77d3f847c3$var$SafeReact.useInsertionEffect;
const $9e31ee77d3f847c3$var$useSafeInsertionEffect = $9e31ee77d3f847c3$var$useInsertionEffect || ((fn)=>fn());
function $9e31ee77d3f847c3$var$useEffectEvent(callback) {
    const ref = $c56K2.useRef(()=>{});
    $9e31ee77d3f847c3$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $c56K2.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $9e31ee77d3f847c3$var$ARROW_UP = 'ArrowUp';
const $9e31ee77d3f847c3$var$ARROW_DOWN = 'ArrowDown';
const $9e31ee77d3f847c3$var$ARROW_LEFT = 'ArrowLeft';
const $9e31ee77d3f847c3$var$ARROW_RIGHT = 'ArrowRight';
function $9e31ee77d3f847c3$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $9e31ee77d3f847c3$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $9e31ee77d3f847c3$var$getMinIndex(listRef, disabledIndices) {
    return $9e31ee77d3f847c3$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $9e31ee77d3f847c3$var$getMaxIndex(listRef, disabledIndices) {
    return $9e31ee77d3f847c3$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $9e31ee77d3f847c3$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $9e31ee77d3f847c3$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $9e31ee77d3f847c3$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $9e31ee77d3f847c3$var$ARROW_UP) {
        stop && (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($9e31ee77d3f847c3$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $9e31ee77d3f847c3$var$ARROW_DOWN) {
        stop && (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($9e31ee77d3f847c3$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $08f09f43fc3adce0$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $9e31ee77d3f847c3$var$ARROW_LEFT : $9e31ee77d3f847c3$var$ARROW_RIGHT)) {
            stop && (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $9e31ee77d3f847c3$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($9e31ee77d3f847c3$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $9e31ee77d3f847c3$var$ARROW_RIGHT : $9e31ee77d3f847c3$var$ARROW_LEFT)) {
            stop && (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $9e31ee77d3f847c3$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($9e31ee77d3f847c3$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $08f09f43fc3adce0$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($9e31ee77d3f847c3$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $9e31ee77d3f847c3$var$ARROW_RIGHT : $9e31ee77d3f847c3$var$ARROW_LEFT) ? maxIndex : $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $9e31ee77d3f847c3$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $9e31ee77d3f847c3$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $9e31ee77d3f847c3$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $9e31ee77d3f847c3$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var $9e31ee77d3f847c3$var$index = typeof document !== 'undefined' ? (0, $c56K2.useLayoutEffect) : (0, $c56K2.useEffect);
function $9e31ee77d3f847c3$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $9e31ee77d3f847c3$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $9e31ee77d3f847c3$var$FloatingListContext = /*#__PURE__*/ $c56K2.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $9e31ee77d3f847c3$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $c56K2.useState(()=>new Map());
    const register = $c56K2.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $c56K2.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $9e31ee77d3f847c3$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($9e31ee77d3f847c3$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$9e31ee77d3f847c3$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FloatingListContext.Provider, {
        value: $c56K2.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $9e31ee77d3f847c3$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $c56K2.useContext($9e31ee77d3f847c3$var$FloatingListContext);
    const [index$1, setIndex] = $c56K2.useState(null);
    const componentRef = $c56K2.useRef(null);
    const ref = $c56K2.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $c56K2.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $9e31ee77d3f847c3$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $c56K2.cloneElement(render, computedProps);
    return /*#__PURE__*/ $c56K2.createElement("div", computedProps);
}
const $9e31ee77d3f847c3$var$CompositeContext = /*#__PURE__*/ $c56K2.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $9e31ee77d3f847c3$var$horizontalKeys = [
    $9e31ee77d3f847c3$var$ARROW_LEFT,
    $9e31ee77d3f847c3$var$ARROW_RIGHT
];
const $9e31ee77d3f847c3$var$verticalKeys = [
    $9e31ee77d3f847c3$var$ARROW_UP,
    $9e31ee77d3f847c3$var$ARROW_DOWN
];
const $9e31ee77d3f847c3$var$allKeys = [
    ...$9e31ee77d3f847c3$var$horizontalKeys,
    ...$9e31ee77d3f847c3$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $9e31ee77d3f847c3$export$43586241d9db0c6d = /*#__PURE__*/ $c56K2.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $c56K2.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $9e31ee77d3f847c3$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $c56K2.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $c56K2.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$9e31ee77d3f847c3$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $9e31ee77d3f847c3$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $9e31ee77d3f847c3$var$getMaxIndex(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $9e31ee77d3f847c3$var$ARROW_LEFT : $9e31ee77d3f847c3$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $9e31ee77d3f847c3$var$ARROW_RIGHT : $9e31ee77d3f847c3$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $9e31ee77d3f847c3$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$9e31ee77d3f847c3$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$9e31ee77d3f847c3$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$9e31ee77d3f847c3$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $9e31ee77d3f847c3$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$9e31ee77d3f847c3$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $9e31ee77d3f847c3$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $9e31ee77d3f847c3$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $9e31ee77d3f847c3$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $9e31ee77d3f847c3$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $9e31ee77d3f847c3$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $9e31ee77d3f847c3$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $9e31ee77d3f847c3$var$allKeys : ({
            horizontal: $9e31ee77d3f847c3$var$horizontalKeys,
            vertical: $9e31ee77d3f847c3$var$verticalKeys,
            both: $9e31ee77d3f847c3$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $9e31ee77d3f847c3$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$9e31ee77d3f847c3$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $9e31ee77d3f847c3$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $9e31ee77d3f847c3$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $c56K2.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $c56K2.useContext($9e31ee77d3f847c3$var$CompositeContext);
    const { ref: ref, index: index } = $9e31ee77d3f847c3$export$dcdc7ff5149f7d1a();
    const mergedRef = $9e31ee77d3f847c3$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $9e31ee77d3f847c3$var$renderJsx(render, computedProps);
});
function $9e31ee77d3f847c3$var$_extends() {
    $9e31ee77d3f847c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e31ee77d3f847c3$var$_extends.apply(this, arguments);
}
let $9e31ee77d3f847c3$var$serverHandoffComplete = false;
let $9e31ee77d3f847c3$var$count = 0;
const $9e31ee77d3f847c3$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $9e31ee77d3f847c3$var$count++;
function $9e31ee77d3f847c3$var$useFloatingId() {
    const [id, setId] = $c56K2.useState(()=>$9e31ee77d3f847c3$var$serverHandoffComplete ? $9e31ee77d3f847c3$var$genId() : undefined);
    $9e31ee77d3f847c3$var$index(()=>{
        if (id == null) setId($9e31ee77d3f847c3$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $c56K2.useEffect(()=>{
        $9e31ee77d3f847c3$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $9e31ee77d3f847c3$var$useReactId = $9e31ee77d3f847c3$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $9e31ee77d3f847c3$export$f680877a34711e37 = $9e31ee77d3f847c3$var$useReactId || $9e31ee77d3f847c3$var$useFloatingId;
let $9e31ee77d3f847c3$var$devMessageSet;
function $9e31ee77d3f847c3$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $9e31ee77d3f847c3$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $9e31ee77d3f847c3$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $9e31ee77d3f847c3$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $9e31ee77d3f847c3$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $9e31ee77d3f847c3$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $9e31ee77d3f847c3$export$33511391554732bc = /*#__PURE__*/ $c56K2.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $9e31ee77d3f847c3$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $c56K2.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $9e31ee77d3f847c3$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $d5ca47c9e734d524$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $c56K2.createElement("svg", $9e31ee77d3f847c3$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $c56K2.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $c56K2.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $c56K2.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $c56K2.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $9e31ee77d3f847c3$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $9e31ee77d3f847c3$var$FloatingNodeContext = /*#__PURE__*/ $c56K2.createContext(null);
const $9e31ee77d3f847c3$var$FloatingTreeContext = /*#__PURE__*/ $c56K2.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $9e31ee77d3f847c3$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $c56K2.useContext($9e31ee77d3f847c3$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $9e31ee77d3f847c3$export$db0c2a7c7a2a4f69 = ()=>$c56K2.useContext($9e31ee77d3f847c3$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $9e31ee77d3f847c3$export$9b136e0e758a42f4(customParentId) {
    const id = $9e31ee77d3f847c3$export$f680877a34711e37();
    const tree = $9e31ee77d3f847c3$export$db0c2a7c7a2a4f69();
    const reactParentId = $9e31ee77d3f847c3$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $9e31ee77d3f847c3$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $9e31ee77d3f847c3$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $9e31ee77d3f847c3$export$165209eae06d3488();
    return /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FloatingNodeContext.Provider, {
        value: $c56K2.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $9e31ee77d3f847c3$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $c56K2.useRef([]);
    const addNode = $c56K2.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $c56K2.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $c56K2.useState(()=>$9e31ee77d3f847c3$var$createPubSub())[0];
    return /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FloatingTreeContext.Provider, {
        value: $c56K2.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $9e31ee77d3f847c3$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $9e31ee77d3f847c3$var$useLatestRef(value) {
    const ref = (0, $c56K2.useRef)(value);
    $9e31ee77d3f847c3$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $9e31ee77d3f847c3$var$safePolygonIdentifier = /*#__PURE__*/ $9e31ee77d3f847c3$var$createAttribute('safe-polygon');
function $9e31ee77d3f847c3$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $3567a0f9e185fb8e$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $9e31ee77d3f847c3$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $9e31ee77d3f847c3$export$db0c2a7c7a2a4f69();
    const parentId = $9e31ee77d3f847c3$export$165209eae06d3488();
    const handleCloseRef = $9e31ee77d3f847c3$var$useLatestRef(handleClose);
    const delayRef = $9e31ee77d3f847c3$var$useLatestRef(delay);
    const openRef = $9e31ee77d3f847c3$var$useLatestRef(open);
    const pointerTypeRef = $c56K2.useRef();
    const timeoutRef = $c56K2.useRef(-1);
    const handlerRef = $c56K2.useRef();
    const restTimeoutRef = $c56K2.useRef(-1);
    const blockMouseMoveRef = $c56K2.useRef(true);
    const performedPointerEventsMutationRef = $c56K2.useRef(false);
    const unbindMouseMoveRef = $c56K2.useRef(()=>{});
    const restTimeoutPendingRef = $c56K2.useRef(false);
    const isHoverOpen = $c56K2.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $c56K2.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $c56K2.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $c56K2.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $9e31ee77d3f847c3$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $9e31ee77d3f847c3$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $9e31ee77d3f847c3$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($9e31ee77d3f847c3$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = $9e31ee77d3f847c3$var$useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $c56K2.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $3567a0f9e185fb8e$export$81cf264172d31e51)(pointerTypeRef.current) || restMs > 0 && !$9e31ee77d3f847c3$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $9e31ee77d3f847c3$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $3567a0f9e185fb8e$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $9e31ee77d3f847c3$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($9e31ee77d3f847c3$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $c56K2.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $c56K2.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $3567a0f9e185fb8e$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $c56K2.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $9e31ee77d3f847c3$var$NOOP = ()=>{};
const $9e31ee77d3f847c3$var$FloatingDelayGroupContext = /*#__PURE__*/ $c56K2.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $9e31ee77d3f847c3$var$NOOP,
    setState: $9e31ee77d3f847c3$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $9e31ee77d3f847c3$export$e2411914b150383d = ()=>$c56K2.useContext($9e31ee77d3f847c3$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $9e31ee77d3f847c3$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $c56K2.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $c56K2.useRef(null);
    const setCurrentId = $c56K2.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $9e31ee77d3f847c3$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FloatingDelayGroupContext.Provider, {
        value: $c56K2.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $9e31ee77d3f847c3$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $9e31ee77d3f847c3$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $9e31ee77d3f847c3$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $9e31ee77d3f847c3$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $9e31ee77d3f847c3$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
let $9e31ee77d3f847c3$var$rafId = 0;
function $9e31ee77d3f847c3$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($9e31ee77d3f847c3$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $9e31ee77d3f847c3$var$rafId = requestAnimationFrame(exec);
}
function $9e31ee77d3f847c3$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $9e31ee77d3f847c3$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $9e31ee77d3f847c3$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $9e31ee77d3f847c3$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $9e31ee77d3f847c3$var$counterMap = /*#__PURE__*/ new WeakMap();
let $9e31ee77d3f847c3$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $9e31ee77d3f847c3$var$markerMap = {};
let $9e31ee77d3f847c3$var$lockCount$1 = 0;
const $9e31ee77d3f847c3$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $9e31ee77d3f847c3$var$unwrapHost = (node)=>node && (node.host || $9e31ee77d3f847c3$var$unwrapHost(node.parentNode));
const $9e31ee77d3f847c3$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $9e31ee77d3f847c3$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $9e31ee77d3f847c3$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $9e31ee77d3f847c3$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$9e31ee77d3f847c3$var$markerMap[markerName]) $9e31ee77d3f847c3$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $9e31ee77d3f847c3$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $d5ca47c9e734d524$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($9e31ee77d3f847c3$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $9e31ee77d3f847c3$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $9e31ee77d3f847c3$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $9e31ee77d3f847c3$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($9e31ee77d3f847c3$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $9e31ee77d3f847c3$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$9e31ee77d3f847c3$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $9e31ee77d3f847c3$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $9e31ee77d3f847c3$var$lockCount$1--;
        if (!$9e31ee77d3f847c3$var$lockCount$1) {
            $9e31ee77d3f847c3$var$counterMap = new WeakMap();
            $9e31ee77d3f847c3$var$counterMap = new WeakMap();
            $9e31ee77d3f847c3$var$uncontrolledElementsSet = new WeakSet();
            $9e31ee77d3f847c3$var$markerMap = {};
        }
    };
}
function $9e31ee77d3f847c3$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(avoidElements[0]).body;
    return $9e31ee77d3f847c3$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $9e31ee77d3f847c3$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $9e31ee77d3f847c3$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $82cd98eb5c062693$export$17100aea90429aa7)(container, $9e31ee77d3f847c3$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $3567a0f9e185fb8e$export$da980962bd2147a4)((0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $9e31ee77d3f847c3$var$getNextTabbable() {
    return $9e31ee77d3f847c3$var$getTabbableIn(document.body, 'next');
}
function $9e31ee77d3f847c3$var$getPreviousTabbable() {
    return $9e31ee77d3f847c3$var$getTabbableIn(document.body, 'prev');
}
function $9e31ee77d3f847c3$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $3567a0f9e185fb8e$export$2344b14b097df817)(containerElement, relatedTarget);
}
function $9e31ee77d3f847c3$var$disableFocusInside(container) {
    const tabbableElements = (0, $82cd98eb5c062693$export$17100aea90429aa7)(container, $9e31ee77d3f847c3$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $9e31ee77d3f847c3$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $9e31ee77d3f847c3$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $9e31ee77d3f847c3$var$timeoutId;
function $9e31ee77d3f847c3$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($9e31ee77d3f847c3$var$timeoutId);
    }
}
const $9e31ee77d3f847c3$var$FocusGuard = /*#__PURE__*/ $c56K2.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $c56K2.useState();
    $9e31ee77d3f847c3$var$index(()=>{
        if ((0, $3567a0f9e185fb8e$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $9e31ee77d3f847c3$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $9e31ee77d3f847c3$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$9e31ee77d3f847c3$var$createAttribute('focus-guard')]: '',
        style: $9e31ee77d3f847c3$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $c56K2.createElement("span", $9e31ee77d3f847c3$var$_extends({}, props, restProps));
});
const $9e31ee77d3f847c3$var$PortalContext = /*#__PURE__*/ $c56K2.createContext(null);
const $9e31ee77d3f847c3$var$attr = /*#__PURE__*/ $9e31ee77d3f847c3$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $9e31ee77d3f847c3$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $9e31ee77d3f847c3$export$f680877a34711e37();
    const portalContext = $9e31ee77d3f847c3$var$usePortalContext();
    const [portalNode, setPortalNode] = $c56K2.useState(null);
    const portalNodeRef = $c56K2.useRef(null);
    $9e31ee77d3f847c3$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($9e31ee77d3f847c3$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($9e31ee77d3f847c3$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $9e31ee77d3f847c3$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $9e31ee77d3f847c3$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $c56K2.useState(null);
    const beforeOutsideRef = $c56K2.useRef(null);
    const afterOutsideRef = $c56K2.useRef(null);
    const beforeInsideRef = $c56K2.useRef(null);
    const afterInsideRef = $c56K2.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $c56K2.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $9e31ee77d3f847c3$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $9e31ee77d3f847c3$var$enableFocusInside : $9e31ee77d3f847c3$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $c56K2.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $9e31ee77d3f847c3$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$PortalContext.Provider, {
        value: $c56K2.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($9e31ee77d3f847c3$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $9e31ee77d3f847c3$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $c56K2.createElement("span", {
        "aria-owns": portalNode.id,
        style: $9e31ee77d3f847c3$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $dg2Np.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($9e31ee77d3f847c3$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $9e31ee77d3f847c3$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $9e31ee77d3f847c3$var$usePortalContext = ()=>$c56K2.useContext($9e31ee77d3f847c3$var$PortalContext);
const $9e31ee77d3f847c3$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $9e31ee77d3f847c3$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($9e31ee77d3f847c3$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $9e31ee77d3f847c3$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $9e31ee77d3f847c3$var$LIST_LIMIT = 20;
let $9e31ee77d3f847c3$var$previouslyFocusedElements = [];
function $9e31ee77d3f847c3$var$addPreviouslyFocusedElement(element) {
    $9e31ee77d3f847c3$var$previouslyFocusedElements = $9e31ee77d3f847c3$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $d5ca47c9e734d524$export$651544f548703224)(tabbableEl) === 'body') return;
    if (!(0, $82cd98eb5c062693$export$bebd5a1431fec25d)(tabbableEl, $9e31ee77d3f847c3$var$getTabbableOptions())) {
        const tabbableChild = (0, $82cd98eb5c062693$export$17100aea90429aa7)(tabbableEl, $9e31ee77d3f847c3$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $9e31ee77d3f847c3$var$previouslyFocusedElements.push(tabbableEl);
    if ($9e31ee77d3f847c3$var$previouslyFocusedElements.length > $9e31ee77d3f847c3$var$LIST_LIMIT) $9e31ee77d3f847c3$var$previouslyFocusedElements = $9e31ee77d3f847c3$var$previouslyFocusedElements.slice(-$9e31ee77d3f847c3$var$LIST_LIMIT);
}
function $9e31ee77d3f847c3$var$getPreviouslyFocusedElement() {
    return $9e31ee77d3f847c3$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $9e31ee77d3f847c3$var$VisuallyHiddenDismiss = /*#__PURE__*/ $c56K2.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $c56K2.createElement("button", $9e31ee77d3f847c3$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $9e31ee77d3f847c3$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $9e31ee77d3f847c3$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $3567a0f9e185fb8e$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $9e31ee77d3f847c3$var$supportsInert() ? _guards : true;
    const orderRef = $9e31ee77d3f847c3$var$useLatestRef(order);
    const initialFocusRef = $9e31ee77d3f847c3$var$useLatestRef(initialFocus);
    const returnFocusRef = $9e31ee77d3f847c3$var$useLatestRef(returnFocus);
    const tree = $9e31ee77d3f847c3$export$db0c2a7c7a2a4f69();
    const portalContext = $9e31ee77d3f847c3$var$usePortalContext();
    const startDismissButtonRef = $c56K2.useRef(null);
    const endDismissButtonRef = $c56K2.useRef(null);
    const preventReturnFocusRef = $c56K2.useRef(false);
    const isPointerDownRef = $c56K2.useRef(false);
    const tabbableIndexRef = $c56K2.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $9e31ee77d3f847c3$var$getFloatingFocusElement(floating);
    const getTabbableContent = $9e31ee77d3f847c3$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $82cd98eb5c062693$export$17100aea90429aa7)(container, $9e31ee77d3f847c3$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $9e31ee77d3f847c3$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $c56K2.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $3567a0f9e185fb8e$export$2344b14b097df817)(floatingFocusElement, (0, $3567a0f9e185fb8e$export$da980962bd2147a4)((0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $9e31ee77d3f847c3$var$enqueueFocus(els[els.length - 1]);
                    else $9e31ee77d3f847c3$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                    $9e31ee77d3f847c3$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $c56K2.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $c56K2.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $3567a0f9e185fb8e$export$2344b14b097df817)(domReference, relatedTarget) || (0, $3567a0f9e185fb8e$export$2344b14b097df817)(floating, relatedTarget) || (0, $3567a0f9e185fb8e$export$2344b14b097df817)(relatedTarget, floating) || (0, $3567a0f9e185fb8e$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($9e31ee77d3f847c3$var$createAttribute('focus-guard')) || tree && ($9e31ee77d3f847c3$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $3567a0f9e185fb8e$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $3567a0f9e185fb8e$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $9e31ee77d3f847c3$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $3567a0f9e185fb8e$export$da980962bd2147a4)((0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $9e31ee77d3f847c3$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $c56K2.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $9e31ee77d3f847c3$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $9e31ee77d3f847c3$var$markOthers(insideElements, guards, !guards) : $9e31ee77d3f847c3$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        if (disabled || !(0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $3567a0f9e185fb8e$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $3567a0f9e185fb8e$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $9e31ee77d3f847c3$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $3567a0f9e185fb8e$export$da980962bd2147a4)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $9e31ee77d3f847c3$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $9e31ee77d3f847c3$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $3567a0f9e185fb8e$export$60278871457622de)(event) || (0, $3567a0f9e185fb8e$export$29bf1b5f2c56cf63)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $9e31ee77d3f847c3$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') return $9e31ee77d3f847c3$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $3567a0f9e185fb8e$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $3567a0f9e185fb8e$export$2344b14b097df817)(floating, activeEl) || tree && $9e31ee77d3f847c3$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $3567a0f9e185fb8e$export$2344b14b097df817)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $9e31ee77d3f847c3$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    $c56K2.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $9e31ee77d3f847c3$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $3567a0f9e185fb8e$export$da980962bd2147a4)((0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $c56K2.createElement($c56K2.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $9e31ee77d3f847c3$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($9e31ee77d3f847c3$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $9e31ee77d3f847c3$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $c56K2.createElement($9e31ee77d3f847c3$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $9e31ee77d3f847c3$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($9e31ee77d3f847c3$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $9e31ee77d3f847c3$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $9e31ee77d3f847c3$var$lockCount = 0;
function $9e31ee77d3f847c3$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $3567a0f9e185fb8e$export$867a782338812cb4)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $9e31ee77d3f847c3$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $9e31ee77d3f847c3$export$a35954495955337b = /*#__PURE__*/ $c56K2.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $9e31ee77d3f847c3$var$index(()=>{
        if (!lockScroll) return;
        $9e31ee77d3f847c3$var$lockCount++;
        if ($9e31ee77d3f847c3$var$lockCount === 1) $9e31ee77d3f847c3$var$cleanup = $9e31ee77d3f847c3$var$enableScrollLock();
        return ()=>{
            $9e31ee77d3f847c3$var$lockCount--;
            if ($9e31ee77d3f847c3$var$lockCount === 0) $9e31ee77d3f847c3$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $c56K2.createElement("div", $9e31ee77d3f847c3$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $9e31ee77d3f847c3$var$isButtonTarget(event) {
    return (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $9e31ee77d3f847c3$var$isSpaceIgnored(element) {
    return (0, $3567a0f9e185fb8e$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $9e31ee77d3f847c3$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $c56K2.useRef();
    const didKeyDownRef = $c56K2.useRef(false);
    const reference = $c56K2.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $3567a0f9e185fb8e$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $3567a0f9e185fb8e$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $9e31ee77d3f847c3$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$9e31ee77d3f847c3$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $9e31ee77d3f847c3$var$isButtonTarget(event) || $9e31ee77d3f847c3$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $9e31ee77d3f847c3$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $9e31ee77d3f847c3$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $9e31ee77d3f847c3$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $c56K2.useRef(false);
    const cleanupListenerRef = $c56K2.useRef(null);
    const [pointerType, setPointerType] = $c56K2.useState();
    const [reactive, setReactive] = $c56K2.useState([]);
    const setReference = $9e31ee77d3f847c3$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$9e31ee77d3f847c3$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($9e31ee77d3f847c3$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $9e31ee77d3f847c3$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $3567a0f9e185fb8e$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $c56K2.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event);
            if (!(0, $3567a0f9e185fb8e$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $9e31ee77d3f847c3$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $c56K2.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $c56K2.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $c56K2.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $c56K2.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $9e31ee77d3f847c3$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $9e31ee77d3f847c3$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $9e31ee77d3f847c3$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $9e31ee77d3f847c3$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $9e31ee77d3f847c3$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $9e31ee77d3f847c3$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $c56K2.useRef(false);
    const endedOrStartedInsideRef = $c56K2.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $9e31ee77d3f847c3$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $9e31ee77d3f847c3$var$normalizeProp(capture);
    const isComposingRef = $c56K2.useRef(false);
    const closeOnEscapeKeyDown = $9e31ee77d3f847c3$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $9e31ee77d3f847c3$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $3567a0f9e185fb8e$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $9e31ee77d3f847c3$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $9e31ee77d3f847c3$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $9e31ee77d3f847c3$var$createAttribute('inert') + "]";
        const markers = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $d5ca47c9e734d524$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $d5ca47c9e734d524$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $d5ca47c9e734d524$export$d1162fb0b6d4cd51)(nextParent) || !(0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(target) && !(0, $3567a0f9e185fb8e$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $3567a0f9e185fb8e$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $3567a0f9e185fb8e$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $d5ca47c9e734d524$export$3735103072e4a80)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $9e31ee77d3f847c3$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $3567a0f9e185fb8e$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $3567a0f9e185fb8e$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $3567a0f9e185fb8e$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $9e31ee77d3f847c3$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $9e31ee77d3f847c3$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $c56K2.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $d5ca47c9e734d524$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $d5ca47c9e734d524$export$3b57c1601291186b)(elements.domReference);
            if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $d5ca47c9e734d524$export$3b57c1601291186b)(elements.floating));
            if (!(0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $d5ca47c9e734d524$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $c56K2.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $c56K2.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$9e31ee77d3f847c3$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $c56K2.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$9e31ee77d3f847c3$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $9e31ee77d3f847c3$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $9e31ee77d3f847c3$export$f680877a34711e37();
    const dataRef = $c56K2.useRef({});
    const [events] = $c56K2.useState(()=>$9e31ee77d3f847c3$var$createPubSub());
    const nested = $9e31ee77d3f847c3$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $c56K2.useState(elementsProp.reference);
    const onOpenChange = $9e31ee77d3f847c3$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $c56K2.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $c56K2.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $c56K2.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $9e31ee77d3f847c3$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $9e31ee77d3f847c3$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $c56K2.useState(null);
    const [positionReference, _setPositionReference] = $c56K2.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $c56K2.useRef(null);
    const tree = $9e31ee77d3f847c3$export$db0c2a7c7a2a4f69();
    $9e31ee77d3f847c3$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $49265da98b96e02c$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $c56K2.useCallback((node)=>{
        const computedPositionReference = (0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $c56K2.useCallback((node)=>{
        if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $c56K2.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $c56K2.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $c56K2.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $c56K2.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $9e31ee77d3f847c3$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $c56K2.useRef(false);
    const timeoutRef = $c56K2.useRef();
    const keyboardModalityRef = $c56K2.useRef(true);
    $c56K2.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $d5ca47c9e734d524$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $3567a0f9e185fb8e$export$da980962bd2147a4)((0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $c56K2.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $c56K2.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $c56K2.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $3567a0f9e185fb8e$export$29bf1b5f2c56cf63)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $3567a0f9e185fb8e$export$95df08bae54cb4df)() && (0, $3567a0f9e185fb8e$export$9ac100e40613ea10)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $3567a0f9e185fb8e$export$42ad131c32f0fb8d)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($9e31ee77d3f847c3$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $3567a0f9e185fb8e$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $3567a0f9e185fb8e$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $3567a0f9e185fb8e$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $9e31ee77d3f847c3$var$ACTIVE_KEY = 'active';
const $9e31ee77d3f847c3$var$SELECTED_KEY = 'selected';
function $9e31ee77d3f847c3$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$9e31ee77d3f847c3$var$ACTIVE_KEY]: _, [$9e31ee77d3f847c3$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$9e31ee77d3f847c3$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $9e31ee77d3f847c3$var$ACTIVE_KEY,
                    $9e31ee77d3f847c3$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $9e31ee77d3f847c3$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $c56K2.useCallback((userProps)=>$9e31ee77d3f847c3$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $c56K2.useCallback((userProps)=>$9e31ee77d3f847c3$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $c56K2.useCallback((userProps)=>$9e31ee77d3f847c3$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $c56K2.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $9e31ee77d3f847c3$var$isPreventScrollSupported = false;
function $9e31ee77d3f847c3$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $9e31ee77d3f847c3$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $9e31ee77d3f847c3$var$ARROW_UP || key === $9e31ee77d3f847c3$var$ARROW_DOWN;
    const horizontal = key === $9e31ee77d3f847c3$var$ARROW_LEFT || key === $9e31ee77d3f847c3$var$ARROW_RIGHT;
    return $9e31ee77d3f847c3$var$doSwitch(orientation, vertical, horizontal);
}
function $9e31ee77d3f847c3$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $9e31ee77d3f847c3$var$ARROW_DOWN;
    const horizontal = rtl ? key === $9e31ee77d3f847c3$var$ARROW_LEFT : key === $9e31ee77d3f847c3$var$ARROW_RIGHT;
    return $9e31ee77d3f847c3$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $9e31ee77d3f847c3$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $9e31ee77d3f847c3$var$ARROW_LEFT : key === $9e31ee77d3f847c3$var$ARROW_RIGHT;
    const horizontal = key === $9e31ee77d3f847c3$var$ARROW_DOWN;
    return $9e31ee77d3f847c3$var$doSwitch(orientation, vertical, horizontal);
}
function $9e31ee77d3f847c3$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $9e31ee77d3f847c3$var$ARROW_RIGHT : key === $9e31ee77d3f847c3$var$ARROW_LEFT;
    const horizontal = key === $9e31ee77d3f847c3$var$ARROW_UP;
    return $9e31ee77d3f847c3$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $9e31ee77d3f847c3$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $9e31ee77d3f847c3$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $9e31ee77d3f847c3$var$useLatestRef(floatingFocusElement);
    const parentId = $9e31ee77d3f847c3$export$165209eae06d3488();
    const tree = $9e31ee77d3f847c3$export$db0c2a7c7a2a4f69();
    const onNavigate = $9e31ee77d3f847c3$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $3567a0f9e185fb8e$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $c56K2.useRef(focusItemOnOpen);
    const indexRef = $c56K2.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $c56K2.useRef(null);
    const isPointerModalityRef = $c56K2.useRef(true);
    const previousOnNavigateRef = $c56K2.useRef(onNavigate);
    const previousMountedRef = $c56K2.useRef(!!elements.floating);
    const previousOpenRef = $c56K2.useRef(open);
    const forceSyncFocus = $c56K2.useRef(false);
    const forceScrollIntoViewRef = $c56K2.useRef(false);
    const disabledIndicesRef = $9e31ee77d3f847c3$var$useLatestRef(disabledIndices);
    const latestOpenRef = $9e31ee77d3f847c3$var$useLatestRef(open);
    const scrollItemIntoViewRef = $9e31ee77d3f847c3$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $9e31ee77d3f847c3$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $c56K2.useState();
    const [virtualId, setVirtualId] = $c56K2.useState();
    const focusItem = $9e31ee77d3f847c3$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $9e31ee77d3f847c3$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $3567a0f9e185fb8e$export$9ac100e40613ea10)() && (0, $3567a0f9e185fb8e$export$95df08bae54cb4df)() ? $9e31ee77d3f847c3$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $9e31ee77d3f847c3$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $9e31ee77d3f847c3$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $9e31ee77d3f847c3$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $9e31ee77d3f847c3$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $9e31ee77d3f847c3$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $9e31ee77d3f847c3$var$getMinIndex(listRef, disabledIndicesRef.current) : $9e31ee77d3f847c3$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$9e31ee77d3f847c3$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $9e31ee77d3f847c3$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $3567a0f9e185fb8e$export$da980962bd2147a4)((0, $3567a0f9e185fb8e$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $3567a0f9e185fb8e$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $9e31ee77d3f847c3$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $c56K2.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $9e31ee77d3f847c3$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $9e31ee77d3f847c3$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $9e31ee77d3f847c3$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $d5ca47c9e734d524$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $9e31ee77d3f847c3$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $9e31ee77d3f847c3$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $9e31ee77d3f847c3$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$9e31ee77d3f847c3$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$9e31ee77d3f847c3$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$9e31ee77d3f847c3$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $9e31ee77d3f847c3$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$9e31ee77d3f847c3$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $9e31ee77d3f847c3$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $9e31ee77d3f847c3$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $9e31ee77d3f847c3$var$ARROW_LEFT : $9e31ee77d3f847c3$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($9e31ee77d3f847c3$var$isMainOrientationKey(event.key, orientation)) {
            (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $3567a0f9e185fb8e$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $9e31ee77d3f847c3$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($9e31ee77d3f847c3$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $9e31ee77d3f847c3$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $9e31ee77d3f847c3$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $9e31ee77d3f847c3$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $9e31ee77d3f847c3$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($9e31ee77d3f847c3$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $c56K2.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $c56K2.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $3567a0f9e185fb8e$export$259ba5ae38188551)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $c56K2.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $3567a0f9e185fb8e$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $3567a0f9e185fb8e$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $9e31ee77d3f847c3$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $9e31ee77d3f847c3$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $9e31ee77d3f847c3$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $9e31ee77d3f847c3$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = $9e31ee77d3f847c3$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $9e31ee77d3f847c3$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $9e31ee77d3f847c3$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $9e31ee77d3f847c3$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $9e31ee77d3f847c3$export$f680877a34711e37();
    const parentId = $9e31ee77d3f847c3$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $c56K2.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $c56K2.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $c56K2.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $9e31ee77d3f847c3$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $9e31ee77d3f847c3$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $9e31ee77d3f847c3$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $c56K2.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $c56K2.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $9e31ee77d3f847c3$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $c56K2.useState('unmounted');
    const isMounted = $9e31ee77d3f847c3$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $9e31ee77d3f847c3$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $9e31ee77d3f847c3$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $c56K2.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $c56K2.useState(()=>({
            ...$9e31ee77d3f847c3$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$9e31ee77d3f847c3$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $9e31ee77d3f847c3$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $9e31ee77d3f847c3$var$useLatestRef(unstable_initial);
    const openRef = $9e31ee77d3f847c3$var$useLatestRef(unstable_open);
    const closeRef = $9e31ee77d3f847c3$var$useLatestRef(unstable_close);
    const commonRef = $9e31ee77d3f847c3$var$useLatestRef(unstable_common);
    $9e31ee77d3f847c3$var$index(()=>{
        const initialStyles = $9e31ee77d3f847c3$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $9e31ee77d3f847c3$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $9e31ee77d3f847c3$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $9e31ee77d3f847c3$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($9e31ee77d3f847c3$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($9e31ee77d3f847c3$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $9e31ee77d3f847c3$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $c56K2.useRef();
    const stringRef = $c56K2.useRef('');
    const prevIndexRef = $c56K2.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $c56K2.useRef(null);
    const onMatch = $9e31ee77d3f847c3$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $9e31ee77d3f847c3$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $9e31ee77d3f847c3$var$useLatestRef(findMatch);
    const ignoreKeysRef = $9e31ee77d3f847c3$var$useLatestRef(ignoreKeys);
    $9e31ee77d3f847c3$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $9e31ee77d3f847c3$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $9e31ee77d3f847c3$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $9e31ee77d3f847c3$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $3567a0f9e185fb8e$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $c56K2.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $c56K2.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $9e31ee77d3f847c3$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $9e31ee77d3f847c3$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $08f09f43fc3adce0$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $49265da98b96e02c$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $2f43b0e664909b14$export$37b6bde19b108ecc)($9e31ee77d3f847c3$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $2f43b0e664909b14$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $08f09f43fc3adce0$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $08f09f43fc3adce0$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $08f09f43fc3adce0$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $08f09f43fc3adce0$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $08f09f43fc3adce0$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $dg2Np.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $2f43b0e664909b14$export$37b6bde19b108ecc)($9e31ee77d3f847c3$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $9e31ee77d3f847c3$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $9e31ee77d3f847c3$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $c56K2.useRef(false);
    const prevScrollTopRef = $c56K2.useRef(null);
    const initialOverflowRef = $c56K2.useRef(null);
    $c56K2.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $dg2Np.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $3567a0f9e185fb8e$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $c56K2.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $dg2Np.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $c56K2.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $9e31ee77d3f847c3$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $9e31ee77d3f847c3$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $9e31ee77d3f847c3$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $3567a0f9e185fb8e$export$c22522a4dfa48e9c)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $3567a0f9e185fb8e$export$2344b14b097df817)(elements.floating, target);
            const isOverReferenceEl = (0, $3567a0f9e185fb8e$export$2344b14b097df817)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $9e31ee77d3f847c3$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $d5ca47c9e734d524$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $3567a0f9e185fb8e$export$2344b14b097df817)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $9e31ee77d3f847c3$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($9e31ee77d3f847c3$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$9e31ee77d3f847c3$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $c56K2 = parcelRequire("c56K2");




let $c70662e5a775018d$var$y = (0, $c56K2.createContext)({
    styles: void 0,
    setReference: ()=>{},
    setFloating: ()=>{},
    getReferenceProps: ()=>({}),
    getFloatingProps: ()=>({}),
    slot: {}
});
$c70662e5a775018d$var$y.displayName = "FloatingContext";
let $c70662e5a775018d$var$$ = (0, $c56K2.createContext)(null);
$c70662e5a775018d$var$$.displayName = "PlacementContext";
function $c70662e5a775018d$export$ee5342e485f0bdb0(e) {
    return (0, $c56K2.useMemo)(()=>e ? typeof e == "string" ? {
            to: e
        } : e : null, [
        e
    ]);
}
function $c70662e5a775018d$export$916a28f343467e85() {
    return (0, $c56K2.useContext)($c70662e5a775018d$var$y).setReference;
}
function $c70662e5a775018d$export$c7931d5027a8ead4() {
    return (0, $c56K2.useContext)($c70662e5a775018d$var$y).getReferenceProps;
}
function $c70662e5a775018d$export$106e71f938eae412() {
    let { getFloatingProps: e, slot: t } = (0, $c56K2.useContext)($c70662e5a775018d$var$y);
    return (0, $c56K2.useCallback)((...n)=>Object.assign({}, e(...n), {
            "data-anchor": t.anchor
        }), [
        e,
        t
    ]);
}
function $c70662e5a775018d$export$aff4be9ef2a28e43(e = null) {
    e === !1 && (e = null), typeof e == "string" && (e = {
        to: e
    });
    let t = (0, $c56K2.useContext)($c70662e5a775018d$var$$), n = (0, $c56K2.useMemo)(()=>e, [
        JSON.stringify(e, (l, o)=>{
            var u;
            return (u = o == null ? void 0 : o.outerHTML) != null ? u : o;
        })
    ]);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        t == null || t(n != null ? n : null);
    }, [
        t,
        n
    ]);
    let r = (0, $c56K2.useContext)($c70662e5a775018d$var$y);
    return (0, $c56K2.useMemo)(()=>[
            r.setFloating,
            e ? r.styles : {}
        ], [
        r.setFloating,
        e,
        r.styles
    ]);
}
let $c70662e5a775018d$var$D = 4;
function $c70662e5a775018d$export$e473aa84737d3250({ children: e, enabled: t = !0 }) {
    let [n, r] = (0, $c56K2.useState)(null), [l, o] = (0, $c56K2.useState)(0), u = (0, $c56K2.useRef)(null), [f, s] = (0, $c56K2.useState)(null);
    $c70662e5a775018d$var$ce(f);
    let i = t && n !== null && f !== null, { to: F = "bottom", gap: E = 0, offset: A = 0, padding: c = 0, inner: h } = $c70662e5a775018d$var$ge(n, f), [a, p = "center"] = F.split(" ");
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        i && o(0);
    }, [
        i
    ]);
    let { refs: b, floatingStyles: S, context: g } = (0, $9e31ee77d3f847c3$export$4e02a5c1d08bac65)({
        open: i,
        placement: a === "selection" ? p === "center" ? "bottom" : `bottom-${p}` : p === "center" ? `${a}` : `${a}-${p}`,
        strategy: "absolute",
        transform: !1,
        middleware: [
            (0, $49265da98b96e02c$export$cc800923e997bb8)({
                mainAxis: a === "selection" ? 0 : E,
                crossAxis: A
            }),
            (0, $49265da98b96e02c$export$fba63a578e423eb)({
                padding: c
            }),
            a !== "selection" && (0, $49265da98b96e02c$export$8a83211c878a3f1f)({
                padding: c
            }),
            a === "selection" && h ? (0, $9e31ee77d3f847c3$export$4ae363f1d88fb658)({
                ...h,
                padding: c,
                overflowRef: u,
                offset: l,
                minItemsVisible: $c70662e5a775018d$var$D,
                referenceOverflowThreshold: c,
                onFallbackChange (P) {
                    var L, N;
                    if (!P) return;
                    let d = g.elements.floating;
                    if (!d) return;
                    let M = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0, I = Math.min($c70662e5a775018d$var$D, d.childElementCount), W = 0, B = 0;
                    for (let m of (N = (L = g.elements.floating) == null ? void 0 : L.childNodes) != null ? N : [])if ($72273189d405b787$export$1b3bfaa9684536aa(m)) {
                        let x = m.offsetTop, k = x + m.clientHeight + M, H = d.scrollTop, U = H + d.clientHeight;
                        if (x >= H && k <= U) I--;
                        else {
                            B = Math.max(0, Math.min(k, U) - Math.max(x, H)), W = m.clientHeight;
                            break;
                        }
                    }
                    I >= 1 && o((m)=>{
                        let x = W * I - B + M;
                        return m >= x ? m : x;
                    });
                }
            }) : null,
            (0, $49265da98b96e02c$export$346677f925de839c)({
                padding: c,
                apply ({ availableWidth: P, availableHeight: d, elements: M }) {
                    Object.assign(M.floating.style, {
                        overflow: "auto",
                        maxWidth: `${P}px`,
                        maxHeight: `min(var(--anchor-max-height, 100vh), ${d}px)`
                    });
                }
            })
        ].filter(Boolean),
        whileElementsMounted: (0, $2f43b0e664909b14$export$deee3a793edee05f)
    }), [w = a, V = p] = g.placement.split("-");
    a === "selection" && (w = "selection");
    let G = (0, $c56K2.useMemo)(()=>({
            anchor: [
                w,
                V
            ].filter(Boolean).join(" ")
        }), [
        w,
        V
    ]), K = (0, $9e31ee77d3f847c3$export$3d74b0dda7cc82ff)(g, {
        overflowRef: u,
        onChange: o
    }), { getReferenceProps: Q, getFloatingProps: X } = (0, $9e31ee77d3f847c3$export$a519f7794e446ddd)([
        K
    ]), Y = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((P)=>{
        s(P), b.setFloating(P);
    });
    return $c56K2.createElement($c70662e5a775018d$var$$.Provider, {
        value: r
    }, $c56K2.createElement($c70662e5a775018d$var$y.Provider, {
        value: {
            setFloating: Y,
            setReference: b.setReference,
            styles: S,
            getReferenceProps: Q,
            getFloatingProps: X,
            slot: G
        }
    }, e));
}
function $c70662e5a775018d$var$ce(e) {
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (!e) return;
        let t = new MutationObserver(()=>{
            let n = window.getComputedStyle(e).maxHeight, r = parseFloat(n);
            if (isNaN(r)) return;
            let l = parseInt(n);
            isNaN(l) || r !== l && (e.style.maxHeight = `${Math.ceil(r)}px`);
        });
        return t.observe(e, {
            attributes: !0,
            attributeFilter: [
                "style"
            ]
        }), ()=>{
            t.disconnect();
        };
    }, [
        e
    ]);
}
function $c70662e5a775018d$var$ge(e, t) {
    var o, u, f;
    let n = $c70662e5a775018d$var$O((o = e == null ? void 0 : e.gap) != null ? o : "var(--anchor-gap, 0)", t), r = $c70662e5a775018d$var$O((u = e == null ? void 0 : e.offset) != null ? u : "var(--anchor-offset, 0)", t), l = $c70662e5a775018d$var$O((f = e == null ? void 0 : e.padding) != null ? f : "var(--anchor-padding, 0)", t);
    return {
        ...e,
        gap: n,
        offset: r,
        padding: l
    };
}
function $c70662e5a775018d$var$O(e, t, n) {
    let r = (0, $3517a9b6093b86b1$export$fd183955ff4b45d9)(), l = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((s, i)=>{
        if (s == null) return [
            n,
            null
        ];
        if (typeof s == "number") return [
            s,
            null
        ];
        if (typeof s == "string") {
            if (!i) return [
                n,
                null
            ];
            let F = $c70662e5a775018d$var$J(s, i);
            return [
                F,
                (E)=>{
                    let A = $c70662e5a775018d$var$q(s);
                    {
                        let c = A.map((h)=>window.getComputedStyle(i).getPropertyValue(h));
                        r.requestAnimationFrame(function h() {
                            r.nextFrame(h);
                            let a = !1;
                            for (let [b, S] of A.entries()){
                                let g = window.getComputedStyle(i).getPropertyValue(S);
                                if (c[b] !== g) {
                                    c[b] = g, a = !0;
                                    break;
                                }
                            }
                            if (!a) return;
                            let p = $c70662e5a775018d$var$J(s, i);
                            F !== p && (E(p), F = p);
                        });
                    }
                    return r.dispose;
                }
            ];
        }
        return [
            n,
            null
        ];
    }), o = (0, $c56K2.useMemo)(()=>l(e, t)[0], [
        e,
        t
    ]), [u = o, f] = (0, $c56K2.useState)();
    return (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        let [s, i] = l(e, t);
        if (f(s), !!i) return i(f);
    }, [
        e,
        t
    ]), u;
}
function $c70662e5a775018d$var$q(e) {
    let t = /var\((.*)\)/.exec(e);
    if (t) {
        let n = t[1].indexOf(",");
        if (n === -1) return [
            t[1]
        ];
        let r = t[1].slice(0, n).trim(), l = t[1].slice(n + 1).trim();
        return l ? [
            r,
            ...$c70662e5a775018d$var$q(l)
        ] : [
            r
        ];
    }
    return [];
}
function $c70662e5a775018d$var$J(e, t) {
    let n = document.createElement("div");
    t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
    let r = parseFloat(window.getComputedStyle(n).marginTop) || 0;
    return t.removeChild(n), r;
}





function $59e339314c471d90$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $59e339314c471d90$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($59e339314c471d90$export$807a7eae502106e7 || {});
function $59e339314c471d90$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            s === -1 && (s = t.length);
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $59e339314c471d90$var$u(l);
    }
}











var $c56K2 = parcelRequire("c56K2");


var $c56K2 = parcelRequire("c56K2");





var $c56K2 = parcelRequire("c56K2");
let $e898b670ac3d1c31$var$e = (0, $c56K2.createContext)(void 0);
function $e898b670ac3d1c31$export$6ba3910d268310db() {
    return (0, $c56K2.useContext)($e898b670ac3d1c31$var$e);
}
function $e898b670ac3d1c31$export$6be90bcb437e928f({ id: t, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($e898b670ac3d1c31$var$e.Provider, {
        value: t
    }, r);
}




"use client";
let $7e826a51f36c1711$var$L = (0, $c56K2.createContext)(null);
$7e826a51f36c1711$var$L.displayName = "LabelContext";
function $7e826a51f36c1711$export$feddbbf47baabdb9() {
    let n = (0, $c56K2.useContext)($7e826a51f36c1711$var$L);
    if (n === null) {
        let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(l, $7e826a51f36c1711$export$feddbbf47baabdb9), l;
    }
    return n;
}
function $7e826a51f36c1711$export$1f86aee6764cddb2(n) {
    var a, e, o;
    let l = (e = (a = (0, $c56K2.useContext)($7e826a51f36c1711$var$L)) == null ? void 0 : a.value) != null ? e : void 0;
    return ((o = n == null ? void 0 : n.length) != null ? o : 0) > 0 ? [
        l,
        ...n
    ].filter(Boolean).join(" ") : l;
}
function $7e826a51f36c1711$export$d6875122194c7b44({ inherit: n = !1 } = {}) {
    let l = $7e826a51f36c1711$export$1f86aee6764cddb2(), [a, e] = (0, $c56K2.useState)([]), o = n ? [
        l,
        ...a
    ].filter(Boolean) : a;
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $c56K2.useMemo)(()=>function(t) {
                let p = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((i)=>(e((u)=>[
                            ...u,
                            i
                        ]), ()=>e((u)=>{
                            let d = u.slice(), f = d.indexOf(i);
                            return f !== -1 && d.splice(f, 1), d;
                        }))), b = (0, $c56K2.useMemo)(()=>({
                        register: p,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    p,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement($7e826a51f36c1711$var$L.Provider, {
                    value: b
                }, t.children);
            }, [
            e
        ])
    ];
}
let $7e826a51f36c1711$var$G = "label";
function $7e826a51f36c1711$var$U(n, l) {
    var y;
    let a = (0, $c56K2.useId)(), e = $7e826a51f36c1711$export$feddbbf47baabdb9(), o = (0, $e898b670ac3d1c31$export$6ba3910d268310db)(), T = (0, $4f0e83537aaf78fb$export$c763bb7a184a0f11)(), { id: t = `headlessui-label-${a}`, htmlFor: p = o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor, passive: b = !1, ...i } = n, u = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(l);
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>e.register(t), [
        t,
        e.register
    ]);
    let d = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((s)=>{
        let g = s.currentTarget;
        if (!(s.target !== s.currentTarget && $72273189d405b787$export$3dee5e4542c672d9(s.target)) && ($72273189d405b787$export$42dc0115f0e5e4fc(g) && s.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(s), $72273189d405b787$export$42dc0115f0e5e4fc(g))) {
            let r = document.getElementById(g.htmlFor);
            if (r) {
                let E = r.getAttribute("disabled");
                if (E === "true" || E === "") return;
                let x = r.getAttribute("aria-disabled");
                if (x === "true" || x === "") return;
                ($72273189d405b787$export$88a6ceeed5737ba3(r) && (r.type === "file" || r.type === "radio" || r.type === "checkbox") || r.role === "radio" || r.role === "checkbox" || r.role === "switch") && r.click(), r.focus({
                    preventScroll: !0
                });
            }
        }
    }), f = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        ...e.slot,
        disabled: T || !1
    }), c = {
        ref: u,
        ...e.props,
        id: t,
        htmlFor: p,
        onClick: d
    };
    return b && ("onClick" in c && (delete c.htmlFor, delete c.onClick), "onClick" in i && delete i.onClick), (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: c,
        theirProps: i,
        slot: f,
        defaultTag: p ? $7e826a51f36c1711$var$G : "div",
        name: e.name || "Label"
    });
}
let $7e826a51f36c1711$var$j = (0, $bc193d85907afa60$export$e43f39796049410c)($7e826a51f36c1711$var$U), $7e826a51f36c1711$export$b04be29aa201d4f5 = Object.assign($7e826a51f36c1711$var$j, {});







const $3622661dfb7a5c36$export$6e185a5347a09ebe = {
    Idle: {
        kind: "Idle"
    },
    Tracked: (e)=>({
            kind: "Tracked",
            position: e
        }),
    Moved: {
        kind: "Moved"
    }
};
function $3622661dfb7a5c36$export$988ea8227f238095(e) {
    let t = e.getBoundingClientRect();
    return `${t.x},${t.y}`;
}
function $3622661dfb7a5c36$export$3449027609988d06(e, t, i) {
    let n = (0, $a1511df59d6e26ec$export$12b26c28a05aa001)();
    if (t.kind === "Tracked") {
        let o = function() {
            d !== $3622661dfb7a5c36$export$988ea8227f238095(e) && (n.dispose(), i());
        };
        var f = o;
        let { position: d } = t, s = new ResizeObserver(o);
        s.observe(e), n.add(()=>s.disconnect()), n.addEventListener(window, "scroll", o, {
            passive: !0
        }), n.addEventListener(window, "resize", o);
    }
    return ()=>n.dispose();
}




var $5f0e0ef194f40015$var$y = Object.defineProperty;
var $5f0e0ef194f40015$var$M = (e, i, t)=>i in e ? $5f0e0ef194f40015$var$y(e, i, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[i] = t;
var $5f0e0ef194f40015$var$S = (e, i, t)=>($5f0e0ef194f40015$var$M(e, typeof i != "symbol" ? i + "" : i, t), t);
var $5f0e0ef194f40015$export$b9c7f256f19297fb = ((t)=>(t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))($5f0e0ef194f40015$export$b9c7f256f19297fb || {}), $5f0e0ef194f40015$export$604fb2d029447fbb = ((t)=>(t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))($5f0e0ef194f40015$export$604fb2d029447fbb || {}), $5f0e0ef194f40015$export$1385d81a6c6bbcd4 = ((o)=>(o[o.OpenMenu = 0] = "OpenMenu", o[o.CloseMenu = 1] = "CloseMenu", o[o.GoToItem = 2] = "GoToItem", o[o.Search = 3] = "Search", o[o.ClearSearch = 4] = "ClearSearch", o[o.RegisterItems = 5] = "RegisterItems", o[o.UnregisterItems = 6] = "UnregisterItems", o[o.SetButtonElement = 7] = "SetButtonElement", o[o.SetItemsElement = 8] = "SetItemsElement", o[o.SortItems = 9] = "SortItems", o[o.MarkButtonAsMoved = 10] = "MarkButtonAsMoved", o))($5f0e0ef194f40015$export$1385d81a6c6bbcd4 || {});
function $5f0e0ef194f40015$var$x(e, i = (t)=>t) {
    let t = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, n = (0, $fe570d29719c408c$export$20305e96f91bf103)(i(e.items.slice()), (s)=>s.dataRef.current.domRef.current), r = t ? n.indexOf(t) : null;
    return r === -1 && (r = null), {
        items: n,
        activeItemIndex: r
    };
}
let $5f0e0ef194f40015$var$k = {
    [1] (e) {
        if (e.menuState === 1) return e;
        let i = e.buttonElement ? (0, $3622661dfb7a5c36$export$6e185a5347a09ebe).Tracked((0, $3622661dfb7a5c36$export$988ea8227f238095)(e.buttonElement)) : e.buttonPositionState;
        return {
            ...e,
            activeItemIndex: null,
            pendingFocus: {
                focus: (0, $59e339314c471d90$export$807a7eae502106e7).Nothing
            },
            menuState: 1,
            buttonPositionState: i
        };
    },
    [0] (e, i) {
        return e.menuState === 0 ? e : {
            ...e,
            __demoMode: !1,
            pendingFocus: i.focus,
            menuState: 0,
            buttonPositionState: (0, $3622661dfb7a5c36$export$6e185a5347a09ebe).Idle
        };
    },
    [2]: (e, i)=>{
        var s, l, a, I, f;
        if (e.menuState === 1) return e;
        let t = {
            ...e,
            searchQuery: "",
            activationTrigger: (s = i.trigger) != null ? s : 1,
            __demoMode: !1
        };
        if (i.focus === (0, $59e339314c471d90$export$807a7eae502106e7).Nothing) return {
            ...t,
            activeItemIndex: null
        };
        if (i.focus === (0, $59e339314c471d90$export$807a7eae502106e7).Specific) return {
            ...t,
            activeItemIndex: e.items.findIndex((d)=>d.id === i.id)
        };
        if (i.focus === (0, $59e339314c471d90$export$807a7eae502106e7).Previous) {
            let d = e.activeItemIndex;
            if (d !== null) {
                let o = e.items[d].dataRef.current.domRef, c = (0, $59e339314c471d90$export$c6b4626b54936d5e)(i, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (u)=>u.id,
                    resolveDisabled: (u)=>u.dataRef.current.disabled
                });
                if (c !== null) {
                    let u = e.items[c].dataRef.current.domRef;
                    if (((l = o.current) == null ? void 0 : l.previousElementSibling) === u.current || ((a = u.current) == null ? void 0 : a.previousElementSibling) === null) return {
                        ...t,
                        activeItemIndex: c
                    };
                }
            }
        } else if (i.focus === (0, $59e339314c471d90$export$807a7eae502106e7).Next) {
            let d = e.activeItemIndex;
            if (d !== null) {
                let o = e.items[d].dataRef.current.domRef, c = (0, $59e339314c471d90$export$c6b4626b54936d5e)(i, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (u)=>u.id,
                    resolveDisabled: (u)=>u.dataRef.current.disabled
                });
                if (c !== null) {
                    let u = e.items[c].dataRef.current.domRef;
                    if (((I = o.current) == null ? void 0 : I.nextElementSibling) === u.current || ((f = u.current) == null ? void 0 : f.nextElementSibling) === null) return {
                        ...t,
                        activeItemIndex: c
                    };
                }
            }
        }
        let n = $5f0e0ef194f40015$var$x(e), r = (0, $59e339314c471d90$export$c6b4626b54936d5e)(i, {
            resolveItems: ()=>n.items,
            resolveActiveIndex: ()=>n.activeItemIndex,
            resolveId: (d)=>d.id,
            resolveDisabled: (d)=>d.dataRef.current.disabled
        });
        return {
            ...t,
            ...n,
            activeItemIndex: r
        };
    },
    [3]: (e, i)=>{
        let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + i.value.toLowerCase(), l = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + n).concat(e.items.slice(0, e.activeItemIndex + n)) : e.items).find((I)=>{
            var f;
            return ((f = I.dataRef.current.textValue) == null ? void 0 : f.startsWith(r)) && !I.dataRef.current.disabled;
        }), a = l ? e.items.indexOf(l) : -1;
        return a === -1 || a === e.activeItemIndex ? {
            ...e,
            searchQuery: r
        } : {
            ...e,
            searchQuery: r,
            activeItemIndex: a,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.searchQuery === "" ? e : {
            ...e,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (e, i)=>{
        let t = e.items.concat(i.items.map((r)=>r)), n = e.activeItemIndex;
        return e.pendingFocus.focus !== (0, $59e339314c471d90$export$807a7eae502106e7).Nothing && (n = (0, $59e339314c471d90$export$c6b4626b54936d5e)(e.pendingFocus, {
            resolveItems: ()=>t,
            resolveActiveIndex: ()=>e.activeItemIndex,
            resolveId: (r)=>r.id,
            resolveDisabled: (r)=>r.dataRef.current.disabled
        })), {
            ...e,
            items: t,
            activeItemIndex: n,
            pendingFocus: {
                focus: (0, $59e339314c471d90$export$807a7eae502106e7).Nothing
            },
            pendingShouldSort: !0
        };
    },
    [6]: (e, i)=>{
        let t = e.items, n = [], r = new Set(i.items);
        for (let [s, l] of t.entries())if (r.has(l.id) && (n.push(s), r.delete(l.id), r.size === 0)) break;
        if (n.length > 0) {
            t = t.slice();
            for (let s of n.reverse())t.splice(s, 1);
        }
        return {
            ...e,
            items: t,
            activationTrigger: 1
        };
    },
    [7]: (e, i)=>e.buttonElement === i.element ? e : {
            ...e,
            buttonElement: i.element
        },
    [8]: (e, i)=>e.itemsElement === i.element ? e : {
            ...e,
            itemsElement: i.element
        },
    [9]: (e)=>e.pendingShouldSort ? {
            ...e,
            ...$5f0e0ef194f40015$var$x(e),
            pendingShouldSort: !1
        } : e,
    [10] (e) {
        return e.buttonPositionState.kind !== "Tracked" ? e : {
            ...e,
            buttonPositionState: (0, $3622661dfb7a5c36$export$6e185a5347a09ebe).Moved
        };
    }
};
class $5f0e0ef194f40015$export$648f6cb766064520 extends (0, $de3d24966fd59e11$export$f391db14ff2d9279) {
    constructor(t){
        super(t);
        $5f0e0ef194f40015$var$S(this, "actions", {
            registerItem: (0, $de3d24966fd59e11$export$712ea50be43a7858)(()=>{
                let t = [], n = new Set;
                return [
                    (r, s)=>{
                        n.has(s) || (n.add(s), t.push({
                            id: r,
                            dataRef: s
                        }));
                    },
                    ()=>(n.clear(), this.send({
                            type: 5,
                            items: t.splice(0)
                        }))
                ];
            }),
            unregisterItem: (0, $de3d24966fd59e11$export$712ea50be43a7858)(()=>{
                let t = [];
                return [
                    (n)=>t.push(n),
                    ()=>this.send({
                            type: 6,
                            items: t.splice(0)
                        })
                ];
            })
        });
        $5f0e0ef194f40015$var$S(this, "selectors", {
            activeDescendantId (t) {
                var s;
                let n = t.activeItemIndex, r = t.items;
                return n === null || (s = r[n]) == null ? void 0 : s.id;
            },
            isActive (t, n) {
                var l;
                let r = t.activeItemIndex, s = t.items;
                return r !== null ? ((l = s[r]) == null ? void 0 : l.id) === n : !1;
            },
            shouldScrollIntoView (t, n) {
                return t.__demoMode || t.menuState !== 0 || t.activationTrigger === 0 ? !1 : this.isActive(t, n);
            },
            didButtonMove (t) {
                return t.buttonPositionState.kind === "Moved";
            }
        });
        this.on(5, ()=>{
            this.disposables.requestAnimationFrame(()=>{
                this.send({
                    type: 9
                });
            });
        });
        {
            let n = this.state.id, r = (0, $cd6058473eaf339d$export$151359021f43c28a).get(null);
            this.disposables.add(r.on((0, $cd6058473eaf339d$export$1385d81a6c6bbcd4).Push, (s)=>{
                !r.selectors.isTop(s, n) && this.state.menuState === 0 && this.send({
                    type: 1
                });
            })), this.on(0, ()=>r.actions.push(n)), this.on(1, ()=>r.actions.pop(n));
        }
        this.disposables.group((n)=>{
            this.on(1, (r)=>{
                r.buttonElement && (n.dispose(), n.add((0, $3622661dfb7a5c36$export$3449027609988d06)(r.buttonElement, r.buttonPositionState, ()=>{
                    this.send({
                        type: 10
                    });
                })));
            });
        });
    }
    static new({ id: t, __demoMode: n = !1 }) {
        return new $5f0e0ef194f40015$export$648f6cb766064520({
            id: t,
            __demoMode: n,
            menuState: n ? 0 : 1,
            buttonElement: null,
            itemsElement: null,
            items: [],
            searchQuery: "",
            activeItemIndex: null,
            activationTrigger: 1,
            pendingShouldSort: !1,
            pendingFocus: {
                focus: (0, $59e339314c471d90$export$807a7eae502106e7).Nothing
            },
            buttonPositionState: (0, $3622661dfb7a5c36$export$6e185a5347a09ebe).Idle
        });
    }
    reduce(t, n) {
        return (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(n.type, $5f0e0ef194f40015$var$k, t, n);
    }
}



var $c56K2 = parcelRequire("c56K2");


const $7d4a13707a6889c4$export$c7e742effb1c51e2 = (0, $c56K2.createContext)(null);
function $7d4a13707a6889c4$export$3be2a17d43f51472(t) {
    let n = (0, $c56K2.useContext)($7d4a13707a6889c4$export$c7e742effb1c51e2);
    if (n === null) {
        let e = new Error(`<${t} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $7d4a13707a6889c4$export$f9f36e6f046f8066), e;
    }
    return n;
}
function $7d4a13707a6889c4$export$f9f36e6f046f8066({ id: t, __demoMode: n = !1 }) {
    let e = (0, $c56K2.useMemo)(()=>(0, $5f0e0ef194f40015$export$648f6cb766064520).new({
            id: t,
            __demoMode: n
        }), []);
    return (0, $c25897243d7c7050$export$cd059ee7fd0e9f3d)(()=>e.dispose()), e;
}


"use client";
let $f0aa233e31c3adc2$var$Ze = (0, $c56K2.Fragment);
function $f0aa233e31c3adc2$var$et(m, y) {
    let l = (0, $c56K2.useId)(), { __demoMode: a = !1, ...p } = m, s = (0, $7d4a13707a6889c4$export$f9f36e6f046f8066)({
        id: l,
        __demoMode: a
    }), [n, M, f] = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(s, (d)=>[
            d.menuState,
            d.itemsElement,
            d.buttonElement
        ]), _ = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(y), o = (0, $cd6058473eaf339d$export$151359021f43c28a).get(null), F = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(o, (0, $c56K2.useCallback)((d)=>o.selectors.isTop(d, l), [
        o,
        l
    ]));
    (0, $709911b5ca379297$export$71b2224f1ce5e08e)(F, [
        f,
        M
    ], (d, T)=>{
        var P;
        s.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
        }), (0, $fe570d29719c408c$export$ff1ec1c740b3c8d5)(T, (0, $fe570d29719c408c$export$27112a34f2f8402d).Loose) || (d.preventDefault(), (P = s.state.buttonElement) == null || P.focus());
    });
    let I = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        s.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
        });
    }), b = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: n === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open,
        close: I
    }), i = {
        ref: _
    }, g = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $c70662e5a775018d$export$e473aa84737d3250), null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $7d4a13707a6889c4$export$c7e742effb1c51e2).Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $081f425c3e48d631$export$2a0ed818b175f558), {
        value: (0, $c1ca8b69c3a050c3$export$4659b591c19bdf3d)(n, {
            [(0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open]: (0, $081f425c3e48d631$export$7254cc27399e90bd).Open,
            [(0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Closed]: (0, $081f425c3e48d631$export$7254cc27399e90bd).Closed
        })
    }, g({
        ourProps: i,
        theirProps: p,
        slot: b,
        defaultTag: $f0aa233e31c3adc2$var$Ze,
        name: "Menu"
    }))));
}
let $f0aa233e31c3adc2$var$tt = "button";
function $f0aa233e31c3adc2$var$ot(m, y) {
    let l = (0, $7d4a13707a6889c4$export$3be2a17d43f51472)("Menu.Button"), a = (0, $c56K2.useId)(), { id: p = `headlessui-menu-button-${a}`, disabled: s = !1, autoFocus: n = !1, ...M } = m, f = (0, $c56K2.useRef)(null), _ = (0, $c70662e5a775018d$export$c7931d5027a8ead4)(), o = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(y, f, (0, $c70662e5a775018d$export$916a28f343467e85)(), (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>l.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).SetButtonElement,
            element: t
        }))), F = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>{
        switch(t.key){
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space:
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Enter:
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowDown:
                t.preventDefault(), t.stopPropagation(), l.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).OpenMenu,
                    focus: {
                        focus: (0, $59e339314c471d90$export$807a7eae502106e7).First
                    }
                });
                break;
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowUp:
                t.preventDefault(), t.stopPropagation(), l.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).OpenMenu,
                    focus: {
                        focus: (0, $59e339314c471d90$export$807a7eae502106e7).Last
                    }
                });
                break;
        }
    }), I = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>{
        switch(t.key){
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space:
                t.preventDefault();
                break;
        }
    }), [b, i, g] = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(l, (t)=>[
            t.menuState,
            t.buttonElement,
            t.itemsElement
        ]), d = b === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open;
    (0, $9e20f4f433cb6952$export$a46c853b8b55573a)(d, {
        trigger: i,
        action: (0, $c56K2.useCallback)((t)=>{
            if (i != null && i.contains(t.target)) return (0, $9e20f4f433cb6952$export$e19cd5f9376f8cee).Ignore;
            let S = t.target.closest('[role="menuitem"]:not([data-disabled])');
            return $72273189d405b787$export$1b3bfaa9684536aa(S) ? (0, $9e20f4f433cb6952$export$e19cd5f9376f8cee).Select(S) : g != null && g.contains(t.target) ? (0, $9e20f4f433cb6952$export$e19cd5f9376f8cee).Ignore : (0, $9e20f4f433cb6952$export$e19cd5f9376f8cee).Close;
        }, [
            i,
            g
        ]),
        close: (0, $c56K2.useCallback)(()=>l.send({
                type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
            }), []),
        select: (0, $c56K2.useCallback)((t)=>t.click(), [])
    });
    let T = (0, $166d31fda7ba37f1$export$87bd167e79a089ba)((t)=>{
        var S;
        s || (b === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open ? ((0, $dg2Np.flushSync)(()=>l.send({
                type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
            })), (S = f.current) == null || S.focus({
            preventScroll: !0
        })) : (t.preventDefault(), l.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).OpenMenu,
            focus: {
                focus: (0, $59e339314c471d90$export$807a7eae502106e7).Nothing
            },
            trigger: (0, $5f0e0ef194f40015$export$604fb2d029447fbb).Pointer
        })));
    }), { isFocusVisible: P, focusProps: L } = (0, $c6173221ab826b78$export$4e328f61c538687f)({
        autoFocus: n
    }), { isHovered: O, hoverProps: v } = (0, $207f2e029c99ee9c$export$ae780daf29e6d456)({
        isDisabled: s
    }), { pressed: D, pressProps: U } = (0, $d03ea1a53b0cd3b8$export$73224eeef4bbe873)({
        disabled: s
    }), H = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: b === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open,
        active: D || b === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open,
        disabled: s,
        hover: O,
        focus: P,
        autofocus: n
    }), G = (0, $bc193d85907afa60$export$9d1611c77c2fe928)(_(), {
        ref: o,
        id: p,
        type: (0, $e45a94ef65e2bafd$export$53652b2b272efe9c)(m, f.current),
        "aria-haspopup": "menu",
        "aria-controls": g == null ? void 0 : g.id,
        "aria-expanded": b === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open,
        disabled: s || void 0,
        autoFocus: n,
        onKeyDown: F,
        onKeyUp: I
    }, T, L, v, U);
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: G,
        theirProps: M,
        slot: H,
        defaultTag: $f0aa233e31c3adc2$var$tt,
        name: "Menu.Button"
    });
}
let $f0aa233e31c3adc2$var$nt = "div", $f0aa233e31c3adc2$var$rt = (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).RenderStrategy | (0, $bc193d85907afa60$export$ba0ea3f20e7bf777).Static;
function $f0aa233e31c3adc2$var$at(m, y) {
    let l = (0, $c56K2.useId)(), { id: a = `headlessui-menu-items-${l}`, anchor: p, portal: s = !1, modal: n = !0, transition: M = !1, ...f } = m, _ = (0, $c70662e5a775018d$export$ee5342e485f0bdb0)(p), o = (0, $7d4a13707a6889c4$export$3be2a17d43f51472)("Menu.Items"), [F, I] = (0, $c70662e5a775018d$export$aff4be9ef2a28e43)(_), b = (0, $c70662e5a775018d$export$106e71f938eae412)(), [i, g] = (0, $c56K2.useState)(null), d = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(y, _ ? F : null, (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((e)=>o.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).SetItemsElement,
            element: e
        })), g), [T, P] = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(o, (e)=>[
            e.menuState,
            e.buttonElement
        ]), L = (0, $71d996aa44864848$export$dd9fbcea3de0ae36)(P), O = (0, $71d996aa44864848$export$dd9fbcea3de0ae36)(i);
    _ && (s = !0);
    let v = (0, $081f425c3e48d631$export$fc6fdf0ecf360e)(), [D, U] = (0, $2f3cfd664d133d0e$export$7b286972b8d8ccbf)(M, i, v !== null ? (v & (0, $081f425c3e48d631$export$7254cc27399e90bd).Open) === (0, $081f425c3e48d631$export$7254cc27399e90bd).Open : T === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open);
    (0, $271d62a22f8321aa$export$b41b9097915aa006)(D, P, ()=>{
        o.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
        });
    });
    let H = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(o, (e)=>e.__demoMode), G = H ? !1 : n && T === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open;
    (0, $ad60b3b67ac8c8ab$export$e47ba1b900da5d3b)(G, O);
    let w = H ? !1 : n && T === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open;
    (0, $45f770423adace2b$export$af489fa7e5283cc3)(w, {
        allowed: (0, $c56K2.useCallback)(()=>[
                P,
                i
            ], [
            P,
            i
        ])
    });
    let S = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(o, o.selectors.didButtonMove) ? !1 : D;
    (0, $c56K2.useEffect)(()=>{
        let e = i;
        e && T === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open && ((0, $874591f6f1a15c7a$export$8a2eb51c14bb8899)(e) || e.focus({
            preventScroll: !0
        }));
    }, [
        T,
        i
    ]), (0, $635d76e34fc51215$export$b0abce39eb34b36)(T === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open, {
        container: i,
        accept (e) {
            return e.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (e) {
            e.setAttribute("role", "none");
        }
    });
    let z = (0, $3517a9b6093b86b1$export$fd183955ff4b45d9)(), le = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((e)=>{
        var N, Y, Z;
        switch(z.dispose(), e.key){
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space:
                if (o.state.searchQuery !== "") return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).Search,
                    value: e.key
                });
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Enter:
                if (e.preventDefault(), e.stopPropagation(), o.state.activeItemIndex !== null) {
                    let { dataRef: de } = o.state.items[o.state.activeItemIndex];
                    (Y = (N = de.current) == null ? void 0 : N.domRef.current) == null || Y.click();
                }
                o.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
                }), (0, $fe570d29719c408c$export$46388676ec35ab85)(o.state.buttonElement);
                break;
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowDown:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $59e339314c471d90$export$807a7eae502106e7).Next
                });
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).ArrowUp:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $59e339314c471d90$export$807a7eae502106e7).Previous
                });
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Home:
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).PageUp:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $59e339314c471d90$export$807a7eae502106e7).First
                });
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).End:
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).PageDown:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $59e339314c471d90$export$807a7eae502106e7).Last
                });
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Escape:
                e.preventDefault(), e.stopPropagation(), (0, $dg2Np.flushSync)(()=>o.send({
                        type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
                    })), (Z = o.state.buttonElement) == null || Z.focus({
                    preventScroll: !0
                });
                break;
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Tab:
                e.preventDefault(), e.stopPropagation(), (0, $dg2Np.flushSync)(()=>o.send({
                        type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
                    })), (0, $fe570d29719c408c$export$7fb6c844b485e870)(o.state.buttonElement, e.shiftKey ? (0, $fe570d29719c408c$export$807a7eae502106e7).Previous : (0, $fe570d29719c408c$export$807a7eae502106e7).Next);
                break;
            default:
                e.key.length === 1 && (o.send({
                    type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).Search,
                    value: e.key
                }), z.setTimeout(()=>o.send({
                        type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).ClearSearch
                    }), 350));
                break;
        }
    }), pe = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((e)=>{
        switch(e.key){
            case (0, $5db93c425b4f2ea2$export$4b0075e5ea5e1f26).Space:
                e.preventDefault();
                break;
        }
    }), ie = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        open: T === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open
    }), ue = (0, $bc193d85907afa60$export$9d1611c77c2fe928)(_ ? b() : {}, {
        "aria-activedescendant": (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(o, o.selectors.activeDescendantId),
        "aria-labelledby": (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(o, (e)=>{
            var N;
            return (N = e.buttonElement) == null ? void 0 : N.id;
        }),
        id: a,
        onKeyDown: le,
        onKeyUp: pe,
        role: "menu",
        tabIndex: T === (0, $5f0e0ef194f40015$export$b9c7f256f19297fb).Open ? 0 : void 0,
        ref: d,
        style: {
            ...f.style,
            ...I,
            "--button-width": (0, $e544cadd2233c923$export$2b86bedf890eab8)(D, P, !0).width
        },
        ...(0, $2f3cfd664d133d0e$export$c291d481c40a2fc3)(U)
    }), me = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement((0, $b0504cce4db6877e$export$602eac185826482c), {
        enabled: s ? m.static || D : !1,
        ownerDocument: L
    }, me({
        ourProps: ue,
        theirProps: f,
        slot: ie,
        defaultTag: $f0aa233e31c3adc2$var$nt,
        features: $f0aa233e31c3adc2$var$rt,
        visible: S,
        name: "Menu.Items"
    }));
}
let $f0aa233e31c3adc2$var$st = (0, $c56K2.Fragment);
function $f0aa233e31c3adc2$var$lt(m, y) {
    let l = (0, $c56K2.useId)(), { id: a = `headlessui-menu-item-${l}`, disabled: p = !1, ...s } = m, n = (0, $7d4a13707a6889c4$export$3be2a17d43f51472)("Menu.Item"), M = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(n, (t)=>n.selectors.isActive(t, a)), f = (0, $c56K2.useRef)(null), _ = (0, $a67d248eafae96c4$export$f6a25a78204acc7e)(y, f), o = (0, $193c4d61ee9eb975$export$89d3cfa2bf31e31a)(n, (t)=>n.selectors.shouldScrollIntoView(t, a));
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        if (o) return (0, $a1511df59d6e26ec$export$12b26c28a05aa001)().requestAnimationFrame(()=>{
            var t, S;
            (S = (t = f.current) == null ? void 0 : t.scrollIntoView) == null || S.call(t, {
                block: "nearest"
            });
        });
    }, [
        o,
        f
    ]);
    let F = (0, $dfa4a89254ea6105$export$f6862afd851a1cf4)(f), I = (0, $c56K2.useRef)({
        disabled: p,
        domRef: f,
        get textValue () {
            return F();
        }
    });
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>{
        I.current.disabled = p;
    }, [
        I,
        p
    ]), (0, $485146febb523711$export$ce5ed857c741fd71)(()=>(n.actions.registerItem(a, I), ()=>n.actions.unregisterItem(a)), [
        I,
        a
    ]);
    let b = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        n.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
        });
    }), i = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>{
        if (p) return t.preventDefault();
        n.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).CloseMenu
        }), (0, $fe570d29719c408c$export$46388676ec35ab85)(n.state.buttonElement);
    }), g = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)(()=>{
        if (p) return n.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $59e339314c471d90$export$807a7eae502106e7).Nothing
        });
        n.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $59e339314c471d90$export$807a7eae502106e7).Specific,
            id: a
        });
    }), d = (0, $cb40363295794194$export$24ebee078bde85c3)(), T = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>d.update(t)), P = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>{
        d.wasMoved(t) && (p || M || n.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $59e339314c471d90$export$807a7eae502106e7).Specific,
            id: a,
            trigger: (0, $5f0e0ef194f40015$export$604fb2d029447fbb).Pointer
        }));
    }), L = (0, $1c09c694ceff33d2$export$90fc3a17d93f704c)((t)=>{
        d.wasMoved(t) && (p || M && n.state.activationTrigger === (0, $5f0e0ef194f40015$export$604fb2d029447fbb).Pointer && n.send({
            type: (0, $5f0e0ef194f40015$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $59e339314c471d90$export$807a7eae502106e7).Nothing
        }));
    }), [O, v] = (0, $7e826a51f36c1711$export$d6875122194c7b44)(), [D, U] = (0, $39fd9e43e376396c$export$babde88292020af7)(), H = (0, $6c4bb6c253d44d18$export$9d4c57ee4c6ffdd8)({
        active: M,
        focus: M,
        disabled: p,
        close: b
    }), G = {
        id: a,
        ref: _,
        role: "menuitem",
        tabIndex: p === !0 ? void 0 : -1,
        "aria-disabled": p === !0 ? !0 : void 0,
        "aria-labelledby": O,
        "aria-describedby": D,
        disabled: void 0,
        onClick: i,
        onFocus: g,
        onPointerEnter: T,
        onMouseEnter: T,
        onPointerMove: P,
        onMouseMove: P,
        onPointerLeave: L,
        onMouseLeave: L
    }, w = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement(v, null, (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement(U, null, w({
        ourProps: G,
        theirProps: s,
        slot: H,
        defaultTag: $f0aa233e31c3adc2$var$st,
        name: "Menu.Item"
    })));
}
let $f0aa233e31c3adc2$var$pt = "div";
function $f0aa233e31c3adc2$var$it(m, y) {
    let [l, a] = (0, $7e826a51f36c1711$export$d6875122194c7b44)(), p = m, s = {
        ref: y,
        "aria-labelledby": l,
        role: "group"
    }, n = (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).createElement(a, null, n({
        ourProps: s,
        theirProps: p,
        slot: {},
        defaultTag: $f0aa233e31c3adc2$var$pt,
        name: "Menu.Section"
    }));
}
let $f0aa233e31c3adc2$var$ut = "header";
function $f0aa233e31c3adc2$var$mt(m, y) {
    let l = (0, $c56K2.useId)(), { id: a = `headlessui-menu-heading-${l}`, ...p } = m, s = (0, $7e826a51f36c1711$export$feddbbf47baabdb9)();
    (0, $485146febb523711$export$ce5ed857c741fd71)(()=>s.register(a), [
        a,
        s.register
    ]);
    let n = {
        id: a,
        ref: y,
        role: "presentation",
        ...s.props
    };
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: n,
        theirProps: p,
        slot: {},
        defaultTag: $f0aa233e31c3adc2$var$ut,
        name: "Menu.Heading"
    });
}
let $f0aa233e31c3adc2$var$dt = "div";
function $f0aa233e31c3adc2$var$Tt(m, y) {
    let l = m, a = {
        ref: y,
        role: "separator"
    };
    return (0, $bc193d85907afa60$export$e25bb1e5b53cbdff)()({
        ourProps: a,
        theirProps: l,
        slot: {},
        defaultTag: $f0aa233e31c3adc2$var$dt,
        name: "Menu.Separator"
    });
}
let $f0aa233e31c3adc2$var$ct = (0, $bc193d85907afa60$export$e43f39796049410c)($f0aa233e31c3adc2$var$et), $f0aa233e31c3adc2$export$266a769812832828 = (0, $bc193d85907afa60$export$e43f39796049410c)($f0aa233e31c3adc2$var$ot), $f0aa233e31c3adc2$export$15a41fea157b048a = (0, $bc193d85907afa60$export$e43f39796049410c)($f0aa233e31c3adc2$var$at), $f0aa233e31c3adc2$export$2ce376c2cc3355c8 = (0, $bc193d85907afa60$export$e43f39796049410c)($f0aa233e31c3adc2$var$lt), $f0aa233e31c3adc2$export$4b1545b4f2016d26 = (0, $bc193d85907afa60$export$e43f39796049410c)($f0aa233e31c3adc2$var$it), $f0aa233e31c3adc2$export$ef9631cf12896f8 = (0, $bc193d85907afa60$export$e43f39796049410c)($f0aa233e31c3adc2$var$mt), $f0aa233e31c3adc2$export$1cec7dcdd713e220 = (0, $bc193d85907afa60$export$e43f39796049410c)($f0aa233e31c3adc2$var$Tt), $f0aa233e31c3adc2$export$d9b273488cd8ce6f = Object.assign($f0aa233e31c3adc2$var$ct, {
    Button: $f0aa233e31c3adc2$export$266a769812832828,
    Items: $f0aa233e31c3adc2$export$15a41fea157b048a,
    Item: $f0aa233e31c3adc2$export$2ce376c2cc3355c8,
    Section: $f0aa233e31c3adc2$export$4b1545b4f2016d26,
    Heading: $f0aa233e31c3adc2$export$ef9631cf12896f8,
    Separator: $f0aa233e31c3adc2$export$1cec7dcdd713e220
});



var $c56K2 = parcelRequire("c56K2");

var $c56K2 = parcelRequire("c56K2");
function $1681c9375d187940$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $c56K2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $c56K2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $c56K2.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $1681c9375d187940$var$ForwardRef = /*#__PURE__*/ $c56K2.forwardRef($1681c9375d187940$var$Bars3Icon);
var $1681c9375d187940$export$2e2bcd8739ae039 = $1681c9375d187940$var$ForwardRef;




const $f03feb956d8584c4$var$MenuNavigation = ({ align: align } = {
    align: "right"
})=>{
    const { setIsOpen: setOpenBookNav } = (0, $c56K2.useContext)((0, $e55f5946e67ab9f3$export$8d6bf6257d5e67d2));
    const pageType = document.querySelector("[data-type]")?.dataset.type ?? "";
    const navigation = [
        {
            label: "Read the Bible",
            href: "",
            className: "font-medium",
            onClick: (evt, close)=>{
                evt?.preventDefault();
                if (close) close();
                setOpenBookNav(true);
            }
        },
        {
            label: "Home",
            href: "/index.html"
        }
    ];
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
        className: "not-prose flex items-center font-sans",
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $f0aa233e31c3adc2$export$d9b273488cd8ce6f), {
            as: "div",
            className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("inline-flex", align === "right" ? "text-right" : "text-left"),
            children: [
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $f0aa233e31c3adc2$export$266a769812832828), {
                    "aria-label": "Menu",
                    className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("inline-flex items-center rounded-md", "text-sm text-white", "focus:outline-none focus-visible:ring-2 focus-visible:ring-white"),
                    children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)("div", {
                        className: "inline-flex justify-center px-2 py-1 align-middle text-white hover:text-slate-300",
                        children: [
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $1681c9375d187940$export$2e2bcd8739ae039), {
                                className: "size-8"
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Open Menu"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $a7ee497b70cfad78$export$be58926105124dd4), {
                    as: "div",
                    enter: "transition ease-out duration-100",
                    enterFrom: "transform opacity-0 scale-95",
                    enterTo: "transform opacity-100 scale-100",
                    leave: "transition ease-in duration-75",
                    leaveFrom: "transform opacity-100 scale-100",
                    leaveTo: "transform opacity-0 scale-95",
                    children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $f0aa233e31c3adc2$export$15a41fea157b048a), {
                        className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("absolute top-12 mt-2 w-54", "divide-y divide-gray-100 rounded-md bg-white shadow-lg", "ring-1 ring-black ring-opacity-5 focus:outline-none", align === "right" ? "right-3 origin-top-right" : "left-0 origin-top-left"),
                        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                            className: "p-1",
                            children: navigation.map((link)=>link.divider ? /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                                    className: "mb-1 border"
                                }, link.label) : /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $f0aa233e31c3adc2$export$2ce376c2cc3355c8), {
                                    as: "div",
                                    children: ({ active: active, close: close })=>/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("a", {
                                            href: link.href,
                                            className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)(active ? "bg-rose-500/80 text-white" : pageType !== "book" && link.label !== "Read the Bible" ? "bg-rose-500 text-white" : "text-gray-900", "group flex w-full items-center rounded-md px-2 py-2 mb-1 last:mb-0 no-underline text-sm", link.className ?? ""),
                                            onClick: link.onClick ? (evt)=>{
                                                link.onClick && link.onClick(evt, close);
                                            } : undefined,
                                            children: link.label
                                        }, link.href)
                                }, link.label))
                        })
                    })
                })
            ]
        })
    });
};
var $f03feb956d8584c4$export$2e2bcd8739ae039 = $f03feb956d8584c4$var$MenuNavigation;




const $106c13cd0ae6e96b$var$Provider = ({ children: children, isHelpOpen: isHelpOpen, setIsHelpOpen: setIsHelpOpen, isBookNavOpen: isBookNavOpen, setIsBookNavOpen: setIsBookNavOpen })=>{
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $e55f5946e67ab9f3$export$ae85633f8b51022a).Provider, {
        value: {
            isOpen: isHelpOpen,
            setIsOpen: setIsHelpOpen
        },
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $e55f5946e67ab9f3$export$8d6bf6257d5e67d2).Provider, {
            value: {
                isOpen: isBookNavOpen,
                setIsOpen: setIsBookNavOpen
            },
            children: children
        })
    });
};
var $106c13cd0ae6e96b$export$2e2bcd8739ae039 = $106c13cd0ae6e96b$var$Provider;





var $c56K2 = parcelRequire("c56K2");


const $7a1273b4d7fc220f$var$SubNav = ()=>{
    const { setIsOpen: setOpenHelp } = (0, $c56K2.useContext)((0, $e55f5946e67ab9f3$export$ae85633f8b51022a));
    const pageType = document.querySelector("[data-type]")?.dataset.type ?? "";
    const navigation = [
        {
            label: "About",
            href: "/index.html"
        },
        {
            label: "Digital Access",
            href: "/digital-access.html"
        },
        {
            label: "Translation",
            href: "/translation.html"
        },
        {
            label: "Pre-Order Printed Bibles",
            href: "/pre-order.html"
        },
        {
            label: "Help",
            href: "",
            onClick: (evt)=>{
                if (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.currentTarget.blur();
                }
                setOpenHelp(true);
            }
        }
    ];
    const currentPage = navigation.findIndex((n)=>n.label.toLowerCase() === pageType);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$85fd4ed3b8ca1010), {
        as: "div",
        defaultIndex: currentPage,
        selectedIndex: currentPage,
        onChange: (index)=>{
            const link = navigation[index];
            if (link.onClick) link.onClick();
            else // @ts-expect-error not sure how to type this
            window.location = link.href;
        },
        manual: true,
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$e51a686c67fdaa2d), {
            className: "flex flex-wrap items-center justify-center space-x-3 p-1 text-center sm:space-x-4",
            children: navigation.map((link, index)=>/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c0df5d1e196685e0$export$3e41faf802a29e71), {
                    as: "a",
                    href: link.href,
                    className: ({ selected: selected })=>(0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("rounded-lg p-2 text-sm font-medium whitespace-nowrap", "ring-white/60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2", selected ? "bg-white shadow text-sky-700" : "text-blue-100 hover:bg-white/[0.12] hover:text-white", navigation.length - 1 === index ? "" : ""),
                    onClick: link.onClick ? (evt)=>{
                        link.onClick && link.onClick(evt);
                    } : undefined,
                    children: link.label
                }, link.label))
        })
    });
};
var $7a1273b4d7fc220f$export$2e2bcd8739ae039 = $7a1273b4d7fc220f$var$SubNav;






var $c56K2 = parcelRequire("c56K2");
function $63a032f7b8b096ba$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $c56K2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $c56K2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $c56K2.createElement("path", {
        fillRule: "evenodd",
        d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $63a032f7b8b096ba$var$ForwardRef = /*#__PURE__*/ $c56K2.forwardRef($63a032f7b8b096ba$var$ChevronDownIcon);
var $63a032f7b8b096ba$export$2e2bcd8739ae039 = $63a032f7b8b096ba$var$ForwardRef;


var $c56K2 = parcelRequire("c56K2");
function $1dac06e1d18d1aa9$var$ChevronUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $c56K2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $c56K2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $c56K2.createElement("path", {
        fillRule: "evenodd",
        d: "M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z",
        clipRule: "evenodd"
    }));
}
const $1dac06e1d18d1aa9$var$ForwardRef = /*#__PURE__*/ $c56K2.forwardRef($1dac06e1d18d1aa9$var$ChevronUpIcon);
var $1dac06e1d18d1aa9$export$2e2bcd8739ae039 = $1dac06e1d18d1aa9$var$ForwardRef;



var $c56K2 = parcelRequire("c56K2");
const $37cfa5ef5fbceae6$var$Tribute = ()=>{
    const ref = (0, $c56K2.useRef)(null);
    const disclosureButton = "h-8 w-8 rounded-full bg-rose-500 drop-shadow-md";
    (0, $c56K2.useEffect)(()=>{
        ref.current?.parentElement?.classList.remove("h-32");
    }, []);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $af1524c7fad304d2$export$74a362b31437ec83), {
        as: "div",
        ref: ref,
        className: "scroll-m-0",
        children: ({ open: open, close: close })=>/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $782cc9fb2a36dc63$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $af1524c7fad304d2$export$4edbb1575344e6fc), {
                        as: "div",
                        className: open ? "" : "cursor-pointer",
                        disabled: open,
                        children: [
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("p", {
                                className: (0, $368fefc0ded317e5$export$ce4ab0c55987d1ff)("mx-auto max-w-prose px-8", open ? "" : "line-clamp-3 gradient-mask-b-10"),
                                children: "In 2021, Pastor Kikuo Kanemoto went to be with our Lord Savior Jesus Christ. This Chuukese translation was a life work for Pastor Kikuo\u2014one that took great time and effort, in which he labored for the best possible way to convey God\u2019s word to the people in a familiar way. With this task also came the struggles, the setbacks, and the sacrifice he made to see that this work the Lord had given him would be completed. Through it all, and in the humble way he worked, we know without a doubt that this task brought Pastor Kikuo great joy."
                            }),
                            !open && /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                                className: "mt-[-29px] flex justify-center text-white",
                                children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $63a032f7b8b096ba$export$2e2bcd8739ae039), {
                                    className: disclosureButton
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $af1524c7fad304d2$export$feabaa331e1d464c), {
                        as: "div",
                        children: [
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("p", {
                                className: "mx-auto max-w-prose px-8",
                                children: "Pastor Kikuo often shared of the gratitude he had toward his wife and co-laborer Sandy\u2014someone who also gave so much time and energy to see this work completed. What a blessing to the church it was to see them in marriage, laboring for the Gospel and for God\u2019s word to be known afresh for the people and country they loved."
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("div", {
                                className: "relative pt-[50%]",
                                children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("iframe", {
                                    src: "https://player.vimeo.com/video/811498082?h=64fe4b2961&badge=0&autopause=0&player_id=0&app_id=58479&loop=0",
                                    allow: "autoplay; fullscreen; picture-in-picture",
                                    allowFullScreen: true,
                                    style: {
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        borderWidth: 0
                                    },
                                    title: "Chuukese Bible: Why This Translation?"
                                })
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("script", {
                                src: "https://player.vimeo.com/api/player.js"
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("p", {
                                className: "mx-auto max-w-prose px-8",
                                children: "We are grateful that before his passing, Pastor Kikuo saw this translation work go through its first printing and distribution, and also knew that this translation would be available on the internet for a far greater reach and accessibility to the next generation."
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)("p", {
                                className: "mx-auto max-w-prose px-8",
                                children: "It was always Pastor Kikuo\u2019s hope that this translation would stir up greater reverence and glory to God in every reading, sharing, teaching, preaching, and proclaiming of God\u2019s word. Pastor Kikuo would always say of the translation, \u201CTo God be the glory.\u201D May this translation be one more means (among many) with which the Chuukese church can glorify God and enjoy him forever."
                            }),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $af1524c7fad304d2$export$4edbb1575344e6fc), {
                                className: "mx-auto flex text-white",
                                onClick: (evt)=>{
                                    evt.preventDefault();
                                    close();
                                    if (ref.current) {
                                        // @see https://stackoverflow.com/questions/24665602/scrollintoview-scrolls-just-too-far
                                        const yOffset = -180;
                                        const y = ref.current.getBoundingClientRect().top + window.scrollY + yOffset;
                                        window.scrollTo({
                                            top: y,
                                            behavior: "smooth"
                                        });
                                    }
                                },
                                children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $1dac06e1d18d1aa9$export$2e2bcd8739ae039), {
                                    className: disclosureButton
                                })
                            })
                        ]
                    })
                ]
            })
    });
};
var $37cfa5ef5fbceae6$export$2e2bcd8739ae039 = $37cfa5ef5fbceae6$var$Tribute;



const $c489cfa8a8069215$var$Root = ({ inBook: inBook, previous: previous, next: next })=>{
    const tribute = (0, $c56K2.useRef)(document.getElementById("tribute"));
    const languageToggle = (0, $c56K2.useRef)(document.getElementById("language-toggle"));
    const menuNavigation = (0, $c56K2.useRef)(document.getElementById("menu-navigation"));
    const readBibleButtons = (0, $c56K2.useRef)(document.querySelectorAll(".app\\:openBible"));
    const bookHeader = (0, $c56K2.useRef)(document.getElementById("book-header"));
    const subNav = (0, $c56K2.useRef)(document.getElementById("sub-nav"));
    const [isHelpOpen, setIsHelpOpen] = (0, $c56K2.useState)(false);
    const [isBookNavOpen, setIsBookNavOpen] = (0, $c56K2.useState)(false);
    // @TODO: is this really helping the flash of content?
    const emptyAndRenderPortal = (children, container)=>{
        if (container) {
            if (container.firstElementChild) {
                const span = document.createElement("span");
                container.firstElementChild.replaceWith(span);
            }
            const portal = /*#__PURE__*/ (0, $dg2Np.createPortal)(children, container);
            return portal;
        }
        return null;
    };
    (0, $c56K2.useEffect)(()=>{
        const sources = readBibleButtons.current;
        const events = [
            "click",
            "touchstart"
        ];
        const handleEvent = (event)=>{
            event.preventDefault();
            event.stopImmediatePropagation();
            setIsBookNavOpen(true);
        };
        if (sources.length) sources.forEach((source)=>{
            events.forEach((evt)=>{
                source.addEventListener(evt, handleEvent, true);
            });
        });
        return ()=>{
            sources.forEach((source)=>{
                events.forEach((evt)=>{
                    source.removeEventListener(evt, handleEvent, true);
                });
            });
        };
    }, []);
    (0, $c56K2.useEffect)(()=>{
        if (inBook) (async function() {
            await (parcelRequire("2k2dg"));
        })();
    }, [
        inBook
    ]);
    return /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $782cc9fb2a36dc63$exports.Fragment), {
        children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c56K2))).StrictMode, {
            children: /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $106c13cd0ae6e96b$export$2e2bcd8739ae039), {
                isBookNavOpen: isBookNavOpen,
                setIsBookNavOpen: setIsBookNavOpen,
                isHelpOpen: isHelpOpen,
                setIsHelpOpen: setIsHelpOpen,
                children: [
                    inBook && /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsxs)((0, $782cc9fb2a36dc63$exports.Fragment), {
                        children: [
                            bookHeader.current && /*#__PURE__*/ (0, $dg2Np.createPortal)(/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $b5775686cc6bd89f$export$2e2bcd8739ae039), {}), bookHeader.current),
                            /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $b1ba1390ab07b77a$export$2e2bcd8739ae039), {
                                previous: previous,
                                next: next
                            })
                        ]
                    }),
                    tribute.current && /*#__PURE__*/ (0, $dg2Np.createPortal)(/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $37cfa5ef5fbceae6$export$2e2bcd8739ae039), {}), tribute.current),
                    languageToggle.current && /*#__PURE__*/ (0, $dg2Np.createPortal)(/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $3dbfb9a09cd9cef0$export$2e2bcd8739ae039), {}), languageToggle.current),
                    isHelpOpen && /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $08d61d74174dc16c$export$2e2bcd8739ae039), {
                        setIsOpen: setIsHelpOpen,
                        isOpen: isHelpOpen
                    }),
                    /*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $edff944d21e04014$export$2e2bcd8739ae039), {}),
                    emptyAndRenderPortal(/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $7a1273b4d7fc220f$export$2e2bcd8739ae039), {}), subNav.current),
                    emptyAndRenderPortal(/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $f03feb956d8584c4$export$2e2bcd8739ae039), {
                        align: "right"
                    }), menuNavigation.current)
                ]
            })
        })
    });
};
var $c489cfa8a8069215$export$2e2bcd8739ae039 = $c489cfa8a8069215$var$Root;


const $0115c9ead8780559$var$container = document.getElementById("app");
(0, $let0R.default)($0115c9ead8780559$var$container != null, "No app container element in document");
const $0115c9ead8780559$export$4051a07651545597 = $0115c9ead8780559$var$container.dataset;
const $0115c9ead8780559$var$inBook = $0115c9ead8780559$export$4051a07651545597.title !== undefined;
const $0115c9ead8780559$var$previous = $0115c9ead8780559$export$4051a07651545597.previous;
const $0115c9ead8780559$var$next = $0115c9ead8780559$export$4051a07651545597.next;
const $0115c9ead8780559$var$root = (0, $9dfd74aff40bc7d6$exports.createRoot)($0115c9ead8780559$var$container);
$0115c9ead8780559$var$root.render(/*#__PURE__*/ (0, $782cc9fb2a36dc63$exports.jsx)((0, $c489cfa8a8069215$export$2e2bcd8739ae039), {
    inBook: $0115c9ead8780559$var$inBook,
    previous: $0115c9ead8780559$var$previous,
    next: $0115c9ead8780559$var$next
}));
$0115c9ead8780559$var$container.classList.add("h-0") /*
if (process.env.NODE_ENV !== "production") {
  import("@axe-core/react").then(axe => {
    axe(React, root, 1000)
  })
}
*/ ;


//# sourceMappingURL=chuukese-bible.f5d0fdfd.js.map
